/*! vita-word-add-in v.1.0.0 (1548262980429) ©  */
webpackJsonp([0],{

/***/ "../node_modules/@emotion/hash/dist/hash.esm.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */
// murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash2_32_gc(str) {
  var l = str.length,
      h = l ^ l,
      i = 0,
      k;

  while (l >= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    k ^= k >>> 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
    l -= 4;
    ++i;
  }

  switch (l) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  }

  h ^= h >>> 13;
  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  h ^= h >>> 15;
  return (h >>> 0).toString(36);
}

/* harmony default export */ __webpack_exports__["a"] = (murmurhash2_32_gc);


/***/ }),

/***/ "../node_modules/@emotion/memoize/dist/memoize.esm.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (memoize);


/***/ }),

/***/ "../node_modules/@emotion/stylis/dist/stylis.esm.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e, m).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e, m).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        switch (d.constructor) {
          case Array:
            for (var c = 0, e = d.length; c < e; ++c) {
              T(d[c]);
            }

            break;

          case Function:
            S[A++] = d;
            break;

          case Boolean:
            Y = !!d | 0;
        }

    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

/* harmony default export */ __webpack_exports__["a"] = (stylis_min);


/***/ }),

/***/ "../node_modules/@emotion/unitless/dist/unitless.esm.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ __webpack_exports__["a"] = (unitlessKeys);


/***/ }),

/***/ "../node_modules/@microsoft/office-js-helpers/dist/office.helpers.js":
/***/ (function(module, exports, __webpack_require__) {

/*!
 * @microsoft/office-js-helpers v.1.0.2
 * Copyright (c) Microsoft. All rights reserved.
 * Licensed under the MIT license.
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("OfficeHelpers", [], factory);
	else if(typeof exports === 'object')
		exports["OfficeHelpers"] = factory();
	else
		root["OfficeHelpers"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/index.ts");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./node_modules/lodash-es/_DataView.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__("./node_modules/lodash-es/_getNative.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__("./node_modules/lodash-es/_root.js");



/* Built-in method references that are verified to be native. */
var DataView = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'DataView');

/* harmony default export */ __webpack_exports__["a"] = (DataView);


/***/ }),

/***/ "./node_modules/lodash-es/_Map.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__("./node_modules/lodash-es/_getNative.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__("./node_modules/lodash-es/_root.js");



/* Built-in method references that are verified to be native. */
var Map = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Map');

/* harmony default export */ __webpack_exports__["a"] = (Map);


/***/ }),

/***/ "./node_modules/lodash-es/_Promise.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__("./node_modules/lodash-es/_getNative.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__("./node_modules/lodash-es/_root.js");



/* Built-in method references that are verified to be native. */
var Promise = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Promise');

/* harmony default export */ __webpack_exports__["a"] = (Promise);


/***/ }),

/***/ "./node_modules/lodash-es/_Set.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__("./node_modules/lodash-es/_getNative.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__("./node_modules/lodash-es/_root.js");



/* Built-in method references that are verified to be native. */
var Set = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Set');

/* harmony default export */ __webpack_exports__["a"] = (Set);


/***/ }),

/***/ "./node_modules/lodash-es/_Symbol.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__("./node_modules/lodash-es/_root.js");


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),

/***/ "./node_modules/lodash-es/_WeakMap.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__("./node_modules/lodash-es/_getNative.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__("./node_modules/lodash-es/_root.js");



/* Built-in method references that are verified to be native. */
var WeakMap = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'WeakMap');

/* harmony default export */ __webpack_exports__["a"] = (WeakMap);


/***/ }),

/***/ "./node_modules/lodash-es/_baseGetTag.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__("./node_modules/lodash-es/_Symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__("./node_modules/lodash-es/_getRawTag.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__("./node_modules/lodash-es/_objectToString.js");




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),

/***/ "./node_modules/lodash-es/_baseIsArguments.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__("./node_modules/lodash-es/_baseGetTag.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__("./node_modules/lodash-es/isObjectLike.js");



/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == argsTag;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsArguments);


/***/ }),

/***/ "./node_modules/lodash-es/_baseIsNative.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction_js__ = __webpack_require__("./node_modules/lodash-es/isFunction.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isMasked_js__ = __webpack_require__("./node_modules/lodash-es/_isMasked.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObject_js__ = __webpack_require__("./node_modules/lodash-es/isObject.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toSource_js__ = __webpack_require__("./node_modules/lodash-es/_toSource.js");





/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObject_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_1__isMasked_js__["a" /* default */])(value)) {
    return false;
  }
  var pattern = Object(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(value) ? reIsNative : reIsHostCtor;
  return pattern.test(Object(__WEBPACK_IMPORTED_MODULE_3__toSource_js__["a" /* default */])(value));
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsNative);


/***/ }),

/***/ "./node_modules/lodash-es/_baseIsTypedArray.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__("./node_modules/lodash-es/_baseGetTag.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isLength_js__ = __webpack_require__("./node_modules/lodash-es/isLength.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__("./node_modules/lodash-es/isObjectLike.js");




/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) &&
    Object(__WEBPACK_IMPORTED_MODULE_1__isLength_js__["a" /* default */])(value.length) && !!typedArrayTags[Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value)];
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsTypedArray);


/***/ }),

/***/ "./node_modules/lodash-es/_baseKeys.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPrototype_js__ = __webpack_require__("./node_modules/lodash-es/_isPrototype.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nativeKeys_js__ = __webpack_require__("./node_modules/lodash-es/_nativeKeys.js");



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPrototype_js__["a" /* default */])(object)) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__nativeKeys_js__["a" /* default */])(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseKeys);


/***/ }),

/***/ "./node_modules/lodash-es/_baseUnary.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseUnary);


/***/ }),

/***/ "./node_modules/lodash-es/_coreJsData.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__("./node_modules/lodash-es/_root.js");


/** Used to detect overreaching core-js shims. */
var coreJsData = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */]['__core-js_shared__'];

/* harmony default export */ __webpack_exports__["a"] = (coreJsData);


/***/ }),

/***/ "./node_modules/lodash-es/_freeGlobal.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/lodash-es/_getNative.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsNative_js__ = __webpack_require__("./node_modules/lodash-es/_baseIsNative.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getValue_js__ = __webpack_require__("./node_modules/lodash-es/_getValue.js");



/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = Object(__WEBPACK_IMPORTED_MODULE_1__getValue_js__["a" /* default */])(object, key);
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseIsNative_js__["a" /* default */])(value) ? value : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (getNative);


/***/ }),

/***/ "./node_modules/lodash-es/_getRawTag.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__("./node_modules/lodash-es/_Symbol.js");


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),

/***/ "./node_modules/lodash-es/_getTag.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataView_js__ = __webpack_require__("./node_modules/lodash-es/_DataView.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Map_js__ = __webpack_require__("./node_modules/lodash-es/_Map.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Promise_js__ = __webpack_require__("./node_modules/lodash-es/_Promise.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Set_js__ = __webpack_require__("./node_modules/lodash-es/_Set.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WeakMap_js__ = __webpack_require__("./node_modules/lodash-es/_WeakMap.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__ = __webpack_require__("./node_modules/lodash-es/_baseGetTag.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toSource_js__ = __webpack_require__("./node_modules/lodash-es/_toSource.js");








/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */]),
    mapCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */]),
    promiseCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */]),
    setCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */]),
    weakMapCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */]);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = __WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__["a" /* default */];

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((__WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */](new ArrayBuffer(1))) != dataViewTag) ||
    (__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */]) != mapTag) ||
    (__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */] && getTag(__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */].resolve()) != promiseTag) ||
    (__WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */]) != setTag) ||
    (__WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */]) != weakMapTag)) {
  getTag = function(value) {
    var result = Object(__WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__["a" /* default */])(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (getTag);


/***/ }),

/***/ "./node_modules/lodash-es/_getValue.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/* harmony default export */ __webpack_exports__["a"] = (getValue);


/***/ }),

/***/ "./node_modules/lodash-es/_isMasked.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__ = __webpack_require__("./node_modules/lodash-es/_coreJsData.js");


/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(__WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */].keys && __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */].keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/* harmony default export */ __webpack_exports__["a"] = (isMasked);


/***/ }),

/***/ "./node_modules/lodash-es/_isPrototype.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/* harmony default export */ __webpack_exports__["a"] = (isPrototype);


/***/ }),

/***/ "./node_modules/lodash-es/_nativeKeys.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__("./node_modules/lodash-es/_overArg.js");


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.keys, Object);

/* harmony default export */ __webpack_exports__["a"] = (nativeKeys);


/***/ }),

/***/ "./node_modules/lodash-es/_nodeUtil.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__("./node_modules/lodash-es/_freeGlobal.js");


/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */].process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* harmony default export */ __webpack_exports__["a"] = (nodeUtil);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("./node_modules/webpack/buildin/harmony-module.js")(module)))

/***/ }),

/***/ "./node_modules/lodash-es/_objectToString.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),

/***/ "./node_modules/lodash-es/_overArg.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),

/***/ "./node_modules/lodash-es/_root.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__("./node_modules/lodash-es/_freeGlobal.js");


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),

/***/ "./node_modules/lodash-es/_toSource.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/* harmony default export */ __webpack_exports__["a"] = (toSource);


/***/ }),

/***/ "./node_modules/lodash-es/debounce.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__("./node_modules/lodash-es/isObject.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__now_js__ = __webpack_require__("./node_modules/lodash-es/now.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toNumber_js__ = __webpack_require__("./node_modules/lodash-es/toNumber.js");




/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = Object(__WEBPACK_IMPORTED_MODULE_2__toNumber_js__["a" /* default */])(wait) || 0;
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(Object(__WEBPACK_IMPORTED_MODULE_2__toNumber_js__["a" /* default */])(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = Object(__WEBPACK_IMPORTED_MODULE_1__now_js__["a" /* default */])();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(Object(__WEBPACK_IMPORTED_MODULE_1__now_js__["a" /* default */])());
  }

  function debounced() {
    var time = Object(__WEBPACK_IMPORTED_MODULE_1__now_js__["a" /* default */])(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/* harmony default export */ __webpack_exports__["a"] = (debounce);


/***/ }),

/***/ "./node_modules/lodash-es/isArguments.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__ = __webpack_require__("./node_modules/lodash-es/_baseIsArguments.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__("./node_modules/lodash-es/isObjectLike.js");



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = Object(__WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__["a" /* default */])(function() { return arguments; }()) ? __WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__["a" /* default */] : function(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/* harmony default export */ __webpack_exports__["a"] = (isArguments);


/***/ }),

/***/ "./node_modules/lodash-es/isArray.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/* harmony default export */ __webpack_exports__["a"] = (isArray);


/***/ }),

/***/ "./node_modules/lodash-es/isArrayLike.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction_js__ = __webpack_require__("./node_modules/lodash-es/isFunction.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isLength_js__ = __webpack_require__("./node_modules/lodash-es/isLength.js");



/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && Object(__WEBPACK_IMPORTED_MODULE_1__isLength_js__["a" /* default */])(value.length) && !Object(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isArrayLike);


/***/ }),

/***/ "./node_modules/lodash-es/isBuffer.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__("./node_modules/lodash-es/_root.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stubFalse_js__ = __webpack_require__("./node_modules/lodash-es/stubFalse.js");



/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || __WEBPACK_IMPORTED_MODULE_1__stubFalse_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isBuffer);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("./node_modules/webpack/buildin/harmony-module.js")(module)))

/***/ }),

/***/ "./node_modules/lodash-es/isEmpty.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseKeys_js__ = __webpack_require__("./node_modules/lodash-es/_baseKeys.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getTag_js__ = __webpack_require__("./node_modules/lodash-es/_getTag.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArguments_js__ = __webpack_require__("./node_modules/lodash-es/isArguments.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArray_js__ = __webpack_require__("./node_modules/lodash-es/isArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isArrayLike_js__ = __webpack_require__("./node_modules/lodash-es/isArrayLike.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isBuffer_js__ = __webpack_require__("./node_modules/lodash-es/isBuffer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isPrototype_js__ = __webpack_require__("./node_modules/lodash-es/_isPrototype.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__ = __webpack_require__("./node_modules/lodash-es/isTypedArray.js");









/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_4__isArrayLike_js__["a" /* default */])(value) &&
      (Object(__WEBPACK_IMPORTED_MODULE_3__isArray_js__["a" /* default */])(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        Object(__WEBPACK_IMPORTED_MODULE_5__isBuffer_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_2__isArguments_js__["a" /* default */])(value))) {
    return !value.length;
  }
  var tag = Object(__WEBPACK_IMPORTED_MODULE_1__getTag_js__["a" /* default */])(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_6__isPrototype_js__["a" /* default */])(value)) {
    return !Object(__WEBPACK_IMPORTED_MODULE_0__baseKeys_js__["a" /* default */])(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

/* harmony default export */ __webpack_exports__["a"] = (isEmpty);


/***/ }),

/***/ "./node_modules/lodash-es/isFunction.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__("./node_modules/lodash-es/_baseGetTag.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObject_js__ = __webpack_require__("./node_modules/lodash-es/isObject.js");



/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_1__isObject_js__["a" /* default */])(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/* harmony default export */ __webpack_exports__["a"] = (isFunction);


/***/ }),

/***/ "./node_modules/lodash-es/isLength.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/* harmony default export */ __webpack_exports__["a"] = (isLength);


/***/ }),

/***/ "./node_modules/lodash-es/isNil.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

/* harmony default export */ __webpack_exports__["a"] = (isNil);


/***/ }),

/***/ "./node_modules/lodash-es/isObject.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/* harmony default export */ __webpack_exports__["a"] = (isObject);


/***/ }),

/***/ "./node_modules/lodash-es/isObjectLike.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),

/***/ "./node_modules/lodash-es/isString.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__("./node_modules/lodash-es/_baseGetTag.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArray_js__ = __webpack_require__("./node_modules/lodash-es/isArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__("./node_modules/lodash-es/isObjectLike.js");




/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!Object(__WEBPACK_IMPORTED_MODULE_1__isArray_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == stringTag);
}

/* harmony default export */ __webpack_exports__["a"] = (isString);


/***/ }),

/***/ "./node_modules/lodash-es/isSymbol.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__("./node_modules/lodash-es/_baseGetTag.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__("./node_modules/lodash-es/isObjectLike.js");



/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == symbolTag);
}

/* harmony default export */ __webpack_exports__["a"] = (isSymbol);


/***/ }),

/***/ "./node_modules/lodash-es/isTypedArray.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsTypedArray_js__ = __webpack_require__("./node_modules/lodash-es/_baseIsTypedArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseUnary_js__ = __webpack_require__("./node_modules/lodash-es/_baseUnary.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__ = __webpack_require__("./node_modules/lodash-es/_nodeUtil.js");




/* Node.js helper references. */
var nodeIsTypedArray = __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */].isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? Object(__WEBPACK_IMPORTED_MODULE_1__baseUnary_js__["a" /* default */])(nodeIsTypedArray) : __WEBPACK_IMPORTED_MODULE_0__baseIsTypedArray_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isTypedArray);


/***/ }),

/***/ "./node_modules/lodash-es/now.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__("./node_modules/lodash-es/_root.js");


/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Date.now();
};

/* harmony default export */ __webpack_exports__["a"] = (now);


/***/ }),

/***/ "./node_modules/lodash-es/stubFalse.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (stubFalse);


/***/ }),

/***/ "./node_modules/lodash-es/toNumber.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__("./node_modules/lodash-es/isObject.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isSymbol_js__ = __webpack_require__("./node_modules/lodash-es/isSymbol.js");



/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_1__isSymbol_js__["a" /* default */])(value)) {
    return NAN;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

/* harmony default export */ __webpack_exports__["a"] = (toNumber);


/***/ }),

/***/ "./node_modules/rxjs/Observable.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__("./node_modules/rxjs/util/root.js");
var toSubscriber_1 = __webpack_require__("./node_modules/rxjs/util/toSubscriber.js");
var observable_1 = __webpack_require__("./node_modules/rxjs/symbol/observable.js");
var pipe_1 = __webpack_require__("./node_modules/rxjs/util/pipe.js");
/**
 * A representation of any set of values over any amount of time. This is the most basic building block
 * of RxJS.
 *
 * @class Observable<T>
 */
var Observable = (function () {
    /**
     * @constructor
     * @param {Function} subscribe the function that is called when the Observable is
     * initially subscribed to. This function is given a Subscriber, to which new values
     * can be `next`ed, or an `error` method can be called to raise an error, or
     * `complete` can be called to notify of a successful completion.
     */
    function Observable(subscribe) {
        this._isScalar = false;
        if (subscribe) {
            this._subscribe = subscribe;
        }
    }
    /**
     * Creates a new Observable, with this Observable as the source, and the passed
     * operator defined as the new observable's operator.
     * @method lift
     * @param {Operator} operator the operator defining the operation to take on the observable
     * @return {Observable} a new observable with the Operator applied
     */
    Observable.prototype.lift = function (operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    /**
     * Invokes an execution of an Observable and registers Observer handlers for notifications it will emit.
     *
     * <span class="informal">Use it when you have all these Observables, but still nothing is happening.</span>
     *
     * `subscribe` is not a regular operator, but a method that calls Observable's internal `subscribe` function. It
     * might be for example a function that you passed to a {@link create} static factory, but most of the time it is
     * a library implementation, which defines what and when will be emitted by an Observable. This means that calling
     * `subscribe` is actually the moment when Observable starts its work, not when it is created, as it is often
     * thought.
     *
     * Apart from starting the execution of an Observable, this method allows you to listen for values
     * that an Observable emits, as well as for when it completes or errors. You can achieve this in two
     * following ways.
     *
     * The first way is creating an object that implements {@link Observer} interface. It should have methods
     * defined by that interface, but note that it should be just a regular JavaScript object, which you can create
     * yourself in any way you want (ES6 class, classic function constructor, object literal etc.). In particular do
     * not attempt to use any RxJS implementation details to create Observers - you don't need them. Remember also
     * that your object does not have to implement all methods. If you find yourself creating a method that doesn't
     * do anything, you can simply omit it. Note however, that if `error` method is not provided, all errors will
     * be left uncaught.
     *
     * The second way is to give up on Observer object altogether and simply provide callback functions in place of its methods.
     * This means you can provide three functions as arguments to `subscribe`, where first function is equivalent
     * of a `next` method, second of an `error` method and third of a `complete` method. Just as in case of Observer,
     * if you do not need to listen for something, you can omit a function, preferably by passing `undefined` or `null`,
     * since `subscribe` recognizes these functions by where they were placed in function call. When it comes
     * to `error` function, just as before, if not provided, errors emitted by an Observable will be thrown.
     *
     * Whatever style of calling `subscribe` you use, in both cases it returns a Subscription object.
     * This object allows you to call `unsubscribe` on it, which in turn will stop work that an Observable does and will clean
     * up all resources that an Observable used. Note that cancelling a subscription will not call `complete` callback
     * provided to `subscribe` function, which is reserved for a regular completion signal that comes from an Observable.
     *
     * Remember that callbacks provided to `subscribe` are not guaranteed to be called asynchronously.
     * It is an Observable itself that decides when these functions will be called. For example {@link of}
     * by default emits all its values synchronously. Always check documentation for how given Observable
     * will behave when subscribed and if its default behavior can be modified with a {@link Scheduler}.
     *
     * @example <caption>Subscribe with an Observer</caption>
     * const sumObserver = {
     *   sum: 0,
     *   next(value) {
     *     console.log('Adding: ' + value);
     *     this.sum = this.sum + value;
     *   },
     *   error() { // We actually could just remove this method,
     *   },        // since we do not really care about errors right now.
     *   complete() {
     *     console.log('Sum equals: ' + this.sum);
     *   }
     * };
     *
     * Rx.Observable.of(1, 2, 3) // Synchronously emits 1, 2, 3 and then completes.
     * .subscribe(sumObserver);
     *
     * // Logs:
     * // "Adding: 1"
     * // "Adding: 2"
     * // "Adding: 3"
     * // "Sum equals: 6"
     *
     *
     * @example <caption>Subscribe with functions</caption>
     * let sum = 0;
     *
     * Rx.Observable.of(1, 2, 3)
     * .subscribe(
     *   function(value) {
     *     console.log('Adding: ' + value);
     *     sum = sum + value;
     *   },
     *   undefined,
     *   function() {
     *     console.log('Sum equals: ' + sum);
     *   }
     * );
     *
     * // Logs:
     * // "Adding: 1"
     * // "Adding: 2"
     * // "Adding: 3"
     * // "Sum equals: 6"
     *
     *
     * @example <caption>Cancel a subscription</caption>
     * const subscription = Rx.Observable.interval(1000).subscribe(
     *   num => console.log(num),
     *   undefined,
     *   () => console.log('completed!') // Will not be called, even
     * );                                // when cancelling subscription
     *
     *
     * setTimeout(() => {
     *   subscription.unsubscribe();
     *   console.log('unsubscribed!');
     * }, 2500);
     *
     * // Logs:
     * // 0 after 1s
     * // 1 after 2s
     * // "unsubscribed!" after 2.5s
     *
     *
     * @param {Observer|Function} observerOrNext (optional) Either an observer with methods to be called,
     *  or the first of three possible handlers, which is the handler for each value emitted from the subscribed
     *  Observable.
     * @param {Function} error (optional) A handler for a terminal event resulting from an error. If no error handler is provided,
     *  the error will be thrown as unhandled.
     * @param {Function} complete (optional) A handler for a terminal event resulting from successful completion.
     * @return {ISubscription} a subscription reference to the registered handlers
     * @method subscribe
     */
    Observable.prototype.subscribe = function (observerOrNext, error, complete) {
        var operator = this.operator;
        var sink = toSubscriber_1.toSubscriber(observerOrNext, error, complete);
        if (operator) {
            operator.call(sink, this.source);
        }
        else {
            sink.add(this.source || !sink.syncErrorThrowable ? this._subscribe(sink) : this._trySubscribe(sink));
        }
        if (sink.syncErrorThrowable) {
            sink.syncErrorThrowable = false;
            if (sink.syncErrorThrown) {
                throw sink.syncErrorValue;
            }
        }
        return sink;
    };
    Observable.prototype._trySubscribe = function (sink) {
        try {
            return this._subscribe(sink);
        }
        catch (err) {
            sink.syncErrorThrown = true;
            sink.syncErrorValue = err;
            sink.error(err);
        }
    };
    /**
     * @method forEach
     * @param {Function} next a handler for each value emitted by the observable
     * @param {PromiseConstructor} [PromiseCtor] a constructor function used to instantiate the Promise
     * @return {Promise} a promise that either resolves on observable completion or
     *  rejects with the handled error
     */
    Observable.prototype.forEach = function (next, PromiseCtor) {
        var _this = this;
        if (!PromiseCtor) {
            if (root_1.root.Rx && root_1.root.Rx.config && root_1.root.Rx.config.Promise) {
                PromiseCtor = root_1.root.Rx.config.Promise;
            }
            else if (root_1.root.Promise) {
                PromiseCtor = root_1.root.Promise;
            }
        }
        if (!PromiseCtor) {
            throw new Error('no Promise impl found');
        }
        return new PromiseCtor(function (resolve, reject) {
            // Must be declared in a separate statement to avoid a RefernceError when
            // accessing subscription below in the closure due to Temporal Dead Zone.
            var subscription;
            subscription = _this.subscribe(function (value) {
                if (subscription) {
                    // if there is a subscription, then we can surmise
                    // the next handling is asynchronous. Any errors thrown
                    // need to be rejected explicitly and unsubscribe must be
                    // called manually
                    try {
                        next(value);
                    }
                    catch (err) {
                        reject(err);
                        subscription.unsubscribe();
                    }
                }
                else {
                    // if there is NO subscription, then we're getting a nexted
                    // value synchronously during subscription. We can just call it.
                    // If it errors, Observable's `subscribe` will ensure the
                    // unsubscription logic is called, then synchronously rethrow the error.
                    // After that, Promise will trap the error and send it
                    // down the rejection path.
                    next(value);
                }
            }, reject, resolve);
        });
    };
    Observable.prototype._subscribe = function (subscriber) {
        return this.source.subscribe(subscriber);
    };
    /**
     * An interop point defined by the es7-observable spec https://github.com/zenparsing/es-observable
     * @method Symbol.observable
     * @return {Observable} this instance of the observable
     */
    Observable.prototype[observable_1.observable] = function () {
        return this;
    };
    /* tslint:enable:max-line-length */
    /**
     * Used to stitch together functional operators into a chain.
     * @method pipe
     * @return {Observable} the Observable result of all of the operators having
     * been called in the order they were passed in.
     *
     * @example
     *
     * import { map, filter, scan } from 'rxjs/operators';
     *
     * Rx.Observable.interval(1000)
     *   .pipe(
     *     filter(x => x % 2 === 0),
     *     map(x => x + x),
     *     scan((acc, x) => acc + x)
     *   )
     *   .subscribe(x => console.log(x))
     */
    Observable.prototype.pipe = function () {
        var operations = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            operations[_i - 0] = arguments[_i];
        }
        if (operations.length === 0) {
            return this;
        }
        return pipe_1.pipeFromArray(operations)(this);
    };
    /* tslint:enable:max-line-length */
    Observable.prototype.toPromise = function (PromiseCtor) {
        var _this = this;
        if (!PromiseCtor) {
            if (root_1.root.Rx && root_1.root.Rx.config && root_1.root.Rx.config.Promise) {
                PromiseCtor = root_1.root.Rx.config.Promise;
            }
            else if (root_1.root.Promise) {
                PromiseCtor = root_1.root.Promise;
            }
        }
        if (!PromiseCtor) {
            throw new Error('no Promise impl found');
        }
        return new PromiseCtor(function (resolve, reject) {
            var value;
            _this.subscribe(function (x) { return value = x; }, function (err) { return reject(err); }, function () { return resolve(value); });
        });
    };
    // HACK: Since TypeScript inherits static properties too, we have to
    // fight against TypeScript here so Subject can have a different static create signature
    /**
     * Creates a new cold Observable by calling the Observable constructor
     * @static true
     * @owner Observable
     * @method create
     * @param {Function} subscribe? the subscriber function to be passed to the Observable constructor
     * @return {Observable} a new cold observable
     */
    Observable.create = function (subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}());
exports.Observable = Observable;
//# sourceMappingURL=Observable.js.map

/***/ }),

/***/ "./node_modules/rxjs/Observer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.empty = {
    closed: true,
    next: function (value) { },
    error: function (err) { throw err; },
    complete: function () { }
};
//# sourceMappingURL=Observer.js.map

/***/ }),

/***/ "./node_modules/rxjs/Subscriber.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var isFunction_1 = __webpack_require__("./node_modules/rxjs/util/isFunction.js");
var Subscription_1 = __webpack_require__("./node_modules/rxjs/Subscription.js");
var Observer_1 = __webpack_require__("./node_modules/rxjs/Observer.js");
var rxSubscriber_1 = __webpack_require__("./node_modules/rxjs/symbol/rxSubscriber.js");
/**
 * Implements the {@link Observer} interface and extends the
 * {@link Subscription} class. While the {@link Observer} is the public API for
 * consuming the values of an {@link Observable}, all Observers get converted to
 * a Subscriber, in order to provide Subscription-like capabilities such as
 * `unsubscribe`. Subscriber is a common type in RxJS, and crucial for
 * implementing operators, but it is rarely used as a public API.
 *
 * @class Subscriber<T>
 */
var Subscriber = (function (_super) {
    __extends(Subscriber, _super);
    /**
     * @param {Observer|function(value: T): void} [destinationOrNext] A partially
     * defined Observer or a `next` callback function.
     * @param {function(e: ?any): void} [error] The `error` callback of an
     * Observer.
     * @param {function(): void} [complete] The `complete` callback of an
     * Observer.
     */
    function Subscriber(destinationOrNext, error, complete) {
        _super.call(this);
        this.syncErrorValue = null;
        this.syncErrorThrown = false;
        this.syncErrorThrowable = false;
        this.isStopped = false;
        switch (arguments.length) {
            case 0:
                this.destination = Observer_1.empty;
                break;
            case 1:
                if (!destinationOrNext) {
                    this.destination = Observer_1.empty;
                    break;
                }
                if (typeof destinationOrNext === 'object') {
                    if (destinationOrNext instanceof Subscriber) {
                        this.syncErrorThrowable = destinationOrNext.syncErrorThrowable;
                        this.destination = destinationOrNext;
                        this.destination.add(this);
                    }
                    else {
                        this.syncErrorThrowable = true;
                        this.destination = new SafeSubscriber(this, destinationOrNext);
                    }
                    break;
                }
            default:
                this.syncErrorThrowable = true;
                this.destination = new SafeSubscriber(this, destinationOrNext, error, complete);
                break;
        }
    }
    Subscriber.prototype[rxSubscriber_1.rxSubscriber] = function () { return this; };
    /**
     * A static factory for a Subscriber, given a (potentially partial) definition
     * of an Observer.
     * @param {function(x: ?T): void} [next] The `next` callback of an Observer.
     * @param {function(e: ?any): void} [error] The `error` callback of an
     * Observer.
     * @param {function(): void} [complete] The `complete` callback of an
     * Observer.
     * @return {Subscriber<T>} A Subscriber wrapping the (partially defined)
     * Observer represented by the given arguments.
     */
    Subscriber.create = function (next, error, complete) {
        var subscriber = new Subscriber(next, error, complete);
        subscriber.syncErrorThrowable = false;
        return subscriber;
    };
    /**
     * The {@link Observer} callback to receive notifications of type `next` from
     * the Observable, with a value. The Observable may call this method 0 or more
     * times.
     * @param {T} [value] The `next` value.
     * @return {void}
     */
    Subscriber.prototype.next = function (value) {
        if (!this.isStopped) {
            this._next(value);
        }
    };
    /**
     * The {@link Observer} callback to receive notifications of type `error` from
     * the Observable, with an attached {@link Error}. Notifies the Observer that
     * the Observable has experienced an error condition.
     * @param {any} [err] The `error` exception.
     * @return {void}
     */
    Subscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            this.isStopped = true;
            this._error(err);
        }
    };
    /**
     * The {@link Observer} callback to receive a valueless notification of type
     * `complete` from the Observable. Notifies the Observer that the Observable
     * has finished sending push-based notifications.
     * @return {void}
     */
    Subscriber.prototype.complete = function () {
        if (!this.isStopped) {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function () {
        if (this.closed) {
            return;
        }
        this.isStopped = true;
        _super.prototype.unsubscribe.call(this);
    };
    Subscriber.prototype._next = function (value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function (err) {
        this.destination.error(err);
        this.unsubscribe();
    };
    Subscriber.prototype._complete = function () {
        this.destination.complete();
        this.unsubscribe();
    };
    Subscriber.prototype._unsubscribeAndRecycle = function () {
        var _a = this, _parent = _a._parent, _parents = _a._parents;
        this._parent = null;
        this._parents = null;
        this.unsubscribe();
        this.closed = false;
        this.isStopped = false;
        this._parent = _parent;
        this._parents = _parents;
        return this;
    };
    return Subscriber;
}(Subscription_1.Subscription));
exports.Subscriber = Subscriber;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SafeSubscriber = (function (_super) {
    __extends(SafeSubscriber, _super);
    function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
        _super.call(this);
        this._parentSubscriber = _parentSubscriber;
        var next;
        var context = this;
        if (isFunction_1.isFunction(observerOrNext)) {
            next = observerOrNext;
        }
        else if (observerOrNext) {
            next = observerOrNext.next;
            error = observerOrNext.error;
            complete = observerOrNext.complete;
            if (observerOrNext !== Observer_1.empty) {
                context = Object.create(observerOrNext);
                if (isFunction_1.isFunction(context.unsubscribe)) {
                    this.add(context.unsubscribe.bind(context));
                }
                context.unsubscribe = this.unsubscribe.bind(this);
            }
        }
        this._context = context;
        this._next = next;
        this._error = error;
        this._complete = complete;
    }
    SafeSubscriber.prototype.next = function (value) {
        if (!this.isStopped && this._next) {
            var _parentSubscriber = this._parentSubscriber;
            if (!_parentSubscriber.syncErrorThrowable) {
                this.__tryOrUnsub(this._next, value);
            }
            else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) {
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._error) {
                if (!_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(this._error, err);
                    this.unsubscribe();
                }
                else {
                    this.__tryOrSetError(_parentSubscriber, this._error, err);
                    this.unsubscribe();
                }
            }
            else if (!_parentSubscriber.syncErrorThrowable) {
                this.unsubscribe();
                throw err;
            }
            else {
                _parentSubscriber.syncErrorValue = err;
                _parentSubscriber.syncErrorThrown = true;
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.complete = function () {
        var _this = this;
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._complete) {
                var wrappedComplete = function () { return _this._complete.call(_this._context); };
                if (!_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(wrappedComplete);
                    this.unsubscribe();
                }
                else {
                    this.__tryOrSetError(_parentSubscriber, wrappedComplete);
                    this.unsubscribe();
                }
            }
            else {
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.__tryOrUnsub = function (fn, value) {
        try {
            fn.call(this._context, value);
        }
        catch (err) {
            this.unsubscribe();
            throw err;
        }
    };
    SafeSubscriber.prototype.__tryOrSetError = function (parent, fn, value) {
        try {
            fn.call(this._context, value);
        }
        catch (err) {
            parent.syncErrorValue = err;
            parent.syncErrorThrown = true;
            return true;
        }
        return false;
    };
    SafeSubscriber.prototype._unsubscribe = function () {
        var _parentSubscriber = this._parentSubscriber;
        this._context = null;
        this._parentSubscriber = null;
        _parentSubscriber.unsubscribe();
    };
    return SafeSubscriber;
}(Subscriber));
//# sourceMappingURL=Subscriber.js.map

/***/ }),

/***/ "./node_modules/rxjs/Subscription.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isArray_1 = __webpack_require__("./node_modules/rxjs/util/isArray.js");
var isObject_1 = __webpack_require__("./node_modules/rxjs/util/isObject.js");
var isFunction_1 = __webpack_require__("./node_modules/rxjs/util/isFunction.js");
var tryCatch_1 = __webpack_require__("./node_modules/rxjs/util/tryCatch.js");
var errorObject_1 = __webpack_require__("./node_modules/rxjs/util/errorObject.js");
var UnsubscriptionError_1 = __webpack_require__("./node_modules/rxjs/util/UnsubscriptionError.js");
/**
 * Represents a disposable resource, such as the execution of an Observable. A
 * Subscription has one important method, `unsubscribe`, that takes no argument
 * and just disposes the resource held by the subscription.
 *
 * Additionally, subscriptions may be grouped together through the `add()`
 * method, which will attach a child Subscription to the current Subscription.
 * When a Subscription is unsubscribed, all its children (and its grandchildren)
 * will be unsubscribed as well.
 *
 * @class Subscription
 */
var Subscription = (function () {
    /**
     * @param {function(): void} [unsubscribe] A function describing how to
     * perform the disposal of resources when the `unsubscribe` method is called.
     */
    function Subscription(unsubscribe) {
        /**
         * A flag to indicate whether this Subscription has already been unsubscribed.
         * @type {boolean}
         */
        this.closed = false;
        this._parent = null;
        this._parents = null;
        this._subscriptions = null;
        if (unsubscribe) {
            this._unsubscribe = unsubscribe;
        }
    }
    /**
     * Disposes the resources held by the subscription. May, for instance, cancel
     * an ongoing Observable execution or cancel any other type of work that
     * started when the Subscription was created.
     * @return {void}
     */
    Subscription.prototype.unsubscribe = function () {
        var hasErrors = false;
        var errors;
        if (this.closed) {
            return;
        }
        var _a = this, _parent = _a._parent, _parents = _a._parents, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
        this.closed = true;
        this._parent = null;
        this._parents = null;
        // null out _subscriptions first so any child subscriptions that attempt
        // to remove themselves from this subscription will noop
        this._subscriptions = null;
        var index = -1;
        var len = _parents ? _parents.length : 0;
        // if this._parent is null, then so is this._parents, and we
        // don't have to remove ourselves from any parent subscriptions.
        while (_parent) {
            _parent.remove(this);
            // if this._parents is null or index >= len,
            // then _parent is set to null, and the loop exits
            _parent = ++index < len && _parents[index] || null;
        }
        if (isFunction_1.isFunction(_unsubscribe)) {
            var trial = tryCatch_1.tryCatch(_unsubscribe).call(this);
            if (trial === errorObject_1.errorObject) {
                hasErrors = true;
                errors = errors || (errorObject_1.errorObject.e instanceof UnsubscriptionError_1.UnsubscriptionError ?
                    flattenUnsubscriptionErrors(errorObject_1.errorObject.e.errors) : [errorObject_1.errorObject.e]);
            }
        }
        if (isArray_1.isArray(_subscriptions)) {
            index = -1;
            len = _subscriptions.length;
            while (++index < len) {
                var sub = _subscriptions[index];
                if (isObject_1.isObject(sub)) {
                    var trial = tryCatch_1.tryCatch(sub.unsubscribe).call(sub);
                    if (trial === errorObject_1.errorObject) {
                        hasErrors = true;
                        errors = errors || [];
                        var err = errorObject_1.errorObject.e;
                        if (err instanceof UnsubscriptionError_1.UnsubscriptionError) {
                            errors = errors.concat(flattenUnsubscriptionErrors(err.errors));
                        }
                        else {
                            errors.push(err);
                        }
                    }
                }
            }
        }
        if (hasErrors) {
            throw new UnsubscriptionError_1.UnsubscriptionError(errors);
        }
    };
    /**
     * Adds a tear down to be called during the unsubscribe() of this
     * Subscription.
     *
     * If the tear down being added is a subscription that is already
     * unsubscribed, is the same reference `add` is being called on, or is
     * `Subscription.EMPTY`, it will not be added.
     *
     * If this subscription is already in an `closed` state, the passed
     * tear down logic will be executed immediately.
     *
     * @param {TeardownLogic} teardown The additional logic to execute on
     * teardown.
     * @return {Subscription} Returns the Subscription used or created to be
     * added to the inner subscriptions list. This Subscription can be used with
     * `remove()` to remove the passed teardown logic from the inner subscriptions
     * list.
     */
    Subscription.prototype.add = function (teardown) {
        if (!teardown || (teardown === Subscription.EMPTY)) {
            return Subscription.EMPTY;
        }
        if (teardown === this) {
            return this;
        }
        var subscription = teardown;
        switch (typeof teardown) {
            case 'function':
                subscription = new Subscription(teardown);
            case 'object':
                if (subscription.closed || typeof subscription.unsubscribe !== 'function') {
                    return subscription;
                }
                else if (this.closed) {
                    subscription.unsubscribe();
                    return subscription;
                }
                else if (typeof subscription._addParent !== 'function' /* quack quack */) {
                    var tmp = subscription;
                    subscription = new Subscription();
                    subscription._subscriptions = [tmp];
                }
                break;
            default:
                throw new Error('unrecognized teardown ' + teardown + ' added to Subscription.');
        }
        var subscriptions = this._subscriptions || (this._subscriptions = []);
        subscriptions.push(subscription);
        subscription._addParent(this);
        return subscription;
    };
    /**
     * Removes a Subscription from the internal list of subscriptions that will
     * unsubscribe during the unsubscribe process of this Subscription.
     * @param {Subscription} subscription The subscription to remove.
     * @return {void}
     */
    Subscription.prototype.remove = function (subscription) {
        var subscriptions = this._subscriptions;
        if (subscriptions) {
            var subscriptionIndex = subscriptions.indexOf(subscription);
            if (subscriptionIndex !== -1) {
                subscriptions.splice(subscriptionIndex, 1);
            }
        }
    };
    Subscription.prototype._addParent = function (parent) {
        var _a = this, _parent = _a._parent, _parents = _a._parents;
        if (!_parent || _parent === parent) {
            // If we don't have a parent, or the new parent is the same as the
            // current parent, then set this._parent to the new parent.
            this._parent = parent;
        }
        else if (!_parents) {
            // If there's already one parent, but not multiple, allocate an Array to
            // store the rest of the parent Subscriptions.
            this._parents = [parent];
        }
        else if (_parents.indexOf(parent) === -1) {
            // Only add the new parent to the _parents list if it's not already there.
            _parents.push(parent);
        }
    };
    Subscription.EMPTY = (function (empty) {
        empty.closed = true;
        return empty;
    }(new Subscription()));
    return Subscription;
}());
exports.Subscription = Subscription;
function flattenUnsubscriptionErrors(errors) {
    return errors.reduce(function (errs, err) { return errs.concat((err instanceof UnsubscriptionError_1.UnsubscriptionError) ? err.errors : err); }, []);
}
//# sourceMappingURL=Subscription.js.map

/***/ }),

/***/ "./node_modules/rxjs/symbol/observable.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__("./node_modules/rxjs/util/root.js");
function getSymbolObservable(context) {
    var $$observable;
    var Symbol = context.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) {
            $$observable = Symbol.observable;
        }
        else {
            $$observable = Symbol('observable');
            Symbol.observable = $$observable;
        }
    }
    else {
        $$observable = '@@observable';
    }
    return $$observable;
}
exports.getSymbolObservable = getSymbolObservable;
exports.observable = getSymbolObservable(root_1.root);
/**
 * @deprecated use observable instead
 */
exports.$$observable = exports.observable;
//# sourceMappingURL=observable.js.map

/***/ }),

/***/ "./node_modules/rxjs/symbol/rxSubscriber.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__("./node_modules/rxjs/util/root.js");
var Symbol = root_1.root.Symbol;
exports.rxSubscriber = (typeof Symbol === 'function' && typeof Symbol.for === 'function') ?
    Symbol.for('rxSubscriber') : '@@rxSubscriber';
/**
 * @deprecated use rxSubscriber instead
 */
exports.$$rxSubscriber = exports.rxSubscriber;
//# sourceMappingURL=rxSubscriber.js.map

/***/ }),

/***/ "./node_modules/rxjs/util/UnsubscriptionError.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when one or more errors have occurred during the
 * `unsubscribe` of a {@link Subscription}.
 */
var UnsubscriptionError = (function (_super) {
    __extends(UnsubscriptionError, _super);
    function UnsubscriptionError(errors) {
        _super.call(this);
        this.errors = errors;
        var err = Error.call(this, errors ?
            errors.length + " errors occurred during unsubscription:\n  " + errors.map(function (err, i) { return ((i + 1) + ") " + err.toString()); }).join('\n  ') : '');
        this.name = err.name = 'UnsubscriptionError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return UnsubscriptionError;
}(Error));
exports.UnsubscriptionError = UnsubscriptionError;
//# sourceMappingURL=UnsubscriptionError.js.map

/***/ }),

/***/ "./node_modules/rxjs/util/errorObject.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// typeof any so that it we don't have to cast when comparing a result to the error object
exports.errorObject = { e: {} };
//# sourceMappingURL=errorObject.js.map

/***/ }),

/***/ "./node_modules/rxjs/util/isArray.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.isArray = Array.isArray || (function (x) { return x && typeof x.length === 'number'; });
//# sourceMappingURL=isArray.js.map

/***/ }),

/***/ "./node_modules/rxjs/util/isFunction.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function isFunction(x) {
    return typeof x === 'function';
}
exports.isFunction = isFunction;
//# sourceMappingURL=isFunction.js.map

/***/ }),

/***/ "./node_modules/rxjs/util/isObject.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function isObject(x) {
    return x != null && typeof x === 'object';
}
exports.isObject = isObject;
//# sourceMappingURL=isObject.js.map

/***/ }),

/***/ "./node_modules/rxjs/util/noop.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* tslint:disable:no-empty */
function noop() { }
exports.noop = noop;
//# sourceMappingURL=noop.js.map

/***/ }),

/***/ "./node_modules/rxjs/util/pipe.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var noop_1 = __webpack_require__("./node_modules/rxjs/util/noop.js");
/* tslint:enable:max-line-length */
function pipe() {
    var fns = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        fns[_i - 0] = arguments[_i];
    }
    return pipeFromArray(fns);
}
exports.pipe = pipe;
/* @internal */
function pipeFromArray(fns) {
    if (!fns) {
        return noop_1.noop;
    }
    if (fns.length === 1) {
        return fns[0];
    }
    return function piped(input) {
        return fns.reduce(function (prev, fn) { return fn(prev); }, input);
    };
}
exports.pipeFromArray = pipeFromArray;
//# sourceMappingURL=pipe.js.map

/***/ }),

/***/ "./node_modules/rxjs/util/root.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {
// CommonJS / Node have global context exposed as "global" variable.
// We don't want to include the whole node.d.ts this this compilation unit so we'll just fake
// the global "global" var for now.
var __window = typeof window !== 'undefined' && window;
var __self = typeof self !== 'undefined' && typeof WorkerGlobalScope !== 'undefined' &&
    self instanceof WorkerGlobalScope && self;
var __global = typeof global !== 'undefined' && global;
var _root = __window || __global || __self;
exports.root = _root;
// Workaround Closure Compiler restriction: The body of a goog.module cannot use throw.
// This is needed when used with angular/tsickle which inserts a goog.module statement.
// Wrap in IIFE
(function () {
    if (!_root) {
        throw new Error('RxJS could not find any global context (window, self, global)');
    }
})();
//# sourceMappingURL=root.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/rxjs/util/toSubscriber.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Subscriber_1 = __webpack_require__("./node_modules/rxjs/Subscriber.js");
var rxSubscriber_1 = __webpack_require__("./node_modules/rxjs/symbol/rxSubscriber.js");
var Observer_1 = __webpack_require__("./node_modules/rxjs/Observer.js");
function toSubscriber(nextOrObserver, error, complete) {
    if (nextOrObserver) {
        if (nextOrObserver instanceof Subscriber_1.Subscriber) {
            return nextOrObserver;
        }
        if (nextOrObserver[rxSubscriber_1.rxSubscriber]) {
            return nextOrObserver[rxSubscriber_1.rxSubscriber]();
        }
    }
    if (!nextOrObserver && !error && !complete) {
        return new Subscriber_1.Subscriber(Observer_1.empty);
    }
    return new Subscriber_1.Subscriber(nextOrObserver, error, complete);
}
exports.toSubscriber = toSubscriber;
//# sourceMappingURL=toSubscriber.js.map

/***/ }),

/***/ "./node_modules/rxjs/util/tryCatch.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var errorObject_1 = __webpack_require__("./node_modules/rxjs/util/errorObject.js");
var tryCatchTarget;
function tryCatcher() {
    try {
        return tryCatchTarget.apply(this, arguments);
    }
    catch (e) {
        errorObject_1.errorObject.e = e;
        return errorObject_1.errorObject;
    }
}
function tryCatch(fn) {
    tryCatchTarget = fn;
    return tryCatcher;
}
exports.tryCatch = tryCatch;
;
//# sourceMappingURL=tryCatch.js.map

/***/ }),

/***/ "./node_modules/webpack/buildin/global.js":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "./node_modules/webpack/buildin/harmony-module.js":
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ "./src/authentication/authenticator.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Authenticator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__endpoint_manager__ = __webpack_require__("./src/authentication/endpoint.manager.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__token_manager__ = __webpack_require__("./src/authentication/token.manager.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_dialog__ = __webpack_require__("./src/helpers/dialog.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__errors_custom_error__ = __webpack_require__("./src/errors/custom.error.ts");
// Copyright (c) Microsoft. All rights reserved. Licensed under the MIT license.
var __extends = this && this.__extends || function () {
    var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = this && this.__generator || function (thisArg, body) {
    var _ = { label: 0, sent: function sent() {
            if (t[0] & 1) throw t[1];return t[1];
        }, trys: [], ops: [] },
        f,
        y,
        t,
        g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
        return this;
    }), g;
    function verb(n) {
        return function (v) {
            return step([n, v]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) {
            try {
                if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [0, t.value];
                switch (op[0]) {
                    case 0:case 1:
                        t = op;break;
                    case 4:
                        _.label++;return { value: op[1], done: false };
                    case 5:
                        _.label++;y = op[1];op = [0];continue;
                    case 7:
                        op = _.ops.pop();_.trys.pop();continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];t = op;break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];_.ops.push(op);break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [6, e];y = 0;
            } finally {
                f = t = 0;
            }
        }if (op[0] & 5) throw op[1];return { value: op[0] ? op[1] : void 0, done: true };
    }
};




/**
 * Custom error type to handle OAuth specific errors.
 */
var AuthError = /** @class */function (_super) {
    __extends(AuthError, _super);
    /**
     * @constructor
     *
     * @param message Error message to be propagated.
     * @param state OAuth state if available.
    */
    function AuthError(message, innerError) {
        var _this = _super.call(this, 'AuthError', message, innerError) || this;
        _this.innerError = innerError;
        return _this;
    }
    return AuthError;
}(__WEBPACK_IMPORTED_MODULE_3__errors_custom_error__["a" /* CustomError */]);

/**
 * Helper for performing Implicit OAuth Authentication with registered endpoints.
 */
var Authenticator = /** @class */function () {
    /**
     * @constructor
     *
     * @param endpoints Depends on an instance of EndpointStorage.
     * @param tokens Depends on an instance of TokenStorage.
    */
    function Authenticator(endpoints, tokens) {
        this.endpoints = endpoints;
        this.tokens = tokens;
        if (endpoints == null) {
            this.endpoints = new __WEBPACK_IMPORTED_MODULE_0__endpoint_manager__["b" /* EndpointStorage */]();
        }
        if (tokens == null) {
            this.tokens = new __WEBPACK_IMPORTED_MODULE_1__token_manager__["a" /* TokenStorage */]();
        }
    }
    /**
     * Authenticate based on the given provider.
     * Either uses DialogAPI or Window Popups based on where its being called from either Add-in or Web.
     * If the token was cached, the it retrieves the cached token.
     * If the cached token has expired then the authentication dialog is displayed.
     *
     * NOTE: you have to manually check the expires_in or expires_at property to determine
     * if the token has expired.
     *
     * @param {string} provider Link to the provider.
     * @param {boolean} force Force re-authentication.
     * @return {Promise<IToken|ICode>} Returns a promise of the token or code or error.
     */
    Authenticator.prototype.authenticate = function (provider, force, useMicrosoftTeams) {
        if (force === void 0) {
            force = false;
        }
        if (useMicrosoftTeams === void 0) {
            useMicrosoftTeams = false;
        }
        var token = this.tokens.get(provider);
        var hasTokenExpired = __WEBPACK_IMPORTED_MODULE_1__token_manager__["a" /* TokenStorage */].hasExpired(token);
        if (!hasTokenExpired && !force) {
            return Promise.resolve(token);
        }
        return this._openAuthDialog(provider, useMicrosoftTeams);
    };
    /**
     * Check if the currrent url is running inside of a Dialog that contains an access_token or code or error.
     * If true then it calls messageParent by extracting the token information, thereby closing the dialog.
     * Otherwise, the caller should proceed with normal initialization of their application.
     *
     * This logic assumes that the redirect url is your application and hence when your code runs again in
     * the dialog, this logic takes over and closes it for you.
     *
     * @return {boolean}
     * Returns false if the code is running inside of a dialog without the required information
     * or is not running inside of a dialog at all.
     */
    Authenticator.isAuthDialog = function (useMicrosoftTeams) {
        if (useMicrosoftTeams === void 0) {
            useMicrosoftTeams = false;
        }
        // If the url doesn't contain and access_token, code or error then return false.
        // This is in scenarios where we don't want to automatically control what happens to the dialog.
        if (!/(access_token|code|error|state)/gi.test(location.href)) {
            return false;
        }
        __WEBPACK_IMPORTED_MODULE_2__helpers_dialog__["a" /* Dialog */].close(location.href, useMicrosoftTeams);
        return true;
    };
    /**
     * Extract the token from the URL
     *
     * @param {string} url The url to extract the token from.
     * @param {string} exclude Exclude a particlaur string from the url, such as a query param or specific substring.
     * @param {string} delimiter[optional] Delimiter used by OAuth provider to mark the beginning of token response. Defaults to #.
     * @return {object} Returns the extracted token.
     */
    Authenticator.getUrlParams = function (url, exclude, delimiter) {
        if (url === void 0) {
            url = location.href;
        }
        if (exclude === void 0) {
            exclude = location.origin;
        }
        if (delimiter === void 0) {
            delimiter = '#';
        }
        if (exclude) {
            url = url.replace(exclude, '');
        }
        var _a = url.split(delimiter),
            left = _a[0],
            right = _a[1];
        var tokenString = right == null ? left : right;
        if (tokenString.indexOf('?') !== -1) {
            tokenString = tokenString.split('?')[1];
        }
        return Authenticator.extractParams(tokenString);
    };
    Authenticator.extractParams = function (segment) {
        if (segment == null || segment.trim() === '') {
            return null;
        }
        var params = {};
        var regex = /([^&=]+)=([^&]*)/g;
        var matchParts;
        while ((matchParts = regex.exec(segment)) !== null) {
            // Fixes bugs when the state parameters contains a / before them
            if (matchParts[1] === '/state') {
                matchParts[1] = matchParts[1].replace('/', '');
            }
            params[decodeURIComponent(matchParts[1])] = decodeURIComponent(matchParts[2]);
        }
        return params;
    };
    Authenticator.prototype._openAuthDialog = function (provider, useMicrosoftTeams) {
        return __awaiter(this, void 0, void 0, function () {
            var endpoint, _a, state, url, redirectUrl;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        endpoint = this.endpoints.get(provider);
                        if (endpoint == null) {
                            return [2 /*return*/, Promise.reject(new AuthError("No such registered endpoint: " + provider + " could be found."))];
                        }
                        _a = __WEBPACK_IMPORTED_MODULE_0__endpoint_manager__["b" /* EndpointStorage */].getLoginParams(endpoint), state = _a.state, url = _a.url;
                        return [4 /*yield*/, new __WEBPACK_IMPORTED_MODULE_2__helpers_dialog__["a" /* Dialog */](url, 1024, 768, useMicrosoftTeams).result];
                    case 1:
                        redirectUrl = _b.sent();
                        // Try and extract the result and pass it along.
                        return [2 /*return*/, this._handleTokenResult(redirectUrl, endpoint, state)];
                }
            });
        });
    };
    /**
     * Helper for exchanging the code with a registered Endpoint.
     * The helper sends a POST request to the given Endpoint's tokenUrl.
     *
     * The Endpoint must accept the data JSON input and return an 'access_token'
     * in the JSON output.
     *
     * @param {Endpoint} endpoint Endpoint configuration.
     * @param {object} data Data to be sent to the tokenUrl.
     * @param {object} headers Headers to be sent to the tokenUrl.     *
     * @return {Promise<IToken>} Returns a promise of the token or error.
     */
    Authenticator.prototype._exchangeCodeForToken = function (endpoint, data, headers) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (endpoint.tokenUrl == null) {
                console.warn('We couldn\'t exchange the received code for an access_token. The value returned is not an access_token. Please set the tokenUrl property or refer to our docs.');
                return resolve(data);
            }
            var xhr = new XMLHttpRequest();
            xhr.open('POST', endpoint.tokenUrl);
            xhr.setRequestHeader('Accept', 'application/json');
            xhr.setRequestHeader('Content-Type', 'application/json');
            for (var header in headers) {
                if (header === 'Accept' || header === 'Content-Type') {
                    continue;
                }
                xhr.setRequestHeader(header, headers[header]);
            }
            xhr.onerror = function () {
                return reject(new AuthError('Unable to send request due to a Network error'));
            };
            xhr.onload = function () {
                try {
                    if (xhr.status === 200) {
                        var json = JSON.parse(xhr.responseText);
                        if (json == null) {
                            return reject(new AuthError('No access_token or code could be parsed.'));
                        } else if ('access_token' in json) {
                            _this.tokens.add(endpoint.provider, json);
                            return resolve(json);
                        } else {
                            return reject(new AuthError(json.error, json.state));
                        }
                    } else if (xhr.status !== 200) {
                        return reject(new AuthError('Request failed. ' + xhr.response));
                    }
                } catch (e) {
                    return reject(new AuthError('An error occured while parsing the response'));
                }
            };
            xhr.send(JSON.stringify(data));
        });
    };
    Authenticator.prototype._handleTokenResult = function (redirectUrl, endpoint, state) {
        var result = Authenticator.getUrlParams(redirectUrl, endpoint.redirectUrl);
        if (result == null) {
            throw new AuthError('No access_token or code could be parsed.');
        } else if (endpoint.state && +result.state !== state) {
            throw new AuthError('State couldn\'t be verified');
        } else if ('code' in result) {
            return this._exchangeCodeForToken(endpoint, result);
        } else if ('access_token' in result) {
            return this.tokens.add(endpoint.provider, result);
        } else {
            throw new AuthError(result.error);
        }
    };
    return Authenticator;
}();


/***/ }),

/***/ "./src/authentication/endpoint.manager.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DefaultEndpoints; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EndpointStorage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_utilities__ = __webpack_require__("./src/helpers/utilities.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_storage__ = __webpack_require__("./src/helpers/storage.ts");
var __extends = this && this.__extends || function () {
    var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var __assign = this && this.__assign || Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
    }
    return t;
};
// Copyright (c) Microsoft. All rights reserved. Licensed under the MIT license.


var DefaultEndpoints = {
    Google: 'Google',
    Microsoft: 'Microsoft',
    Facebook: 'Facebook',
    AzureAD: 'AzureAD',
    Dropbox: 'Dropbox'
};
/**
 * Helper for creating and registering OAuth Endpoints.
 */
var EndpointStorage = /** @class */function (_super) {
    __extends(EndpointStorage, _super);
    /**
     * @constructor
    */
    function EndpointStorage(storageType) {
        if (storageType === void 0) {
            storageType = __WEBPACK_IMPORTED_MODULE_1__helpers_storage__["b" /* StorageType */].LocalStorage;
        }
        return _super.call(this, 'OAuth2Endpoints', storageType) || this;
    }
    /**
     * Extends Storage's default add method.
     * Registers a new OAuth Endpoint.
     *
     * @param {string} provider Unique name for the registered OAuth Endpoint.
     * @param {object} config Valid Endpoint configuration.
     * @see {@link IEndpointConfiguration}.
     * @return {object} Returns the added endpoint.
     */
    EndpointStorage.prototype.add = function (provider, config) {
        if (config.redirectUrl == null) {
            config.redirectUrl = window.location.origin;
        }
        config.provider = provider;
        return _super.prototype.set.call(this, provider, config);
    };
    /**
     * Register Google Implicit OAuth.
     * If overrides is left empty, the default scope is limited to basic profile information.
     *
     * @param {string} clientId ClientID for the Google App.
     * @param {object} config Valid Endpoint configuration to override the defaults.
     * @return {object} Returns the added endpoint.
     */
    EndpointStorage.prototype.registerGoogleAuth = function (clientId, overrides) {
        var defaults = {
            clientId: clientId,
            baseUrl: 'https://accounts.google.com',
            authorizeUrl: '/o/oauth2/v2/auth',
            resource: 'https://www.googleapis.com',
            responseType: 'token',
            scope: 'https://www.googleapis.com/auth/plus.me',
            state: true
        };
        var config = __assign({}, defaults, overrides);
        return this.add(DefaultEndpoints.Google, config);
    };
    /**
     * Register Microsoft Implicit OAuth.
     * If overrides is left empty, the default scope is limited to basic profile information.
     *
     * @param {string} clientId ClientID for the Microsoft App.
     * @param {object} config Valid Endpoint configuration to override the defaults.
     * @return {object} Returns the added endpoint.
     */
    EndpointStorage.prototype.registerMicrosoftAuth = function (clientId, overrides) {
        var defaults = {
            clientId: clientId,
            baseUrl: 'https://login.microsoftonline.com/common/oauth2/v2.0',
            authorizeUrl: '/authorize',
            responseType: 'token',
            scope: 'https://graph.microsoft.com/user.read',
            extraQueryParameters: {
                response_mode: 'fragment'
            },
            nonce: true,
            state: true
        };
        var config = __assign({}, defaults, overrides);
        this.add(DefaultEndpoints.Microsoft, config);
    };
    /**
     * Register Facebook Implicit OAuth.
     * If overrides is left empty, the default scope is limited to basic profile information.
     *
     * @param {string} clientId ClientID for the Facebook App.
     * @param {object} config Valid Endpoint configuration to override the defaults.
     * @return {object} Returns the added endpoint.
     */
    EndpointStorage.prototype.registerFacebookAuth = function (clientId, overrides) {
        var defaults = {
            clientId: clientId,
            baseUrl: 'https://www.facebook.com',
            authorizeUrl: '/dialog/oauth',
            resource: 'https://graph.facebook.com',
            responseType: 'token',
            scope: 'public_profile',
            nonce: true,
            state: true
        };
        var config = __assign({}, defaults, overrides);
        this.add(DefaultEndpoints.Facebook, config);
    };
    /**
     * Register AzureAD Implicit OAuth.
     * If overrides is left empty, the default scope is limited to basic profile information.
     *
     * @param {string} clientId ClientID for the AzureAD App.
     * @param {string} tenant Tenant for the AzureAD App.
     * @param {object} config Valid Endpoint configuration to override the defaults.
     * @return {object} Returns the added endpoint.
     */
    EndpointStorage.prototype.registerAzureADAuth = function (clientId, tenant, overrides) {
        var defaults = {
            clientId: clientId,
            baseUrl: "https://login.windows.net/" + tenant,
            authorizeUrl: '/oauth2/authorize',
            resource: 'https://graph.microsoft.com',
            responseType: 'token',
            nonce: true,
            state: true
        };
        var config = __assign({}, defaults, overrides);
        this.add(DefaultEndpoints.AzureAD, config);
    };
    /**
     * Register Dropbox Implicit OAuth.
     * If overrides is left empty, the default scope is limited to basic profile information.
     *
     * @param {string} clientId ClientID for the Dropbox App.
     * @param {object} config Valid Endpoint configuration to override the defaults.
     * @return {object} Returns the added endpoint.
     */
    EndpointStorage.prototype.registerDropboxAuth = function (clientId, overrides) {
        var defaults = {
            clientId: clientId,
            baseUrl: "https://www.dropbox.com/1",
            authorizeUrl: '/oauth2/authorize',
            responseType: 'token',
            state: true
        };
        var config = __assign({}, defaults, overrides);
        this.add(DefaultEndpoints.Dropbox, config);
    };
    /**
     * Helper to generate the OAuth login url.
     *
     * @param {object} config Valid Endpoint configuration.
     * @return {object} Returns the added endpoint.
     */
    EndpointStorage.getLoginParams = function (endpointConfig) {
        var scope = endpointConfig.scope ? encodeURIComponent(endpointConfig.scope) : null;
        var resource = endpointConfig.resource ? encodeURIComponent(endpointConfig.resource) : null;
        var state = endpointConfig.state && __WEBPACK_IMPORTED_MODULE_0__helpers_utilities__["c" /* Utilities */].generateCryptoSafeRandom();
        var nonce = endpointConfig.nonce && __WEBPACK_IMPORTED_MODULE_0__helpers_utilities__["c" /* Utilities */].generateCryptoSafeRandom();
        var urlSegments = ["response_type=" + endpointConfig.responseType, "client_id=" + encodeURIComponent(endpointConfig.clientId), "redirect_uri=" + encodeURIComponent(endpointConfig.redirectUrl)];
        if (scope) {
            urlSegments.push("scope=" + scope);
        }
        if (resource) {
            urlSegments.push("resource=" + resource);
        }
        if (state) {
            urlSegments.push("state=" + state);
        }
        if (nonce) {
            urlSegments.push("nonce=" + nonce);
        }
        if (endpointConfig.extraQueryParameters) {
            for (var _i = 0, _a = Object.keys(endpointConfig.extraQueryParameters); _i < _a.length; _i++) {
                var param = _a[_i];
                urlSegments.push(param + "=" + encodeURIComponent(endpointConfig.extraQueryParameters[param]));
            }
        }
        return {
            url: "" + endpointConfig.baseUrl + endpointConfig.authorizeUrl + "?" + urlSegments.join('&'),
            state: state
        };
    };
    return EndpointStorage;
}(__WEBPACK_IMPORTED_MODULE_1__helpers_storage__["a" /* Storage */]);


/***/ }),

/***/ "./src/authentication/token.manager.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TokenStorage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_storage__ = __webpack_require__("./src/helpers/storage.ts");
// Copyright (c) Microsoft. All rights reserved. Licensed under the MIT license.
var __extends = this && this.__extends || function () {
    var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();

/**
 * Helper for caching and managing OAuth Tokens.
 */
var TokenStorage = /** @class */function (_super) {
    __extends(TokenStorage, _super);
    /**
     * @constructor
    */
    function TokenStorage(storageType) {
        if (storageType === void 0) {
            storageType = __WEBPACK_IMPORTED_MODULE_0__helpers_storage__["b" /* StorageType */].LocalStorage;
        }
        return _super.call(this, 'OAuth2Tokens', storageType) || this;
    }
    /**
     * Compute the expiration date based on the expires_in field in a OAuth token.
     */
    TokenStorage.setExpiry = function (token) {
        var expire = function expire(seconds) {
            return seconds == null ? null : new Date(new Date().getTime() + ~~seconds * 1000);
        };
        if (!(token == null) && token.expires_at == null) {
            token.expires_at = expire(token.expires_in);
        }
    };
    /**
     * Check if an OAuth token has expired.
     */
    TokenStorage.hasExpired = function (token) {
        if (token == null) {
            return true;
        }
        if (token.expires_at == null) {
            return false;
        } else {
            // If the token was stored, it's Date type property was stringified, so it needs to be converted back to Date.
            token.expires_at = token.expires_at instanceof Date ? token.expires_at : new Date(token.expires_at);
            return token.expires_at.getTime() - new Date().getTime() < 0;
        }
    };
    /**
     * Extends Storage's default get method
     * Gets an OAuth Token after checking its expiry
     *
     * @param {string} provider Unique name of the corresponding OAuth Token.
     * @return {object} Returns the token or null if its either expired or doesn't exist.
     */
    TokenStorage.prototype.get = function (provider) {
        var token = _super.prototype.get.call(this, provider);
        if (token == null) {
            return token;
        }
        var expired = TokenStorage.hasExpired(token);
        if (expired) {
            _super.prototype.delete.call(this, provider);
            return null;
        } else {
            return token;
        }
    };
    /**
     * Extends Storage's default add method
     * Adds a new OAuth Token after settings its expiry
     *
     * @param {string} provider Unique name of the corresponding OAuth Token.
     * @param {object} config valid Token
     * @see {@link IToken}.
     * @return {object} Returns the added token.
     */
    TokenStorage.prototype.add = function (provider, value) {
        value.provider = provider;
        TokenStorage.setExpiry(value);
        return _super.prototype.set.call(this, provider, value);
    };
    return TokenStorage;
}(__WEBPACK_IMPORTED_MODULE_0__helpers_storage__["a" /* Storage */]);


/***/ }),

/***/ "./src/errors/api.error.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return APIError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__custom_error__ = __webpack_require__("./src/errors/custom.error.ts");
// Copyright (c) Microsoft. All rights reserved. Licensed under the MIT license.
var __extends = this && this.__extends || function () {
    var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();

/**
 * Custom error type to handle API specific errors.
 */
var APIError = /** @class */function (_super) {
    __extends(APIError, _super);
    /**
     * @constructor
     *
     * @param message: Error message to be propagated.
     * @param innerError: Inner error if any
    */
    function APIError(message, innerError) {
        var _this = _super.call(this, 'APIError', message, innerError) || this;
        _this.innerError = innerError;
        return _this;
    }
    return APIError;
}(__WEBPACK_IMPORTED_MODULE_0__custom_error__["a" /* CustomError */]);


/***/ }),

/***/ "./src/errors/custom.error.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CustomError; });
// Copyright (c) Microsoft. All rights reserved. Licensed under the MIT license.
var __extends = this && this.__extends || function () {
    var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Custom error type
 */
var CustomError = /** @class */function (_super) {
    __extends(CustomError, _super);
    function CustomError(name, message, innerError) {
        var _this = _super.call(this, message) || this;
        _this.name = name;
        _this.message = message;
        _this.innerError = innerError;
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_this, _this.constructor);
        } else {
            var error = new Error();
            if (error.stack) {
                var last_part = error.stack.match(/[^\s]+$/);
                _this.stack = _this.name + " at " + last_part;
            }
        }
        return _this;
    }
    return CustomError;
}(Error);


/***/ }),

/***/ "./src/errors/exception.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Exception; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__custom_error__ = __webpack_require__("./src/errors/custom.error.ts");
var __extends = this && this.__extends || function () {
    var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();

/**
 * Error type to handle general errors.
 */
var Exception = /** @class */function (_super) {
    __extends(Exception, _super);
    /**
     * @constructor
     *
     * @param message: Error message to be propagated.
     * @param innerError: Inner error if any
    */
    function Exception(message, innerError) {
        var _this = _super.call(this, 'Exception', message, innerError) || this;
        _this.innerError = innerError;
        return _this;
    }
    return Exception;
}(__WEBPACK_IMPORTED_MODULE_0__custom_error__["a" /* CustomError */]);


/***/ }),

/***/ "./src/excel/utilities.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExcelUtilities; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__errors_api_error__ = __webpack_require__("./src/errors/api.error.ts");
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// Copyright (c) Microsoft. All rights reserved. Licensed under the MIT license.
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = this && this.__generator || function (thisArg, body) {
    var _ = { label: 0, sent: function sent() {
            if (t[0] & 1) throw t[1];return t[1];
        }, trys: [], ops: [] },
        f,
        y,
        t,
        g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
        return this;
    }), g;
    function verb(n) {
        return function (v) {
            return step([n, v]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) {
            try {
                if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [0, t.value];
                switch (op[0]) {
                    case 0:case 1:
                        t = op;break;
                    case 4:
                        _.label++;return { value: op[1], done: false };
                    case 5:
                        _.label++;y = op[1];op = [0];continue;
                    case 7:
                        op = _.ops.pop();_.trys.pop();continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];t = op;break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];_.ops.push(op);break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [6, e];y = 0;
            } finally {
                f = t = 0;
            }
        }if (op[0] & 5) throw op[1];return { value: op[0] ? op[1] : void 0, done: true };
    }
};

/**
 * Helper exposing useful Utilities for Excel Add-ins.
 */
var ExcelUtilities = /** @class */function () {
    function ExcelUtilities() {}
    /**
     * Utility to create (or re-create) a worksheet, even if it already exists.
     * @param workbook
     * @param sheetName
     * @param clearOnly If the sheet already exists, keep it as is, and only clear its grid.
     * This results in a faster operation, and avoid a screen-update flash
     * (and the re-setting of the current selection).
     * Note: Clearing the grid does not remove floating objects like charts.
     * @returns the new worksheet
     */
    ExcelUtilities.forceCreateSheet = function (workbook, sheetName, clearOnly) {
        return __awaiter(this, void 0, void 0, function () {
            var sheet;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (workbook == null && (typeof workbook === "undefined" ? "undefined" : _typeof(workbook)) !== _typeof(Excel.Workbook)) {
                            throw new __WEBPACK_IMPORTED_MODULE_0__errors_api_error__["a" /* APIError */]('Invalid workbook parameter.');
                        }
                        if (sheetName == null || sheetName.trim() === '') {
                            throw new __WEBPACK_IMPORTED_MODULE_0__errors_api_error__["a" /* APIError */]('Sheet name cannot be blank.');
                        }
                        if (sheetName.length > 31) {
                            throw new __WEBPACK_IMPORTED_MODULE_0__errors_api_error__["a" /* APIError */]('Sheet name cannot be greater than 31 characters.');
                        }
                        if (!clearOnly) return [3 /*break*/, 2];
                        return [4 /*yield*/, createOrClear(workbook.context, workbook, sheetName)];
                    case 1:
                        sheet = _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        return [4 /*yield*/, recreateFromScratch(workbook.context, workbook, sheetName)];
                    case 3:
                        sheet = _a.sent();
                        _a.label = 4;
                    case 4:
                        // To work around an issue with Office Online (tracked by the API team), it is
                        // currently necessary to do a `context.sync()` before any call to `sheet.activate()`.
                        // So to be safe, in case the caller of this helper method decides to immediately
                        // turn around and call `sheet.activate()`, call `sync` before returning the sheet.
                        return [4 /*yield*/, workbook.context.sync()];
                    case 5:
                        // To work around an issue with Office Online (tracked by the API team), it is
                        // currently necessary to do a `context.sync()` before any call to `sheet.activate()`.
                        // So to be safe, in case the caller of this helper method decides to immediately
                        // turn around and call `sheet.activate()`, call `sync` before returning the sheet.
                        _a.sent();
                        return [2 /*return*/, sheet];
                }
            });
        });
    };
    return ExcelUtilities;
}();

/**
 * Helpers
 */
function createOrClear(context, workbook, sheetName) {
    return __awaiter(this, void 0, void 0, function () {
        var existingSheet, oldSheet, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!Office.context.requirements.isSetSupported('ExcelApi', 1.4)) return [3 /*break*/, 2];
                    existingSheet = context.workbook.worksheets.getItemOrNullObject(sheetName);
                    return [4 /*yield*/, context.sync()];
                case 1:
                    _a.sent();
                    if (existingSheet.isNullObject) {
                        return [2 /*return*/, context.workbook.worksheets.add(sheetName)];
                    } else {
                        existingSheet.getRange().clear();
                        return [2 /*return*/, existingSheet];
                    }
                    return [3 /*break*/, 7];
                case 2:
                    // Flush anything already in the queue, so as to scope the error handling logic below.
                    return [4 /*yield*/, context.sync()];
                case 3:
                    // Flush anything already in the queue, so as to scope the error handling logic below.
                    _a.sent();
                    _a.label = 4;
                case 4:
                    _a.trys.push([4, 6,, 7]);
                    oldSheet = workbook.worksheets.getItem(sheetName);
                    oldSheet.getRange().clear();
                    return [4 /*yield*/, context.sync()];
                case 5:
                    _a.sent();
                    return [2 /*return*/, oldSheet];
                case 6:
                    error_1 = _a.sent();
                    if (error_1 instanceof OfficeExtension.Error && error_1.code === Excel.ErrorCodes.itemNotFound) {
                        // This is an expected case where the sheet didn't exist. Create it now.
                        return [2 /*return*/, workbook.worksheets.add(sheetName)];
                    } else {
                        throw new __WEBPACK_IMPORTED_MODULE_0__errors_api_error__["a" /* APIError */]('Unexpected error while trying to delete sheet.', error_1);
                    }
                    return [3 /*break*/, 7];
                case 7:
                    return [2 /*return*/];
            }
        });
    });
}
function recreateFromScratch(context, workbook, sheetName) {
    return __awaiter(this, void 0, void 0, function () {
        var newSheet, oldSheet, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    newSheet = workbook.worksheets.add();
                    if (!Office.context.requirements.isSetSupported('ExcelApi', 1.4)) return [3 /*break*/, 1];
                    context.workbook.worksheets.getItemOrNullObject(sheetName).delete();
                    return [3 /*break*/, 6];
                case 1:
                    // Flush anything already in the queue, so as to scope the error handling logic below.
                    return [4 /*yield*/, context.sync()];
                case 2:
                    // Flush anything already in the queue, so as to scope the error handling logic below.
                    _a.sent();
                    _a.label = 3;
                case 3:
                    _a.trys.push([3, 5,, 6]);
                    oldSheet = workbook.worksheets.getItem(sheetName);
                    oldSheet.delete();
                    return [4 /*yield*/, context.sync()];
                case 4:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 5:
                    error_2 = _a.sent();
                    if (error_2 instanceof OfficeExtension.Error && error_2.code === Excel.ErrorCodes.itemNotFound) {
                        // This is an expected case where the sheet didn't exist. Hence no-op.
                    } else {
                        throw new __WEBPACK_IMPORTED_MODULE_0__errors_api_error__["a" /* APIError */]('Unexpected error while trying to delete sheet.', error_2);
                    }
                    return [3 /*break*/, 6];
                case 6:
                    newSheet.name = sheetName;
                    return [2 /*return*/, newSheet];
            }
        });
    });
}

/***/ }),

/***/ "./src/helpers/dialog.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DialogError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dialog; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities__ = __webpack_require__("./src/helpers/utilities.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__errors_custom_error__ = __webpack_require__("./src/errors/custom.error.ts");
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// Copyright (c) Microsoft. All rights reserved. Licensed under the MIT license.
var __extends = this && this.__extends || function () {
    var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();


/**
 * Custom error type to handle API specific errors.
 */
var DialogError = /** @class */function (_super) {
    __extends(DialogError, _super);
    /**
     * @constructor
     *
     * @param message Error message to be propagated.
     * @param state OAuth state if available.
    */
    function DialogError(message, innerError) {
        var _this = _super.call(this, 'DialogError', message, innerError) || this;
        _this.innerError = innerError;
        return _this;
    }
    return DialogError;
}(__WEBPACK_IMPORTED_MODULE_1__errors_custom_error__["a" /* CustomError */]);

var Dialog = /** @class */function () {
    /**
     * @constructor
     *
     * @param url Url to be opened in the dialog.
     * @param width Width of the dialog.
     * @param height Height of the dialog.
    */
    function Dialog(url, width, height, useTeamsDialog) {
        if (url === void 0) {
            url = location.origin;
        }
        if (width === void 0) {
            width = 1024;
        }
        if (height === void 0) {
            height = 768;
        }
        if (useTeamsDialog === void 0) {
            useTeamsDialog = false;
        }
        this.url = url;
        this.useTeamsDialog = useTeamsDialog;
        this._windowFeatures = ',menubar=no,toolbar=no,location=no,resizable=yes,scrollbars=yes,status=no';
        if (!/^https/.test(url)) {
            throw new DialogError('URL has to be loaded over HTTPS.');
        }
        this.size = this._optimizeSize(width, height);
    }
    Object.defineProperty(Dialog.prototype, "result", {
        get: function get() {
            if (this._result == null) {
                if (this.useTeamsDialog) {
                    this._result = this._teamsDialog();
                } else if (__WEBPACK_IMPORTED_MODULE_0__utilities__["c" /* Utilities */].isAddin) {
                    this._result = this._addinDialog();
                } else {
                    this._result = this._webDialog();
                }
            }
            return this._result;
        },
        enumerable: true,
        configurable: true
    });
    Dialog.prototype._addinDialog = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            Office.context.ui.displayDialogAsync(_this.url, { width: _this.size.width$, height: _this.size.height$ }, function (result) {
                if (result.status === Office.AsyncResultStatus.Failed) {
                    reject(new DialogError(result.error.message, result.error));
                } else {
                    var dialog_1 = result.value;
                    dialog_1.addEventHandler(Office.EventType.DialogMessageReceived, function (args) {
                        var result = _this._safeParse(args.message);
                        resolve(result);
                        dialog_1.close();
                    });
                    dialog_1.addEventHandler(Office.EventType.DialogEventReceived, function (args) {
                        reject(new DialogError(args.message, args.error));
                        dialog_1.close();
                    });
                }
            });
        });
    };
    Dialog.prototype._teamsDialog = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            microsoftTeams.initialize();
            microsoftTeams.authentication.authenticate({
                url: _this.url,
                width: _this.size.width,
                height: _this.size.height,
                failureCallback: function failureCallback(exception) {
                    return reject(new DialogError('Error while launching dialog', exception));
                },
                successCallback: function successCallback(message) {
                    return resolve(_this._safeParse(message));
                }
            });
        });
    };
    Dialog.prototype._webDialog = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            try {
                var options = 'width=' + _this.size.width + ',height=' + _this.size.height + _this._windowFeatures;
                window.open(_this.url, _this.url, options);
                if (__WEBPACK_IMPORTED_MODULE_0__utilities__["c" /* Utilities */].isIEOrEdge) {
                    _this._pollLocalStorageForToken(resolve, reject);
                } else {
                    var handler_1 = function handler_1(event) {
                        if (event.origin === location.origin) {
                            window.removeEventListener('message', handler_1, false);
                            resolve(_this._safeParse(event.data));
                        }
                    };
                    window.addEventListener('message', handler_1);
                }
            } catch (exception) {
                return reject(new DialogError('Unexpected error occured while creating popup', exception));
            }
        });
    };
    Dialog.prototype._pollLocalStorageForToken = function (resolve, reject) {
        var _this = this;
        localStorage.removeItem(Dialog.key);
        var POLL_INTERVAL = 400;
        var interval = setInterval(function () {
            try {
                var data = localStorage.getItem(Dialog.key);
                if (!(data == null)) {
                    clearInterval(interval);
                    localStorage.removeItem(Dialog.key);
                    return resolve(_this._safeParse(data));
                }
            } catch (exception) {
                clearInterval(interval);
                localStorage.removeItem(Dialog.key);
                return reject(new DialogError('Unexpected error occured in the dialog', exception));
            }
        }, POLL_INTERVAL);
    };
    /**
     * Close any open dialog by providing an optional message.
     * If more than one dialogs are attempted to be opened
     * an expcetion will be created.
     */
    Dialog.close = function (message, useTeamsDialog) {
        if (useTeamsDialog === void 0) {
            useTeamsDialog = false;
        }
        var parse = false;
        var value = message;
        if (typeof message === 'function') {
            throw new DialogError('Invalid message. Cannot pass functions as arguments');
        } else if (!(value == null) && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
            parse = true;
            value = JSON.stringify(value);
        }
        try {
            if (useTeamsDialog) {
                microsoftTeams.initialize();
                microsoftTeams.authentication.notifySuccess(JSON.stringify({ parse: parse, value: value }));
            } else if (__WEBPACK_IMPORTED_MODULE_0__utilities__["c" /* Utilities */].isAddin) {
                Office.context.ui.messageParent(JSON.stringify({ parse: parse, value: value }));
            } else {
                if (__WEBPACK_IMPORTED_MODULE_0__utilities__["c" /* Utilities */].isIEOrEdge) {
                    localStorage.setItem(Dialog.key, JSON.stringify({ parse: parse, value: value }));
                } else if (window.opener) {
                    window.opener.postMessage(JSON.stringify({ parse: parse, value: value }), location.origin);
                }
                window.close();
            }
        } catch (error) {
            throw new DialogError('Cannot close dialog', error);
        }
    };
    Dialog.prototype._optimizeSize = function (desiredWidth, desiredHeight) {
        var _a = window.screen,
            screenWidth = _a.width,
            screenHeight = _a.height;
        var width = this._maxSize(desiredWidth, screenWidth);
        var height = this._maxSize(desiredHeight, screenHeight);
        var width$ = this._percentage(width, screenWidth);
        var height$ = this._percentage(height, screenHeight);
        return { width$: width$, height$: height$, width: width, height: height };
    };
    Dialog.prototype._maxSize = function (value, max) {
        return value < max - 30 ? value : max - 30;
    };
    Dialog.prototype._percentage = function (value, max) {
        return value * 100 / max;
    };
    Dialog.prototype._safeParse = function (data) {
        try {
            var result = JSON.parse(data);
            if (result.parse === true) {
                return this._safeParse(result.value);
            }
            return result.value;
        } catch (_e) {
            return data;
        }
    };
    Dialog.key = 'VGVtcG9yYXJ5S2V5Rm9yT0pIQXV0aA==';
    return Dialog;
}();


/***/ }),

/***/ "./src/helpers/dictionary.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dictionary; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isEmpty__ = __webpack_require__("./node_modules/lodash-es/isEmpty.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isString__ = __webpack_require__("./node_modules/lodash-es/isString.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_isNil__ = __webpack_require__("./node_modules/lodash-es/isNil.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_isObject__ = __webpack_require__("./node_modules/lodash-es/isObject.js");



 // Copyright (c) Microsoft. All rights reserved. Licensed under the MIT license.

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Helper for creating and querying Dictionaries.
 * A wrapper around ES6 Maps.
 */
var Dictionary = /** @class */function () {
    /**
     * @constructor
     * @param {object} items Initial seed of items.
     */
    function Dictionary(items) {
        if (Object(__WEBPACK_IMPORTED_MODULE_2_lodash_es_isNil__["a" /* default */])(items)) {
            this._items = new Map();
        } else if (items instanceof Set) {
            throw new TypeError("Invalid type of argument: Set");
        } else if (items instanceof Map) {
            this._items = new Map(items);
        } else if (Array.isArray(items)) {
            this._items = new Map(items);
        } else if (Object(__WEBPACK_IMPORTED_MODULE_3_lodash_es_isObject__["a" /* default */])(items)) {
            this._items = new Map();
            for (var _i = 0, _a = Object.keys(items); _i < _a.length; _i++) {
                var key = _a[_i];
                this._items.set(key, items[key]);
            }
        } else {
            throw new TypeError("Invalid type of argument: " + (typeof items === "undefined" ? "undefined" : _typeof(items)));
        }
    }
    /**
     * Gets an item from the dictionary.
     *
     * @param {string} key The key of the item.
     * @return {object} Returns an item if found.
     */
    Dictionary.prototype.get = function (key) {
        return this._items.get(key);
    };
    /**
     * Inserts an item into the dictionary.
     * If an item already exists with the same key, it will be overridden by the new value.
     *
     * @param {string} key The key of the item.
     * @param {object} value The item to be added.
     * @return {object} Returns the added item.
     */
    Dictionary.prototype.set = function (key, value) {
        this._validateKey(key);
        this._items.set(key, value);
        return value;
    };
    /**
     * Removes an item from the dictionary.
     * Will throw if the key doesn't exist.
     *
     * @param {string} key The key of the item.
     * @return {object} Returns the deleted item.
     */
    Dictionary.prototype.delete = function (key) {
        if (!this.has(key)) {
            throw new ReferenceError("Key: " + key + " not found.");
        }
        var value = this._items.get(key);
        this._items.delete(key);
        return value;
    };
    /**
     * Clears the dictionary.
     */
    Dictionary.prototype.clear = function () {
        this._items.clear();
    };
    /**
     * Check if the dictionary contains the given key.
     *
     * @param {string} key The key of the item.
     * @return {boolean} Returns true if the key was found.
     */
    Dictionary.prototype.has = function (key) {
        this._validateKey(key);
        return this._items.has(key);
    };
    /**
     * Lists all the keys in the dictionary.
     *
     * @return {array} Returns all the keys.
     */
    Dictionary.prototype.keys = function () {
        return Array.from(this._items.keys());
    };
    /**
     * Lists all the values in the dictionary.
     *
     * @return {array} Returns all the values.
     */
    Dictionary.prototype.values = function () {
        return Array.from(this._items.values());
    };
    /**
     * Get a shallow copy of the underlying map.
     *
     * @return {object} Returns the shallow copy of the map.
     */
    Dictionary.prototype.clone = function () {
        return new Map(this._items);
    };
    Object.defineProperty(Dictionary.prototype, "count", {
        /**
         * Number of items in the dictionary.
         *
         * @return {number} Returns the number of items in the dictionary.
         */
        get: function get() {
            return this._items.size;
        },
        enumerable: true,
        configurable: true
    });
    Dictionary.prototype._validateKey = function (key) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isString__["a" /* default */])(key) || Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isEmpty__["a" /* default */])(key)) {
            throw new TypeError('Key needs to be a string');
        }
    };
    return Dictionary;
}();


/***/ }),

/***/ "./src/helpers/storage.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StorageType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Storage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isNil__ = __webpack_require__("./node_modules/lodash-es/isNil.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isString__ = __webpack_require__("./node_modules/lodash-es/isString.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_isEmpty__ = __webpack_require__("./node_modules/lodash-es/isEmpty.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_debounce__ = __webpack_require__("./node_modules/lodash-es/debounce.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_Observable__ = __webpack_require__("./node_modules/rxjs/Observable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__errors_exception__ = __webpack_require__("./src/errors/exception.ts");



 /* Copyright (c) Microsoft. All rights reserved. Licensed under the MIT license. */



var NOTIFICATION_DEBOUNCE = 300;
var DATE_REGEX = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z$/;
var StorageType;
(function (StorageType) {
    StorageType[StorageType["LocalStorage"] = 0] = "LocalStorage";
    StorageType[StorageType["SessionStorage"] = 1] = "SessionStorage";
    StorageType[StorageType["InMemoryStorage"] = 2] = "InMemoryStorage";
})(StorageType || (StorageType = {}));
/**
 * Helper for creating and querying Local Storage or Session Storage.
 * Uses {@link Dictionary} so all the data is encapsulated in a single
 * storage namespace. Writes update the actual storage.
 */
var Storage = /** @class */function () {
    /**
     * @constructor
     * @param {string} container Container name to be created in the LocalStorage.
     * @param {StorageType} type[optional] Storage Type to be used, defaults to Local Storage.
     */
    function Storage(container, _type) {
        if (_type === void 0) {
            _type = StorageType.LocalStorage;
        }
        this.container = container;
        this._type = _type;
        this._observable = null;
        this._containerRegex = null;
        this._validateKey(container);
        this._containerRegex = new RegExp("^@" + this.container + "/");
        this.switchStorage(this._type);
    }
    /**
     * Switch the storage type.
     * Switches the storage type and then reloads the in-memory collection.
     *
     * @type {StorageType} type The desired storage to be used.
     */
    Storage.prototype.switchStorage = function (type) {
        switch (type) {
            case StorageType.LocalStorage:
                this._storage = window.localStorage;
                break;
            case StorageType.SessionStorage:
                this._storage = window.sessionStorage;
                break;
            case StorageType.InMemoryStorage:
                this._storage = new InMemoryStorage();
                break;
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isNil__["a" /* default */])(this._storage)) {
            throw new __WEBPACK_IMPORTED_MODULE_5__errors_exception__["a" /* Exception */]('Browser local or session storage is not supported.');
        }
        if (!this._storage.hasOwnProperty(this.container)) {
            this._storage[this.container] = null;
        }
    };
    /**
     * Gets an item from the storage.
     *
     * @param {string} key The key of the item.
     * @return {object} Returns an item if found.
     */
    Storage.prototype.get = function (key) {
        var scopedKey = this._scope(key);
        var item = this._storage.getItem(scopedKey);
        try {
            return JSON.parse(item, this._reviver.bind(this));
        } catch (_error) {
            return item;
        }
    };
    /**
     * Inserts an item into the storage.
     * If an item already exists with the same key,
     * it will be overridden by the new value.
     *
     * @param {string} key The key of the item.
     * @param {object} value The item to be added.
     * @return {object} Returns the added item.
     */
    Storage.prototype.set = function (key, value) {
        this._validateKey(key);
        try {
            var scopedKey = this._scope(key);
            var item = JSON.stringify(value);
            this._storage.setItem(scopedKey, item);
            return value;
        } catch (error) {
            throw new __WEBPACK_IMPORTED_MODULE_5__errors_exception__["a" /* Exception */]("Unable to serialize value for: " + key + " ", error);
        }
    };
    /**
     * Removes an item from the storage.
     * Will throw if the key doesn't exist.
     *
     * @param {string} key The key of the item.
     * @return {object} Returns the deleted item.
     */
    Storage.prototype.delete = function (key) {
        try {
            var value = this.get(key);
            if (value === undefined) {
                throw new ReferenceError("Key: " + key + " not found.");
            }
            var scopedKey = this._scope(key);
            this._storage.removeItem(scopedKey);
            return value;
        } catch (error) {
            throw new __WEBPACK_IMPORTED_MODULE_5__errors_exception__["a" /* Exception */]("Unable to delete '" + key + "' from storage", error);
        }
    };
    /**
     * Clear the storage.
     */
    Storage.prototype.clear = function () {
        this._storage.removeItem(this.container);
    };
    /**
     * Check if the storage contains the given key.
     *
     * @param {string} key The key of the item.
     * @return {boolean} Returns true if the key was found.
     */
    Storage.prototype.has = function (key) {
        this._validateKey(key);
        return this.get(key) !== undefined;
    };
    /**
     * Lists all the keys in the storage.
     *
     * @return {array} Returns all the keys.
     */
    Storage.prototype.keys = function () {
        var _this = this;
        try {
            return Object.keys(this._storage).filter(function (key) {
                return _this._containerRegex.test(key);
            });
        } catch (error) {
            throw new __WEBPACK_IMPORTED_MODULE_5__errors_exception__["a" /* Exception */]("Unable to get keys from storage", error);
        }
    };
    /**
     * Lists all the values in the storage.
     *
     * @return {array} Returns all the values.
     */
    Storage.prototype.values = function () {
        var _this = this;
        try {
            return this.keys().map(function (key) {
                return _this.get(key);
            });
        } catch (error) {
            throw new __WEBPACK_IMPORTED_MODULE_5__errors_exception__["a" /* Exception */]("Unable to get values from storage", error);
        }
    };
    Object.defineProperty(Storage.prototype, "count", {
        /**
         * Number of items in the store.
         *
         * @return {number} Returns the number of items in the dictionary.
         */
        get: function get() {
            try {
                return this.keys().length;
            } catch (error) {
                throw new __WEBPACK_IMPORTED_MODULE_5__errors_exception__["a" /* Exception */]("Unable to get size of localStorage", error);
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Clear all storages.
     * Completely clears both the localStorage and sessionStorage.
     */
    Storage.clearAll = function () {
        window.localStorage.clear();
        window.sessionStorage.clear();
    };
    /**
     * Returns an observable that triggers everytime there's a Storage Event
     * or if the collection is modified in a different tab.
     */
    Storage.prototype.notify = function (next, error, complete) {
        var _this = this;
        if (!(this._observable == null)) {
            return this._observable.subscribe(next, error, complete);
        }
        this._observable = new __WEBPACK_IMPORTED_MODULE_4_rxjs_Observable__["Observable"](function (observer) {
            // Debounced listener to storage events
            var debouncedUpdate = Object(__WEBPACK_IMPORTED_MODULE_3_lodash_es_debounce__["a" /* default */])(function (event) {
                try {
                    // If the change is on the current container
                    if (_this._containerRegex.test(event.key)) {
                        // Notify the listener of the change
                        observer.next(event.key);
                    }
                } catch (e) {
                    observer.error(e);
                }
            }, NOTIFICATION_DEBOUNCE);
            window.addEventListener('storage', debouncedUpdate, false);
            // Teardown
            return function () {
                window.removeEventListener('storage', debouncedUpdate, false);
                _this._observable = null;
            };
        });
        return this._observable.subscribe(next, error, complete);
    };
    Storage.prototype._validateKey = function (key) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isString__["a" /* default */])(key) || Object(__WEBPACK_IMPORTED_MODULE_2_lodash_es_isEmpty__["a" /* default */])(key)) {
            throw new TypeError('Key needs to be a string');
        }
    };
    /**
     * Determine if the value was a Date type and if so return a Date object instead.
     * https://blog.mariusschulz.com/2016/04/28/deserializing-json-strings-as-javascript-date-objects
     */
    Storage.prototype._reviver = function (_key, value) {
        if (Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isString__["a" /* default */])(value) && DATE_REGEX.test(value)) {
            return new Date(value);
        }
        return value;
    };
    /**
     * Scope the key to the container as @<container>/<key> so as to easily identify
     * the item in localStorage and reduce collisions
     * @param key key to be scoped
     */
    Storage.prototype._scope = function (key) {
        if (Object(__WEBPACK_IMPORTED_MODULE_2_lodash_es_isEmpty__["a" /* default */])(this.container)) {
            return key;
        }
        return "@" + this.container + "/" + key;
    };
    return Storage;
}();

/**
 * Creating a mock for folks who don't want to use localStorage.
 * This will still allow them to use the APIs.
*/
var InMemoryStorage = /** @class */function () {
    function InMemoryStorage() {
        console.warn("Using non persistant storage. Data will be lost when browser is refreshed/closed");
        this._map = new Map();
    }
    Object.defineProperty(InMemoryStorage.prototype, "length", {
        get: function get() {
            return this._map.size;
        },
        enumerable: true,
        configurable: true
    });
    InMemoryStorage.prototype.clear = function () {
        this._map.clear();
    };
    InMemoryStorage.prototype.getItem = function (key) {
        return this._map.get(key);
    };
    InMemoryStorage.prototype.removeItem = function (key) {
        return this._map.delete(key);
    };
    InMemoryStorage.prototype.setItem = function (key, data) {
        this._map.set(key, data);
    };
    InMemoryStorage.prototype.key = function (index) {
        var result = undefined;
        var ctr = 0;
        this._map.forEach(function (_val, key) {
            if (++ctr === index) {
                result = key;
            }
        });
        return result;
    };
    return InMemoryStorage;
}();

/***/ }),

/***/ "./src/helpers/utilities.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HostType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PlatformType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Utilities; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__errors_custom_error__ = __webpack_require__("./src/errors/custom.error.ts");
/* Copyright (c) Microsoft. All rights reserved. Licensed under the MIT license. */

/**
 * Constant strings for the host types
 */
var HostType = {
    WEB: 'WEB',
    ACCESS: 'ACCESS',
    EXCEL: 'EXCEL',
    ONENOTE: 'ONENOTE',
    OUTLOOK: 'OUTLOOK',
    POWERPOINT: 'POWERPOINT',
    PROJECT: 'PROJECT',
    WORD: 'WORD'
};
/**
 * Constant strings for the host platforms
 */
var PlatformType = {
    IOS: 'IOS',
    MAC: 'MAC',
    OFFICE_ONLINE: 'OFFICE_ONLINE',
    PC: 'PC'
};
/*
* Retrieves host info using a workaround that utilizes the internals of the
* Office.js library. Such workarounds should be avoided, as they can lead to
* a break in behavior, if the internals are ever changed. In this case, however,
* Office.js will soon be delivering a new API to provide the host and platform
* information.
*/
function getHostInfo() {
    // A forthcoming API (partially rolled-out) will expose the host and platform info natively
    // when queried from within an add-in.
    // If the platform already exposes that info, then just return it
    // (but only after massaging it to fit the return types expected by this function)
    var context = window.Office && window.Office.context || useHostInfoFallbackLogic();
    return {
        host: convertHostValue(context.host),
        platform: convertPlatformValue(context.platform)
    };
}
function useHostInfoFallbackLogic() {
    try {
        if (window.sessionStorage == null) {
            throw new Error("Session Storage isn't supported");
        }
        var hostInfoValue = window.sessionStorage['hostInfoValue'];
        var _a = hostInfoValue.split('$'),
            hostRaw = _a[0],
            platformRaw = _a[1],
            extras = _a[2];
        // Older hosts used "|", so check for that as well:
        if (extras == null) {
            _b = hostInfoValue.split('|'), hostRaw = _b[0], platformRaw = _b[1];
        }
        var host = hostRaw.toUpperCase() || 'WEB';
        var platform = null;
        if (Utilities.host !== HostType.WEB) {
            var platforms = {
                'IOS': PlatformType.IOS,
                'MAC': PlatformType.MAC,
                'WEB': PlatformType.OFFICE_ONLINE,
                'WIN32': PlatformType.PC
            };
            platform = platforms[platformRaw.toUpperCase()] || null;
        }
        return { host: host, platform: platform };
    } catch (error) {
        return { host: 'WEB', platform: null };
    }
    var _b;
}
/** Convert the Office.context.host value to one of the Office JS Helpers constants. */
function convertHostValue(host) {
    var officeJsToHelperEnumMapping = {
        'Word': HostType.WORD,
        'Excel': HostType.EXCEL,
        'PowerPoint': HostType.POWERPOINT,
        'Outlook': HostType.OUTLOOK,
        'OneNote': HostType.ONENOTE,
        'Project': HostType.PROJECT,
        'Access': HostType.ACCESS
    };
    return officeJsToHelperEnumMapping[host] || host;
}
/** Convert the Office.context.platform value to one of the Office JS Helpers constants. */
function convertPlatformValue(platform) {
    var officeJsToHelperEnumMapping = {
        'PC': PlatformType.PC,
        'OfficeOnline': PlatformType.OFFICE_ONLINE,
        'Mac': PlatformType.MAC,
        'iOS': PlatformType.IOS
    };
    return officeJsToHelperEnumMapping[platform] || platform;
}
/**
 * Helper exposing useful Utilities for Office-Add-ins.
 */
var Utilities = /** @class */function () {
    function Utilities() {}
    /**
     * A promise based helper for Office initialize.
     * If Office.js was found, the 'initialize' event is waited for and
     * the promise is resolved with the right reason.
     *
     * Else the application starts as a web application.
     */
    Utilities.initialize = function () {
        return new Promise(function (resolve, reject) {
            try {
                Office.initialize = function (reason) {
                    return resolve(reason);
                };
            } catch (exception) {
                if (window['Office']) {
                    reject(exception);
                } else {
                    resolve('Office was not found. Running as web application.');
                }
            }
        });
    };
    Object.defineProperty(Utilities, "host", {
        /*
         * Returns the current host which is either the name of the application where the
         * Office Add-in is running ("EXCEL", "WORD", etc.) or simply "WEB" for all other platforms.
         * The property is always returned in ALL_CAPS.
         * Note that this property is guaranteed to return the correct value ONLY after Office has
         * initialized (i.e., inside, or sequentially after, an Office.initialize = function() { ... }; statement).
         *
         * This code currently uses a workaround that relies on the internals of Office.js.
         * A more robust approach is forthcoming within the official  Office.js library.
         * Once the new approach is released, this implementation will switch to using it
         * instead of the current workaround.
         */
        get: function get() {
            return getHostInfo().host;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Utilities, "platform", {
        /*
        * Returns the host application's platform ("IOS", "MAC", "OFFICE_ONLINE", or "PC").
        * This is only valid for Office Add-ins, and hence returns null if the HostType is WEB.
        * The platform is in ALL-CAPS.
        * Note that this property is guaranteed to return the correct value ONLY after Office has
        * initialized (i.e., inside, or sequentially after, an Office.initialize = function() { ... }; statement).
        *
        * This code currently uses a workaround that relies on the internals of Office.js.
        * A more robust approach is forthcoming within the official  Office.js library.
        * Once the new approach is released, this implementation will switch to using it
        * instead of the current workaround.
        */
        get: function get() {
            return getHostInfo().platform;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Utilities, "isAddin", {
        /**
         * Utility to check if the code is running inside of an add-in.
         */
        get: function get() {
            return Utilities.host !== HostType.WEB;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Utilities, "isIEOrEdge", {
        /**
         * Utility to check if the browser is IE11 or Edge.
         */
        get: function get() {
            return (/Edge\/|Trident\//gi.test(window.navigator.userAgent)
            );
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Utility to generate crypto safe random numbers
     */
    Utilities.generateCryptoSafeRandom = function () {
        var random = new Uint32Array(1);
        if ('msCrypto' in window) {
            window.msCrypto.getRandomValues(random);
        } else if ('crypto' in window) {
            window.crypto.getRandomValues(random);
        } else {
            throw new Error('The platform doesn\'t support generation of cryptographically safe randoms. Please disable the state flag and try again.');
        }
        return random[0];
    };
    /**
     * Utility to print prettified errors.
     * If multiple parameters are sent then it just logs them instead.
     */
    Utilities.log = function (exception, extras) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        if (!(extras == null)) {
            return console.log.apply(console, [exception, extras].concat(args));
        }
        if (exception == null) {
            console.error(exception);
        } else if (typeof exception === 'string') {
            console.error(exception);
        } else {
            console.group(exception.name + ": " + exception.message);
            {
                var innerException = exception;
                if (exception instanceof __WEBPACK_IMPORTED_MODULE_0__errors_custom_error__["a" /* CustomError */]) {
                    innerException = exception.innerError;
                }
                if (window.OfficeExtension && innerException instanceof OfficeExtension.Error) {
                    console.groupCollapsed('Debug Info');
                    console.error(innerException.debugInfo);
                    console.groupEnd();
                }
                {
                    console.groupCollapsed('Stack Trace');
                    console.error(exception.stack);
                    console.groupEnd();
                }
                {
                    console.groupCollapsed('Inner Error');
                    console.error(innerException);
                    console.groupEnd();
                }
            }
            console.groupEnd();
        }
    };
    return Utilities;
}();


/***/ }),

/***/ "./src/index.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__errors_custom_error__ = __webpack_require__("./src/errors/custom.error.ts");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "CustomError", function() { return __WEBPACK_IMPORTED_MODULE_0__errors_custom_error__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_dialog__ = __webpack_require__("./src/helpers/dialog.ts");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DialogError", function() { return __WEBPACK_IMPORTED_MODULE_1__helpers_dialog__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Dialog", function() { return __WEBPACK_IMPORTED_MODULE_1__helpers_dialog__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_utilities__ = __webpack_require__("./src/helpers/utilities.ts");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "HostType", function() { return __WEBPACK_IMPORTED_MODULE_2__helpers_utilities__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "PlatformType", function() { return __WEBPACK_IMPORTED_MODULE_2__helpers_utilities__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Utilities", function() { return __WEBPACK_IMPORTED_MODULE_2__helpers_utilities__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_dictionary__ = __webpack_require__("./src/helpers/dictionary.ts");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Dictionary", function() { return __WEBPACK_IMPORTED_MODULE_3__helpers_dictionary__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_storage__ = __webpack_require__("./src/helpers/storage.ts");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "StorageType", function() { return __WEBPACK_IMPORTED_MODULE_4__helpers_storage__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Storage", function() { return __WEBPACK_IMPORTED_MODULE_4__helpers_storage__["a"]; });
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__authentication_token_manager__ = __webpack_require__("./src/authentication/token.manager.ts");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TokenStorage", function() { return __WEBPACK_IMPORTED_MODULE_5__authentication_token_manager__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__authentication_endpoint_manager__ = __webpack_require__("./src/authentication/endpoint.manager.ts");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DefaultEndpoints", function() { return __WEBPACK_IMPORTED_MODULE_6__authentication_endpoint_manager__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "EndpointStorage", function() { return __WEBPACK_IMPORTED_MODULE_6__authentication_endpoint_manager__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__authentication_authenticator__ = __webpack_require__("./src/authentication/authenticator.ts");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "AuthError", function() { return __WEBPACK_IMPORTED_MODULE_7__authentication_authenticator__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Authenticator", function() { return __WEBPACK_IMPORTED_MODULE_7__authentication_authenticator__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__excel_utilities__ = __webpack_require__("./src/excel/utilities.ts");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ExcelUtilities", function() { return __WEBPACK_IMPORTED_MODULE_8__excel_utilities__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_ui__ = __webpack_require__("./src/ui/ui.ts");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "UI", function() { return __WEBPACK_IMPORTED_MODULE_9__ui_ui__["a"]; });
/* Copyright (c) Microsoft. All rights reserved. Licensed under the MIT license. */












/***/ }),

/***/ "./src/ui/message-banner.html":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ("<div class=\"office-js-helpers-notification ms-font-m ms-MessageBar @@CLASS\">\n  <style>\n    .office-js-helpers-notification {\n      position: fixed;\n      z-index: 2147483647;\n      top: 0;\n      left: 0;\n      right: 0;\n      width: 100%;\n      padding: 0 0 10px 0;\n    }\n\n    .office-js-helpers-notification > div > div {\n      padding: 10px 15px;\n      box-sizing: border-box;\n    }\n\n    .office-js-helpers-notification pre {\n      white-space: pre-wrap;\n      word-wrap: break-word;\n      margin: 0px;\n      font-size: smaller;\n    }\n\n    .office-js-helpers-notification > button {\n      height: 52px;\n      width: 40px;\n      cursor: pointer;\n      float: right;\n      background: transparent;\n      border: 0;\n      margin-left: 10px;\n      margin-right: '@@PADDING'\n    }\n  </style>\n  <button>\n      <i class=\"ms-Icon ms-Icon--Clear\"></i>\n  </button>\n</div>");

/***/ }),

/***/ "./src/ui/ui.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UI; });
/* unused harmony export _parseNotificationParams */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_utilities__ = __webpack_require__("./src/helpers/utilities.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_stringify__ = __webpack_require__("./src/util/stringify.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__message_banner_html__ = __webpack_require__("./src/ui/message-banner.html");
/* Copyright (c) Microsoft. All rights reserved. Licensed under the MIT license. */



var DEFAULT_WHITESPACE = 2;
var UI = /** @class */function () {
    function UI() {}
    UI.notify = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var params = _parseNotificationParams(args);
        if (params == null) {
            console.error(new Error('Invalid params. Cannot create a notification'));
            return null;
        }
        var messageBarClasses = {
            'success': 'ms-MessageBar--success',
            'error': 'ms-MessageBar--error',
            'warning': 'ms-MessageBar--warning',
            'severe-warning': 'ms-MessageBar--severeWarning'
        };
        var messageBarTypeClass = messageBarClasses[params.type] || '';
        var paddingForPersonalityMenu = '0';
        if (__WEBPACK_IMPORTED_MODULE_0__helpers_utilities__["c" /* Utilities */].platform === __WEBPACK_IMPORTED_MODULE_0__helpers_utilities__["b" /* PlatformType */].PC) {
            paddingForPersonalityMenu = '20px';
        } else if (__WEBPACK_IMPORTED_MODULE_0__helpers_utilities__["c" /* Utilities */].platform === __WEBPACK_IMPORTED_MODULE_0__helpers_utilities__["b" /* PlatformType */].MAC) {
            paddingForPersonalityMenu = '40px';
        }
        var messageBannerHtml = __WEBPACK_IMPORTED_MODULE_2__message_banner_html__["a" /* default */].replace('@@CLASS', messageBarTypeClass).replace('\'@@PADDING\'', paddingForPersonalityMenu);
        var existingNotifications = document.getElementsByClassName('office-js-helpers-notification');
        while (existingNotifications[0]) {
            existingNotifications[0].parentNode.removeChild(existingNotifications[0]);
        }
        document.body.insertAdjacentHTML('afterbegin', messageBannerHtml);
        var notificationDiv = document.getElementsByClassName('office-js-helpers-notification')[0];
        var messageTextArea = document.createElement('div');
        notificationDiv.insertAdjacentElement('beforeend', messageTextArea);
        if (params.title) {
            var titleDiv = document.createElement('div');
            titleDiv.textContent = params.title;
            titleDiv.classList.add('ms-fontWeight-semibold');
            messageTextArea.insertAdjacentElement('beforeend', titleDiv);
        }
        params.message.split('\n').forEach(function (text) {
            var div = document.createElement('div');
            div.textContent = text;
            messageTextArea.insertAdjacentElement('beforeend', div);
        });
        if (params.details) {
            var labelDiv_1 = document.createElement('div');
            messageTextArea.insertAdjacentElement('beforeend', labelDiv_1);
            var label = document.createElement('a');
            label.setAttribute('href', 'javascript:void(0)');
            label.onclick = function () {
                document.querySelector('.office-js-helpers-notification pre').parentElement.style.display = 'block';
                labelDiv_1.style.display = 'none';
            };
            label.textContent = 'Details';
            labelDiv_1.insertAdjacentElement('beforeend', label);
            var preDiv = document.createElement('div');
            preDiv.style.display = 'none';
            messageTextArea.insertAdjacentElement('beforeend', preDiv);
            var detailsDiv = document.createElement('pre');
            detailsDiv.textContent = params.details;
            preDiv.insertAdjacentElement('beforeend', detailsDiv);
        }
        document.querySelector('.office-js-helpers-notification > button').onclick = function () {
            return notificationDiv.parentNode.removeChild(notificationDiv);
        };
    };
    return UI;
}();

function _parseNotificationParams(params) {
    if (params == null) {
        return null;
    }
    var body = params[0],
        title = params[1],
        type = params[2];
    if (body instanceof Error) {
        var details = '';
        var _a = body,
            innerError = _a.innerError,
            stack = _a.stack;
        if (innerError) {
            var error = JSON.stringify(innerError.debugInfo || innerError, null, DEFAULT_WHITESPACE);
            details += "Inner Error: \n" + error + "\n";
        }
        if (stack) {
            details += "Stack Trace: \n" + body.stack + "\n";
        }
        return {
            message: body.message,
            title: title || body.name,
            type: 'error',
            details: details
        };
    } else {
        return {
            message: Object(__WEBPACK_IMPORTED_MODULE_1__util_stringify__["a" /* default */])(body),
            title: title,
            type: type || 'default',
            details: null
        };
    }
}

/***/ }),

/***/ "./src/util/stringify.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = stringify;
function stringify(value) {
    // JSON.stringify of undefined will return undefined rather than 'undefined'
    if (value === undefined) {
        return 'undefined';
    }
    // Don't JSON.stringify strings, we don't want quotes in the output
    if (typeof value === 'string') {
        return value;
    }
    // Use toString() only if it's useful
    if (typeof value.toString === 'function' && value.toString() !== '[object Object]') {
        return value.toString();
    }
    // Otherwise, JSON stringify the object
    return JSON.stringify(value, null, 2);
}

/***/ })

/******/ });
});
//# sourceMappingURL=office.helpers.js.map

/***/ }),

/***/ "../node_modules/@uifabric/icons/lib/fabric-icons-0.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable:max-line-length
var index_1 = __webpack_require__("../node_modules/@uifabric/styling/lib/index.js");
function initializeIcons(baseUrl, options) {
    if (baseUrl === void 0) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none'
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons-0\"",
            src: "url('" + baseUrl + "fabric-icons-0-29734c63.woff') format('woff')"
        },
        icons: {
            'DecreaseIndentLegacy': '\uE290',
            'IncreaseIndentLegacy': '\uE291',
            'SizeLegacy': '\uE2B2',
            'InternetSharing': '\uE704',
            'Brightness': '\uE706',
            'MapPin': '\uE707',
            'Airplane': '\uE709',
            'Tablet': '\uE70A',
            'QuickNote': '\uE70B',
            'Video': '\uE714',
            'People': '\uE716',
            'Phone': '\uE717',
            'Pin': '\uE718',
            'Shop': '\uE719',
            'Stop': '\uE71A',
            'Link': '\uE71B',
            'AllApps': '\uE71D',
            'Zoom': '\uE71E',
            'ZoomOut': '\uE71F',
            'Microphone': '\uE720',
            'Camera': '\uE722',
            'Attach': '\uE723',
            'Send': '\uE724',
            'FavoriteList': '\uE728',
            'PageSolid': '\uE729',
            'Forward': '\uE72A',
            'Back': '\uE72B',
            'Refresh': '\uE72C',
            'Lock': '\uE72E',
            'ReportHacked': '\uE730',
            'EMI': '\uE731',
            'MiniLink': '\uE732',
            'Blocked': '\uE733',
            'ReadingMode': '\uE736',
            'Favicon': '\uE737',
            'Remove': '\uE738',
            'Checkbox': '\uE739',
            'CheckboxComposite': '\uE73A',
            'CheckboxIndeterminate': '\uE73C',
            'CheckboxCompositeReversed': '\uE73D',
            'BackToWindow': '\uE73F',
            'FullScreen': '\uE740',
            'Print': '\uE749',
            'Up': '\uE74A',
            'Down': '\uE74B',
            'OEM': '\uE74C',
            'Save': '\uE74E',
            'Cloud': '\uE753',
            'CommandPrompt': '\uE756',
            'Sad': '\uE757',
            'SIPMove': '\uE759',
            'EraseTool': '\uE75C',
            'GripperTool': '\uE75E',
            'Dialpad': '\uE75F',
            'PageLeft': '\uE760',
            'PageRight': '\uE761',
            'MultiSelect': '\uE762',
            'KeyboardClassic': '\uE765',
            'Play': '\uE768',
            'Pause': '\uE769',
            'Emoji2': '\uE76E',
            'GripperBarHorizontal': '\uE76F',
            'System': '\uE770',
            'Personalize': '\uE771',
            'SearchAndApps': '\uE773',
            'Globe': '\uE774',
            'ContactInfo': '\uE779',
            'Unpin': '\uE77A',
            'Contact': '\uE77B',
            'Memo': '\uE77C',
            'Paste': '\uE77F',
            'WindowsLogo': '\uE782',
            'Error': '\uE783',
            'GripperBarVertical': '\uE784',
            'Unlock': '\uE785',
            'AutoEnhanceOn': '\uE78D',
            'AutoEnhanceOff': '\uE78E',
            'Color': '\uE790',
            'SaveAs': '\uE792',
            'Light': '\uE793',
            'Filters': '\uE795',
            'AspectRatio': '\uE799',
            'Contrast': '\uE7A1',
            'Redo': '\uE7A6',
            'Crop': '\uE7A8',
            'PhotoCollection': '\uE7AA',
            'Album': '\uE7AB',
            'Rotate': '\uE7AD',
            'PanoIndicator': '\uE7B0',
            'RedEye': '\uE7B3',
            'ThumbnailView': '\uE7B6',
            'Package': '\uE7B8',
            'Warning': '\uE7BA',
            'Financial': '\uE7BB',
            'Education': '\uE7BE',
            'ShoppingCart': '\uE7BF',
            'Train': '\uE7C0',
            'Move': '\uE7C2',
            'TouchPointer': '\uE7C9',
            'Merge': '\uE7D5'
        }
    };
    index_1.registerIcons(subset, options);
}
exports.initializeIcons = initializeIcons;
//# sourceMappingURL=fabric-icons-0.js.map

/***/ }),

/***/ "../node_modules/@uifabric/icons/lib/fabric-icons-1.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable:max-line-length
var index_1 = __webpack_require__("../node_modules/@uifabric/styling/lib/index.js");
function initializeIcons(baseUrl, options) {
    if (baseUrl === void 0) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none'
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons-1\"",
            src: "url('" + baseUrl + "fabric-icons-1-a653c37c.woff') format('woff')"
        },
        icons: {
            'TurnRight': '\uE7DB',
            'Ferry': '\uE7E3',
            'Highlight': '\uE7E6',
            'PowerButton': '\uE7E8',
            'Tab': '\uE7E9',
            'Admin': '\uE7EF',
            'TVMonitor': '\uE7F4',
            'Speakers': '\uE7F5',
            'StackIndicator': '\uE7FF',
            'Nav2DMapView': '\uE800',
            'Car': '\uE804',
            'Bus': '\uE806',
            'EatDrink': '\uE807',
            'LocationCircle': '\uE80E',
            'Home': '\uE80F',
            'SwitcherStartEnd': '\uE810',
            'ParkingLocation': '\uE811',
            'IncidentTriangle': '\uE814',
            'Touch': '\uE815',
            'MapDirections': '\uE816',
            'CaretHollow': '\uE817',
            'CaretSolid': '\uE818',
            'History': '\uE81C',
            'Location': '\uE81D',
            'Work': '\uE821',
            'Recent': '\uE823',
            'Hotel': '\uE824',
            'LocationDot': '\uE827',
            'Dictionary': '\uE82D',
            'ChromeBack': '\uE830',
            'FolderOpen': '\uE838',
            'PinnedFill': '\uE842',
            'RevToggleKey': '\uE845',
            'Previous': '\uE892',
            'Next': '\uE893',
            'Sync': '\uE895',
            'Help': '\uE897',
            'Emoji': '\uE899',
            'MailForward': '\uE89C',
            'ClosePane': '\uE89F',
            'OpenPane': '\uE8A0',
            'PreviewLink': '\uE8A1',
            'ZoomIn': '\uE8A3',
            'Bookmarks': '\uE8A4',
            'Document': '\uE8A5',
            'ProtectedDocument': '\uE8A6',
            'OpenInNewWindow': '\uE8A7',
            'MailFill': '\uE8A8',
            'ViewAll': '\uE8A9',
            'Switch': '\uE8AB',
            'Rename': '\uE8AC',
            'Remote': '\uE8AF',
            'SelectAll': '\uE8B3',
            'Orientation': '\uE8B4',
            'Import': '\uE8B5',
            'Picture': '\uE8B9',
            'ChromeClose': '\uE8BB',
            'ShowResults': '\uE8BC',
            'Message': '\uE8BD',
            'CalendarDay': '\uE8BF',
            'CalendarWeek': '\uE8C0',
            'MailReplyAll': '\uE8C2',
            'Read': '\uE8C3',
            'Cut': '\uE8C6',
            'PaymentCard': '\uE8C7',
            'Copy': '\uE8C8',
            'Important': '\uE8C9',
            'MailReply': '\uE8CA',
            'GotoToday': '\uE8D1',
            'Font': '\uE8D2',
            'FontColor': '\uE8D3',
            'FolderFill': '\uE8D5',
            'Permissions': '\uE8D7',
            'DisableUpdates': '\uE8D8',
            'Unfavorite': '\uE8D9',
            'Italic': '\uE8DB',
            'Underline': '\uE8DC',
            'Bold': '\uE8DD',
            'MoveToFolder': '\uE8DE',
            'Dislike': '\uE8E0',
            'Like': '\uE8E1',
            'AlignCenter': '\uE8E3',
            'OpenFile': '\uE8E5',
            'FontDecrease': '\uE8E7',
            'FontIncrease': '\uE8E8',
            'FontSize': '\uE8E9',
            'CellPhone': '\uE8EA',
            'Calculator': '\uE8EF',
            'Library': '\uE8F1',
            'PostUpdate': '\uE8F3',
            'NewFolder': '\uE8F4',
            'CalendarReply': '\uE8F5',
            'UnsyncFolder': '\uE8F6',
            'SyncFolder': '\uE8F7',
            'BlockContact': '\uE8F8',
            'Accept': '\uE8FB',
            'BulletedList': '\uE8FD',
            'Preview': '\uE8FF',
            'News': '\uE900',
            'Chat': '\uE901'
        }
    };
    index_1.registerIcons(subset, options);
}
exports.initializeIcons = initializeIcons;
//# sourceMappingURL=fabric-icons-1.js.map

/***/ }),

/***/ "../node_modules/@uifabric/icons/lib/fabric-icons-10.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable:max-line-length
var index_1 = __webpack_require__("../node_modules/@uifabric/styling/lib/index.js");
function initializeIcons(baseUrl, options) {
    if (baseUrl === void 0) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none'
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons-10\"",
            src: "url('" + baseUrl + "fabric-icons-10-fb519450.woff') format('woff')"
        },
        icons: {
            'CPlusPlus': '\uF2F4',
            'FSharpLanguage': '\uF2F5',
            'FSharp': '\uF2F6',
            'TypeScriptLanguage': '\uF2F7',
            'PythonLanguage': '\uF2F8',
            'PY': '\uF2F9',
            'CoffeeScript': '\uF2FA',
            'MarkDownLanguage': '\uF2FB',
            'FullWidth': '\uF2FE',
            'FullWidthEdit': '\uF2FF',
            'Plug': '\uF300',
            'PlugSolid': '\uF301',
            'PlugConnected': '\uF302',
            'PlugDisconnected': '\uF303',
            'UnlockSolid': '\uF304',
            'Variable': '\uF305',
            'Parameter': '\uF306',
            'CommentUrgent': '\uF307',
            'Storyboard': '\uF308',
            'DiffInline': '\uF309',
            'DiffSideBySide': '\uF30A',
            'ImageDiff': '\uF30B',
            'ImagePixel': '\uF30C',
            'FileBug': '\uF30D',
            'FileCode': '\uF30E',
            'FileComment': '\uF30F',
            'BusinessHoursSign': '\uF310',
            'FileImage': '\uF311',
            'FileSymlink': '\uF312',
            'AutoFillTemplate': '\uF313',
            'WorkItem': '\uF314',
            'WorkItemBug': '\uF315',
            'LogRemove': '\uF316',
            'ColumnOptions': '\uF317',
            'Packages': '\uF318',
            'BuildIssue': '\uF319',
            'AssessmentGroup': '\uF31A',
            'VariableGroup': '\uF31B',
            'FullHistory': '\uF31C',
            'SingleColumnEdit': '\uF321',
            'DoubleColumnEdit': '\uF322',
            'TripleColumnEdit': '\uF323',
            'ColumnLeftTwoThirdsEdit': '\uF324',
            'ColumnRightTwoThirdsEdit': '\uF325',
            'StreamLogo': '\uF329',
            'PassiveAuthentication': '\uF32A',
            'AlertSolid': '\uF331',
            'MegaphoneSolid': '\uF332',
            'TaskSolid': '\uF333',
            'ConfigurationSolid': '\uF334',
            'BugSolid': '\uF335',
            'CrownSolid': '\uF336',
            'Trophy2Solid': '\uF337',
            'QuickNoteSolid': '\uF338',
            'ConstructionConeSolid': '\uF339',
            'PageListSolid': '\uF33A',
            'PageListMirroredSolid': '\uF33B',
            'StarburstSolid': '\uF33C',
            'ReadingModeSolid': '\uF33D',
            'SadSolid': '\uF33E',
            'HealthSolid': '\uF33F',
            'ShieldSolid': '\uF340',
            'GiftBoxSolid': '\uF341',
            'ShoppingCartSolid': '\uF342',
            'MailSolid': '\uF343',
            'ChatSolid': '\uF344',
            'RibbonSolid': '\uF345',
            'FinancialSolid': '\uF346',
            'FinancialMirroredSolid': '\uF347',
            'HeadsetSolid': '\uF348',
            'PermissionsSolid': '\uF349',
            'ParkingSolid': '\uF34A',
            'ParkingMirroredSolid': '\uF34B',
            'DiamondSolid': '\uF34C',
            'AsteriskSolid': '\uF34D',
            'OfflineStorageSolid': '\uF34E',
            'BankSolid': '\uF34F',
            'DecisionSolid': '\uF350',
            'Parachute': '\uF351',
            'ParachuteSolid': '\uF352',
            'FiltersSolid': '\uF353',
            'ColorSolid': '\uF354',
            'ReviewSolid': '\uF355',
            'ReviewRequestSolid': '\uF356',
            'ReviewRequestMirroredSolid': '\uF357',
            'ReviewResponseSolid': '\uF358',
            'FeedbackRequestSolid': '\uF359',
            'FeedbackRequestMirroredSolid': '\uF35A',
            'FeedbackResponseSolid': '\uF35B',
            'WorkItemBar': '\uF35C',
            'WorkItemBarSolid': '\uF35D',
            'Separator': '\uF35E',
            'NavigateExternalInline': '\uF35F',
            'PlanView': '\uF360',
            'TimelineMatrixView': '\uF361',
            'EngineeringGroup': '\uF362',
            'ProjectCollection': '\uF363',
            'CaretBottomRightCenter8': '\uF364',
            'CaretBottomLeftCenter8': '\uF365',
            'CaretTopRightCenter8': '\uF366'
        }
    };
    index_1.registerIcons(subset, options);
}
exports.initializeIcons = initializeIcons;
//# sourceMappingURL=fabric-icons-10.js.map

/***/ }),

/***/ "../node_modules/@uifabric/icons/lib/fabric-icons-11.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable:max-line-length
var index_1 = __webpack_require__("../node_modules/@uifabric/styling/lib/index.js");
function initializeIcons(baseUrl, options) {
    if (baseUrl === void 0) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none'
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons-11\"",
            src: "url('" + baseUrl + "fabric-icons-11-a4026982.woff') format('woff')"
        },
        icons: {
            'CaretTopLeftCenter8': '\uF367',
            'DonutChart': '\uF368',
            'ChevronUnfold10': '\uF369',
            'ChevronFold10': '\uF36A',
            'DoubleChevronDown8': '\uF36B',
            'DoubleChevronUp8': '\uF36C',
            'DoubleChevronLeft8': '\uF36D',
            'DoubleChevronRight8': '\uF36E',
            'ChevronDownEnd6': '\uF36F',
            'ChevronUpEnd6': '\uF370',
            'ChevronLeftEnd6': '\uF371',
            'ChevronRightEnd6': '\uF372',
            'ContextMenu': '\uF37C',
            'AzureAPIManagement': '\uF37F',
            'AzureServiceEndpoint': '\uF380',
            'VSTSLogo': '\uF381',
            'VSTSAltLogo1': '\uF382',
            'VSTSAltLogo2': '\uF383',
            'FileTypeSolution': '\uF387',
            'WordLogoInverse16': '\uF390',
            'WordLogo16': '\uF391',
            'WordLogoFill16': '\uF392',
            'PowerPointLogoInverse16': '\uF393',
            'PowerPointLogo16': '\uF394',
            'PowerPointLogoFill16': '\uF395',
            'ExcelLogoInverse16': '\uF396',
            'ExcelLogo16': '\uF397',
            'ExcelLogoFill16': '\uF398',
            'OneNoteLogoInverse16': '\uF399',
            'OneNoteLogo16': '\uF39A',
            'OneNoteLogoFill16': '\uF39B',
            'OutlookLogoInverse16': '\uF39C',
            'OutlookLogo16': '\uF39D',
            'OutlookLogoFill16': '\uF39E',
            'PublisherLogoInverse16': '\uF39F',
            'PublisherLogo16': '\uF3A0',
            'PublisherLogoFill16': '\uF3A1',
            'VisioLogoInverse16': '\uF3A2',
            'VisioLogo16': '\uF3A3',
            'VisioLogoFill16': '\uF3A4',
            'TestBeaker': '\uF3A5',
            'TestBeakerSolid': '\uF3A6',
            'TestExploreSolid': '\uF3A7',
            'TestAutoSolid': '\uF3A8',
            'TestUserSolid': '\uF3A9',
            'TestImpactSolid': '\uF3AA',
            'TestPlan': '\uF3AB',
            'TestStep': '\uF3AC',
            'TestParameter': '\uF3AD',
            'TestSuite': '\uF3AE',
            'TestCase': '\uF3AF',
            'Sprint': '\uF3B0',
            'SignOut': '\uF3B1',
            'TriggerApproval': '\uF3B2',
            'Rocket': '\uF3B3',
            'AzureKeyVault': '\uF3B4',
            'Transition': '\uF3BC',
            'LikeSolid': '\uF3BF',
            'DislikeSolid': '\uF3C0',
            'UnSetColor': '\uF3F9',
            'DeclineCall': '\uF405',
            'RectangularClipping': '\uF407',
            'TeamsLogo16': '\uF40A',
            'TeamsLogoFill16': '\uF40B',
            'Spacer': '\uF40D',
            'SkypeLogo16': '\uF40E',
            'SkypeForBusinessLogo16': '\uF40F',
            'SkypeForBusinessLogoFill16': '\uF410',
            'FilterSolid': '\uF412',
            'MailUndelivered': '\uF415',
            'MailTentative': '\uF416',
            'MailTentativeMirrored': '\uF417',
            'MailReminder': '\uF418',
            'ReceiptUndelivered': '\uF419',
            'ReceiptTentative': '\uF41A',
            'ReceiptTentativeMirrored': '\uF41B',
            'Inbox': '\uF41C',
            'IRMReply': '\uF41D',
            'IRMReplyMirrored': '\uF41E',
            'IRMForward': '\uF41F',
            'IRMForwardMirrored': '\uF420',
            'VoicemailIRM': '\uF421',
            'EventAccepted': '\uF422',
            'EventTentative': '\uF423',
            'EventTentativeMirrored': '\uF424',
            'EventDeclined': '\uF425',
            'IDBadge': '\uF427',
            'BackgroundColor': '\uF42B',
            'OfficeFormsLogoInverse16': '\uF433',
            'OfficeFormsLogo': '\uF434',
            'OfficeFormsLogoFill': '\uF435',
            'OfficeFormsLogo16': '\uF436',
            'OfficeFormsLogoFill16': '\uF437',
            'OfficeFormsLogoInverse24': '\uF43A',
            'OfficeFormsLogo24': '\uF43B',
            'OfficeFormsLogoFill24': '\uF43C',
            'PageLock': '\uF43F',
            'NotExecuted': '\uF440',
            'NotImpactedSolid': '\uF441',
            'FieldReadOnly': '\uF442'
        }
    };
    index_1.registerIcons(subset, options);
}
exports.initializeIcons = initializeIcons;
//# sourceMappingURL=fabric-icons-11.js.map

/***/ }),

/***/ "../node_modules/@uifabric/icons/lib/fabric-icons-12.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable:max-line-length
var index_1 = __webpack_require__("../node_modules/@uifabric/styling/lib/index.js");
function initializeIcons(baseUrl, options) {
    if (baseUrl === void 0) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none'
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons-12\"",
            src: "url('" + baseUrl + "fabric-icons-12-e6882c74.woff') format('woff')"
        },
        icons: {
            'FieldRequired': '\uF443',
            'BacklogBoard': '\uF444',
            'ExternalBuild': '\uF445',
            'ExternalTFVC': '\uF446',
            'ExternalXAML': '\uF447',
            'IssueSolid': '\uF448',
            'DefectSolid': '\uF449',
            'LadybugSolid': '\uF44A',
            'NugetLogo': '\uF44C',
            'TFVCLogo': '\uF44D',
            'ProjectLogo32': '\uF47E',
            'ProjectLogoFill32': '\uF47F',
            'ProjectLogo16': '\uF480',
            'ProjectLogoFill16': '\uF481',
            'SwayLogo32': '\uF482',
            'SwayLogoFill32': '\uF483',
            'SwayLogo16': '\uF484',
            'SwayLogoFill16': '\uF485',
            'ClassNotebookLogo32': '\uF486',
            'ClassNotebookLogoFill32': '\uF487',
            'ClassNotebookLogo16': '\uF488',
            'ClassNotebookLogoFill16': '\uF489',
            'ClassNotebookLogoInverse32': '\uF48A',
            'ClassNotebookLogoInverse16': '\uF48B',
            'StaffNotebookLogo32': '\uF48C',
            'StaffNotebookLogoFill32': '\uF48D',
            'StaffNotebookLogo16': '\uF48E',
            'StaffNotebookLogoFill16': '\uF48F',
            'StaffNotebookLogoInverted32': '\uF490',
            'StaffNotebookLogoInverted16': '\uF491',
            'KaizalaLogo': '\uF492',
            'TaskLogo': '\uF493',
            'ProtectionCenterLogo32': '\uF494',
            'GallatinLogo': '\uF496',
            'Globe2': '\uF49A',
            'Guitar': '\uF49B',
            'Breakfast': '\uF49C',
            'Brunch': '\uF49D',
            'BeerMug': '\uF49E',
            'Vacation': '\uF49F',
            'Teeth': '\uF4A0',
            'Taxi': '\uF4A1',
            'Chopsticks': '\uF4A2',
            'SyncOccurence': '\uF4A3',
            'UnsyncOccurence': '\uF4A4',
            'PrimaryCalendar': '\uF4AE',
            'SearchCalendar': '\uF4AF',
            'VideoOff': '\uF4B0',
            'MicrosoftFlowLogo': '\uF4B1',
            'BusinessCenterLogo': '\uF4B2',
            'ToDoLogoBottom': '\uF4B3',
            'ToDoLogoTop': '\uF4B4',
            'EditSolid12': '\uF4B5',
            'EditSolidMirrored12': '\uF4B6',
            'UneditableSolid12': '\uF4B7',
            'UneditableSolidMirrored12': '\uF4B8',
            'UneditableMirrored': '\uF4B9',
            'AdminALogo32': '\uF4BA',
            'AdminALogoFill32': '\uF4BB',
            'ToDoLogoInverse': '\uF4BC',
            'Snooze': '\uF4BD',
            'WaffleOffice365': '\uF4E0',
            'ImageSearch': '\uF4E8',
            'NewsSearch': '\uF4E9',
            'VideoSearch': '\uF4EA',
            'R': '\uF4EB',
            'FontColorA': '\uF4EC',
            'FontColorSwatch': '\uF4ED',
            'LightWeight': '\uF4EE',
            'NormalWeight': '\uF4EF',
            'SemiboldWeight': '\uF4F0',
            'GroupObject': '\uF4F1',
            'UngroupObject': '\uF4F2',
            'AlignHorizontalLeft': '\uF4F3',
            'AlignHorizontalCenter': '\uF4F4',
            'AlignHorizontalRight': '\uF4F5',
            'AlignVerticalTop': '\uF4F6',
            'AlignVerticalCenter': '\uF4F7',
            'AlignVerticalBottom': '\uF4F8',
            'HorizontalDistributeCenter': '\uF4F9',
            'VerticalDistributeCenter': '\uF4FA',
            'Ellipse': '\uF4FB',
            'Line': '\uF4FC',
            'Octagon': '\uF4FD',
            'Hexagon': '\uF4FE',
            'Pentagon': '\uF4FF',
            'RightTriangle': '\uF500',
            'HalfCircle': '\uF501',
            'QuarterCircle': '\uF502',
            'ThreeQuarterCircle': '\uF503',
            '6PointStar': '\uF504',
            '12PointStar': '\uF505',
            'ArrangeBringToFront': '\uF506',
            'ArrangeSendToBack': '\uF507',
            'ArrangeSendBackward': '\uF508',
            'ArrangeBringForward': '\uF509',
            'BorderDash': '\uF50A',
            'BorderDot': '\uF50B',
            'LineStyle': '\uF50C',
            'LineThickness': '\uF50D'
        }
    };
    index_1.registerIcons(subset, options);
}
exports.initializeIcons = initializeIcons;
//# sourceMappingURL=fabric-icons-12.js.map

/***/ }),

/***/ "../node_modules/@uifabric/icons/lib/fabric-icons-13.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable:max-line-length
var index_1 = __webpack_require__("../node_modules/@uifabric/styling/lib/index.js");
function initializeIcons(baseUrl, options) {
    if (baseUrl === void 0) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none'
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons-13\"",
            src: "url('" + baseUrl + "fabric-icons-13-0980cd6d.woff') format('woff')"
        },
        icons: {
            'WindowEdit': '\uF50E',
            'HintText': '\uF50F',
            'MediaAdd': '\uF510',
            'AnchorLock': '\uF511',
            'AutoHeight': '\uF512',
            'ChartSeries': '\uF513',
            'ChartXAngle': '\uF514',
            'ChartYAngle': '\uF515',
            'Combobox': '\uF516',
            'LineSpacing': '\uF517',
            'Padding': '\uF518',
            'PaddingTop': '\uF519',
            'PaddingBottom': '\uF51A',
            'PaddingLeft': '\uF51B',
            'PaddingRight': '\uF51C',
            'NavigationFlipper': '\uF51D',
            'AlignJustify': '\uF51E',
            'TextOverflow': '\uF51F',
            'VisualsFolder': '\uF520',
            'VisualsStore': '\uF521',
            'PictureCenter': '\uF522',
            'PictureFill': '\uF523',
            'PicturePosition': '\uF524',
            'PictureStretch': '\uF525',
            'PictureTile': '\uF526',
            'Slider': '\uF527',
            'SliderHandleSize': '\uF528',
            'DefaultRatio': '\uF529',
            'NumberSequence': '\uF52A',
            'GUID': '\uF52B',
            'ReportAdd': '\uF52C',
            'DashboardAdd': '\uF52D',
            'MapPinSolid': '\uF52E',
            'WebPublish': '\uF52F',
            'PieSingleSolid': '\uF530',
            'BlockedSolid': '\uF531',
            'DrillDown': '\uF532',
            'DrillDownSolid': '\uF533',
            'DrillExpand': '\uF534',
            'DrillShow': '\uF535',
            'OneDriveFolder16': '\uF53B',
            'FunctionalManagerDashboard': '\uF542',
            'BIDashboard': '\uF543',
            'CodeEdit': '\uF544',
            'RenewalCurrent': '\uF545',
            'RenewalFuture': '\uF546',
            'SplitObject': '\uF547',
            'BulkUpload': '\uF548',
            'DownloadDocument': '\uF549',
            'WaitlistConfirm': '\uF550',
            'WaitlistConfirmMirrored': '\uF551',
            'LaptopSecure': '\uF552',
            'DragObject': '\uF553',
            'EntryView': '\uF554',
            'EntryDecline': '\uF555',
            'ContactCardSettings': '\uF556',
            'ContactCardSettingsMirrored': '\uF557',
            'CalendarSettings': '\uF558',
            'CalendarSettingsMirrored': '\uF559',
            'HardDriveLock': '\uF55A',
            'HardDriveUnlock': '\uF55B',
            'AccountManagement': '\uF55C',
            'TransitionPop': '\uF5B2',
            'TransitionPush': '\uF5B3',
            'TransitionEffect': '\uF5B4',
            'LookupEntities': '\uF5B5',
            'ExploreData': '\uF5B6',
            'AddBookmark': '\uF5B7',
            'SearchBookmark': '\uF5B8',
            'DrillThrough': '\uF5B9',
            'MasterDatabase': '\uF5BA',
            'CertifiedDatabase': '\uF5BB',
            'MaximumValue': '\uF5BC',
            'MinimumValue': '\uF5BD',
            'VisualStudioIDELogo32': '\uF5D0',
            'PasteAsText': '\uF5D5',
            'PasteAsCode': '\uF5D6',
            'BrowserTab': '\uF5D7',
            'BrowserTabScreenshot': '\uF5D8',
            'DesktopScreenshot': '\uF5D9',
            'FileYML': '\uF5DA',
            'ClipboardSolid': '\uF5DC',
            'AnalyticsView': '\uF5F1',
            'Leave': '\uF627',
            'Trending12': '\uF62D',
            'Blocked12': '\uF62E',
            'Warning12': '\uF62F',
            'CheckedOutByOther12': '\uF630',
            'CheckedOutByYou12': '\uF631',
            'CircleShapeSolid': '\uF63C',
            'SquareShapeSolid': '\uF63D',
            'TriangleShapeSolid': '\uF63E',
            'DropShapeSolid': '\uF63F',
            'RectangleShapeSolid': '\uF640',
            'InsertColumnsLeft': '\uF64A',
            'InsertColumnsRight': '\uF64B',
            'InsertRowsAbove': '\uF64C',
            'InsertRowsBelow': '\uF64D',
            'DeleteColumns': '\uF64E',
            'DeleteRows': '\uF64F'
        }
    };
    index_1.registerIcons(subset, options);
}
exports.initializeIcons = initializeIcons;
//# sourceMappingURL=fabric-icons-13.js.map

/***/ }),

/***/ "../node_modules/@uifabric/icons/lib/fabric-icons-14.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable:max-line-length
var index_1 = __webpack_require__("../node_modules/@uifabric/styling/lib/index.js");
function initializeIcons(baseUrl, options) {
    if (baseUrl === void 0) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none'
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons-14\"",
            src: "url('" + baseUrl + "fabric-icons-14-eb4d1150.woff') format('woff')"
        },
        icons: {
            'DeleteRowsMirrored': '\uF650',
            'DeleteTable': '\uF651',
            'VersionControlPush': '\uF664',
            'WhiteBoardApp16': '\uF673',
            'WhiteBoardApp32': '\uF674',
            'InsertSignatureLine': '\uF677',
            'ArrangeByFrom': '\uF678',
            'Phishing': '\uF679',
            'CreateMailRule': '\uF67A',
            'PublishCourse': '\uF699',
            'DictionaryRemove': '\uF69A',
            'UserRemove': '\uF69B',
            'UserEvent': '\uF69C',
            'Encryption': '\uF69D',
            'D365TalentLearn': '\uF6BB',
            'D365TalentInsight': '\uF6BC',
            'D365TalentHRCore': '\uF6BD',
            'BacklogList': '\uF6BF',
            'ButtonControl': '\uF6C0',
            'TableGroup': '\uF6D9',
            'MountainClimbing': '\uF6DB',
            'TagUnknown': '\uF6DF',
            'TagUnknownMirror': '\uF6E0',
            'TagUnknown12': '\uF6E1',
            'TagUnknown12Mirror': '\uF6E2',
            'Link12': '\uF6E3',
            'Presentation': '\uF6E4',
            'Presentation12': '\uF6E5',
            'Lock12': '\uF6E6',
            'BuildDefinition': '\uF6E9',
            'ReleaseDefinition': '\uF6EA',
            'SaveTemplate': '\uF6EC',
            'UserGauge': '\uF6ED',
            'BlockedSiteSolid12': '\uF70A',
            'TagSolid': '\uF70E',
            'OfficeChat': '\uF70F',
            'OfficeChatSolid': '\uF710',
            'MailSchedule': '\uF72E'
        }
    };
    index_1.registerIcons(subset, options);
}
exports.initializeIcons = initializeIcons;
//# sourceMappingURL=fabric-icons-14.js.map

/***/ }),

/***/ "../node_modules/@uifabric/icons/lib/fabric-icons-2.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable:max-line-length
var index_1 = __webpack_require__("../node_modules/@uifabric/styling/lib/index.js");
function initializeIcons(baseUrl, options) {
    if (baseUrl === void 0) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none'
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons-2\"",
            src: "url('" + baseUrl + "fabric-icons-2-b9379dbc.woff') format('woff')"
        },
        icons: {
            'Group': '\uE902',
            'World': '\uE909',
            'Comment': '\uE90A',
            'DockLeft': '\uE90C',
            'DockRight': '\uE90D',
            'Repair': '\uE90F',
            'Accounts': '\uE910',
            'RadioBullet': '\uE915',
            'Stopwatch': '\uE916',
            'Clock': '\uE917',
            'WorldClock': '\uE918',
            'AlarmClock': '\uE919',
            'Photo': '\uE91B',
            'Hospital': '\uE91D',
            'Timer': '\uE91E',
            'FullCircleMask': '\uE91F',
            'LocationFill': '\uE920',
            'ChromeMinimize': '\uE921',
            'Annotation': '\uE924',
            'Fingerprint': '\uE928',
            'Handwriting': '\uE929',
            'Completed': '\uE930',
            'Label': '\uE932',
            'FlickDown': '\uE935',
            'FlickUp': '\uE936',
            'FlickLeft': '\uE937',
            'FlickRight': '\uE938',
            'MiniExpand': '\uE93A',
            'MiniContract': '\uE93B',
            'Streaming': '\uE93E',
            'MusicInCollection': '\uE940',
            'OneDriveLogo': '\uE941',
            'CompassNW': '\uE942',
            'Code': '\uE943',
            'LightningBolt': '\uE945',
            'CalculatorMultiply': '\uE947',
            'CalculatorAddition': '\uE948',
            'CalculatorSubtract': '\uE949',
            'CalculatorEqualTo': '\uE94E',
            'PrintfaxPrinterFile': '\uE956',
            'Communications': '\uE95A',
            'Headset': '\uE95B',
            'Health': '\uE95E',
            'ChevronUpSmall': '\uE96D',
            'ChevronDownSmall': '\uE96E',
            'ChevronLeftSmall': '\uE96F',
            'ChevronRightSmall': '\uE970',
            'ChevronUpMed': '\uE971',
            'ChevronDownMed': '\uE972',
            'ChevronLeftMed': '\uE973',
            'ChevronRightMed': '\uE974',
            'PC1': '\uE977',
            'PresenceChickletVideo': '\uE979',
            'Reply': '\uE97A',
            'HalfAlpha': '\uE97E',
            'ConstructionCone': '\uE98F',
            'DoubleChevronLeftMed': '\uE991',
            'Volume0': '\uE992',
            'Volume1': '\uE993',
            'Volume2': '\uE994',
            'Volume3': '\uE995',
            'Chart': '\uE999',
            'Robot': '\uE99A',
            'Manufacturing': '\uE99C',
            'LockSolid': '\uE9A2',
            'BidiLtr': '\uE9AA',
            'BidiRtl': '\uE9AB',
            'RightDoubleQuote': '\uE9B1',
            'Sunny': '\uE9BD',
            'CloudWeather': '\uE9BE',
            'Cloudy': '\uE9BF',
            'PartlyCloudyDay': '\uE9C0',
            'PartlyCloudyNight': '\uE9C1',
            'ClearNight': '\uE9C2',
            'RainShowersDay': '\uE9C3',
            'Rain': '\uE9C4',
            'Thunderstorms': '\uE9C6',
            'RainSnow': '\uE9C7',
            'Snow': '\uE9C8',
            'BlowingSnow': '\uE9C9',
            'Frigid': '\uE9CA',
            'Fog': '\uE9CB',
            'Squalls': '\uE9CC',
            'Duststorm': '\uE9CD',
            'Unknown': '\uE9CE',
            'Precipitation': '\uE9CF',
            'Ribbon': '\uE9D1',
            'AreaChart': '\uE9D2',
            'Assign': '\uE9D3',
            'CheckList': '\uE9D5',
            'Diagnostic': '\uE9D9',
            'Generate': '\uE9DA',
            'LineChart': '\uE9E6',
            'Equalizer': '\uE9E9',
            'BarChartHorizontal': '\uE9EB',
            'BarChartVertical': '\uE9EC',
            'Freezing': '\uE9EF',
            'Processing': '\uE9F5',
            'SnowShowerDay': '\uE9FD',
            'HailDay': '\uEA00'
        }
    };
    index_1.registerIcons(subset, options);
}
exports.initializeIcons = initializeIcons;
//# sourceMappingURL=fabric-icons-2.js.map

/***/ }),

/***/ "../node_modules/@uifabric/icons/lib/fabric-icons-3.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable:max-line-length
var index_1 = __webpack_require__("../node_modules/@uifabric/styling/lib/index.js");
function initializeIcons(baseUrl, options) {
    if (baseUrl === void 0) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none'
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons-3\"",
            src: "url('" + baseUrl + "fabric-icons-3-ef2110da.woff') format('woff')"
        },
        icons: {
            'WorkFlow': '\uEA01',
            'HourGlass': '\uEA03',
            'StoreLogoMed20': '\uEA04',
            'TimeSheet': '\uEA05',
            'TriangleSolid': '\uEA08',
            'VideoSolid': '\uEA0C',
            'RainShowersNight': '\uEA0F',
            'SnowShowerNight': '\uEA11',
            'Teamwork': '\uEA12',
            'HailNight': '\uEA13',
            'PeopleAdd': '\uEA15',
            'Glasses': '\uEA16',
            'DateTime2': '\uEA17',
            'Shield': '\uEA18',
            'Header1': '\uEA19',
            'PageAdd': '\uEA1A',
            'NumberedList': '\uEA1C',
            'PowerBILogo': '\uEA1E',
            'Info2': '\uEA1F',
            'MusicInCollectionFill': '\uEA36',
            'Asterisk': '\uEA38',
            'ErrorBadge': '\uEA39',
            'CircleFill': '\uEA3B',
            'Record2': '\uEA3F',
            'AllAppsMirrored': '\uEA40',
            'BookmarksMirrored': '\uEA41',
            'BulletedListMirrored': '\uEA42',
            'CaretHollowMirrored': '\uEA45',
            'CaretSolidMirrored': '\uEA46',
            'ChromeBackMirrored': '\uEA47',
            'ClosePaneMirrored': '\uEA49',
            'DockLeftMirrored': '\uEA4C',
            'DoubleChevronLeftMedMirrored': '\uEA4D',
            'HelpMirrored': '\uEA51',
            'ImportMirrored': '\uEA52',
            'ListMirrored': '\uEA55',
            'MailForwardMirrored': '\uEA56',
            'MailReplyMirrored': '\uEA57',
            'MailReplyAllMirrored': '\uEA58',
            'OpenPaneMirrored': '\uEA5B',
            'ParkingLocationMirrored': '\uEA5E',
            'SendMirrored': '\uEA63',
            'ShowResultsMirrored': '\uEA65',
            'ThumbnailViewMirrored': '\uEA67',
            'Devices3': '\uEA6C',
            'Lightbulb': '\uEA80',
            'StatusTriangle': '\uEA82',
            'VolumeDisabled': '\uEA85',
            'Puzzle': '\uEA86',
            'EmojiNeutral': '\uEA87',
            'EmojiDisappointed': '\uEA88',
            'HomeSolid': '\uEA8A',
            'Ringer': '\uEA8F',
            'PDF': '\uEA90',
            'HeartBroken': '\uEA92',
            'StoreLogo16': '\uEA96',
            'MultiSelectMirrored': '\uEA98',
            'Broom': '\uEA99',
            'Cocktails': '\uEA9D',
            'Wines': '\uEABF',
            'Articles': '\uEAC1',
            'Cycling': '\uEAC7',
            'DietPlanNotebook': '\uEAC8',
            'Pill': '\uEACB',
            'ExerciseTracker': '\uEACC',
            'HandsFree': '\uEAD0',
            'Medical': '\uEAD4',
            'Running': '\uEADA',
            'Weights': '\uEADB',
            'Trackers': '\uEADF',
            'AddNotes': '\uEAE3',
            'AllCurrency': '\uEAE4',
            'BarChart4': '\uEAE7',
            'CirclePlus': '\uEAEE',
            'Coffee': '\uEAEF',
            'Cotton': '\uEAF3',
            'Market': '\uEAFC',
            'Money': '\uEAFD',
            'PieDouble': '\uEB04',
            'PieSingle': '\uEB05',
            'RemoveFilter': '\uEB08',
            'Savings': '\uEB0B',
            'Sell': '\uEB0C',
            'StockDown': '\uEB0F',
            'StockUp': '\uEB11',
            'Lamp': '\uEB19',
            'Source': '\uEB1B',
            'MSNVideos': '\uEB1C',
            'Cricket': '\uEB1E',
            'Golf': '\uEB1F',
            'Baseball': '\uEB20',
            'Soccer': '\uEB21',
            'MoreSports': '\uEB22',
            'AutoRacing': '\uEB24',
            'CollegeHoops': '\uEB25',
            'CollegeFootball': '\uEB26',
            'ProFootball': '\uEB27',
            'ProHockey': '\uEB28',
            'Rugby': '\uEB2D',
            'SubstitutionsIn': '\uEB31'
        }
    };
    index_1.registerIcons(subset, options);
}
exports.initializeIcons = initializeIcons;
//# sourceMappingURL=fabric-icons-3.js.map

/***/ }),

/***/ "../node_modules/@uifabric/icons/lib/fabric-icons-4.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable:max-line-length
var index_1 = __webpack_require__("../node_modules/@uifabric/styling/lib/index.js");
function initializeIcons(baseUrl, options) {
    if (baseUrl === void 0) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none'
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons-4\"",
            src: "url('" + baseUrl + "fabric-icons-4-aeecd474.woff') format('woff')"
        },
        icons: {
            'Tennis': '\uEB33',
            'Arrivals': '\uEB34',
            'Design': '\uEB3C',
            'Website': '\uEB41',
            'Drop': '\uEB42',
            'SkiResorts': '\uEB45',
            'Snowflake': '\uEB46',
            'BusSolid': '\uEB47',
            'FerrySolid': '\uEB48',
            'AirplaneSolid': '\uEB4C',
            'TrainSolid': '\uEB4D',
            'Ticket': '\uEB54',
            'Devices4': '\uEB66',
            'AzureLogo': '\uEB6A',
            'BingLogo': '\uEB6B',
            'MSNLogo': '\uEB6C',
            'OutlookLogoInverse': '\uEB6D',
            'OfficeLogo': '\uEB6E',
            'SkypeLogo': '\uEB6F',
            'Door': '\uEB75',
            'EditMirrored': '\uEB7E',
            'GiftCard': '\uEB8E',
            'DoubleBookmark': '\uEB8F',
            'StatusErrorFull': '\uEB90',
            'Certificate': '\uEB95',
            'FastForward': '\uEB9D',
            'Rewind': '\uEB9E',
            'Photo2': '\uEB9F',
            'OpenSource': '\uEBC2',
            'Movers': '\uEBCD',
            'CloudDownload': '\uEBD3',
            'Family': '\uEBDA',
            'WindDirection': '\uEBE6',
            'Bug': '\uEBE8',
            'SiteScan': '\uEBEC',
            'BrowserScreenShot': '\uEBED',
            'F12DevTools': '\uEBEE',
            'CSS': '\uEBEF',
            'JS': '\uEBF0',
            'DeliveryTruck': '\uEBF4',
            'ReminderPerson': '\uEBF7',
            'ReminderGroup': '\uEBF8',
            'TabletMode': '\uEBFC',
            'Umbrella': '\uEC04',
            'NetworkTower': '\uEC05',
            'CityNext': '\uEC06',
            'Section': '\uEC0C',
            'OneNoteLogoInverse': '\uEC0D',
            'ToggleFilled': '\uEC11',
            'ToggleBorder': '\uEC12',
            'SliderThumb': '\uEC13',
            'ToggleThumb': '\uEC14',
            'Documentation': '\uEC17',
            'Badge': '\uEC1B',
            'Giftbox': '\uEC1F',
            'VisualStudioLogo': '\uEC22',
            'ExcelLogoInverse': '\uEC28',
            'WordLogoInverse': '\uEC29',
            'PowerPointLogoInverse': '\uEC2A',
            'Cafe': '\uEC32',
            'SpeedHigh': '\uEC4A',
            'Commitments': '\uEC4D',
            'ThisPC': '\uEC4E',
            'MusicNote': '\uEC4F',
            'MicOff': '\uEC54',
            'EdgeLogo': '\uEC60',
            'CompletedSolid': '\uEC61',
            'AlbumRemove': '\uEC62',
            'MessageFill': '\uEC70',
            'TabletSelected': '\uEC74',
            'MobileSelected': '\uEC75',
            'LaptopSelected': '\uEC76',
            'TVMonitorSelected': '\uEC77',
            'DeveloperTools': '\uEC7A',
            'InsertTextBox': '\uEC7D',
            'LowerBrightness': '\uEC8A',
            'DOM': '\uEC8D',
            'CloudUpload': '\uEC8E',
            'ScrollUpDown': '\uEC8F',
            'DateTime': '\uEC92',
            'Event': '\uECA3',
            'Cake': '\uECA4',
            'Org': '\uECA6',
            'PartyLeader': '\uECA7',
            'DRM': '\uECA8',
            'CloudAdd': '\uECA9',
            'AppIconDefault': '\uECAA',
            'Photo2Add': '\uECAB',
            'Photo2Remove': '\uECAC',
            'POI': '\uECAF',
            'AddTo': '\uECC8',
            'RadioBtnOff': '\uECCA',
            'RadioBtnOn': '\uECCB',
            'ExploreContent': '\uECCD',
            'Product': '\uECDC',
            'ProgressLoopInner': '\uECDE',
            'ProgressLoopOuter': '\uECDF',
            'Blocked2': '\uECE4',
            'FangBody': '\uECEB',
            'ChatInviteFriend': '\uECFE'
        }
    };
    index_1.registerIcons(subset, options);
}
exports.initializeIcons = initializeIcons;
//# sourceMappingURL=fabric-icons-4.js.map

/***/ }),

/***/ "../node_modules/@uifabric/icons/lib/fabric-icons-5.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable:max-line-length
var index_1 = __webpack_require__("../node_modules/@uifabric/styling/lib/index.js");
function initializeIcons(baseUrl, options) {
    if (baseUrl === void 0) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none'
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons-5\"",
            src: "url('" + baseUrl + "fabric-icons-5-f6547654.woff') format('woff')"
        },
        icons: {
            'Crown': '\uED01',
            'Diamond': '\uED02',
            'ScaleUp': '\uED09',
            'Feedback': '\uED15',
            'SharepointLogoInverse': '\uED18',
            'YammerLogo': '\uED19',
            'Hide': '\uED1A',
            'Uneditable': '\uED1D',
            'ReturnToSession': '\uED24',
            'OpenFolderHorizontal': '\uED25',
            'CalendarMirrored': '\uED28',
            'SwayLogoInverse': '\uED29',
            'OutOfOffice': '\uED34',
            'Trophy': '\uED3F',
            'ReopenPages': '\uED50',
            'EmojiTabSymbols': '\uED58',
            'AADLogo': '\uED68',
            'AccessLogo': '\uED69',
            'AdminALogoInverse32': '\uED6A',
            'AdminCLogoInverse32': '\uED6B',
            'AdminDLogoInverse32': '\uED6C',
            'AdminELogoInverse32': '\uED6D',
            'AdminLLogoInverse32': '\uED6E',
            'AdminMLogoInverse32': '\uED6F',
            'AdminOLogoInverse32': '\uED70',
            'AdminPLogoInverse32': '\uED71',
            'AdminSLogoInverse32': '\uED72',
            'AdminYLogoInverse32': '\uED73',
            'DelveLogoInverse': '\uED76',
            'ExchangeLogoInverse': '\uED78',
            'LyncLogo': '\uED79',
            'OfficeVideoLogoInverse': '\uED7A',
            'SocialListeningLogo': '\uED7C',
            'VisioLogoInverse': '\uED7D',
            'Balloons': '\uED7E',
            'Cat': '\uED7F',
            'MailAlert': '\uED80',
            'MailCheck': '\uED81',
            'MailLowImportance': '\uED82',
            'MailPause': '\uED83',
            'MailRepeat': '\uED84',
            'SecurityGroup': '\uED85',
            'Table': '\uED86',
            'VoicemailForward': '\uED87',
            'VoicemailReply': '\uED88',
            'Waffle': '\uED89',
            'RemoveEvent': '\uED8A',
            'EventInfo': '\uED8B',
            'ForwardEvent': '\uED8C',
            'WipePhone': '\uED8D',
            'AddOnlineMeeting': '\uED8E',
            'JoinOnlineMeeting': '\uED8F',
            'RemoveLink': '\uED90',
            'PeopleBlock': '\uED91',
            'PeopleRepeat': '\uED92',
            'PeopleAlert': '\uED93',
            'PeoplePause': '\uED94',
            'TransferCall': '\uED95',
            'AddPhone': '\uED96',
            'UnknownCall': '\uED97',
            'NoteReply': '\uED98',
            'NoteForward': '\uED99',
            'NotePinned': '\uED9A',
            'RemoveOccurrence': '\uED9B',
            'Timeline': '\uED9C',
            'EditNote': '\uED9D',
            'CircleHalfFull': '\uED9E',
            'Room': '\uED9F',
            'Unsubscribe': '\uEDA0',
            'Subscribe': '\uEDA1',
            'HardDrive': '\uEDA2',
            'RecurringTask': '\uEDB2',
            'TaskManager': '\uEDB7',
            'TaskManagerMirrored': '\uEDB8',
            'Combine': '\uEDBB',
            'Split': '\uEDBC',
            'DoubleChevronUp': '\uEDBD',
            'DoubleChevronLeft': '\uEDBE',
            'DoubleChevronRight': '\uEDBF',
            'TextBox': '\uEDC2',
            'TextField': '\uEDC3',
            'NumberField': '\uEDC4',
            'Dropdown': '\uEDC5',
            'BookingsLogo': '\uEDC7',
            'ClassNotebookLogoInverse': '\uEDC8',
            'DelveAnalyticsLogo': '\uEDCA',
            'DocsLogoInverse': '\uEDCB',
            'Dynamics365Logo': '\uEDCC',
            'DynamicSMBLogo': '\uEDCD',
            'OfficeAssistantLogo': '\uEDCE',
            'OfficeStoreLogo': '\uEDCF',
            'OneNoteEduLogoInverse': '\uEDD0',
            'PlannerLogo': '\uEDD1',
            'PowerApps': '\uEDD2',
            'Suitcase': '\uEDD3',
            'ProjectLogoInverse': '\uEDD4',
            'CaretLeft8': '\uEDD5',
            'CaretRight8': '\uEDD6',
            'CaretUp8': '\uEDD7',
            'CaretDown8': '\uEDD8'
        }
    };
    index_1.registerIcons(subset, options);
}
exports.initializeIcons = initializeIcons;
//# sourceMappingURL=fabric-icons-5.js.map

/***/ }),

/***/ "../node_modules/@uifabric/icons/lib/fabric-icons-6.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable:max-line-length
var index_1 = __webpack_require__("../node_modules/@uifabric/styling/lib/index.js");
function initializeIcons(baseUrl, options) {
    if (baseUrl === void 0) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none'
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons-6\"",
            src: "url('" + baseUrl + "fabric-icons-6-3954c770.woff') format('woff')"
        },
        icons: {
            'CaretLeftSolid8': '\uEDD9',
            'CaretRightSolid8': '\uEDDA',
            'CaretUpSolid8': '\uEDDB',
            'CaretDownSolid8': '\uEDDC',
            'ClearFormatting': '\uEDDD',
            'Superscript': '\uEDDE',
            'Subscript': '\uEDDF',
            'Strikethrough': '\uEDE0',
            'Export': '\uEDE1',
            'ExportMirrored': '\uEDE2',
            'SingleBookmark': '\uEDFF',
            'SingleBookmarkSolid': '\uEE00',
            'DoubleChevronDown': '\uEE04',
            'FollowUser': '\uEE05',
            'ReplyAll': '\uEE0A',
            'WorkforceManagement': '\uEE0F',
            'RecruitmentManagement': '\uEE12',
            'Questionnaire': '\uEE19',
            'ManagerSelfService': '\uEE23',
            'ReplyMirrored': '\uEE35',
            'ReplyAllMirrored': '\uEE36',
            'Medal': '\uEE38',
            'AddGroup': '\uEE3D',
            'QuestionnaireMirrored': '\uEE4B',
            'TemporaryUser': '\uEE58',
            'CaretSolid16': '\uEE62',
            'GroupedDescending': '\uEE66',
            'GroupedAscending': '\uEE67',
            'AwayStatus': '\uEE6A',
            'MyMoviesTV': '\uEE6C',
            'GenericScan': '\uEE6F',
            'AustralianRules': '\uEE70',
            'WifiEthernet': '\uEE77',
            'TrackersMirrored': '\uEE92',
            'DateTimeMirrored': '\uEE93',
            'StopSolid': '\uEE95',
            'DoubleChevronUp12': '\uEE96',
            'DoubleChevronDown12': '\uEE97',
            'DoubleChevronLeft12': '\uEE98',
            'DoubleChevronRight12': '\uEE99',
            'CalendarAgenda': '\uEE9A',
            'AddEvent': '\uEEB5',
            'AssetLibrary': '\uEEB6',
            'DataConnectionLibrary': '\uEEB7',
            'DocLibrary': '\uEEB8',
            'FormLibrary': '\uEEB9',
            'FormLibraryMirrored': '\uEEBA',
            'ReportLibrary': '\uEEBB',
            'ReportLibraryMirrored': '\uEEBC',
            'ContactCard': '\uEEBD',
            'CustomList': '\uEEBE',
            'CustomListMirrored': '\uEEBF',
            'IssueTracking': '\uEEC0',
            'IssueTrackingMirrored': '\uEEC1',
            'PictureLibrary': '\uEEC2',
            'OfficeAddinsLogo': '\uEEC7',
            'OfflineOneDriveParachute': '\uEEC8',
            'OfflineOneDriveParachuteDisabled': '\uEEC9',
            'TriangleSolidUp12': '\uEECC',
            'TriangleSolidDown12': '\uEECD',
            'TriangleSolidLeft12': '\uEECE',
            'TriangleSolidRight12': '\uEECF',
            'TriangleUp12': '\uEED0',
            'TriangleDown12': '\uEED1',
            'TriangleLeft12': '\uEED2',
            'TriangleRight12': '\uEED3',
            'ArrowUpRight8': '\uEED4',
            'ArrowDownRight8': '\uEED5',
            'DocumentSet': '\uEED6',
            'DelveAnalytics': '\uEEEE',
            'ArrowUpRightMirrored8': '\uEEEF',
            'ArrowDownRightMirrored8': '\uEEF0',
            'CompanyDirectory': '\uEF0D',
            'CompanyDirectoryMirrored': '\uEF2B',
            'OneDriveAdd': '\uEF32',
            'ProfileSearch': '\uEF35',
            'Header2': '\uEF36',
            'Header3': '\uEF37',
            'Header4': '\uEF38',
            'Eyedropper': '\uEF3C',
            'MarketDown': '\uEF42',
            'CalendarWorkWeek': '\uEF51',
            'SidePanel': '\uEF52',
            'GlobeFavorite': '\uEF53',
            'CaretTopLeftSolid8': '\uEF54',
            'CaretTopRightSolid8': '\uEF55',
            'ViewAll2': '\uEF56',
            'DocumentReply': '\uEF57',
            'PlayerSettings': '\uEF58',
            'ReceiptForward': '\uEF59',
            'ReceiptReply': '\uEF5A',
            'ReceiptCheck': '\uEF5B',
            'Fax': '\uEF5C',
            'RecurringEvent': '\uEF5D',
            'ReplyAlt': '\uEF5E',
            'ReplyAllAlt': '\uEF5F',
            'EditStyle': '\uEF60',
            'EditMail': '\uEF61',
            'Lifesaver': '\uEF62',
            'LifesaverLock': '\uEF63'
        }
    };
    index_1.registerIcons(subset, options);
}
exports.initializeIcons = initializeIcons;
//# sourceMappingURL=fabric-icons-6.js.map

/***/ }),

/***/ "../node_modules/@uifabric/icons/lib/fabric-icons-7.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable:max-line-length
var index_1 = __webpack_require__("../node_modules/@uifabric/styling/lib/index.js");
function initializeIcons(baseUrl, options) {
    if (baseUrl === void 0) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none'
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons-7\"",
            src: "url('" + baseUrl + "fabric-icons-7-02107cf8.woff') format('woff')"
        },
        icons: {
            'InboxCheck': '\uEF64',
            'FolderSearch': '\uEF65',
            'CollapseMenu': '\uEF66',
            'ExpandMenu': '\uEF67',
            'Boards': '\uEF68',
            'SunAdd': '\uEF69',
            'SunQuestionMark': '\uEF6A',
            'LandscapeOrientation': '\uEF6B',
            'DocumentSearch': '\uEF6C',
            'PublicCalendar': '\uEF6D',
            'PublicContactCard': '\uEF6E',
            'PublicEmail': '\uEF6F',
            'PublicFolder': '\uEF70',
            'WordDocument': '\uEF71',
            'PowerPointDocument': '\uEF72',
            'ExcelDocument': '\uEF73',
            'GroupedList': '\uEF74',
            'ClassroomLogo': '\uEF75',
            'Sections': '\uEF76',
            'EditPhoto': '\uEF77',
            'Starburst': '\uEF78',
            'ShareiOS': '\uEF79',
            'AirTickets': '\uEF7A',
            'PencilReply': '\uEF7B',
            'Tiles2': '\uEF7C',
            'SkypeCircleCheck': '\uEF7D',
            'SkypeCircleClock': '\uEF7E',
            'SkypeCircleMinus': '\uEF7F',
            'SkypeMessage': '\uEF83',
            'ClosedCaption': '\uEF84',
            'ATPLogo': '\uEF85',
            'OfficeFormsLogoInverse': '\uEF86',
            'RecycleBin': '\uEF87',
            'EmptyRecycleBin': '\uEF88',
            'Hide2': '\uEF89',
            'Breadcrumb': '\uEF8C',
            'BirthdayCake': '\uEF8D',
            'TimeEntry': '\uEF95',
            'PageEdit': '\uEFB6',
            'PageRemove': '\uEFBA',
            'Database': '\uEFC7',
            'EditContact': '\uEFD3',
            'ConnectContacts': '\uEFD4',
            'ActivateOrders': '\uEFE0',
            'DeactivateOrders': '\uEFE1',
            'DocumentManagement': '\uEFFC',
            'CRMReport': '\uEFFE',
            'ZipFolder': '\uF012',
            'SurveyQuestions': '\uF01B',
            'TextDocument': '\uF029',
            'TextDocumentShared': '\uF02B',
            'PageCheckedOut': '\uF02C',
            'SaveAndClose': '\uF038',
            'Script': '\uF03A',
            'Archive': '\uF03F',
            'ActivityFeed': '\uF056',
            'EventDate': '\uF059',
            'ArrowUpRight': '\uF069',
            'CaretRight': '\uF06B',
            'SetAction': '\uF071',
            'CaretSolidLeft': '\uF08D',
            'CaretSolidDown': '\uF08E',
            'CaretSolidRight': '\uF08F',
            'CaretSolidUp': '\uF090',
            'PowerAppsLogo': '\uF091',
            'PowerApps2Logo': '\uF092',
            'SearchIssue': '\uF09A',
            'SearchIssueMirrored': '\uF09B',
            'FabricAssetLibrary': '\uF09C',
            'FabricDataConnectionLibrary': '\uF09D',
            'FabricDocLibrary': '\uF09E',
            'FabricFormLibrary': '\uF09F',
            'FabricFormLibraryMirrored': '\uF0A0',
            'FabricReportLibrary': '\uF0A1',
            'FabricReportLibraryMirrored': '\uF0A2',
            'FabricPublicFolder': '\uF0A3',
            'FabricFolderSearch': '\uF0A4',
            'FabricMovetoFolder': '\uF0A5',
            'FabricUnsyncFolder': '\uF0A6',
            'FabricSyncFolder': '\uF0A7',
            'FabricOpenFolderHorizontal': '\uF0A8',
            'FabricFolder': '\uF0A9',
            'FabricFolderFill': '\uF0AA',
            'FabricNewFolder': '\uF0AB',
            'FabricPictureLibrary': '\uF0AC',
            'AddFavorite': '\uF0C8',
            'AddFavoriteFill': '\uF0C9',
            'BufferTimeBefore': '\uF0CF',
            'BufferTimeAfter': '\uF0D0',
            'BufferTimeBoth': '\uF0D1',
            'CannedChat': '\uF0F2',
            'SkypeForBusinessLogo': '\uF0FC',
            'PageCheckedin': '\uF104',
            'ReadOutLoud': '\uF112',
            'CaretBottomLeftSolid8': '\uF121',
            'CaretBottomRightSolid8': '\uF122',
            'FolderHorizontal': '\uF12B',
            'MicrosoftStaffhubLogo': '\uF130',
            'GiftboxOpen': '\uF133',
            'StatusCircleOuter': '\uF136'
        }
    };
    index_1.registerIcons(subset, options);
}
exports.initializeIcons = initializeIcons;
//# sourceMappingURL=fabric-icons-7.js.map

/***/ }),

/***/ "../node_modules/@uifabric/icons/lib/fabric-icons-8.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable:max-line-length
var index_1 = __webpack_require__("../node_modules/@uifabric/styling/lib/index.js");
function initializeIcons(baseUrl, options) {
    if (baseUrl === void 0) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none'
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons-8\"",
            src: "url('" + baseUrl + "fabric-icons-8-645fa64e.woff') format('woff')"
        },
        icons: {
            'StatusCircleInner': '\uF137',
            'StatusCircleRing': '\uF138',
            'StatusTriangleOuter': '\uF139',
            'StatusTriangleInner': '\uF13A',
            'StatusTriangleExclamation': '\uF13B',
            'StatusCircleExclamation': '\uF13C',
            'StatusCircleErrorX': '\uF13D',
            'StatusCircleInfo': '\uF13F',
            'StatusCircleBlock2': '\uF141',
            'StatusCircleQuestionMark': '\uF142',
            'Toll': '\uF160',
            'ExploreContentSingle': '\uF164',
            'CollapseContent': '\uF165',
            'CollapseContentSingle': '\uF166',
            'InfoSolid': '\uF167',
            'ProgressRingDots': '\uF16A',
            'CaloriesAdd': '\uF172',
            'BranchFork': '\uF173',
            'MobileReport': '\uF18A',
            'HardDriveGroup': '\uF18F',
            'FastMode': '\uF19A',
            'ToggleOn': '\uF19E',
            'ToggleOff': '\uF19F',
            'Trophy2': '\uF1AE',
            'BucketColor': '\uF1B6',
            'BucketColorFill': '\uF1B7',
            'Taskboard': '\uF1C2',
            'SingleColumn': '\uF1D3',
            'DoubleColumn': '\uF1D4',
            'TripleColumn': '\uF1D5',
            'ColumnLeftTwoThirds': '\uF1D6',
            'ColumnRightTwoThirds': '\uF1D7',
            'AccessLogoFill': '\uF1DB',
            'AnalyticsLogo': '\uF1DE',
            'AnalyticsQuery': '\uF1DF',
            'NewAnalyticsQuery': '\uF1E0',
            'AnalyticsReport': '\uF1E1',
            'WordLogo': '\uF1E3',
            'WordLogoFill': '\uF1E4',
            'ExcelLogo': '\uF1E5',
            'ExcelLogoFill': '\uF1E6',
            'OneNoteLogo': '\uF1E7',
            'OneNoteLogoFill': '\uF1E8',
            'OutlookLogo': '\uF1E9',
            'OutlookLogoFill': '\uF1EA',
            'PowerPointLogo': '\uF1EB',
            'PowerPointLogoFill': '\uF1EC',
            'PublisherLogo': '\uF1ED',
            'PublisherLogoFill': '\uF1EE',
            'ScheduleEventAction': '\uF1EF',
            'FlameSolid': '\uF1F3',
            'ServerProcesses': '\uF1FE',
            'Server': '\uF201',
            'SaveAll': '\uF203',
            'LinkedInLogo': '\uF20A',
            'Decimals': '\uF218',
            'SidePanelMirrored': '\uF221',
            'ProtectRestrict': '\uF22A',
            'UnknownMirrored': '\uF22E',
            'PublicContactCardMirrored': '\uF230',
            'GridViewSmall': '\uF232',
            'GridViewMedium': '\uF233',
            'GridViewLarge': '\uF234',
            'Step': '\uF241',
            'StepInsert': '\uF242',
            'StepShared': '\uF243',
            'StepSharedAdd': '\uF244',
            'StepSharedInsert': '\uF245',
            'ViewDashboard': '\uF246',
            'ViewList': '\uF247',
            'ViewListGroup': '\uF248',
            'ViewListTree': '\uF249',
            'TriggerAuto': '\uF24A',
            'TriggerUser': '\uF24B',
            'PivotChart': '\uF24C',
            'StackedBarChart': '\uF24D',
            'StackedLineChart': '\uF24E',
            'BuildQueue': '\uF24F',
            'BuildQueueNew': '\uF250',
            'UserFollowed': '\uF25C',
            'ContactLink': '\uF25F',
            'Stack': '\uF26F',
            'Bullseye': '\uF272',
            'VennDiagram': '\uF273',
            'FiveTileGrid': '\uF274',
            'FocalPoint': '\uF277',
            'RingerRemove': '\uF279',
            'TeamsLogoInverse': '\uF27A',
            'TeamsLogo': '\uF27B',
            'TeamsLogoFill': '\uF27C',
            'SkypeForBusinessLogoFill': '\uF27D',
            'SharepointLogo': '\uF27E',
            'SharepointLogoFill': '\uF27F',
            'DelveLogo': '\uF280',
            'DelveLogoFill': '\uF281',
            'OfficeVideoLogo': '\uF282',
            'OfficeVideoLogoFill': '\uF283',
            'ExchangeLogo': '\uF284',
            'ExchangeLogoFill': '\uF285',
            'DocumentApproval': '\uF28B'
        }
    };
    index_1.registerIcons(subset, options);
}
exports.initializeIcons = initializeIcons;
//# sourceMappingURL=fabric-icons-8.js.map

/***/ }),

/***/ "../node_modules/@uifabric/icons/lib/fabric-icons-9.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable:max-line-length
var index_1 = __webpack_require__("../node_modules/@uifabric/styling/lib/index.js");
function initializeIcons(baseUrl, options) {
    if (baseUrl === void 0) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none'
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons-9\"",
            src: "url('" + baseUrl + "fabric-icons-9-53746c82.woff') format('woff')"
        },
        icons: {
            'CloneToDesktop': '\uF28C',
            'InstallToDrive': '\uF28D',
            'Blur': '\uF28E',
            'Build': '\uF28F',
            'ProcessMetaTask': '\uF290',
            'BranchFork2': '\uF291',
            'BranchLocked': '\uF292',
            'BranchCommit': '\uF293',
            'BranchCompare': '\uF294',
            'BranchMerge': '\uF295',
            'BranchPullRequest': '\uF296',
            'BranchSearch': '\uF297',
            'BranchShelveset': '\uF298',
            'RawSource': '\uF299',
            'MergeDuplicate': '\uF29A',
            'RowsGroup': '\uF29B',
            'RowsChild': '\uF29C',
            'Deploy': '\uF29D',
            'Redeploy': '\uF29E',
            'ServerEnviroment': '\uF29F',
            'VisioDiagram': '\uF2A0',
            'HighlightMappedShapes': '\uF2A1',
            'TextCallout': '\uF2A2',
            'IconSetsFlag': '\uF2A4',
            'VisioLogo': '\uF2A7',
            'VisioLogoFill': '\uF2A8',
            'VisioDocument': '\uF2A9',
            'TimelineProgress': '\uF2AA',
            'TimelineDelivery': '\uF2AB',
            'Backlog': '\uF2AC',
            'TeamFavorite': '\uF2AD',
            'TaskGroup': '\uF2AE',
            'TaskGroupMirrored': '\uF2AF',
            'ScopeTemplate': '\uF2B0',
            'AssessmentGroupTemplate': '\uF2B1',
            'NewTeamProject': '\uF2B2',
            'CommentAdd': '\uF2B3',
            'CommentNext': '\uF2B4',
            'CommentPrevious': '\uF2B5',
            'ShopServer': '\uF2B6',
            'LocaleLanguage': '\uF2B7',
            'QueryList': '\uF2B8',
            'UserSync': '\uF2B9',
            'UserPause': '\uF2BA',
            'StreamingOff': '\uF2BB',
            'ArrowTallUpLeft': '\uF2BD',
            'ArrowTallUpRight': '\uF2BE',
            'ArrowTallDownLeft': '\uF2BF',
            'ArrowTallDownRight': '\uF2C0',
            'FieldEmpty': '\uF2C1',
            'FieldFilled': '\uF2C2',
            'FieldChanged': '\uF2C3',
            'FieldNotChanged': '\uF2C4',
            'RingerOff': '\uF2C5',
            'PlayResume': '\uF2C6',
            'BulletedList2': '\uF2C7',
            'BulletedList2Mirrored': '\uF2C8',
            'ImageCrosshair': '\uF2C9',
            'GitGraph': '\uF2CA',
            'Repo': '\uF2CB',
            'RepoSolid': '\uF2CC',
            'FolderQuery': '\uF2CD',
            'FolderList': '\uF2CE',
            'FolderListMirrored': '\uF2CF',
            'LocationOutline': '\uF2D0',
            'POISolid': '\uF2D1',
            'CalculatorNotEqualTo': '\uF2D2',
            'BoxSubtractSolid': '\uF2D3',
            'BoxAdditionSolid': '\uF2D4',
            'BoxMultiplySolid': '\uF2D5',
            'BoxPlaySolid': '\uF2D6',
            'BoxCheckmarkSolid': '\uF2D7',
            'CirclePauseSolid': '\uF2D8',
            'CirclePause': '\uF2D9',
            'MSNVideosSolid': '\uF2DA',
            'CircleStopSolid': '\uF2DB',
            'CircleStop': '\uF2DC',
            'NavigateBack': '\uF2DD',
            'NavigateBackMirrored': '\uF2DE',
            'NavigateForward': '\uF2DF',
            'NavigateForwardMirrored': '\uF2E0',
            'UnknownSolid': '\uF2E1',
            'UnknownMirroredSolid': '\uF2E2',
            'CircleAddition': '\uF2E3',
            'CircleAdditionSolid': '\uF2E4',
            'FilePDB': '\uF2E5',
            'FileTemplate': '\uF2E6',
            'FileSQL': '\uF2E7',
            'FileJAVA': '\uF2E8',
            'FileASPX': '\uF2E9',
            'FileCSS': '\uF2EA',
            'FileSass': '\uF2EB',
            'FileLess': '\uF2EC',
            'FileHTML': '\uF2ED',
            'JavaScriptLanguage': '\uF2EE',
            'CSharpLanguage': '\uF2EF',
            'CSharp': '\uF2F0',
            'VisualBasicLanguage': '\uF2F1',
            'VB': '\uF2F2',
            'CPlusPlusLanguage': '\uF2F3'
        }
    };
    index_1.registerIcons(subset, options);
}
exports.initializeIcons = initializeIcons;
//# sourceMappingURL=fabric-icons-9.js.map

/***/ }),

/***/ "../node_modules/@uifabric/icons/lib/fabric-icons.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable:max-line-length
var index_1 = __webpack_require__("../node_modules/@uifabric/styling/lib/index.js");
function initializeIcons(baseUrl, options) {
    if (baseUrl === void 0) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none'
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons\"",
            src: "url('" + baseUrl + "fabric-icons-a13498cf.woff') format('woff')"
        },
        icons: {
            'GlobalNavButton': '\uE700',
            'ChevronDown': '\uE70D',
            'ChevronUp': '\uE70E',
            'Edit': '\uE70F',
            'Add': '\uE710',
            'Cancel': '\uE711',
            'More': '\uE712',
            'Settings': '\uE713',
            'Mail': '\uE715',
            'Filter': '\uE71C',
            'Search': '\uE721',
            'Share': '\uE72D',
            'BlockedSite': '\uE72F',
            'FavoriteStar': '\uE734',
            'FavoriteStarFill': '\uE735',
            'CheckMark': '\uE73E',
            'Delete': '\uE74D',
            'ChevronLeft': '\uE76B',
            'ChevronRight': '\uE76C',
            'Calendar': '\uE787',
            'Megaphone': '\uE789',
            'Undo': '\uE7A7',
            'Flag': '\uE7C1',
            'Page': '\uE7C3',
            'Pinned': '\uE840',
            'View': '\uE890',
            'Clear': '\uE894',
            'Download': '\uE896',
            'Upload': '\uE898',
            'Folder': '\uE8B7',
            'Sort': '\uE8CB',
            'AlignRight': '\uE8E2',
            'AlignLeft': '\uE8E4',
            'Tag': '\uE8EC',
            'AddFriend': '\uE8FA',
            'Info': '\uE946',
            'SortLines': '\uE9D0',
            'List': '\uEA37',
            'CircleRing': '\uEA3A',
            'Heart': '\uEB51',
            'HeartFill': '\uEB52',
            'Tiles': '\uECA5',
            'Embed': '\uECCE',
            'Glimmer': '\uECF4',
            'Ascending': '\uEDC0',
            'Descending': '\uEDC1',
            'SortUp': '\uEE68',
            'SortDown': '\uEE69',
            'SyncToPC': '\uEE6E',
            'LargeGrid': '\uEECB',
            'SkypeCheck': '\uEF80',
            'SkypeClock': '\uEF81',
            'SkypeMinus': '\uEF82',
            'ClearFilter': '\uEF8F',
            'Flow': '\uEF90',
            'StatusCircleCheckmark': '\uF13E',
            'MoreVertical': '\uF2BC'
        }
    };
    index_1.registerIcons(subset, options);
}
exports.initializeIcons = initializeIcons;
//# sourceMappingURL=fabric-icons.js.map

/***/ }),

/***/ "../node_modules/@uifabric/icons/lib/iconAliases.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = __webpack_require__("../node_modules/@uifabric/styling/lib/index.js");
index_1.registerIconAlias('trash', 'delete');
index_1.registerIconAlias('onedrive', 'onedrivelogo');
//# sourceMappingURL=iconAliases.js.map

/***/ }),

/***/ "../node_modules/@uifabric/icons/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var fabric_icons_1 = __webpack_require__("../node_modules/@uifabric/icons/lib/fabric-icons.js");
var fabric_icons_0_1 = __webpack_require__("../node_modules/@uifabric/icons/lib/fabric-icons-0.js");
var fabric_icons_1_1 = __webpack_require__("../node_modules/@uifabric/icons/lib/fabric-icons-1.js");
var fabric_icons_2_1 = __webpack_require__("../node_modules/@uifabric/icons/lib/fabric-icons-2.js");
var fabric_icons_3_1 = __webpack_require__("../node_modules/@uifabric/icons/lib/fabric-icons-3.js");
var fabric_icons_4_1 = __webpack_require__("../node_modules/@uifabric/icons/lib/fabric-icons-4.js");
var fabric_icons_5_1 = __webpack_require__("../node_modules/@uifabric/icons/lib/fabric-icons-5.js");
var fabric_icons_6_1 = __webpack_require__("../node_modules/@uifabric/icons/lib/fabric-icons-6.js");
var fabric_icons_7_1 = __webpack_require__("../node_modules/@uifabric/icons/lib/fabric-icons-7.js");
var fabric_icons_8_1 = __webpack_require__("../node_modules/@uifabric/icons/lib/fabric-icons-8.js");
var fabric_icons_9_1 = __webpack_require__("../node_modules/@uifabric/icons/lib/fabric-icons-9.js");
var fabric_icons_10_1 = __webpack_require__("../node_modules/@uifabric/icons/lib/fabric-icons-10.js");
var fabric_icons_11_1 = __webpack_require__("../node_modules/@uifabric/icons/lib/fabric-icons-11.js");
var fabric_icons_12_1 = __webpack_require__("../node_modules/@uifabric/icons/lib/fabric-icons-12.js");
var fabric_icons_13_1 = __webpack_require__("../node_modules/@uifabric/icons/lib/fabric-icons-13.js");
var fabric_icons_14_1 = __webpack_require__("../node_modules/@uifabric/icons/lib/fabric-icons-14.js");
__webpack_require__("../node_modules/@uifabric/icons/lib/iconAliases.js");
var DEFAULT_BASE_URL = 'https://spoprod-a.akamaihd.net/files/fabric/assets/icons/';
function initializeIcons(baseUrl, options) {
    if (baseUrl === void 0) { baseUrl = DEFAULT_BASE_URL; }
    [fabric_icons_1.initializeIcons, fabric_icons_0_1.initializeIcons, fabric_icons_1_1.initializeIcons, fabric_icons_2_1.initializeIcons, fabric_icons_3_1.initializeIcons, fabric_icons_4_1.initializeIcons, fabric_icons_5_1.initializeIcons, fabric_icons_6_1.initializeIcons, fabric_icons_7_1.initializeIcons, fabric_icons_8_1.initializeIcons, fabric_icons_9_1.initializeIcons, fabric_icons_10_1.initializeIcons, fabric_icons_11_1.initializeIcons, fabric_icons_12_1.initializeIcons, fabric_icons_13_1.initializeIcons, fabric_icons_14_1.initializeIcons].forEach(function (initialize) { return initialize(baseUrl, options); });
}
exports.initializeIcons = initializeIcons;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../node_modules/base64-js/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  for (var i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ "../node_modules/buffer/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__("../node_modules/base64-js/index.js")
var ieee754 = __webpack_require__("../node_modules/ieee754/index.js")
var isArray = __webpack_require__("../node_modules/buffer/node_modules/isarray/index.js")

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../node_modules/buffer/node_modules/isarray/index.js":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),

/***/ "../node_modules/create-emotion/dist/index.esm.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_memoize__ = __webpack_require__("../node_modules/@emotion/memoize/dist/memoize.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_unitless__ = __webpack_require__("../node_modules/@emotion/unitless/dist/unitless.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_hash__ = __webpack_require__("../node_modules/@emotion/hash/dist/hash.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emotion_stylis__ = __webpack_require__("../node_modules/@emotion/stylis/dist/stylis.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet__ = __webpack_require__("../node_modules/stylis-rule-sheet/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet__);






var hyphenateRegex = /[A-Z]|^ms/g;
var processStyleName = Object(__WEBPACK_IMPORTED_MODULE_0__emotion_memoize__["a" /* default */])(function (styleName) {
  return styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});
var processStyleValue = function processStyleValue(key, value) {
  if (value == null || typeof value === 'boolean') {
    return '';
  }

  if (__WEBPACK_IMPORTED_MODULE_1__emotion_unitless__["a" /* default */][key] !== 1 && key.charCodeAt(1) !== 45 && // custom properties
  !isNaN(value) && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (process.env.NODE_ENV !== 'production') {
  var contentValuePattern = /(attr|calc|counters?|url)\(/;
  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    return oldProcessStyleValue(key, value);
  };
}

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'function':
        if (process.env.NODE_ENV !== 'production') {
          console.error('Passing functions to cx is deprecated and will be removed in the next major version of Emotion.\n' + 'Please call the function before passing it to cx.');
        }

        toAdd = classnames([arg()]);
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};
var isBrowser = typeof document !== 'undefined';

/*

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance
- 'polyfills' on server side

// usage

import StyleSheet from 'glamor/lib/sheet'
let styleSheet = new StyleSheet()

styleSheet.inject()
- 'injects' the stylesheet into the page (or into memory if on server)

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function makeStyleTag(opts) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', opts.key || '');

  if (opts.nonce !== undefined) {
    tag.setAttribute('nonce', opts.nonce);
  }

  tag.appendChild(document.createTextNode('')) // $FlowFixMe
  ;
  (opts.container !== undefined ? opts.container : document.head).appendChild(tag);
  return tag;
}

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(options) {
    this.isSpeedy = process.env.NODE_ENV === 'production'; // the big drawback here is that the css won't be editable in devtools

    this.tags = [];
    this.ctr = 0;
    this.opts = options;
  }

  var _proto = StyleSheet.prototype;

  _proto.inject = function inject() {
    if (this.injected) {
      throw new Error('already injected!');
    }

    this.tags[0] = makeStyleTag(this.opts);
    this.injected = true;
  };

  _proto.speedy = function speedy(bool) {
    if (this.ctr !== 0) {
      // cannot change speedy mode after inserting any rule to sheet. Either call speedy(${bool}) earlier in your app, or call flush() before speedy(${bool})
      throw new Error("cannot change speedy now");
    }

    this.isSpeedy = !!bool;
  };

  _proto.insert = function insert(rule, sourceMap) {
    // this is the ultrafast version, works across browsers
    if (this.isSpeedy) {
      var tag = this.tags[this.tags.length - 1];
      var sheet = sheetForTag(tag);

      try {
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (process.env.NODE_ENV !== 'production') {
          console.warn('illegal rule', rule); // eslint-disable-line no-console
        }
      }
    } else {
      var _tag = makeStyleTag(this.opts);

      this.tags.push(_tag);

      _tag.appendChild(document.createTextNode(rule + (sourceMap || '')));
    }

    this.ctr++;

    if (this.ctr % 65000 === 0) {
      this.tags.push(makeStyleTag(this.opts));
    }
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0; // todo - look for remnants in document.styleSheets

    this.injected = false;
  };

  return StyleSheet;
}();

function createEmotion(context, options) {
  if (context.__SECRET_EMOTION__ !== undefined) {
    return context.__SECRET_EMOTION__;
  }

  if (options === undefined) options = {};
  var key = options.key || 'css';

  if (process.env.NODE_ENV !== 'production') {
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var current;

  function insertRule(rule) {
    current += rule;

    if (isBrowser) {
      sheet.insert(rule, currentSourceMap);
    }
  }

  var insertionPlugin = __WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet___default()(insertRule);
  var stylisOptions;

  if (options.prefix !== undefined) {
    stylisOptions = {
      prefix: options.prefix
    };
  }

  var caches = {
    registered: {},
    inserted: {},
    nonce: options.nonce,
    key: key
  };
  var sheet = new StyleSheet(options);

  if (isBrowser) {
    // 🚀
    sheet.inject();
  }

  var stylis = new __WEBPACK_IMPORTED_MODULE_3__emotion_stylis__["a" /* default */](stylisOptions);
  stylis.use(options.stylisPlugins)(insertionPlugin);
  var currentSourceMap = '';

  function handleInterpolation(interpolation, couldBeSelectorInterpolation) {
    if (interpolation == null) {
      return '';
    }

    switch (typeof interpolation) {
      case 'boolean':
        return '';

      case 'function':
        if (interpolation.__emotion_styles !== undefined) {
          var selector = interpolation.toString();

          if (selector === 'NO_COMPONENT_SELECTOR' && process.env.NODE_ENV !== 'production') {
            throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
          }

          return selector;
        }

        if (this === undefined && process.env.NODE_ENV !== 'production') {
          console.error('Interpolating functions in css calls is deprecated and will be removed in the next major version of Emotion.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }

        return handleInterpolation.call(this, this === undefined ? interpolation() : // $FlowFixMe
        interpolation(this.mergedProps, this.context), couldBeSelectorInterpolation);

      case 'object':
        return createStringFromObject.call(this, interpolation);

      default:
        var cached = caches.registered[interpolation];
        return couldBeSelectorInterpolation === false && cached !== undefined ? cached : interpolation;
    }
  }

  var objectToStringCache = new WeakMap();

  function createStringFromObject(obj) {
    if (objectToStringCache.has(obj)) {
      // $FlowFixMe
      return objectToStringCache.get(obj);
    }

    var string = '';

    if (Array.isArray(obj)) {
      obj.forEach(function (interpolation) {
        string += handleInterpolation.call(this, interpolation, false);
      }, this);
    } else {
      Object.keys(obj).forEach(function (key) {
        if (typeof obj[key] !== 'object') {
          if (caches.registered[obj[key]] !== undefined) {
            string += key + "{" + caches.registered[obj[key]] + "}";
          } else {
            string += processStyleName(key) + ":" + processStyleValue(key, obj[key]) + ";";
          }
        } else {
          if (key === 'NO_COMPONENT_SELECTOR' && process.env.NODE_ENV !== 'production') {
            throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
          }

          if (Array.isArray(obj[key]) && typeof obj[key][0] === 'string' && caches.registered[obj[key][0]] === undefined) {
            obj[key].forEach(function (value) {
              string += processStyleName(key) + ":" + processStyleValue(key, value) + ";";
            });
          } else {
            string += key + "{" + handleInterpolation.call(this, obj[key], false) + "}";
          }
        }
      }, this);
    }

    objectToStringCache.set(obj, string);
    return string;
  }

  var name;
  var stylesWithLabel;
  var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;

  var createClassName = function createClassName(styles, identifierName) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__emotion_hash__["a" /* default */])(styles + identifierName) + identifierName;
  };

  if (process.env.NODE_ENV !== 'production') {
    var oldCreateClassName = createClassName;
    var sourceMappingUrlPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;

    createClassName = function createClassName(styles, identifierName) {
      return oldCreateClassName(styles.replace(sourceMappingUrlPattern, function (sourceMap) {
        currentSourceMap = sourceMap;
        return '';
      }), identifierName);
    };
  }

  var createStyles = function createStyles(strings) {
    var stringMode = true;
    var styles = '';
    var identifierName = '';

    if (strings == null || strings.raw === undefined) {
      stringMode = false;
      styles += handleInterpolation.call(this, strings, false);
    } else {
      styles += strings[0];
    }

    for (var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }

    interpolations.forEach(function (interpolation, i) {
      styles += handleInterpolation.call(this, interpolation, styles.charCodeAt(styles.length - 1) === 46 // .
      );

      if (stringMode === true && strings[i + 1] !== undefined) {
        styles += strings[i + 1];
      }
    }, this);
    stylesWithLabel = styles;
    styles = styles.replace(labelPattern, function (match, p1) {
      identifierName += "-" + p1;
      return '';
    });
    name = createClassName(styles, identifierName);
    return styles;
  };

  if (process.env.NODE_ENV !== 'production') {
    var oldStylis = stylis;

    stylis = function stylis(selector, styles) {
      oldStylis(selector, styles);
      currentSourceMap = '';
    };
  }

  function insert(scope, styles) {
    if (caches.inserted[name] === undefined) {
      current = '';
      stylis(scope, styles);
      caches.inserted[name] = current;
    }
  }

  var css = function css() {
    var styles = createStyles.apply(this, arguments);
    var selector = key + "-" + name;

    if (caches.registered[selector] === undefined) {
      caches.registered[selector] = stylesWithLabel;
    }

    insert("." + selector, styles);
    return selector;
  };

  var keyframes = function keyframes() {
    var styles = createStyles.apply(this, arguments);
    var animation = "animation-" + name;
    insert('', "@keyframes " + animation + "{" + styles + "}");
    return animation;
  };

  var injectGlobal = function injectGlobal() {
    var styles = createStyles.apply(this, arguments);
    insert('', styles);
  };

  function getRegisteredStyles(registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function (className) {
      if (caches.registered[className] !== undefined) {
        registeredStyles.push(className);
      } else {
        rawClassName += className + " ";
      }
    });
    return rawClassName;
  }

  function merge(className, sourceMap) {
    var registeredStyles = [];
    var rawClassName = getRegisteredStyles(registeredStyles, className);

    if (registeredStyles.length < 2) {
      return className;
    }

    return rawClassName + css(registeredStyles, sourceMap);
  }

  function cx() {
    for (var _len2 = arguments.length, classNames = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      classNames[_key2] = arguments[_key2];
    }

    return merge(classnames(classNames));
  }

  function hydrateSingleId(id) {
    caches.inserted[id] = true;
  }

  function hydrate(ids) {
    ids.forEach(hydrateSingleId);
  }

  function flush() {
    if (isBrowser) {
      sheet.flush();
      sheet.inject();
    }

    caches.inserted = {};
    caches.registered = {};
  }

  if (isBrowser) {
    var chunks = document.querySelectorAll("[data-emotion-" + key + "]");
    Array.prototype.forEach.call(chunks, function (node) {
      // $FlowFixMe
      sheet.tags[0].parentNode.insertBefore(node, sheet.tags[0]); // $FlowFixMe

      node.getAttribute("data-emotion-" + key).split(' ').forEach(hydrateSingleId);
    });
  }

  var emotion = {
    flush: flush,
    hydrate: hydrate,
    cx: cx,
    merge: merge,
    getRegisteredStyles: getRegisteredStyles,
    injectGlobal: injectGlobal,
    keyframes: keyframes,
    css: css,
    sheet: sheet,
    caches: caches
  };
  context.__SECRET_EMOTION__ = emotion;
  return emotion;
}

/* harmony default export */ __webpack_exports__["a"] = (createEmotion);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../node_modules/node-libs-browser/node_modules/process/browser.js")))

/***/ }),

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/dist/cjs.js!./styles.less":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.i, ".flex-row {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n}\n.flex-column {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n}\n* {\n  margin: 0;\n  padding: 0;\n}\nhtml,\nbody {\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n}\n#container {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n}\n#container > div {\n  height: 100%;\n  width: 100%;\n}\n.ms-welcome {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  min-height: 500px;\n  min-width: 320px;\n  overflow: auto;\n  overflow-x: hidden;\n}\n.ms-welcome__progress,\n.ms-welcome__header {\n  padding: 20px;\n  padding-bottom: 30px;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  justify-content: flex-end;\n  align-items: center;\n}\n.ms-welcome__progress h1,\n.ms-welcome__header h1 {\n  margin-top: 30px;\n  text-align: center;\n}\n.ms-welcome__progress {\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  justify-content: center;\n  align-items: center;\n}\n.ms-welcome__progress h1 {\n  margin-bottom: 80px;\n}\n.ms-welcome__progress .ms-Spinner .ms-Spinner-label {\n  color: #999;\n}\n.ms-welcome__progress .ms-Spinner .ms-Spinner-circle {\n  color: #333333;\n  border: 1.5px solid #CCC;\n  border-top-color: #333333;\n}\n.ms-welcome__main {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-items: center;\n  flex: 1 0 0;\n  padding: 30px 20px;\n}\n.ms-welcome__main h2 {\n  width: 100%;\n  text-align: center;\n}\n.ms-welcome__features {\n  list-style-type: none;\n  margin-top: 30px;\n  margin-bottom: 30px;\n}\n.ms-welcome__features.ms-List .ms-ListItem {\n  padding: 0px;\n  padding-bottom: 20px;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-items: center;\n}\n.ms-welcome__features.ms-List .ms-ListItem > .ms-Icon {\n  font-size: 14pt;\n  margin-right: 10px;\n}\n.ms-welcome__action {\n  margin-top: 30px;\n}\n@media (min-width: 0) and (max-width: 350px) {\n  .ms-welcome__features {\n    width: 100%;\n  }\n}\n.vita {\n  font-family: Arial Narrow;\n}\n#content-header {\n  background: #2a8dd4;\n  color: #fff;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 80px;\n  overflow: hidden;\n  font-family: Arial;\n  padding-top: 25px;\n}\n#content-main {\n  background: #fff;\n  position: fixed;\n  top: 80px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  overflow: auto;\n  font-family: Arial;\n}\n.padding {\n  padding: 15px;\n}\n.padding-sm {\n  padding: 4px;\n}\n.normal-button {\n  width: 120px;\n  padding: 2px;\n  background-color: #1ab394;\n  color: #fff;\n}\n", ""]);

// exports


/***/ }),

/***/ "../node_modules/css-loader/index.js!../node_modules/office-ui-fabric-react/dist/css/fabric.min.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.i, "/* Copyright (c) Microsoft. All rights reserved. Licensed under the MIT license. See LICENSE in the project root for license information. */\r\n/**\n * Office UI Fabric Core 9.6.0\n * The front-end framework for building experiences for Office 365.\n **/\n@charset \"UTF-8\";@keyframes ms-slideRightIn10{0%{transform:translate3d(-10px,0,0)}to{transform:translateZ(0)}}@keyframes ms-slideRightIn20{0%{transform:translate3d(-20px,0,0)}to{transform:translateZ(0)}}@keyframes ms-slideRightIn40{0%{transform:translate3d(-40px,0,0)}to{transform:translateZ(0)}}@keyframes ms-slideRightIn400{0%{transform:translate3d(-400px,0,0)}to{transform:translateZ(0)}}@keyframes ms-slideRightOut40{0%{transform:translateZ(0)}to{transform:translate3d(40px,0,0)}}@keyframes ms-slideRightOut400{0%{transform:translateZ(0)}to{transform:translate3d(400px,0,0)}}@keyframes ms-slideLeftIn10{0%{transform:translate3d(10px,0,0)}to{transform:translateZ(0)}}@keyframes ms-slideLeftIn20{0%{transform:translate3d(20px,0,0)}to{transform:translateZ(0)}}@keyframes ms-slideLeftIn40{0%{transform:translate3d(40px,0,0)}to{transform:translateZ(0)}}@keyframes ms-slideLeftIn400{0%{transform:translate3d(400px,0,0)}to{transform:translateZ(0)}}@keyframes ms-slideLeftOut40{0%{transform:translateZ(0)}to{transform:translate3d(-40px,0,0)}}@keyframes ms-slideLeftOut400{0%{transform:translateZ(0)}to{transform:translate3d(-400px,0,0)}}@keyframes ms-slideUpIn10{0%{transform:translate3d(0,10px,0)}to{transform:translateZ(0)}}@keyframes ms-slideUpIn20{0%{transform:translate3d(0,20px,0)}to{transform:translateZ(0)}}@keyframes ms-slideDownIn10{0%{transform:translate3d(0,-10px,0)}to{transform:translateZ(0)}}@keyframes ms-slideDownIn20{0%{transform:translate3d(0,-20px,0)}to{transform:translateZ(0)}}@keyframes ms-slideUpOut10{0%{transform:translateZ(0)}to{transform:translate3d(0,-10px,0)}}@keyframes ms-slideUpOut20{0%{transform:translateZ(0)}to{transform:translate3d(0,-20px,0)}}@keyframes ms-slideDownOut10{0%{transform:translateZ(0)}to{transform:translate3d(0,10px,0)}}@keyframes ms-slideDownOut20{0%{transform:translateZ(0)}to{transform:translate3d(0,20px,0)}}@keyframes ms-scaleUp100{0%{transform:scale3d(.98,.98,1)}to{transform:scaleX(1)}}@keyframes ms-scaleUp103{0%{transform:scaleX(1)}to{transform:scale3d(1.03,1.03,1)}}@keyframes ms-scaleDown98{0%{transform:scaleX(1)}to{transform:scale3d(.98,.98,1)}}@keyframes ms-scaleDown100{0%{transform:scale3d(1.03,1.03,1)}to{transform:scaleX(1)}}@keyframes ms-fadeIn{0%{opacity:0;animation-timing-function:cubic-bezier(.1,.25,.75,.9)}to{opacity:1}}@keyframes ms-fadeOut{0%{opacity:1;animation-timing-function:cubic-bezier(.1,.25,.75,.9)}to{opacity:0}}@keyframes ms-rotate90{0%{transform:rotate(0deg)}to{transform:rotate(90deg)}}@keyframes ms-rotateN90{0%{transform:rotate(90deg)}to{transform:rotate(0deg)}}[dir=ltr] .ms-slideRightIn10{animation-name:ms-fadeIn,ms-slideRightIn10;animation-duration:.367s;animation-timing-function:cubic-bezier(.1,.9,.2,1);animation-fill-mode:both}@media (prefers-reduced-motion:reduce){[dir=ltr] .ms-slideRightIn10{animation:none}}[dir=rtl] .ms-slideRightIn10{animation-name:ms-fadeIn,ms-slideLeftIn10;animation-duration:.367s;animation-timing-function:cubic-bezier(.1,.9,.2,1);animation-fill-mode:both}@media (prefers-reduced-motion:reduce){[dir=rtl] .ms-slideRightIn10{animation:none}}[dir=ltr] .ms-slideRightIn20{animation-name:ms-fadeIn,ms-slideRightIn20;animation-duration:.367s;animation-timing-function:cubic-bezier(.1,.9,.2,1);animation-fill-mode:both}@media (prefers-reduced-motion:reduce){[dir=ltr] .ms-slideRightIn20{animation:none}}[dir=rtl] .ms-slideRightIn20{animation-name:ms-fadeIn,ms-slideLeftIn20;animation-duration:.367s;animation-timing-function:cubic-bezier(.1,.9,.2,1);animation-fill-mode:both}@media (prefers-reduced-motion:reduce){[dir=rtl] .ms-slideRightIn20{animation:none}}[dir=ltr] .ms-slideRightIn40{animation-name:ms-fadeIn,ms-slideRightIn40;animation-duration:.367s;animation-timing-function:cubic-bezier(.1,.9,.2,1);animation-fill-mode:both}@media (prefers-reduced-motion:reduce){[dir=ltr] .ms-slideRightIn40{animation:none}}[dir=rtl] .ms-slideRightIn40{animation-name:ms-fadeIn,ms-slideLeftIn40;animation-duration:.367s;animation-timing-function:cubic-bezier(.1,.9,.2,1);animation-fill-mode:both}@media (prefers-reduced-motion:reduce){[dir=rtl] .ms-slideRightIn40{animation:none}}[dir=ltr] .ms-slideRightIn400{animation-name:ms-fadeIn,ms-slideRightIn400;animation-duration:.367s;animation-timing-function:cubic-bezier(.1,.9,.2,1);animation-fill-mode:both}@media (prefers-reduced-motion:reduce){[dir=ltr] .ms-slideRightIn400{animation:none}}[dir=rtl] .ms-slideRightIn400{animation-name:ms-fadeIn,ms-slideLeftIn400;animation-duration:.367s;animation-timing-function:cubic-bezier(.1,.9,.2,1);animation-fill-mode:both}@media (prefers-reduced-motion:reduce){[dir=rtl] .ms-slideRightIn400{animation:none}}[dir=ltr] .ms-slideRightOut40{animation-name:ms-fadeOut,ms-slideRightOut40;animation-duration:.167s;animation-timing-function:cubic-bezier(.1,.25,.75,.9);animation-fill-mode:both}@media (prefers-reduced-motion:reduce){[dir=ltr] .ms-slideRightOut40{animation:none}}[dir=rtl] .ms-slideRightOut40{animation-name:ms-fadeOut,ms-slideLeftOut40;animation-duration:.167s;animation-timing-function:cubic-bezier(.1,.25,.75,.9);animation-fill-mode:both}@media (prefers-reduced-motion:reduce){[dir=rtl] .ms-slideRightOut40{animation:none}}[dir=ltr] .ms-slideRightOut400{animation-name:ms-fadeOut,ms-slideRightOut400;animation-duration:.167s;animation-timing-function:cubic-bezier(.1,.25,.75,.9);animation-fill-mode:both}@media (prefers-reduced-motion:reduce){[dir=ltr] .ms-slideRightOut400{animation:none}}[dir=rtl] .ms-slideRightOut400{animation-name:ms-fadeOut,ms-slideLeftOut400;animation-duration:.167s;animation-timing-function:cubic-bezier(.1,.25,.75,.9);animation-fill-mode:both}@media (prefers-reduced-motion:reduce){[dir=rtl] .ms-slideRightOut400{animation:none}}[dir=ltr] .ms-slideLeftIn10{animation-name:ms-fadeIn,ms-slideLeftIn10;animation-duration:.367s;animation-timing-function:cubic-bezier(.1,.9,.2,1);animation-fill-mode:both}@media (prefers-reduced-motion:reduce){[dir=ltr] .ms-slideLeftIn10{animation:none}}[dir=rtl] .ms-slideLeftIn10{animation-name:ms-fadeIn,ms-slideRightIn10;animation-duration:.367s;animation-timing-function:cubic-bezier(.1,.9,.2,1);animation-fill-mode:both}@media (prefers-reduced-motion:reduce){[dir=rtl] .ms-slideLeftIn10{animation:none}}[dir=ltr] .ms-slideLeftIn20{animation-name:ms-fadeIn,ms-slideLeftIn20;animation-duration:.367s;animation-timing-function:cubic-bezier(.1,.9,.2,1);animation-fill-mode:both}@media (prefers-reduced-motion:reduce){[dir=ltr] .ms-slideLeftIn20{animation:none}}[dir=rtl] .ms-slideLeftIn20{animation-name:ms-fadeIn,ms-slideRightIn20;animation-duration:.367s;animation-timing-function:cubic-bezier(.1,.9,.2,1);animation-fill-mode:both}@media (prefers-reduced-motion:reduce){[dir=rtl] .ms-slideLeftIn20{animation:none}}[dir=ltr] .ms-slideLeftIn40{animation-name:ms-fadeIn,ms-slideLeftIn40;animation-duration:.367s;animation-timing-function:cubic-bezier(.1,.9,.2,1);animation-fill-mode:both}@media (prefers-reduced-motion:reduce){[dir=ltr] .ms-slideLeftIn40{animation:none}}[dir=rtl] .ms-slideLeftIn40{animation-name:ms-fadeIn,ms-slideRightIn40;animation-duration:.367s;animation-timing-function:cubic-bezier(.1,.9,.2,1);animation-fill-mode:both}@media (prefers-reduced-motion:reduce){[dir=rtl] .ms-slideLeftIn40{animation:none}}[dir=ltr] .ms-slideLeftIn400{animation-name:ms-fadeIn,ms-slideLeftIn400;animation-duration:.367s;animation-timing-function:cubic-bezier(.1,.9,.2,1);animation-fill-mode:both}@media (prefers-reduced-motion:reduce){[dir=ltr] .ms-slideLeftIn400{animation:none}}[dir=rtl] .ms-slideLeftIn400{animation-name:ms-fadeIn,ms-slideRightIn400;animation-duration:.367s;animation-timing-function:cubic-bezier(.1,.9,.2,1);animation-fill-mode:both}@media (prefers-reduced-motion:reduce){[dir=rtl] .ms-slideLeftIn400{animation:none}}[dir=ltr] .ms-slideLeftOut40{animation-name:ms-fadeOut,ms-slideLeftOut40;animation-duration:.167s;animation-timing-function:cubic-bezier(.1,.25,.75,.9);animation-fill-mode:both}@media (prefers-reduced-motion:reduce){[dir=ltr] .ms-slideLeftOut40{animation:none}}[dir=rtl] .ms-slideLeftOut40{animation-name:ms-fadeOut,ms-slideRightOut40;animation-duration:.167s;animation-timing-function:cubic-bezier(.1,.25,.75,.9);animation-fill-mode:both}@media (prefers-reduced-motion:reduce){[dir=rtl] .ms-slideLeftOut40{animation:none}}[dir=ltr] .ms-slideLeftOut400{animation-name:ms-fadeOut,ms-slideLeftOut400;animation-duration:.167s;animation-timing-function:cubic-bezier(.1,.25,.75,.9);animation-fill-mode:both}@media (prefers-reduced-motion:reduce){[dir=ltr] .ms-slideLeftOut400{animation:none}}[dir=rtl] .ms-slideLeftOut400{animation-name:ms-fadeOut,ms-slideRightOut400;animation-duration:.167s;animation-timing-function:cubic-bezier(.1,.25,.75,.9);animation-fill-mode:both}@media (prefers-reduced-motion:reduce){[dir=rtl] .ms-slideLeftOut400{animation:none}}.ms-slideUpIn10{animation-name:ms-fadeIn,ms-slideUpIn10;animation-duration:.167s;animation-timing-function:cubic-bezier(.1,.25,.75,.9);animation-fill-mode:both}@media (prefers-reduced-motion:reduce){.ms-slideUpIn10{animation:none}}.ms-slideUpIn20{animation-name:ms-fadeIn,ms-slideUpIn20;animation-duration:.367s;animation-timing-function:cubic-bezier(.1,.9,.2,1);animation-fill-mode:both}@media (prefers-reduced-motion:reduce){.ms-slideUpIn20{animation:none}}.ms-slideDownIn10{animation-name:ms-fadeIn,ms-slideDownIn10;animation-duration:.167s;animation-timing-function:cubic-bezier(.1,.25,.75,.9);animation-fill-mode:both}@media (prefers-reduced-motion:reduce){.ms-slideDownIn10{animation:none}}.ms-slideDownIn20{animation-name:ms-fadeIn,ms-slideDownIn20;animation-duration:.367s;animation-timing-function:cubic-bezier(.1,.9,.2,1);animation-fill-mode:both}@media (prefers-reduced-motion:reduce){.ms-slideDownIn20{animation:none}}.ms-slideUpOut10{animation-name:ms-fadeOut,ms-slideUpOut10;animation-duration:.167s;animation-timing-function:cubic-bezier(.1,.25,.75,.9);animation-fill-mode:both}@media (prefers-reduced-motion:reduce){.ms-slideUpOut10{animation:none}}.ms-slideUpOut20{animation-name:ms-fadeOut,ms-slideUpOut20;animation-duration:.167s;animation-timing-function:cubic-bezier(.1,.25,.75,.9);animation-fill-mode:both}@media (prefers-reduced-motion:reduce){.ms-slideUpOut20{animation:none}}.ms-slideDownOut10{animation-name:ms-fadeOut,ms-slideDownOut10;animation-duration:.167s;animation-timing-function:cubic-bezier(.1,.25,.75,.9);animation-fill-mode:both}@media (prefers-reduced-motion:reduce){.ms-slideDownOut10{animation:none}}.ms-slideDownOut20{animation-name:ms-fadeOut,ms-slideDownOut20;animation-duration:.167s;animation-timing-function:cubic-bezier(.1,.25,.75,.9);animation-fill-mode:both}@media (prefers-reduced-motion:reduce){.ms-slideDownOut20{animation:none}}.ms-scaleUpIn100{animation-name:ms-fadeIn,ms-scaleUp100;animation-duration:.367s;animation-timing-function:cubic-bezier(.1,.9,.2,1);animation-fill-mode:both}@media (prefers-reduced-motion:reduce){.ms-scaleUpIn100{animation:none}}.ms-scaleUpOut103{animation-name:ms-fadeOut,ms-scaleUp103;animation-duration:.167s;animation-timing-function:cubic-bezier(.1,.25,.75,.9);animation-fill-mode:both}@media (prefers-reduced-motion:reduce){.ms-scaleUpOut103{animation:none}}.ms-scaleDownOut98{animation-name:ms-fadeOut,ms-scaleDown98;animation-duration:.167s;animation-timing-function:cubic-bezier(.1,.25,.75,.9);animation-fill-mode:both}@media (prefers-reduced-motion:reduce){.ms-scaleDownOut98{animation:none}}.ms-scaleDownIn100{animation-name:ms-fadeIn,ms-scaleDown100;animation-duration:.367s;animation-timing-function:cubic-bezier(.1,.9,.2,1);animation-fill-mode:both}@media (prefers-reduced-motion:reduce){.ms-scaleDownIn100{animation:none}}.ms-fadeIn100{animation-name:ms-fadeIn;animation-duration:.167s;animation-timing-function:cubic-bezier(.1,.9,.2,1);animation-fill-mode:both}@media (prefers-reduced-motion:reduce){.ms-fadeIn100{animation:none}}.ms-fadeIn200{animation-name:ms-fadeIn;animation-duration:.267s;animation-timing-function:cubic-bezier(.1,.9,.2,1);animation-fill-mode:both}@media (prefers-reduced-motion:reduce){.ms-fadeIn200{animation:none}}.ms-fadeIn400{animation-name:ms-fadeIn;animation-duration:.367s;animation-timing-function:cubic-bezier(.1,.9,.2,1);animation-fill-mode:both}@media (prefers-reduced-motion:reduce){.ms-fadeIn400{animation:none}}.ms-fadeIn500{animation-name:ms-fadeIn;animation-duration:.467s;animation-timing-function:cubic-bezier(.1,.9,.2,1);animation-fill-mode:both}@media (prefers-reduced-motion:reduce){.ms-fadeIn500{animation:none}}.ms-fadeOut100{animation-name:ms-fadeOut;animation-duration:.1s;animation-timing-function:cubic-bezier(.1,.9,.2,1);animation-fill-mode:both}@media (prefers-reduced-motion:reduce){.ms-fadeOut100{animation:none}}.ms-fadeOut200{animation-name:ms-fadeOut;animation-duration:.167s;animation-timing-function:cubic-bezier(.1,.9,.2,1);animation-fill-mode:both}@media (prefers-reduced-motion:reduce){.ms-fadeOut200{animation:none}}.ms-fadeOut400{animation-name:ms-fadeOut;animation-duration:.367s;animation-timing-function:cubic-bezier(.1,.9,.2,1);animation-fill-mode:both}@media (prefers-reduced-motion:reduce){.ms-fadeOut400{animation:none}}.ms-fadeOut500{animation-name:ms-fadeOut;animation-duration:.467s;animation-timing-function:cubic-bezier(.1,.9,.2,1);animation-fill-mode:both}@media (prefers-reduced-motion:reduce){.ms-fadeOut500{animation:none}}.ms-expandCollapse100{transition:height .1s cubic-bezier(.1,.25,.75,.9)}@media (prefers-reduced-motion:reduce){.ms-expandCollapse100{transition:none}}.ms-expandCollapse200{transition:height .167s cubic-bezier(.1,.25,.75,.9)}@media (prefers-reduced-motion:reduce){.ms-expandCollapse200{transition:none}}.ms-expandCollapse400{transition:height .367s cubic-bezier(.1,.25,.75,.9)}@media (prefers-reduced-motion:reduce){.ms-expandCollapse400{transition:none}}.ms-delay100{animation-delay:.167s}.ms-delay200{animation-delay:.267s}[dir=ltr] .ms-rotate90deg{animation-name:ms-rotate90;animation-duration:.1s;animation-timing-function:cubic-bezier(.1,.25,.75,.9);animation-fill-mode:both}@media (prefers-reduced-motion:reduce){[dir=ltr] .ms-rotate90deg{animation:none}}[dir=rtl] .ms-rotate90deg{animation-name:ms-rotateN90;animation-duration:.1s;animation-timing-function:cubic-bezier(.1,.25,.75,.9);animation-fill-mode:both}@media (prefers-reduced-motion:reduce){[dir=rtl] .ms-rotate90deg{animation:none}}[dir=ltr] .ms-rotateN90deg{animation-name:ms-rotateN90;animation-duration:.1s;animation-timing-function:cubic-bezier(.1,.25,.75,.9);animation-fill-mode:both}@media (prefers-reduced-motion:reduce){[dir=ltr] .ms-rotateN90deg{animation:none}}[dir=rtl] .ms-rotateN90deg{animation-name:ms-rotate90;animation-duration:.1s;animation-timing-function:cubic-bezier(.1,.25,.75,.9);animation-fill-mode:both}@media (prefers-reduced-motion:reduce){[dir=rtl] .ms-rotateN90deg{animation:none}}.ms-BrandIcon--access.ms-BrandIcon--icon16{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/access_16x1.png)}.ms-BrandIcon--access.ms-BrandIcon--icon48{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/access_48x1.png)}.ms-BrandIcon--access.ms-BrandIcon--icon96{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/access_96x1.png)}.ms-BrandIcon--excel.ms-BrandIcon--icon16{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/excel_16x1.png)}.ms-BrandIcon--excel.ms-BrandIcon--icon48{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/excel_48x1.png)}.ms-BrandIcon--excel.ms-BrandIcon--icon96{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/excel_96x1.png)}.ms-BrandIcon--infopath.ms-BrandIcon--icon16{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/infopath_16x1.png)}.ms-BrandIcon--infopath.ms-BrandIcon--icon48{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/infopath_48x1.png)}.ms-BrandIcon--infopath.ms-BrandIcon--icon96{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/infopath_96x1.png)}.ms-BrandIcon--office.ms-BrandIcon--icon16{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/office_16x1.png)}.ms-BrandIcon--office.ms-BrandIcon--icon48{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/office_48x1.png)}.ms-BrandIcon--office.ms-BrandIcon--icon96{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/office_96x1.png)}.ms-BrandIcon--onedrive.ms-BrandIcon--icon16{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/onedrive_16x1.png)}.ms-BrandIcon--onedrive.ms-BrandIcon--icon48{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/onedrive_48x1.png)}.ms-BrandIcon--onedrive.ms-BrandIcon--icon96{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/onedrive_96x1.png)}.ms-BrandIcon--onenote.ms-BrandIcon--icon16{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/onenote_16x1.png)}.ms-BrandIcon--onenote.ms-BrandIcon--icon48{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/onenote_48x1.png)}.ms-BrandIcon--onenote.ms-BrandIcon--icon96{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/onenote_96x1.png)}.ms-BrandIcon--outlook.ms-BrandIcon--icon16{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/outlook_16x1.png)}.ms-BrandIcon--outlook.ms-BrandIcon--icon48{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/outlook_48x1.png)}.ms-BrandIcon--outlook.ms-BrandIcon--icon96{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/outlook_96x1.png)}.ms-BrandIcon--powerpoint.ms-BrandIcon--icon16{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/powerpoint_16x1.png)}.ms-BrandIcon--powerpoint.ms-BrandIcon--icon48{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/powerpoint_48x1.png)}.ms-BrandIcon--powerpoint.ms-BrandIcon--icon96{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/powerpoint_96x1.png)}.ms-BrandIcon--project.ms-BrandIcon--icon16{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/project_16x1.png)}.ms-BrandIcon--project.ms-BrandIcon--icon48{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/project_48x1.png)}.ms-BrandIcon--project.ms-BrandIcon--icon96{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/project_96x1.png)}.ms-BrandIcon--sharepoint.ms-BrandIcon--icon16{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/sharepoint_16x1.png)}.ms-BrandIcon--sharepoint.ms-BrandIcon--icon48{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/sharepoint_48x1.png)}.ms-BrandIcon--sharepoint.ms-BrandIcon--icon96{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/sharepoint_96x1.png)}.ms-BrandIcon--visio.ms-BrandIcon--icon16{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/visio_16x1.png)}.ms-BrandIcon--visio.ms-BrandIcon--icon48{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/visio_48x1.png)}.ms-BrandIcon--visio.ms-BrandIcon--icon96{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/visio_96x1.png)}.ms-BrandIcon--word.ms-BrandIcon--icon16{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/word_16x1.png)}.ms-BrandIcon--word.ms-BrandIcon--icon48{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/word_48x1.png)}.ms-BrandIcon--word.ms-BrandIcon--icon96{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/word_96x1.png)}.ms-BrandIcon--accdb.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16/accdb.png)}.ms-BrandIcon--accdb.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48/accdb.png)}.ms-BrandIcon--accdb.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96/accdb.png)}.ms-BrandIcon--archive.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16/archive.png)}.ms-BrandIcon--archive.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48/archive.png)}.ms-BrandIcon--archive.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96/archive.png)}.ms-BrandIcon--audio.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16/audio.png)}.ms-BrandIcon--audio.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48/audio.png)}.ms-BrandIcon--audio.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96/audio.png)}.ms-BrandIcon--code.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16/code.png)}.ms-BrandIcon--code.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48/code.png)}.ms-BrandIcon--code.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96/code.png)}.ms-BrandIcon--csv.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16/csv.png)}.ms-BrandIcon--csv.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48/csv.png)}.ms-BrandIcon--csv.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96/csv.png)}.ms-BrandIcon--docset.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16/docset.png)}.ms-BrandIcon--docset.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48/docset.png)}.ms-BrandIcon--docset.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96/docset.png)}.ms-BrandIcon--docx.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16/docx.png)}.ms-BrandIcon--docx.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48/docx.png)}.ms-BrandIcon--docx.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96/docx.png)}.ms-BrandIcon--dotx.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16/dotx.png)}.ms-BrandIcon--dotx.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48/dotx.png)}.ms-BrandIcon--dotx.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96/dotx.png)}.ms-BrandIcon--email.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16/email.png)}.ms-BrandIcon--email.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48/email.png)}.ms-BrandIcon--email.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96/email.png)}.ms-BrandIcon--exe.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16/exe.png)}.ms-BrandIcon--exe.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48/exe.png)}.ms-BrandIcon--exe.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96/exe.png)}.ms-BrandIcon--folder.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16/folder.png)}.ms-BrandIcon--folder.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48/folder.png)}.ms-BrandIcon--folder.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96/folder.png)}.ms-BrandIcon--font.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16/font.png)}.ms-BrandIcon--font.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48/font.png)}.ms-BrandIcon--font.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96/font.png)}.ms-BrandIcon--genericfile.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16/genericfile.png)}.ms-BrandIcon--genericfile.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48/genericfile.png)}.ms-BrandIcon--genericfile.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96/genericfile.png)}.ms-BrandIcon--html.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16/html.png)}.ms-BrandIcon--html.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48/html.png)}.ms-BrandIcon--html.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96/html.png)}.ms-BrandIcon--link.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16/link.png)}.ms-BrandIcon--link.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48/link.png)}.ms-BrandIcon--link.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96/link.png)}.ms-BrandIcon--listitem.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16/listitem.png)}.ms-BrandIcon--listitem.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48/listitem.png)}.ms-BrandIcon--listitem.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96/listitem.png)}.ms-BrandIcon--model.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16/model.png)}.ms-BrandIcon--model.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48/model.png)}.ms-BrandIcon--model.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96/model.png)}.ms-BrandIcon--mpp.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16/mpp.png)}.ms-BrandIcon--mpp.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48/mpp.png)}.ms-BrandIcon--mpp.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96/mpp.png)}.ms-BrandIcon--mpt.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16/mpt.png)}.ms-BrandIcon--mpt.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48/mpt.png)}.ms-BrandIcon--mpt.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96/mpt.png)}.ms-BrandIcon--odp.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16/odp.png)}.ms-BrandIcon--odp.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48/odp.png)}.ms-BrandIcon--odp.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96/odp.png)}.ms-BrandIcon--ods.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16/ods.png)}.ms-BrandIcon--ods.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48/ods.png)}.ms-BrandIcon--ods.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96/ods.png)}.ms-BrandIcon--odt.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16/odt.png)}.ms-BrandIcon--odt.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48/odt.png)}.ms-BrandIcon--odt.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96/odt.png)}.ms-BrandIcon--one.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16/one.png)}.ms-BrandIcon--one.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48/one.png)}.ms-BrandIcon--one.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96/one.png)}.ms-BrandIcon--onetoc.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16/onetoc.png)}.ms-BrandIcon--onetoc.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48/onetoc.png)}.ms-BrandIcon--onetoc.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96/onetoc.png)}.ms-BrandIcon--pdf.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16/pdf.png)}.ms-BrandIcon--pdf.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48/pdf.png)}.ms-BrandIcon--pdf.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96/pdf.png)}.ms-BrandIcon--photo.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16/photo.png)}.ms-BrandIcon--photo.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48/photo.png)}.ms-BrandIcon--photo.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96/photo.png)}.ms-BrandIcon--potx.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16/potx.png)}.ms-BrandIcon--potx.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48/potx.png)}.ms-BrandIcon--potx.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96/potx.png)}.ms-BrandIcon--ppsx.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16/ppsx.png)}.ms-BrandIcon--ppsx.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48/ppsx.png)}.ms-BrandIcon--ppsx.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96/ppsx.png)}.ms-BrandIcon--pptx.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16/pptx.png)}.ms-BrandIcon--pptx.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48/pptx.png)}.ms-BrandIcon--pptx.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96/pptx.png)}.ms-BrandIcon--pub.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16/pub.png)}.ms-BrandIcon--pub.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48/pub.png)}.ms-BrandIcon--pub.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96/pub.png)}.ms-BrandIcon--rtf.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16/rtf.png)}.ms-BrandIcon--rtf.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48/rtf.png)}.ms-BrandIcon--rtf.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96/rtf.png)}.ms-BrandIcon--sharedfolder.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16/sharedfolder.png)}.ms-BrandIcon--sharedfolder.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48/sharedfolder.png)}.ms-BrandIcon--sharedfolder.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96/sharedfolder.png)}.ms-BrandIcon--spo.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16/spo.png)}.ms-BrandIcon--spo.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48/spo.png)}.ms-BrandIcon--spo.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96/spo.png)}.ms-BrandIcon--sysfile.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16/sysfile.png)}.ms-BrandIcon--sysfile.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48/sysfile.png)}.ms-BrandIcon--sysfile.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96/sysfile.png)}.ms-BrandIcon--txt.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16/txt.png)}.ms-BrandIcon--txt.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48/txt.png)}.ms-BrandIcon--txt.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96/txt.png)}.ms-BrandIcon--vector.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16/vector.png)}.ms-BrandIcon--vector.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48/vector.png)}.ms-BrandIcon--vector.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96/vector.png)}.ms-BrandIcon--video.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16/video.png)}.ms-BrandIcon--video.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48/video.png)}.ms-BrandIcon--video.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96/video.png)}.ms-BrandIcon--vsdx.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16/vsdx.png)}.ms-BrandIcon--vsdx.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48/vsdx.png)}.ms-BrandIcon--vsdx.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96/vsdx.png)}.ms-BrandIcon--vssx.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16/vssx.png)}.ms-BrandIcon--vssx.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48/vssx.png)}.ms-BrandIcon--vssx.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96/vssx.png)}.ms-BrandIcon--vstx.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16/vstx.png)}.ms-BrandIcon--vstx.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48/vstx.png)}.ms-BrandIcon--vstx.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96/vstx.png)}.ms-BrandIcon--xlsx.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16/xlsx.png)}.ms-BrandIcon--xlsx.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48/xlsx.png)}.ms-BrandIcon--xlsx.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96/xlsx.png)}.ms-BrandIcon--xltx.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16/xltx.png)}.ms-BrandIcon--xltx.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48/xltx.png)}.ms-BrandIcon--xltx.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96/xltx.png)}.ms-BrandIcon--xml.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16/xml.png)}.ms-BrandIcon--xml.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48/xml.png)}.ms-BrandIcon--xml.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96/xml.png)}.ms-BrandIcon--xsn.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16/xsn.png)}.ms-BrandIcon--xsn.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48/xsn.png)}.ms-BrandIcon--xsn.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96/xsn.png)}.ms-BrandIcon--zip.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16/zip.png)}.ms-BrandIcon--zip.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48/zip.png)}.ms-BrandIcon--zip.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96/zip.png)}.ms-BrandIcon--icon16{background-size:100% 100%;width:16px;height:16px}.ms-BrandIcon--icon48{background-size:100% 100%;width:48px;height:48px}.ms-BrandIcon--icon96{background-size:100% 100%;width:96px;height:96px}@media only screen and (-webkit-min-device-pixel-ratio:1.5),only screen and (min-resolution:144dpi){.ms-BrandIcon--access.ms-BrandIcon--icon16{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/access_16x1_5.png)}.ms-BrandIcon--access.ms-BrandIcon--icon48{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/access_48x1_5.png)}.ms-BrandIcon--access.ms-BrandIcon--icon96{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/access_96x1_5.png)}.ms-BrandIcon--excel.ms-BrandIcon--icon16{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/excel_16x1_5.png)}.ms-BrandIcon--excel.ms-BrandIcon--icon48{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/excel_48x1_5.png)}.ms-BrandIcon--excel.ms-BrandIcon--icon96{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/excel_96x1_5.png)}.ms-BrandIcon--infopath.ms-BrandIcon--icon16{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/infopath_16x1_5.png)}.ms-BrandIcon--infopath.ms-BrandIcon--icon48{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/infopath_48x1_5.png)}.ms-BrandIcon--infopath.ms-BrandIcon--icon96{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/infopath_96x1_5.png)}.ms-BrandIcon--office.ms-BrandIcon--icon16{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/office_16x1_5.png)}.ms-BrandIcon--office.ms-BrandIcon--icon48{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/office_48x1_5.png)}.ms-BrandIcon--office.ms-BrandIcon--icon96{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/office_96x1_5.png)}.ms-BrandIcon--onedrive.ms-BrandIcon--icon16{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/onedrive_16x1_5.png)}.ms-BrandIcon--onedrive.ms-BrandIcon--icon48{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/onedrive_48x1_5.png)}.ms-BrandIcon--onedrive.ms-BrandIcon--icon96{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/onedrive_96x1_5.png)}.ms-BrandIcon--onenote.ms-BrandIcon--icon16{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/onenote_16x1_5.png)}.ms-BrandIcon--onenote.ms-BrandIcon--icon48{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/onenote_48x1_5.png)}.ms-BrandIcon--onenote.ms-BrandIcon--icon96{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/onenote_96x1_5.png)}.ms-BrandIcon--outlook.ms-BrandIcon--icon16{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/outlook_16x1_5.png)}.ms-BrandIcon--outlook.ms-BrandIcon--icon48{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/outlook_48x1_5.png)}.ms-BrandIcon--outlook.ms-BrandIcon--icon96{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/outlook_96x1_5.png)}.ms-BrandIcon--powerpoint.ms-BrandIcon--icon16{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/powerpoint_16x1_5.png)}.ms-BrandIcon--powerpoint.ms-BrandIcon--icon48{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/powerpoint_48x1_5.png)}.ms-BrandIcon--powerpoint.ms-BrandIcon--icon96{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/powerpoint_96x1_5.png)}.ms-BrandIcon--project.ms-BrandIcon--icon16{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/project_16x1_5.png)}.ms-BrandIcon--project.ms-BrandIcon--icon48{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/project_48x1_5.png)}.ms-BrandIcon--project.ms-BrandIcon--icon96{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/project_96x1_5.png)}.ms-BrandIcon--sharepoint.ms-BrandIcon--icon16{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/sharepoint_16x1_5.png)}.ms-BrandIcon--sharepoint.ms-BrandIcon--icon48{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/sharepoint_48x1_5.png)}.ms-BrandIcon--sharepoint.ms-BrandIcon--icon96{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/sharepoint_96x1_5.png)}.ms-BrandIcon--visio.ms-BrandIcon--icon16{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/visio_16x1_5.png)}.ms-BrandIcon--visio.ms-BrandIcon--icon48{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/visio_48x1_5.png)}.ms-BrandIcon--visio.ms-BrandIcon--icon96{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/visio_96x1_5.png)}.ms-BrandIcon--word.ms-BrandIcon--icon16{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/word_16x1_5.png)}.ms-BrandIcon--word.ms-BrandIcon--icon48{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/word_48x1_5.png)}.ms-BrandIcon--word.ms-BrandIcon--icon96{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/word_96x1_5.png)}.ms-BrandIcon--accdb.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_1.5x/accdb.png)}.ms-BrandIcon--accdb.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_1.5x/accdb.png)}.ms-BrandIcon--accdb.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_1.5x/accdb.png)}.ms-BrandIcon--archive.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_1.5x/archive.png)}.ms-BrandIcon--archive.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_1.5x/archive.png)}.ms-BrandIcon--archive.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_1.5x/archive.png)}.ms-BrandIcon--audio.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_1.5x/audio.png)}.ms-BrandIcon--audio.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_1.5x/audio.png)}.ms-BrandIcon--audio.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_1.5x/audio.png)}.ms-BrandIcon--code.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_1.5x/code.png)}.ms-BrandIcon--code.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_1.5x/code.png)}.ms-BrandIcon--code.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_1.5x/code.png)}.ms-BrandIcon--csv.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_1.5x/csv.png)}.ms-BrandIcon--csv.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_1.5x/csv.png)}.ms-BrandIcon--csv.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_1.5x/csv.png)}.ms-BrandIcon--docset.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_1.5x/docset.png)}.ms-BrandIcon--docset.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_1.5x/docset.png)}.ms-BrandIcon--docset.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_1.5x/docset.png)}.ms-BrandIcon--docx.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_1.5x/docx.png)}.ms-BrandIcon--docx.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_1.5x/docx.png)}.ms-BrandIcon--docx.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_1.5x/docx.png)}.ms-BrandIcon--dotx.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_1.5x/dotx.png)}.ms-BrandIcon--dotx.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_1.5x/dotx.png)}.ms-BrandIcon--dotx.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_1.5x/dotx.png)}.ms-BrandIcon--email.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_1.5x/email.png)}.ms-BrandIcon--email.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_1.5x/email.png)}.ms-BrandIcon--email.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_1.5x/email.png)}.ms-BrandIcon--exe.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_1.5x/exe.png)}.ms-BrandIcon--exe.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_1.5x/exe.png)}.ms-BrandIcon--exe.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_1.5x/exe.png)}.ms-BrandIcon--folder.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_1.5x/folder.png)}.ms-BrandIcon--folder.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_1.5x/folder.png)}.ms-BrandIcon--folder.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_1.5x/folder.png)}.ms-BrandIcon--font.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_1.5x/font.png)}.ms-BrandIcon--font.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_1.5x/font.png)}.ms-BrandIcon--font.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_1.5x/font.png)}.ms-BrandIcon--genericfile.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_1.5x/genericfile.png)}.ms-BrandIcon--genericfile.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_1.5x/genericfile.png)}.ms-BrandIcon--genericfile.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_1.5x/genericfile.png)}.ms-BrandIcon--html.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_1.5x/html.png)}.ms-BrandIcon--html.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_1.5x/html.png)}.ms-BrandIcon--html.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_1.5x/html.png)}.ms-BrandIcon--link.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_1.5x/link.png)}.ms-BrandIcon--link.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_1.5x/link.png)}.ms-BrandIcon--link.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_1.5x/link.png)}.ms-BrandIcon--listitem.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_1.5x/listitem.png)}.ms-BrandIcon--listitem.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_1.5x/listitem.png)}.ms-BrandIcon--listitem.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_1.5x/listitem.png)}.ms-BrandIcon--model.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_1.5x/model.png)}.ms-BrandIcon--model.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_1.5x/model.png)}.ms-BrandIcon--model.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_1.5x/model.png)}.ms-BrandIcon--mpp.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_1.5x/mpp.png)}.ms-BrandIcon--mpp.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_1.5x/mpp.png)}.ms-BrandIcon--mpp.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_1.5x/mpp.png)}.ms-BrandIcon--mpt.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_1.5x/mpt.png)}.ms-BrandIcon--mpt.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_1.5x/mpt.png)}.ms-BrandIcon--mpt.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_1.5x/mpt.png)}.ms-BrandIcon--odp.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_1.5x/odp.png)}.ms-BrandIcon--odp.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_1.5x/odp.png)}.ms-BrandIcon--odp.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_1.5x/odp.png)}.ms-BrandIcon--ods.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_1.5x/ods.png)}.ms-BrandIcon--ods.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_1.5x/ods.png)}.ms-BrandIcon--ods.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_1.5x/ods.png)}.ms-BrandIcon--odt.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_1.5x/odt.png)}.ms-BrandIcon--odt.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_1.5x/odt.png)}.ms-BrandIcon--odt.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_1.5x/odt.png)}.ms-BrandIcon--one.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_1.5x/one.png)}.ms-BrandIcon--one.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_1.5x/one.png)}.ms-BrandIcon--one.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_1.5x/one.png)}.ms-BrandIcon--onetoc.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_1.5x/onetoc.png)}.ms-BrandIcon--onetoc.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_1.5x/onetoc.png)}.ms-BrandIcon--onetoc.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_1.5x/onetoc.png)}.ms-BrandIcon--pdf.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_1.5x/pdf.png)}.ms-BrandIcon--pdf.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_1.5x/pdf.png)}.ms-BrandIcon--pdf.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_1.5x/pdf.png)}.ms-BrandIcon--photo.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_1.5x/photo.png)}.ms-BrandIcon--photo.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_1.5x/photo.png)}.ms-BrandIcon--photo.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_1.5x/photo.png)}.ms-BrandIcon--potx.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_1.5x/potx.png)}.ms-BrandIcon--potx.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_1.5x/potx.png)}.ms-BrandIcon--potx.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_1.5x/potx.png)}.ms-BrandIcon--ppsx.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_1.5x/ppsx.png)}.ms-BrandIcon--ppsx.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_1.5x/ppsx.png)}.ms-BrandIcon--ppsx.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_1.5x/ppsx.png)}.ms-BrandIcon--pptx.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_1.5x/pptx.png)}.ms-BrandIcon--pptx.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_1.5x/pptx.png)}.ms-BrandIcon--pptx.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_1.5x/pptx.png)}.ms-BrandIcon--pub.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_1.5x/pub.png)}.ms-BrandIcon--pub.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_1.5x/pub.png)}.ms-BrandIcon--pub.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_1.5x/pub.png)}.ms-BrandIcon--rtf.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_1.5x/rtf.png)}.ms-BrandIcon--rtf.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_1.5x/rtf.png)}.ms-BrandIcon--rtf.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_1.5x/rtf.png)}.ms-BrandIcon--sharedfolder.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_1.5x/sharedfolder.png)}.ms-BrandIcon--sharedfolder.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_1.5x/sharedfolder.png)}.ms-BrandIcon--sharedfolder.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_1.5x/sharedfolder.png)}.ms-BrandIcon--spo.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_1.5x/spo.png)}.ms-BrandIcon--spo.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_1.5x/spo.png)}.ms-BrandIcon--spo.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_1.5x/spo.png)}.ms-BrandIcon--sysfile.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_1.5x/sysfile.png)}.ms-BrandIcon--sysfile.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_1.5x/sysfile.png)}.ms-BrandIcon--sysfile.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_1.5x/sysfile.png)}.ms-BrandIcon--txt.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_1.5x/txt.png)}.ms-BrandIcon--txt.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_1.5x/txt.png)}.ms-BrandIcon--txt.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_1.5x/txt.png)}.ms-BrandIcon--vector.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_1.5x/vector.png)}.ms-BrandIcon--vector.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_1.5x/vector.png)}.ms-BrandIcon--vector.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_1.5x/vector.png)}.ms-BrandIcon--video.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_1.5x/video.png)}.ms-BrandIcon--video.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_1.5x/video.png)}.ms-BrandIcon--video.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_1.5x/video.png)}.ms-BrandIcon--vsdx.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_1.5x/vsdx.png)}.ms-BrandIcon--vsdx.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_1.5x/vsdx.png)}.ms-BrandIcon--vsdx.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_1.5x/vsdx.png)}.ms-BrandIcon--vssx.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_1.5x/vssx.png)}.ms-BrandIcon--vssx.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_1.5x/vssx.png)}.ms-BrandIcon--vssx.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_1.5x/vssx.png)}.ms-BrandIcon--vstx.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_1.5x/vstx.png)}.ms-BrandIcon--vstx.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_1.5x/vstx.png)}.ms-BrandIcon--vstx.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_1.5x/vstx.png)}.ms-BrandIcon--xlsx.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_1.5x/xlsx.png)}.ms-BrandIcon--xlsx.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_1.5x/xlsx.png)}.ms-BrandIcon--xlsx.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_1.5x/xlsx.png)}.ms-BrandIcon--xltx.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_1.5x/xltx.png)}.ms-BrandIcon--xltx.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_1.5x/xltx.png)}.ms-BrandIcon--xltx.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_1.5x/xltx.png)}.ms-BrandIcon--xml.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_1.5x/xml.png)}.ms-BrandIcon--xml.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_1.5x/xml.png)}.ms-BrandIcon--xml.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_1.5x/xml.png)}.ms-BrandIcon--xsn.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_1.5x/xsn.png)}.ms-BrandIcon--xsn.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_1.5x/xsn.png)}.ms-BrandIcon--xsn.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_1.5x/xsn.png)}.ms-BrandIcon--zip.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_1.5x/zip.png)}.ms-BrandIcon--zip.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_1.5x/zip.png)}.ms-BrandIcon--zip.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_1.5x/zip.png)}}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min-resolution:192dpi){.ms-BrandIcon--access.ms-BrandIcon--icon16{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/access_16x2.png)}.ms-BrandIcon--access.ms-BrandIcon--icon48{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/access_48x2.png)}.ms-BrandIcon--access.ms-BrandIcon--icon96{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/access_96x2.png)}.ms-BrandIcon--excel.ms-BrandIcon--icon16{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/excel_16x2.png)}.ms-BrandIcon--excel.ms-BrandIcon--icon48{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/excel_48x2.png)}.ms-BrandIcon--excel.ms-BrandIcon--icon96{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/excel_96x2.png)}.ms-BrandIcon--infopath.ms-BrandIcon--icon16{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/infopath_16x2.png)}.ms-BrandIcon--infopath.ms-BrandIcon--icon48{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/infopath_48x2.png)}.ms-BrandIcon--infopath.ms-BrandIcon--icon96{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/infopath_96x2.png)}.ms-BrandIcon--office.ms-BrandIcon--icon16{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/office_16x2.png)}.ms-BrandIcon--office.ms-BrandIcon--icon48{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/office_48x2.png)}.ms-BrandIcon--office.ms-BrandIcon--icon96{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/office_96x2.png)}.ms-BrandIcon--onedrive.ms-BrandIcon--icon16{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/onedrive_16x2.png)}.ms-BrandIcon--onedrive.ms-BrandIcon--icon48{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/onedrive_48x2.png)}.ms-BrandIcon--onedrive.ms-BrandIcon--icon96{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/onedrive_96x2.png)}.ms-BrandIcon--onenote.ms-BrandIcon--icon16{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/onenote_16x2.png)}.ms-BrandIcon--onenote.ms-BrandIcon--icon48{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/onenote_48x2.png)}.ms-BrandIcon--onenote.ms-BrandIcon--icon96{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/onenote_96x2.png)}.ms-BrandIcon--outlook.ms-BrandIcon--icon16{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/outlook_16x2.png)}.ms-BrandIcon--outlook.ms-BrandIcon--icon48{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/outlook_48x2.png)}.ms-BrandIcon--outlook.ms-BrandIcon--icon96{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/outlook_96x2.png)}.ms-BrandIcon--powerpoint.ms-BrandIcon--icon16{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/powerpoint_16x2.png)}.ms-BrandIcon--powerpoint.ms-BrandIcon--icon48{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/powerpoint_48x2.png)}.ms-BrandIcon--powerpoint.ms-BrandIcon--icon96{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/powerpoint_96x2.png)}.ms-BrandIcon--project.ms-BrandIcon--icon16{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/project_16x2.png)}.ms-BrandIcon--project.ms-BrandIcon--icon48{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/project_48x2.png)}.ms-BrandIcon--project.ms-BrandIcon--icon96{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/project_96x2.png)}.ms-BrandIcon--sharepoint.ms-BrandIcon--icon16{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/sharepoint_16x2.png)}.ms-BrandIcon--sharepoint.ms-BrandIcon--icon48{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/sharepoint_48x2.png)}.ms-BrandIcon--sharepoint.ms-BrandIcon--icon96{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/sharepoint_96x2.png)}.ms-BrandIcon--visio.ms-BrandIcon--icon16{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/visio_16x2.png)}.ms-BrandIcon--visio.ms-BrandIcon--icon48{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/visio_48x2.png)}.ms-BrandIcon--visio.ms-BrandIcon--icon96{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/visio_96x2.png)}.ms-BrandIcon--word.ms-BrandIcon--icon16{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/word_16x2.png)}.ms-BrandIcon--word.ms-BrandIcon--icon48{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/word_48x2.png)}.ms-BrandIcon--word.ms-BrandIcon--icon96{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/word_96x2.png)}.ms-BrandIcon--accdb.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_2x/accdb.png)}.ms-BrandIcon--accdb.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_2x/accdb.png)}.ms-BrandIcon--accdb.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_2x/accdb.png)}.ms-BrandIcon--archive.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_2x/archive.png)}.ms-BrandIcon--archive.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_2x/archive.png)}.ms-BrandIcon--archive.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_2x/archive.png)}.ms-BrandIcon--audio.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_2x/audio.png)}.ms-BrandIcon--audio.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_2x/audio.png)}.ms-BrandIcon--audio.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_2x/audio.png)}.ms-BrandIcon--code.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_2x/code.png)}.ms-BrandIcon--code.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_2x/code.png)}.ms-BrandIcon--code.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_2x/code.png)}.ms-BrandIcon--csv.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_2x/csv.png)}.ms-BrandIcon--csv.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_2x/csv.png)}.ms-BrandIcon--csv.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_2x/csv.png)}.ms-BrandIcon--docset.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_2x/docset.png)}.ms-BrandIcon--docset.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_2x/docset.png)}.ms-BrandIcon--docset.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_2x/docset.png)}.ms-BrandIcon--docx.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_2x/docx.png)}.ms-BrandIcon--docx.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_2x/docx.png)}.ms-BrandIcon--docx.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_2x/docx.png)}.ms-BrandIcon--dotx.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_2x/dotx.png)}.ms-BrandIcon--dotx.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_2x/dotx.png)}.ms-BrandIcon--dotx.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_2x/dotx.png)}.ms-BrandIcon--email.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_2x/email.png)}.ms-BrandIcon--email.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_2x/email.png)}.ms-BrandIcon--email.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_2x/email.png)}.ms-BrandIcon--exe.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_2x/exe.png)}.ms-BrandIcon--exe.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_2x/exe.png)}.ms-BrandIcon--exe.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_2x/exe.png)}.ms-BrandIcon--folder.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_2x/folder.png)}.ms-BrandIcon--folder.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_2x/folder.png)}.ms-BrandIcon--folder.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_2x/folder.png)}.ms-BrandIcon--font.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_2x/font.png)}.ms-BrandIcon--font.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_2x/font.png)}.ms-BrandIcon--font.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_2x/font.png)}.ms-BrandIcon--genericfile.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_2x/genericfile.png)}.ms-BrandIcon--genericfile.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_2x/genericfile.png)}.ms-BrandIcon--genericfile.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_2x/genericfile.png)}.ms-BrandIcon--html.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_2x/html.png)}.ms-BrandIcon--html.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_2x/html.png)}.ms-BrandIcon--html.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_2x/html.png)}.ms-BrandIcon--link.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_2x/link.png)}.ms-BrandIcon--link.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_2x/link.png)}.ms-BrandIcon--link.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_2x/link.png)}.ms-BrandIcon--listitem.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_2x/listitem.png)}.ms-BrandIcon--listitem.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_2x/listitem.png)}.ms-BrandIcon--listitem.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_2x/listitem.png)}.ms-BrandIcon--model.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_2x/model.png)}.ms-BrandIcon--model.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_2x/model.png)}.ms-BrandIcon--model.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_2x/model.png)}.ms-BrandIcon--mpp.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_2x/mpp.png)}.ms-BrandIcon--mpp.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_2x/mpp.png)}.ms-BrandIcon--mpp.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_2x/mpp.png)}.ms-BrandIcon--mpt.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_2x/mpt.png)}.ms-BrandIcon--mpt.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_2x/mpt.png)}.ms-BrandIcon--mpt.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_2x/mpt.png)}.ms-BrandIcon--odp.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_2x/odp.png)}.ms-BrandIcon--odp.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_2x/odp.png)}.ms-BrandIcon--odp.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_2x/odp.png)}.ms-BrandIcon--ods.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_2x/ods.png)}.ms-BrandIcon--ods.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_2x/ods.png)}.ms-BrandIcon--ods.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_2x/ods.png)}.ms-BrandIcon--odt.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_2x/odt.png)}.ms-BrandIcon--odt.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_2x/odt.png)}.ms-BrandIcon--odt.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_2x/odt.png)}.ms-BrandIcon--one.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_2x/one.png)}.ms-BrandIcon--one.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_2x/one.png)}.ms-BrandIcon--one.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_2x/one.png)}.ms-BrandIcon--onetoc.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_2x/onetoc.png)}.ms-BrandIcon--onetoc.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_2x/onetoc.png)}.ms-BrandIcon--onetoc.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_2x/onetoc.png)}.ms-BrandIcon--pdf.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_2x/pdf.png)}.ms-BrandIcon--pdf.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_2x/pdf.png)}.ms-BrandIcon--pdf.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_2x/pdf.png)}.ms-BrandIcon--photo.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_2x/photo.png)}.ms-BrandIcon--photo.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_2x/photo.png)}.ms-BrandIcon--photo.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_2x/photo.png)}.ms-BrandIcon--potx.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_2x/potx.png)}.ms-BrandIcon--potx.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_2x/potx.png)}.ms-BrandIcon--potx.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_2x/potx.png)}.ms-BrandIcon--ppsx.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_2x/ppsx.png)}.ms-BrandIcon--ppsx.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_2x/ppsx.png)}.ms-BrandIcon--ppsx.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_2x/ppsx.png)}.ms-BrandIcon--pptx.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_2x/pptx.png)}.ms-BrandIcon--pptx.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_2x/pptx.png)}.ms-BrandIcon--pptx.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_2x/pptx.png)}.ms-BrandIcon--pub.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_2x/pub.png)}.ms-BrandIcon--pub.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_2x/pub.png)}.ms-BrandIcon--pub.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_2x/pub.png)}.ms-BrandIcon--rtf.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_2x/rtf.png)}.ms-BrandIcon--rtf.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_2x/rtf.png)}.ms-BrandIcon--rtf.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_2x/rtf.png)}.ms-BrandIcon--sharedfolder.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_2x/sharedfolder.png)}.ms-BrandIcon--sharedfolder.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_2x/sharedfolder.png)}.ms-BrandIcon--sharedfolder.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_2x/sharedfolder.png)}.ms-BrandIcon--spo.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_2x/spo.png)}.ms-BrandIcon--spo.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_2x/spo.png)}.ms-BrandIcon--spo.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_2x/spo.png)}.ms-BrandIcon--sysfile.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_2x/sysfile.png)}.ms-BrandIcon--sysfile.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_2x/sysfile.png)}.ms-BrandIcon--sysfile.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_2x/sysfile.png)}.ms-BrandIcon--txt.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_2x/txt.png)}.ms-BrandIcon--txt.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_2x/txt.png)}.ms-BrandIcon--txt.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_2x/txt.png)}.ms-BrandIcon--vector.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_2x/vector.png)}.ms-BrandIcon--vector.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_2x/vector.png)}.ms-BrandIcon--vector.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_2x/vector.png)}.ms-BrandIcon--video.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_2x/video.png)}.ms-BrandIcon--video.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_2x/video.png)}.ms-BrandIcon--video.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_2x/video.png)}.ms-BrandIcon--vsdx.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_2x/vsdx.png)}.ms-BrandIcon--vsdx.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_2x/vsdx.png)}.ms-BrandIcon--vsdx.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_2x/vsdx.png)}.ms-BrandIcon--vssx.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_2x/vssx.png)}.ms-BrandIcon--vssx.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_2x/vssx.png)}.ms-BrandIcon--vssx.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_2x/vssx.png)}.ms-BrandIcon--vstx.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_2x/vstx.png)}.ms-BrandIcon--vstx.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_2x/vstx.png)}.ms-BrandIcon--vstx.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_2x/vstx.png)}.ms-BrandIcon--xlsx.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_2x/xlsx.png)}.ms-BrandIcon--xlsx.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_2x/xlsx.png)}.ms-BrandIcon--xlsx.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_2x/xlsx.png)}.ms-BrandIcon--xltx.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_2x/xltx.png)}.ms-BrandIcon--xltx.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_2x/xltx.png)}.ms-BrandIcon--xltx.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_2x/xltx.png)}.ms-BrandIcon--xml.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_2x/xml.png)}.ms-BrandIcon--xml.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_2x/xml.png)}.ms-BrandIcon--xml.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_2x/xml.png)}.ms-BrandIcon--xsn.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_2x/xsn.png)}.ms-BrandIcon--xsn.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_2x/xsn.png)}.ms-BrandIcon--xsn.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_2x/xsn.png)}.ms-BrandIcon--zip.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_2x/zip.png)}.ms-BrandIcon--zip.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_2x/zip.png)}.ms-BrandIcon--zip.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_2x/zip.png)}}@media only screen and (-webkit-min-device-pixel-ratio:3),only screen and (min-resolution:288dpi){.ms-BrandIcon--access.ms-BrandIcon--icon16{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/access_16x3.png)}.ms-BrandIcon--access.ms-BrandIcon--icon48{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/access_48x3.png)}.ms-BrandIcon--access.ms-BrandIcon--icon96{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/access_96x3.png)}.ms-BrandIcon--excel.ms-BrandIcon--icon16{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/excel_16x3.png)}.ms-BrandIcon--excel.ms-BrandIcon--icon48{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/excel_48x3.png)}.ms-BrandIcon--excel.ms-BrandIcon--icon96{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/excel_96x3.png)}.ms-BrandIcon--infopath.ms-BrandIcon--icon16{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/infopath_16x3.png)}.ms-BrandIcon--infopath.ms-BrandIcon--icon48{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/infopath_48x3.png)}.ms-BrandIcon--infopath.ms-BrandIcon--icon96{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/infopath_96x3.png)}.ms-BrandIcon--office.ms-BrandIcon--icon16{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/office_16x3.png)}.ms-BrandIcon--office.ms-BrandIcon--icon48{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/office_48x3.png)}.ms-BrandIcon--office.ms-BrandIcon--icon96{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/office_96x3.png)}.ms-BrandIcon--onedrive.ms-BrandIcon--icon16{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/onedrive_16x3.png)}.ms-BrandIcon--onedrive.ms-BrandIcon--icon48{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/onedrive_48x3.png)}.ms-BrandIcon--onedrive.ms-BrandIcon--icon96{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/onedrive_96x3.png)}.ms-BrandIcon--onenote.ms-BrandIcon--icon16{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/onenote_16x3.png)}.ms-BrandIcon--onenote.ms-BrandIcon--icon48{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/onenote_48x3.png)}.ms-BrandIcon--onenote.ms-BrandIcon--icon96{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/onenote_96x3.png)}.ms-BrandIcon--outlook.ms-BrandIcon--icon16{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/outlook_16x3.png)}.ms-BrandIcon--outlook.ms-BrandIcon--icon48{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/outlook_48x3.png)}.ms-BrandIcon--outlook.ms-BrandIcon--icon96{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/outlook_96x3.png)}.ms-BrandIcon--powerpoint.ms-BrandIcon--icon16{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/powerpoint_16x3.png)}.ms-BrandIcon--powerpoint.ms-BrandIcon--icon48{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/powerpoint_48x3.png)}.ms-BrandIcon--powerpoint.ms-BrandIcon--icon96{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/powerpoint_96x3.png)}.ms-BrandIcon--project.ms-BrandIcon--icon16{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/project_16x3.png)}.ms-BrandIcon--project.ms-BrandIcon--icon48{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/project_48x3.png)}.ms-BrandIcon--project.ms-BrandIcon--icon96{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/project_96x3.png)}.ms-BrandIcon--sharepoint.ms-BrandIcon--icon16{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/sharepoint_16x3.png)}.ms-BrandIcon--sharepoint.ms-BrandIcon--icon48{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/sharepoint_48x3.png)}.ms-BrandIcon--sharepoint.ms-BrandIcon--icon96{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/sharepoint_96x3.png)}.ms-BrandIcon--visio.ms-BrandIcon--icon16{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/visio_16x3.png)}.ms-BrandIcon--visio.ms-BrandIcon--icon48{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/visio_48x3.png)}.ms-BrandIcon--visio.ms-BrandIcon--icon96{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/visio_96x3.png)}.ms-BrandIcon--word.ms-BrandIcon--icon16{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/word_16x3.png)}.ms-BrandIcon--word.ms-BrandIcon--icon48{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/word_48x3.png)}.ms-BrandIcon--word.ms-BrandIcon--icon96{background-image:url(https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product/png/word_96x3.png)}.ms-BrandIcon--accdb.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_3x/accdb.png)}.ms-BrandIcon--accdb.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_3x/accdb.png)}.ms-BrandIcon--accdb.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_3x/accdb.png)}.ms-BrandIcon--archive.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_3x/archive.png)}.ms-BrandIcon--archive.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_3x/archive.png)}.ms-BrandIcon--archive.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_3x/archive.png)}.ms-BrandIcon--audio.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_3x/audio.png)}.ms-BrandIcon--audio.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_3x/audio.png)}.ms-BrandIcon--audio.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_3x/audio.png)}.ms-BrandIcon--code.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_3x/code.png)}.ms-BrandIcon--code.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_3x/code.png)}.ms-BrandIcon--code.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_3x/code.png)}.ms-BrandIcon--csv.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_3x/csv.png)}.ms-BrandIcon--csv.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_3x/csv.png)}.ms-BrandIcon--csv.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_3x/csv.png)}.ms-BrandIcon--docset.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_3x/docset.png)}.ms-BrandIcon--docset.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_3x/docset.png)}.ms-BrandIcon--docset.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_3x/docset.png)}.ms-BrandIcon--docx.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_3x/docx.png)}.ms-BrandIcon--docx.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_3x/docx.png)}.ms-BrandIcon--docx.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_3x/docx.png)}.ms-BrandIcon--dotx.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_3x/dotx.png)}.ms-BrandIcon--dotx.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_3x/dotx.png)}.ms-BrandIcon--dotx.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_3x/dotx.png)}.ms-BrandIcon--email.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_3x/email.png)}.ms-BrandIcon--email.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_3x/email.png)}.ms-BrandIcon--email.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_3x/email.png)}.ms-BrandIcon--exe.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_3x/exe.png)}.ms-BrandIcon--exe.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_3x/exe.png)}.ms-BrandIcon--exe.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_3x/exe.png)}.ms-BrandIcon--folder.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_3x/folder.png)}.ms-BrandIcon--folder.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_3x/folder.png)}.ms-BrandIcon--folder.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_3x/folder.png)}.ms-BrandIcon--font.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_3x/font.png)}.ms-BrandIcon--font.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_3x/font.png)}.ms-BrandIcon--font.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_3x/font.png)}.ms-BrandIcon--genericfile.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_3x/genericfile.png)}.ms-BrandIcon--genericfile.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_3x/genericfile.png)}.ms-BrandIcon--genericfile.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_3x/genericfile.png)}.ms-BrandIcon--html.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_3x/html.png)}.ms-BrandIcon--html.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_3x/html.png)}.ms-BrandIcon--html.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_3x/html.png)}.ms-BrandIcon--link.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_3x/link.png)}.ms-BrandIcon--link.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_3x/link.png)}.ms-BrandIcon--link.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_3x/link.png)}.ms-BrandIcon--listitem.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_3x/listitem.png)}.ms-BrandIcon--listitem.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_3x/listitem.png)}.ms-BrandIcon--listitem.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_3x/listitem.png)}.ms-BrandIcon--model.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_3x/model.png)}.ms-BrandIcon--model.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_3x/model.png)}.ms-BrandIcon--model.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_3x/model.png)}.ms-BrandIcon--mpp.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_3x/mpp.png)}.ms-BrandIcon--mpp.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_3x/mpp.png)}.ms-BrandIcon--mpp.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_3x/mpp.png)}.ms-BrandIcon--mpt.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_3x/mpt.png)}.ms-BrandIcon--mpt.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_3x/mpt.png)}.ms-BrandIcon--mpt.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_3x/mpt.png)}.ms-BrandIcon--odp.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_3x/odp.png)}.ms-BrandIcon--odp.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_3x/odp.png)}.ms-BrandIcon--odp.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_3x/odp.png)}.ms-BrandIcon--ods.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_3x/ods.png)}.ms-BrandIcon--ods.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_3x/ods.png)}.ms-BrandIcon--ods.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_3x/ods.png)}.ms-BrandIcon--odt.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_3x/odt.png)}.ms-BrandIcon--odt.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_3x/odt.png)}.ms-BrandIcon--odt.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_3x/odt.png)}.ms-BrandIcon--one.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_3x/one.png)}.ms-BrandIcon--one.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_3x/one.png)}.ms-BrandIcon--one.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_3x/one.png)}.ms-BrandIcon--onetoc.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_3x/onetoc.png)}.ms-BrandIcon--onetoc.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_3x/onetoc.png)}.ms-BrandIcon--onetoc.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_3x/onetoc.png)}.ms-BrandIcon--pdf.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_3x/pdf.png)}.ms-BrandIcon--pdf.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_3x/pdf.png)}.ms-BrandIcon--pdf.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_3x/pdf.png)}.ms-BrandIcon--photo.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_3x/photo.png)}.ms-BrandIcon--photo.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_3x/photo.png)}.ms-BrandIcon--photo.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_3x/photo.png)}.ms-BrandIcon--potx.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_3x/potx.png)}.ms-BrandIcon--potx.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_3x/potx.png)}.ms-BrandIcon--potx.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_3x/potx.png)}.ms-BrandIcon--ppsx.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_3x/ppsx.png)}.ms-BrandIcon--ppsx.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_3x/ppsx.png)}.ms-BrandIcon--ppsx.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_3x/ppsx.png)}.ms-BrandIcon--pptx.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_3x/pptx.png)}.ms-BrandIcon--pptx.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_3x/pptx.png)}.ms-BrandIcon--pptx.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_3x/pptx.png)}.ms-BrandIcon--pub.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_3x/pub.png)}.ms-BrandIcon--pub.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_3x/pub.png)}.ms-BrandIcon--pub.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_3x/pub.png)}.ms-BrandIcon--rtf.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_3x/rtf.png)}.ms-BrandIcon--rtf.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_3x/rtf.png)}.ms-BrandIcon--rtf.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_3x/rtf.png)}.ms-BrandIcon--sharedfolder.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_3x/sharedfolder.png)}.ms-BrandIcon--sharedfolder.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_3x/sharedfolder.png)}.ms-BrandIcon--sharedfolder.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_3x/sharedfolder.png)}.ms-BrandIcon--spo.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_3x/spo.png)}.ms-BrandIcon--spo.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_3x/spo.png)}.ms-BrandIcon--spo.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_3x/spo.png)}.ms-BrandIcon--sysfile.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_3x/sysfile.png)}.ms-BrandIcon--sysfile.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_3x/sysfile.png)}.ms-BrandIcon--sysfile.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_3x/sysfile.png)}.ms-BrandIcon--txt.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_3x/txt.png)}.ms-BrandIcon--txt.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_3x/txt.png)}.ms-BrandIcon--txt.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_3x/txt.png)}.ms-BrandIcon--vector.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_3x/vector.png)}.ms-BrandIcon--vector.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_3x/vector.png)}.ms-BrandIcon--vector.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_3x/vector.png)}.ms-BrandIcon--video.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_3x/video.png)}.ms-BrandIcon--video.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_3x/video.png)}.ms-BrandIcon--video.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_3x/video.png)}.ms-BrandIcon--vsdx.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_3x/vsdx.png)}.ms-BrandIcon--vsdx.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_3x/vsdx.png)}.ms-BrandIcon--vsdx.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_3x/vsdx.png)}.ms-BrandIcon--vssx.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_3x/vssx.png)}.ms-BrandIcon--vssx.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_3x/vssx.png)}.ms-BrandIcon--vssx.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_3x/vssx.png)}.ms-BrandIcon--vstx.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_3x/vstx.png)}.ms-BrandIcon--vstx.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_3x/vstx.png)}.ms-BrandIcon--vstx.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_3x/vstx.png)}.ms-BrandIcon--xlsx.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_3x/xlsx.png)}.ms-BrandIcon--xlsx.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_3x/xlsx.png)}.ms-BrandIcon--xlsx.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_3x/xlsx.png)}.ms-BrandIcon--xltx.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_3x/xltx.png)}.ms-BrandIcon--xltx.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_3x/xltx.png)}.ms-BrandIcon--xltx.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_3x/xltx.png)}.ms-BrandIcon--xml.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_3x/xml.png)}.ms-BrandIcon--xml.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_3x/xml.png)}.ms-BrandIcon--xml.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_3x/xml.png)}.ms-BrandIcon--xsn.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_3x/xsn.png)}.ms-BrandIcon--xsn.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_3x/xsn.png)}.ms-BrandIcon--xsn.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_3x/xsn.png)}.ms-BrandIcon--zip.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_3x/zip.png)}.ms-BrandIcon--zip.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_3x/zip.png)}.ms-BrandIcon--zip.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_3x/zip.png)}}.ms-BrandIcon--onepkg.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16/one.png)}.ms-BrandIcon--onepkg.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48/one.png)}.ms-BrandIcon--onepkg.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96/one.png)}.ms-BrandIcon--xls.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16/xlsx.png)}.ms-BrandIcon--xls.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48/xlsx.png)}.ms-BrandIcon--xls.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96/xlsx.png)}@media only screen and (-webkit-min-device-pixel-ratio:1.5),only screen and (min-resolution:144dpi){.ms-BrandIcon--onepkg.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_1.5x/one.png)}.ms-BrandIcon--onepkg.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_1.5x/one.png)}.ms-BrandIcon--onepkg.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_1.5x/one.png)}.ms-BrandIcon--xls.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_1.5x/xlsx.png)}.ms-BrandIcon--xls.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_1.5x/xlsx.png)}.ms-BrandIcon--xls.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_1.5x/xlsx.png)}}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min-resolution:192dpi){.ms-BrandIcon--onepkg.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_2x/one.png)}.ms-BrandIcon--onepkg.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_2x/one.png)}.ms-BrandIcon--onepkg.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_2x/one.png)}.ms-BrandIcon--xls.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_2x/xlsx.png)}.ms-BrandIcon--xls.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_2x/xlsx.png)}.ms-BrandIcon--xls.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_2x/xlsx.png)}}@media only screen and (-webkit-min-device-pixel-ratio:3),only screen and (min-resolution:288dpi){.ms-BrandIcon--onepkg.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_3x/one.png)}.ms-BrandIcon--onepkg.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_3x/one.png)}.ms-BrandIcon--onepkg.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_3x/one.png)}.ms-BrandIcon--xls.ms-BrandIcon--icon16{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/16_3x/xlsx.png)}.ms-BrandIcon--xls.ms-BrandIcon--icon48{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/48_3x/xlsx.png)}.ms-BrandIcon--xls.ms-BrandIcon--icon96{background-image:url(https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/96_3x/xlsx.png)}}.ms-bgColor-themeDark,.ms-bgColor-themeDark--hover:hover{background-color:#005a9e}.ms-bgColor-themeDarkAlt,.ms-bgColor-themeDarkAlt--hover:hover{background-color:#106ebe}.ms-bgColor-themeDarker,.ms-bgColor-themeDarker--hover:hover{background-color:#004578}.ms-bgColor-themePrimary,.ms-bgColor-themePrimary--hover:hover{background-color:#0078d4}.ms-bgColor-themeSecondary,.ms-bgColor-themeSecondary--hover:hover{background-color:#2b88d8}.ms-bgColor-themeTertiary,.ms-bgColor-themeTertiary--hover:hover{background-color:#71afe5}.ms-bgColor-themeLight,.ms-bgColor-themeLight--hover:hover{background-color:#c7e0f4}.ms-bgColor-themeLighter,.ms-bgColor-themeLighter--hover:hover{background-color:#deecf9}.ms-bgColor-themeLighterAlt,.ms-bgColor-themeLighterAlt--hover:hover{background-color:#eff6fc}.ms-bgColor-black,.ms-bgColor-black--hover:hover{background-color:#000}.ms-bgColor-neutralDark,.ms-bgColor-neutralDark--hover:hover{background-color:#212121}.ms-bgColor-neutralPrimary,.ms-bgColor-neutralPrimary--hover:hover{background-color:#333}.ms-bgColor-neutralPrimaryAlt,.ms-bgColor-neutralPrimaryAlt--hover:hover{background-color:#3c3c3c}.ms-bgColor-neutralSecondary,.ms-bgColor-neutralSecondary--hover:hover{background-color:#666}.ms-bgColor-neutralSecondaryAlt,.ms-bgColor-neutralSecondaryAlt--hover:hover{background-color:#767676}.ms-bgColor-neutralTertiary,.ms-bgColor-neutralTertiary--hover:hover{background-color:#a6a6a6}.ms-bgColor-neutralTertiaryAlt,.ms-bgColor-neutralTertiaryAlt--hover:hover{background-color:#c8c8c8}.ms-bgColor-neutralQuaternary,.ms-bgColor-neutralQuaternary--hover:hover{background-color:#d0d0d0}.ms-bgColor-neutralQuaternaryAlt,.ms-bgColor-neutralQuaternaryAlt--hover:hover{background-color:#dadada}.ms-bgColor-neutralLight,.ms-bgColor-neutralLight--hover:hover{background-color:#eaeaea}.ms-bgColor-neutralLighter,.ms-bgColor-neutralLighter--hover:hover{background-color:#f4f4f4}.ms-bgColor-neutralLighterAlt,.ms-bgColor-neutralLighterAlt--hover:hover{background-color:#f8f8f8}.ms-bgColor-white,.ms-bgColor-white--hover:hover{background-color:#fff}.ms-bgColor-yellow,.ms-bgColor-yellow--hover:hover{background-color:#ffb900}.ms-bgColor-yellowLight,.ms-bgColor-yellowLight--hover:hover{background-color:#fff100}.ms-bgColor-orange,.ms-bgColor-orange--hover:hover{background-color:#d83b01}.ms-bgColor-orangeLight,.ms-bgColor-orangeLight--hover:hover{background-color:#ea4300}.ms-bgColor-orangeLighter,.ms-bgColor-orangeLighter--hover:hover{background-color:#ff8c00}.ms-bgColor-redDark,.ms-bgColor-redDark--hover:hover{background-color:#a80000}.ms-bgColor-red,.ms-bgColor-red--hover:hover{background-color:#e81123}.ms-bgColor-magentaDark,.ms-bgColor-magentaDark--hover:hover{background-color:#5c005c}.ms-bgColor-magenta,.ms-bgColor-magenta--hover:hover{background-color:#b4009e}.ms-bgColor-magentaLight,.ms-bgColor-magentaLight--hover:hover{background-color:#e3008c}.ms-bgColor-purpleDark,.ms-bgColor-purpleDark--hover:hover{background-color:#32145a}.ms-bgColor-purple,.ms-bgColor-purple--hover:hover{background-color:#5c2d91}.ms-bgColor-purpleLight,.ms-bgColor-purpleLight--hover:hover{background-color:#b4a0ff}.ms-bgColor-blueDark,.ms-bgColor-blueDark--hover:hover{background-color:#002050}.ms-bgColor-blueMid,.ms-bgColor-blueMid--hover:hover{background-color:#00188f}.ms-bgColor-blue,.ms-bgColor-blue--hover:hover{background-color:#0078d7}.ms-bgColor-blueLight,.ms-bgColor-blueLight--hover:hover{background-color:#00bcf2}.ms-bgColor-tealDark,.ms-bgColor-tealDark--hover:hover{background-color:#004b50}.ms-bgColor-teal,.ms-bgColor-teal--hover:hover{background-color:#008272}.ms-bgColor-tealLight,.ms-bgColor-tealLight--hover:hover{background-color:#00b294}.ms-bgColor-greenDark,.ms-bgColor-greenDark--hover:hover{background-color:#004b1c}.ms-bgColor-green,.ms-bgColor-green--hover:hover{background-color:#107c10}.ms-bgColor-greenLight,.ms-bgColor-greenLight--hover:hover{background-color:#bad80a}.ms-bgColor-info,.ms-bgColor-info--hover:hover{background-color:#f4f4f4}.ms-bgColor-success,.ms-bgColor-success--hover:hover{background-color:#dff6dd}.ms-bgColor-severeWarning,.ms-bgColor-severeWarning--hover:hover{background-color:#fed9cc}.ms-bgColor-warning,.ms-bgColor-warning--hover:hover{background-color:#fff4ce}.ms-bgColor-error,.ms-bgColor-error--hover:hover{background-color:#fde7e9}.ms-borderColor-themeDark,.ms-borderColor-themeDark--hover:hover{border-color:#005a9e}.ms-borderColor-themeDarkAlt,.ms-borderColor-themeDarkAlt--hover:hover{border-color:#106ebe}.ms-borderColor-themeDarker,.ms-borderColor-themeDarker--hover:hover{border-color:#004578}.ms-borderColor-themePrimary,.ms-borderColor-themePrimary--hover:hover{border-color:#0078d4}.ms-borderColor-themeSecondary,.ms-borderColor-themeSecondary--hover:hover{border-color:#2b88d8}.ms-borderColor-themeTertiary,.ms-borderColor-themeTertiary--hover:hover{border-color:#71afe5}.ms-borderColor-themeLight,.ms-borderColor-themeLight--hover:hover{border-color:#c7e0f4}.ms-borderColor-themeLighter,.ms-borderColor-themeLighter--hover:hover{border-color:#deecf9}.ms-borderColor-themeLighterAlt,.ms-borderColor-themeLighterAlt--hover:hover{border-color:#eff6fc}.ms-borderColor-black,.ms-borderColor-black--hover:hover{border-color:#000}.ms-borderColor-neutralDark,.ms-borderColor-neutralDark--hover:hover{border-color:#212121}.ms-borderColor-neutralPrimary,.ms-borderColor-neutralPrimary--hover:hover{border-color:#333}.ms-borderColor-neutralPrimaryAlt,.ms-borderColor-neutralPrimaryAlt--hover:hover{border-color:#3c3c3c}.ms-borderColor-neutralSecondary,.ms-borderColor-neutralSecondary--hover:hover{border-color:#666}.ms-borderColor-neutralSecondaryAlt,.ms-borderColor-neutralSecondaryAlt--hover:hover{border-color:#767676}.ms-borderColor-neutralTertiary,.ms-borderColor-neutralTertiary--hover:hover{border-color:#a6a6a6}.ms-borderColor-neutralTertiaryAlt,.ms-borderColor-neutralTertiaryAlt--hover:hover{border-color:#c8c8c8}.ms-borderColor-neutralQuaternary,.ms-borderColor-neutralQuaternary--hover:hover{border-color:#d0d0d0}.ms-borderColor-neutralQuaternaryAlt,.ms-borderColor-neutralQuaternaryAlt--hover:hover{border-color:#dadada}.ms-borderColor-neutralLight,.ms-borderColor-neutralLight--hover:hover{border-color:#eaeaea}.ms-borderColor-neutralLighter,.ms-borderColor-neutralLighter--hover:hover{border-color:#f4f4f4}.ms-borderColor-neutralLighterAlt,.ms-borderColor-neutralLighterAlt--hover:hover{border-color:#f8f8f8}.ms-borderColor-white,.ms-borderColor-white--hover:hover{border-color:#fff}.ms-borderColor-yellow,.ms-borderColor-yellow--hover:hover{border-color:#ffb900}.ms-borderColor-yellowLight,.ms-borderColor-yellowLight--hover:hover{border-color:#fff100}.ms-borderColor-orange,.ms-borderColor-orange--hover:hover{border-color:#d83b01}.ms-borderColor-orangeLight,.ms-borderColor-orangeLight--hover:hover{border-color:#ea4300}.ms-borderColor-orangeLighter,.ms-borderColor-orangeLighter--hover:hover{border-color:#ff8c00}.ms-borderColor-redDark,.ms-borderColor-redDark--hover:hover{border-color:#a80000}.ms-borderColor-red,.ms-borderColor-red--hover:hover{border-color:#e81123}.ms-borderColor-magentaDark,.ms-borderColor-magentaDark--hover:hover{border-color:#5c005c}.ms-borderColor-magenta,.ms-borderColor-magenta--hover:hover{border-color:#b4009e}.ms-borderColor-magentaLight,.ms-borderColor-magentaLight--hover:hover{border-color:#e3008c}.ms-borderColor-purpleDark,.ms-borderColor-purpleDark--hover:hover{border-color:#32145a}.ms-borderColor-purple,.ms-borderColor-purple--hover:hover{border-color:#5c2d91}.ms-borderColor-purpleLight,.ms-borderColor-purpleLight--hover:hover{border-color:#b4a0ff}.ms-borderColor-blueDark,.ms-borderColor-blueDark--hover:hover{border-color:#002050}.ms-borderColor-blueMid,.ms-borderColor-blueMid--hover:hover{border-color:#00188f}.ms-borderColor-blue,.ms-borderColor-blue--hover:hover{border-color:#0078d7}.ms-borderColor-blueLight,.ms-borderColor-blueLight--hover:hover{border-color:#00bcf2}.ms-borderColor-tealDark,.ms-borderColor-tealDark--hover:hover{border-color:#004b50}.ms-borderColor-teal,.ms-borderColor-teal--hover:hover{border-color:#008272}.ms-borderColor-tealLight,.ms-borderColor-tealLight--hover:hover{border-color:#00b294}.ms-borderColor-greenDark,.ms-borderColor-greenDark--hover:hover{border-color:#004b1c}.ms-borderColor-green,.ms-borderColor-green--hover:hover{border-color:#107c10}.ms-borderColor-greenLight,.ms-borderColor-greenLight--hover:hover{border-color:#bad80a}@font-face{font-family:Leelawadee UI Web;src:url(https://static2.sharepointonline.com/files/fabric/assets/fonts/leelawadeeui-thai/leelawadeeui-light.woff2) format(\"woff2\"),url(https://static2.sharepointonline.com/files/fabric/assets/fonts/leelawadeeui-thai/leelawadeeui-light.woff) format(\"woff\");font-weight:100;font-style:normal}@font-face{font-family:Leelawadee UI Web;src:url(https://static2.sharepointonline.com/files/fabric/assets/fonts/leelawadeeui-thai/leelawadeeui-semilight.woff2) format(\"woff2\"),url(https://static2.sharepointonline.com/files/fabric/assets/fonts/leelawadeeui-thai/leelawadeeui-semilight.woff) format(\"woff\");font-weight:300;font-style:normal}@font-face{font-family:Leelawadee UI Web;src:url(https://static2.sharepointonline.com/files/fabric/assets/fonts/leelawadeeui-thai/leelawadeeui-regular.woff2) format(\"woff2\"),url(https://static2.sharepointonline.com/files/fabric/assets/fonts/leelawadeeui-thai/leelawadeeui-regular.woff) format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:Leelawadee UI Web;src:url(https://static2.sharepointonline.com/files/fabric/assets/fonts/leelawadeeui-thai/leelawadeeui-semibold.woff2) format(\"woff2\"),url(https://static2.sharepointonline.com/files/fabric/assets/fonts/leelawadeeui-thai/leelawadeeui-semibold.woff) format(\"woff\");font-weight:600;font-style:normal}@font-face{font-family:Leelawadee UI Web;src:url(https://static2.sharepointonline.com/files/fabric/assets/fonts/leelawadeeui-thai/leelawadeeui-bold.woff2) format(\"woff2\"),url(https://static2.sharepointonline.com/files/fabric/assets/fonts/leelawadeeui-thai/leelawadeeui-bold.woff) format(\"woff\");font-weight:700;font-style:normal}@font-face{font-family:Segoe UI Web\\ (Arabic);src:url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-arabic/segoeui-light.woff2) format(\"woff2\"),url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-arabic/segoeui-light.woff) format(\"woff\");font-weight:100;font-style:normal}@font-face{font-family:Segoe UI Web\\ (Arabic);src:url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-arabic/segoeui-semilight.woff2) format(\"woff2\"),url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-arabic/segoeui-semilight.woff) format(\"woff\");font-weight:300;font-style:normal}@font-face{font-family:Segoe UI Web\\ (Arabic);src:url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-arabic/segoeui-regular.woff2) format(\"woff2\"),url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-arabic/segoeui-regular.woff) format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:Segoe UI Web\\ (Arabic);src:url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-arabic/segoeui-semibold.woff2) format(\"woff2\"),url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-arabic/segoeui-semibold.woff) format(\"woff\");font-weight:600;font-style:normal}@font-face{font-family:Segoe UI Web\\ (Arabic);src:url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-arabic/segoeui-bold.woff2) format(\"woff2\"),url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-arabic/segoeui-bold.woff) format(\"woff\");font-weight:700;font-style:normal}@font-face{font-family:Segoe UI Web\\ (Cyrillic);src:url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-cyrillic/segoeui-light.woff2) format(\"woff2\"),url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-cyrillic/segoeui-light.woff) format(\"woff\");font-weight:100;font-style:normal}@font-face{font-family:Segoe UI Web\\ (Cyrillic);src:url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-cyrillic/segoeui-semilight.woff2) format(\"woff2\"),url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-cyrillic/segoeui-semilight.woff) format(\"woff\");font-weight:300;font-style:normal}@font-face{font-family:Segoe UI Web\\ (Cyrillic);src:url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-cyrillic/segoeui-regular.woff2) format(\"woff2\"),url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-cyrillic/segoeui-regular.woff) format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:Segoe UI Web\\ (Cyrillic);src:url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-cyrillic/segoeui-semibold.woff2) format(\"woff2\"),url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-cyrillic/segoeui-semibold.woff) format(\"woff\");font-weight:600;font-style:normal}@font-face{font-family:Segoe UI Web\\ (Cyrillic);src:url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-cyrillic/segoeui-bold.woff2) format(\"woff2\"),url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-cyrillic/segoeui-bold.woff) format(\"woff\");font-weight:700;font-style:normal}@font-face{font-family:\"Segoe UI Web (East European)\";src:url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-easteuropean/segoeui-light.woff2) format(\"woff2\"),url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-easteuropean/segoeui-light.woff) format(\"woff\");font-weight:100;font-style:normal}@font-face{font-family:\"Segoe UI Web (East European)\";src:url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-easteuropean/segoeui-semilight.woff2) format(\"woff2\"),url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-easteuropean/segoeui-semilight.woff) format(\"woff\");font-weight:300;font-style:normal}@font-face{font-family:\"Segoe UI Web (East European)\";src:url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-easteuropean/segoeui-regular.woff2) format(\"woff2\"),url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-easteuropean/segoeui-regular.woff) format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:\"Segoe UI Web (East European)\";src:url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-easteuropean/segoeui-semibold.woff2) format(\"woff2\"),url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-easteuropean/segoeui-semibold.woff) format(\"woff\");font-weight:600;font-style:normal}@font-face{font-family:\"Segoe UI Web (East European)\";src:url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-easteuropean/segoeui-bold.woff2) format(\"woff2\"),url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-easteuropean/segoeui-bold.woff) format(\"woff\");font-weight:700;font-style:normal}@font-face{font-family:Segoe UI Web\\ (Greek);src:url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-greek/segoeui-light.woff2) format(\"woff2\"),url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-greek/segoeui-light.woff) format(\"woff\");font-weight:100;font-style:normal}@font-face{font-family:Segoe UI Web\\ (Greek);src:url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-greek/segoeui-semilight.woff2) format(\"woff2\"),url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-greek/segoeui-semilight.woff) format(\"woff\");font-weight:300;font-style:normal}@font-face{font-family:Segoe UI Web\\ (Greek);src:url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-greek/segoeui-regular.woff2) format(\"woff2\"),url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-greek/segoeui-regular.woff) format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:Segoe UI Web\\ (Greek);src:url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-greek/segoeui-semibold.woff2) format(\"woff2\"),url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-greek/segoeui-semibold.woff) format(\"woff\");font-weight:600;font-style:normal}@font-face{font-family:Segoe UI Web\\ (Greek);src:url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-greek/segoeui-bold.woff2) format(\"woff2\"),url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-greek/segoeui-bold.woff) format(\"woff\");font-weight:700;font-style:normal}@font-face{font-family:Segoe UI Web\\ (Hebrew);src:url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-hebrew/segoeui-light.woff2) format(\"woff2\"),url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-hebrew/segoeui-light.woff) format(\"woff\");font-weight:100;font-style:normal}@font-face{font-family:Segoe UI Web\\ (Hebrew);src:url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-hebrew/segoeui-semilight.woff2) format(\"woff2\"),url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-hebrew/segoeui-semilight.woff) format(\"woff\");font-weight:300;font-style:normal}@font-face{font-family:Segoe UI Web\\ (Hebrew);src:url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-hebrew/segoeui-regular.woff2) format(\"woff2\"),url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-hebrew/segoeui-regular.woff) format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:Segoe UI Web\\ (Hebrew);src:url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-hebrew/segoeui-semibold.woff2) format(\"woff2\"),url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-hebrew/segoeui-semibold.woff) format(\"woff\");font-weight:600;font-style:normal}@font-face{font-family:Segoe UI Web\\ (Hebrew);src:url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-hebrew/segoeui-bold.woff2) format(\"woff2\"),url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-hebrew/segoeui-bold.woff) format(\"woff\");font-weight:700;font-style:normal}@font-face{font-family:Segoe UI Web\\ (Vietnamese);src:url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-vietnamese/segoeui-light.woff2) format(\"woff2\"),url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-vietnamese/segoeui-light.woff) format(\"woff\");font-weight:100;font-style:normal}@font-face{font-family:Segoe UI Web\\ (Vietnamese);src:url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-vietnamese/segoeui-semilight.woff2) format(\"woff2\"),url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-vietnamese/segoeui-semilight.woff) format(\"woff\");font-weight:300;font-style:normal}@font-face{font-family:Segoe UI Web\\ (Vietnamese);src:url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-vietnamese/segoeui-regular.woff2) format(\"woff2\"),url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-vietnamese/segoeui-regular.woff) format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:Segoe UI Web\\ (Vietnamese);src:url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-vietnamese/segoeui-semibold.woff2) format(\"woff2\"),url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-vietnamese/segoeui-semibold.woff) format(\"woff\");font-weight:600;font-style:normal}@font-face{font-family:Segoe UI Web\\ (Vietnamese);src:url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-vietnamese/segoeui-bold.woff2) format(\"woff2\"),url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-vietnamese/segoeui-bold.woff) format(\"woff\");font-weight:700;font-style:normal}@font-face{font-family:\"Segoe UI Web (West European)\";src:url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-westeuropean/segoeui-light.woff2) format(\"woff2\"),url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-westeuropean/segoeui-light.woff) format(\"woff\");font-weight:100;font-style:normal}@font-face{font-family:\"Segoe UI Web (West European)\";src:url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-westeuropean/segoeui-semilight.woff2) format(\"woff2\"),url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-westeuropean/segoeui-semilight.woff) format(\"woff\");font-weight:300;font-style:normal}@font-face{font-family:\"Segoe UI Web (West European)\";src:url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-westeuropean/segoeui-regular.woff2) format(\"woff2\"),url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-westeuropean/segoeui-regular.woff) format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:\"Segoe UI Web (West European)\";src:url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-westeuropean/segoeui-semibold.woff2) format(\"woff2\"),url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-westeuropean/segoeui-semibold.woff) format(\"woff\");font-weight:600;font-style:normal}@font-face{font-family:\"Segoe UI Web (West European)\";src:url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-westeuropean/segoeui-bold.woff2) format(\"woff2\"),url(https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-westeuropean/segoeui-bold.woff) format(\"woff\");font-weight:700;font-style:normal}@font-face{font-family:Selawik Web;src:url(https://static2.sharepointonline.com/files/fabric/assets/fonts/selawik/selawik-light.woff2) format(\"woff2\"),url(https://static2.sharepointonline.com/files/fabric/assets/fonts/selawik/selawik-light.woff) format(\"woff\");font-weight:100;font-style:normal}@font-face{font-family:Selawik Web;src:url(https://static2.sharepointonline.com/files/fabric/assets/fonts/selawik/selawik-semilight.woff2) format(\"woff2\"),url(https://static2.sharepointonline.com/files/fabric/assets/fonts/selawik/selawik-semilight.woff) format(\"woff\");font-weight:300;font-style:normal}@font-face{font-family:Selawik Web;src:url(https://static2.sharepointonline.com/files/fabric/assets/fonts/selawik/selawik-regular.woff2) format(\"woff2\"),url(https://static2.sharepointonline.com/files/fabric/assets/fonts/selawik/selawik-regular.woff) format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:Selawik Web;src:url(https://static2.sharepointonline.com/files/fabric/assets/fonts/selawik/selawik-semibold.woff2) format(\"woff2\"),url(https://static2.sharepointonline.com/files/fabric/assets/fonts/selawik/selawik-semibold.woff) format(\"woff\");font-weight:600;font-style:normal}@font-face{font-family:Selawik Web;src:url(https://static2.sharepointonline.com/files/fabric/assets/fonts/selawik/selawik-bold.woff2) format(\"woff2\"),url(https://static2.sharepointonline.com/files/fabric/assets/fonts/selawik/selawik-bold.woff) format(\"woff\");font-weight:700;font-style:normal}@font-face{font-family:Leelawadee UI Web;src:url(https://static2.sharepointonline.com/files/fabric/assets/fonts/leelawadeeui-thai/leelawadeeui-semilight.woff2) format(\"woff2\"),url(https://static2.sharepointonline.com/files/fabric/assets/fonts/leelawadeeui-thai/leelawadeeui-semilight.woff) format(\"woff\");font-weight:100;font-style:normal}@font-face{font-family:Leelawadee UI Web;src:url(https://static2.sharepointonline.com/files/fabric/assets/fonts/leelawadeeui-thai/leelawadeeui-bold.woff2) format(\"woff2\"),url(https://static2.sharepointonline.com/files/fabric/assets/fonts/leelawadeeui-thai/leelawadeeui-bold.woff) format(\"woff\");font-weight:600;font-style:normal}.ms-font-su{font-size:42px;font-weight:100}.ms-font-xxl{font-size:28px;font-weight:100}.ms-font-xl-plus{font-size:24px;font-weight:100}.ms-font-xl{font-size:21px;font-weight:100}.ms-font-l{font-size:17px;font-weight:300}.ms-font-m-plus{font-size:15px;font-weight:400}.ms-font-m{font-size:14px;font-weight:400}.ms-font-s-plus{font-size:13px;font-weight:400}.ms-font-s{font-size:12px;font-weight:400}.ms-font-xs{font-size:11px;font-weight:400}.ms-font-mi{font-size:10px;font-weight:600}.ms-fontWeight-light{font-weight:100}.ms-fontWeight-semilight{font-weight:300}.ms-fontWeight-regular{font-weight:400}.ms-fontWeight-semibold{font-weight:600}.ms-fontWeight-bold{font-weight:700}.ms-fontSize-su{font-size:42px}.ms-fontSize-xxl{font-size:28px}.ms-fontSize-xlPlus{font-size:24px}.ms-fontSize-xl{font-size:21px}.ms-fontSize-l{font-size:17px}.ms-fontSize-mPlus{font-size:15px}.ms-fontSize-m{font-size:14px}.ms-fontSize-sPlus{font-size:13px}.ms-fontSize-s{font-size:12px}.ms-fontSize-xs{font-size:11px}.ms-fontSize-mi{font-size:10px}.ms-fontColor-themeDarker,.ms-fontColor-themeDarker--hover:hover{color:#004578}.ms-fontColor-themeDark,.ms-fontColor-themeDark--hover:hover{color:#005a9e}.ms-fontColor-themeDarkAlt,.ms-fontColor-themeDarkAlt--hover:hover{color:#106ebe}.ms-fontColor-themePrimary,.ms-fontColor-themePrimary--hover:hover{color:#0078d4}.ms-fontColor-themeSecondary,.ms-fontColor-themeSecondary--hover:hover{color:#2b88d8}.ms-fontColor-themeTertiary,.ms-fontColor-themeTertiary--hover:hover{color:#71afe5}.ms-fontColor-themeLight,.ms-fontColor-themeLight--hover:hover{color:#c7e0f4}.ms-fontColor-themeLighter,.ms-fontColor-themeLighter--hover:hover{color:#deecf9}.ms-fontColor-themeLighterAlt,.ms-fontColor-themeLighterAlt--hover:hover{color:#eff6fc}.ms-fontColor-black,.ms-fontColor-black--hover:hover{color:#000}.ms-fontColor-neutralDark,.ms-fontColor-neutralDark--hover:hover{color:#212121}.ms-fontColor-neutralPrimary,.ms-fontColor-neutralPrimary--hover:hover{color:#333}.ms-fontColor-neutralPrimaryAlt,.ms-fontColor-neutralPrimaryAlt--hover:hover{color:#3c3c3c}.ms-fontColor-neutralSecondary,.ms-fontColor-neutralSecondary--hover:hover{color:#666}.ms-fontColor-neutralSecondaryAlt,.ms-fontColor-neutralSecondaryAlt--hover:hover{color:#767676}.ms-fontColor-neutralTertiary,.ms-fontColor-neutralTertiary--hover:hover{color:#a6a6a6}.ms-fontColor-neutralTertiaryAlt,.ms-fontColor-neutralTertiaryAlt--hover:hover{color:#c8c8c8}.ms-fontColor-neutralQuaternary,.ms-fontColor-neutralQuaternary--hover:hover{color:#d0d0d0}.ms-fontColor-neutralQuaternaryAlt,.ms-fontColor-neutralQuaternaryAlt--hover:hover{color:#dadada}.ms-fontColor-neutralLight,.ms-fontColor-neutralLight--hover:hover{color:#eaeaea}.ms-fontColor-neutralLighter,.ms-fontColor-neutralLighter--hover:hover{color:#f4f4f4}.ms-fontColor-neutralLighterAlt,.ms-fontColor-neutralLighterAlt--hover:hover{color:#f8f8f8}.ms-fontColor-white,.ms-fontColor-white--hover:hover{color:#fff}.ms-fontColor-yellow,.ms-fontColor-yellow--hover:hover{color:#ffb900}.ms-fontColor-yellowLight,.ms-fontColor-yellowLight--hover:hover{color:#fff100}.ms-fontColor-orange,.ms-fontColor-orange--hover:hover{color:#d83b01}.ms-fontColor-orangeLight,.ms-fontColor-orangeLight--hover:hover{color:#ea4300}.ms-fontColor-orangeLighter,.ms-fontColor-orangeLighter--hover:hover{color:#ff8c00}.ms-fontColor-redDark,.ms-fontColor-redDark--hover:hover{color:#a80000}.ms-fontColor-red,.ms-fontColor-red--hover:hover{color:#e81123}.ms-fontColor-magentaDark,.ms-fontColor-magentaDark--hover:hover{color:#5c005c}.ms-fontColor-magenta,.ms-fontColor-magenta--hover:hover{color:#b4009e}.ms-fontColor-magentaLight,.ms-fontColor-magentaLight--hover:hover{color:#e3008c}.ms-fontColor-purpleDark,.ms-fontColor-purpleDark--hover:hover{color:#32145a}.ms-fontColor-purple,.ms-fontColor-purple--hover:hover{color:#5c2d91}.ms-fontColor-purpleLight,.ms-fontColor-purpleLight--hover:hover{color:#b4a0ff}.ms-fontColor-blueDark,.ms-fontColor-blueDark--hover:hover{color:#002050}.ms-fontColor-blueMid,.ms-fontColor-blueMid--hover:hover{color:#00188f}.ms-fontColor-blue,.ms-fontColor-blue--hover:hover{color:#0078d7}.ms-fontColor-blueLight,.ms-fontColor-blueLight--hover:hover{color:#00bcf2}.ms-fontColor-tealDark,.ms-fontColor-tealDark--hover:hover{color:#004b50}.ms-fontColor-teal,.ms-fontColor-teal--hover:hover{color:#008272}.ms-fontColor-tealLight,.ms-fontColor-tealLight--hover:hover{color:#00b294}.ms-fontColor-greenDark,.ms-fontColor-greenDark--hover:hover{color:#004b1c}.ms-fontColor-green,.ms-fontColor-green--hover:hover{color:#107c10}.ms-fontColor-greenLight,.ms-fontColor-greenLight--hover:hover{color:#bad80a}.ms-fontColor-info,.ms-fontColor-info--hover:hover{color:#767676}.ms-fontColor-success,.ms-fontColor-success--hover:hover{color:#107c10}.ms-fontColor-alert,.ms-fontColor-alert--hover:hover{color:#d83b01}.ms-fontColor-warning,.ms-fontColor-warning--hover:hover{color:#767676}.ms-fontColor-severeWarning,.ms-fontColor-severeWarning--hover:hover{color:#d83b01}.ms-fontColor-error,.ms-fontColor-error--hover:hover{color:#a80000}.ms-Grid{box-sizing:border-box;*zoom:1;padding:0 8px}.ms-Grid:after,.ms-Grid:before{display:table;content:\"\";line-height:0}.ms-Grid:after{clear:both}.ms-Grid-row{margin:0 -8px;box-sizing:border-box;*zoom:1}.ms-Grid-row:after,.ms-Grid-row:before{display:table;content:\"\";line-height:0}.ms-Grid-row:after{clear:both}.ms-Grid-col{position:relative;min-height:1px;padding-left:8px;padding-right:8px;box-sizing:border-box}[dir=ltr] .ms-Grid-col{float:left}[dir=rtl] .ms-Grid-col{float:right}.ms-Grid-col .ms-Grid{padding:0}@font-face{font-family:FabricMDL2Icons;src:url(https://static2.sharepointonline.com/files/fabric/assets/icons/fabricmdl2icons-2.68.woff2) format(\"woff2\"),url(https://static2.sharepointonline.com/files/fabric/assets/icons/fabricmdl2icons-2.68.woff) format(\"woff\"),url(https://static2.sharepointonline.com/files/fabric/assets/icons/fabricmdl2icons-2.68.ttf) format(\"truetype\");font-weight:400;font-style:normal}.ms-Icon{display:inline-block;font-family:FabricMDL2Icons;font-style:normal;font-weight:400;speak:none}.ms-Icon--circle{margin:0 .5em 0 0;position:relative;display:inline-block;font-size:1rem;width:1em;height:1em;padding:0;text-align:left}[dir=rtl] .ms-Icon--circle{margin:0 0 0 .5em}.ms-Icon--circle:after,.ms-Icon--circle:before{line-height:1;font-size:inherit}.ms-Icon--circle:before{display:block;width:100%;height:100%;margin:0;padding:0;vertical-align:top;position:absolute}.ms-Icon--circle:after{content:\"\\E000\";position:absolute;top:0;left:0;transform:scale(2);transform-origin:50% 50%;z-index:0}.ms-Icon--xs{font-size:10px}.ms-Icon--s{font-size:12px}.ms-Icon--m{font-size:16px}.ms-Icon--l{font-size:20px}.ms-Icon--12PointStar:before{content:\"\\F505\"}.ms-Icon--6PointStar:before{content:\"\\F504\"}.ms-Icon--AADLogo:before{content:\"\\ED68\"}.ms-Icon--Accept:before{content:\"\\E8FB\"}.ms-Icon--AccessLogo:before{content:\"\\ED69\"}.ms-Icon--AccessLogoFill:before{content:\"\\F1DB\"}.ms-Icon--AccountManagement:before{content:\"\\F55C\"}.ms-Icon--Accounts:before{content:\"\\E910\"}.ms-Icon--ActivateOrders:before{content:\"\\EFE0\"}.ms-Icon--ActivityFeed:before{content:\"\\F056\"}.ms-Icon--Add:before{content:\"\\E710\"}.ms-Icon--AddBookmark:before{content:\"\\F5B7\"}.ms-Icon--AddEvent:before{content:\"\\EEB5\"}.ms-Icon--AddFavorite:before{content:\"\\F0C8\"}.ms-Icon--AddFavoriteFill:before{content:\"\\F0C9\"}.ms-Icon--AddFriend:before{content:\"\\E8FA\"}.ms-Icon--AddGroup:before{content:\"\\EE3D\"}.ms-Icon--AddNotes:before{content:\"\\EAE3\"}.ms-Icon--AddOnlineMeeting:before{content:\"\\ED8E\"}.ms-Icon--AddPhone:before{content:\"\\ED96\"}.ms-Icon--AddTo:before{content:\"\\ECC8\"}.ms-Icon--Admin:before{content:\"\\E7EF\"}.ms-Icon--AdminALogo32:before{content:\"\\F4BA\"}.ms-Icon--AdminALogoFill32:before{content:\"\\F4BB\"}.ms-Icon--AdminALogoInverse32:before{content:\"\\ED6A\"}.ms-Icon--AdminCLogoInverse32:before{content:\"\\ED6B\"}.ms-Icon--AdminDLogoInverse32:before{content:\"\\ED6C\"}.ms-Icon--AdminELogoInverse32:before{content:\"\\ED6D\"}.ms-Icon--AdminLLogoInverse32:before{content:\"\\ED6E\"}.ms-Icon--AdminMLogoInverse32:before{content:\"\\ED6F\"}.ms-Icon--AdminOLogoInverse32:before{content:\"\\ED70\"}.ms-Icon--AdminPLogoInverse32:before{content:\"\\ED71\"}.ms-Icon--AdminSLogoInverse32:before{content:\"\\ED72\"}.ms-Icon--AdminYLogoInverse32:before{content:\"\\ED73\"}.ms-Icon--Airplane:before{content:\"\\E709\"}.ms-Icon--AirplaneSolid:before{content:\"\\EB4C\"}.ms-Icon--AirTickets:before{content:\"\\EF7A\"}.ms-Icon--AlarmClock:before{content:\"\\E919\"}.ms-Icon--Album:before{content:\"\\E7AB\"}.ms-Icon--AlbumRemove:before{content:\"\\EC62\"}.ms-Icon--AlertSolid:before{content:\"\\F331\"}.ms-Icon--AlignCenter:before{content:\"\\E8E3\"}.ms-Icon--AlignHorizontalCenter:before{content:\"\\F4F4\"}.ms-Icon--AlignHorizontalLeft:before{content:\"\\F4F3\"}.ms-Icon--AlignHorizontalRight:before{content:\"\\F4F5\"}.ms-Icon--AlignJustify:before{content:\"\\F51E\"}.ms-Icon--AlignLeft:before{content:\"\\E8E4\"}.ms-Icon--AlignRight:before{content:\"\\E8E2\"}.ms-Icon--AlignVerticalBottom:before{content:\"\\F4F8\"}.ms-Icon--AlignVerticalCenter:before{content:\"\\F4F7\"}.ms-Icon--AlignVerticalTop:before{content:\"\\F4F6\"}[dir=ltr] .ms-Icon--AllApps:before{content:\"\\E71D\"}[dir=ltr] .ms-Icon--AllAppsMirrored:before,[dir=rtl] .ms-Icon--AllApps:before{content:\"\\EA40\"}[dir=rtl] .ms-Icon--AllAppsMirrored:before{content:\"\\E71D\"}.ms-Icon--AnalyticsLogo:before{content:\"\\F1DE\"}.ms-Icon--AnalyticsQuery:before{content:\"\\F1DF\"}.ms-Icon--AnalyticsReport:before{content:\"\\F1E1\"}.ms-Icon--AnalyticsView:before{content:\"\\F5F1\"}.ms-Icon--AnchorLock:before{content:\"\\F511\"}.ms-Icon--Annotation:before{content:\"\\E924\"}.ms-Icon--AppIconDefault:before{content:\"\\ECAA\"}.ms-Icon--Archive:before{content:\"\\F03F\"}.ms-Icon--AreaChart:before{content:\"\\E9D2\"}.ms-Icon--ArrangeBringForward:before{content:\"\\F509\"}.ms-Icon--ArrangeBringToFront:before{content:\"\\F506\"}.ms-Icon--ArrangeByFrom:before{content:\"\\F678\"}.ms-Icon--ArrangeSendBackward:before{content:\"\\F508\"}.ms-Icon--ArrangeSendToBack:before{content:\"\\F507\"}.ms-Icon--Arrivals:before{content:\"\\EB34\"}[dir=ltr] .ms-Icon--ArrowDownRight8:before{content:\"\\EED5\"}[dir=ltr] .ms-Icon--ArrowDownRightMirrored8:before,[dir=rtl] .ms-Icon--ArrowDownRight8:before{content:\"\\EEF0\"}[dir=rtl] .ms-Icon--ArrowDownRightMirrored8:before{content:\"\\EED5\"}.ms-Icon--ArrowTallDownLeft:before{content:\"\\F2BF\"}.ms-Icon--ArrowTallDownRight:before{content:\"\\F2C0\"}.ms-Icon--ArrowTallUpLeft:before{content:\"\\F2BD\"}.ms-Icon--ArrowTallUpRight:before{content:\"\\F2BE\"}.ms-Icon--ArrowUpRight:before{content:\"\\F069\"}[dir=ltr] .ms-Icon--ArrowUpRight8:before{content:\"\\EED4\"}[dir=ltr] .ms-Icon--ArrowUpRightMirrored8:before,[dir=rtl] .ms-Icon--ArrowUpRight8:before{content:\"\\EEEF\"}[dir=rtl] .ms-Icon--ArrowUpRightMirrored8:before{content:\"\\EED4\"}.ms-Icon--Articles:before{content:\"\\EAC1\"}.ms-Icon--Ascending:before{content:\"\\EDC0\"}.ms-Icon--AspectRatio:before{content:\"\\E799\"}.ms-Icon--AssessmentGroup:before{content:\"\\F31A\"}.ms-Icon--AssessmentGroupTemplate:before{content:\"\\F2B1\"}.ms-Icon--AssetLibrary:before{content:\"\\EEB6\"}.ms-Icon--Assign:before{content:\"\\E9D3\"}.ms-Icon--Asterisk:before{content:\"\\EA38\"}.ms-Icon--AsteriskSolid:before{content:\"\\F34D\"}.ms-Icon--ATPLogo:before{content:\"\\EF85\"}.ms-Icon--Attach:before{content:\"\\E723\"}.ms-Icon--AustralianRules:before{content:\"\\EE70\"}.ms-Icon--AutoEnhanceOff:before{content:\"\\E78E\"}.ms-Icon--AutoEnhanceOn:before{content:\"\\E78D\"}.ms-Icon--AutoFillTemplate:before{content:\"\\F313\"}.ms-Icon--AutoHeight:before{content:\"\\F512\"}.ms-Icon--AutoRacing:before{content:\"\\EB24\"}.ms-Icon--AwayStatus:before{content:\"\\EE6A\"}.ms-Icon--AzureAPIManagement:before{content:\"\\F37F\"}.ms-Icon--AzureKeyVault:before{content:\"\\F3B4\"}.ms-Icon--AzureLogo:before{content:\"\\EB6A\"}.ms-Icon--AzureServiceEndpoint:before{content:\"\\F380\"}.ms-Icon--Back:before{content:\"\\E72B\"}.ms-Icon--BackgroundColor:before{content:\"\\F42B\"}.ms-Icon--Backlog:before{content:\"\\F2AC\"}.ms-Icon--BacklogBoard:before{content:\"\\F444\"}.ms-Icon--BackToWindow:before{content:\"\\E73F\"}.ms-Icon--Badge:before{content:\"\\EC1B\"}.ms-Icon--Balloons:before{content:\"\\ED7E\"}.ms-Icon--BankSolid:before{content:\"\\F34F\"}.ms-Icon--BarChart4:before{content:\"\\EAE7\"}.ms-Icon--BarChartHorizontal:before{content:\"\\E9EB\"}.ms-Icon--BarChartVertical:before{content:\"\\E9EC\"}.ms-Icon--Baseball:before{content:\"\\EB20\"}.ms-Icon--BeerMug:before{content:\"\\F49E\"}.ms-Icon--BIDashboard:before{content:\"\\F543\"}.ms-Icon--BidiLtr:before{content:\"\\E9AA\"}.ms-Icon--BidiRtl:before{content:\"\\E9AB\"}.ms-Icon--BingLogo:before{content:\"\\EB6B\"}.ms-Icon--BirthdayCake:before{content:\"\\EF8D\"}.ms-Icon--BlockContact:before{content:\"\\E8F8\"}.ms-Icon--Blocked:before{content:\"\\E733\"}.ms-Icon--Blocked12:before{content:\"\\F62E\"}.ms-Icon--Blocked2:before{content:\"\\ECE4\"}.ms-Icon--BlockedSite:before{content:\"\\E72F\"}.ms-Icon--BlockedSolid:before{content:\"\\F531\"}.ms-Icon--BlowingSnow:before{content:\"\\E9C9\"}.ms-Icon--Blur:before{content:\"\\F28E\"}.ms-Icon--Boards:before{content:\"\\EF68\"}.ms-Icon--Bold:before{content:\"\\E8DD\"}.ms-Icon--BookingsLogo:before{content:\"\\EDC7\"}[dir=ltr] .ms-Icon--Bookmarks:before{content:\"\\E8A4\"}[dir=ltr] .ms-Icon--BookmarksMirrored:before,[dir=rtl] .ms-Icon--Bookmarks:before{content:\"\\EA41\"}[dir=rtl] .ms-Icon--BookmarksMirrored:before{content:\"\\E8A4\"}.ms-Icon--BorderDash:before{content:\"\\F50A\"}.ms-Icon--BorderDot:before{content:\"\\F50B\"}.ms-Icon--BoxAdditionSolid:before{content:\"\\F2D4\"}.ms-Icon--BoxCheckmarkSolid:before{content:\"\\F2D7\"}.ms-Icon--BoxMultiplySolid:before{content:\"\\F2D5\"}.ms-Icon--BoxPlaySolid:before{content:\"\\F2D6\"}.ms-Icon--BoxSubtractSolid:before{content:\"\\F2D3\"}.ms-Icon--BranchCommit:before{content:\"\\F293\"}.ms-Icon--BranchCompare:before{content:\"\\F294\"}.ms-Icon--BranchFork:before{content:\"\\F173\"}.ms-Icon--BranchFork2:before{content:\"\\F291\"}.ms-Icon--BranchLocked:before{content:\"\\F292\"}.ms-Icon--BranchMerge:before{content:\"\\F295\"}.ms-Icon--BranchPullRequest:before{content:\"\\F296\"}.ms-Icon--BranchSearch:before{content:\"\\F297\"}.ms-Icon--BranchShelveset:before{content:\"\\F298\"}.ms-Icon--Breadcrumb:before{content:\"\\EF8C\"}.ms-Icon--Breakfast:before{content:\"\\F49C\"}.ms-Icon--Brightness:before{content:\"\\E706\"}.ms-Icon--Broom:before{content:\"\\EA99\"}.ms-Icon--BrowserScreenShot:before{content:\"\\EBED\"}.ms-Icon--BrowserTab:before{content:\"\\F5D7\"}.ms-Icon--BrowserTabScreenshot:before{content:\"\\F5D8\"}.ms-Icon--Brunch:before{content:\"\\F49D\"}.ms-Icon--BucketColor:before{content:\"\\F1B6\"}.ms-Icon--BucketColorFill:before{content:\"\\F1B7\"}.ms-Icon--BufferTimeAfter:before{content:\"\\F0D0\"}.ms-Icon--BufferTimeBefore:before{content:\"\\F0CF\"}.ms-Icon--BufferTimeBoth:before{content:\"\\F0D1\"}.ms-Icon--Bug:before{content:\"\\EBE8\"}.ms-Icon--BugSolid:before{content:\"\\F335\"}.ms-Icon--Build:before{content:\"\\F28F\"}.ms-Icon--BuildIssue:before{content:\"\\F319\"}.ms-Icon--BuildQueue:before{content:\"\\F24F\"}.ms-Icon--BuildQueueNew:before{content:\"\\F250\"}.ms-Icon--BulkUpload:before{content:\"\\F548\"}[dir=ltr] .ms-Icon--BulletedList2:before{content:\"\\F2C7\"}[dir=ltr] .ms-Icon--BulletedList2Mirrored:before,[dir=rtl] .ms-Icon--BulletedList2:before{content:\"\\F2C8\"}[dir=rtl] .ms-Icon--BulletedList2Mirrored:before{content:\"\\F2C7\"}[dir=ltr] .ms-Icon--BulletedList:before{content:\"\\E8FD\"}[dir=ltr] .ms-Icon--BulletedListMirrored:before,[dir=rtl] .ms-Icon--BulletedList:before{content:\"\\EA42\"}[dir=rtl] .ms-Icon--BulletedListMirrored:before{content:\"\\E8FD\"}.ms-Icon--Bullseye:before{content:\"\\F272\"}.ms-Icon--Bus:before{content:\"\\E806\"}.ms-Icon--BusinessCenterLogo:before{content:\"\\F4B2\"}.ms-Icon--BusinessHoursSign:before{content:\"\\F310\"}.ms-Icon--BusSolid:before{content:\"\\EB47\"}.ms-Icon--Cafe:before{content:\"\\EC32\"}.ms-Icon--Cake:before{content:\"\\ECA4\"}.ms-Icon--Calculator:before{content:\"\\E8EF\"}.ms-Icon--CalculatorAddition:before{content:\"\\E948\"}.ms-Icon--CalculatorEqualTo:before{content:\"\\E94E\"}.ms-Icon--CalculatorMultiply:before{content:\"\\E947\"}.ms-Icon--CalculatorNotEqualTo:before{content:\"\\F2D2\"}.ms-Icon--CalculatorSubtract:before{content:\"\\E949\"}.ms-Icon--CalendarAgenda:before{content:\"\\EE9A\"}.ms-Icon--CalendarDay:before{content:\"\\E8BF\"}[dir=ltr] .ms-Icon--Calendar:before{content:\"\\E787\"}[dir=ltr] .ms-Icon--CalendarMirrored:before,[dir=rtl] .ms-Icon--Calendar:before{content:\"\\ED28\"}[dir=rtl] .ms-Icon--CalendarMirrored:before{content:\"\\E787\"}.ms-Icon--CalendarReply:before{content:\"\\E8F5\"}[dir=ltr] .ms-Icon--CalendarSettings:before{content:\"\\F558\"}[dir=ltr] .ms-Icon--CalendarSettingsMirrored:before,[dir=rtl] .ms-Icon--CalendarSettings:before{content:\"\\F559\"}[dir=rtl] .ms-Icon--CalendarSettingsMirrored:before{content:\"\\F558\"}.ms-Icon--CalendarWeek:before{content:\"\\E8C0\"}.ms-Icon--CalendarWorkWeek:before{content:\"\\EF51\"}.ms-Icon--CaloriesAdd:before{content:\"\\F172\"}.ms-Icon--Camera:before{content:\"\\E722\"}.ms-Icon--Cancel:before{content:\"\\E711\"}.ms-Icon--CannedChat:before{content:\"\\F0F2\"}.ms-Icon--Car:before{content:\"\\E804\"}.ms-Icon--CaretBottomLeftCenter8:before{content:\"\\F365\"}.ms-Icon--CaretBottomLeftSolid8:before{content:\"\\F121\"}.ms-Icon--CaretBottomRightCenter8:before{content:\"\\F364\"}.ms-Icon--CaretBottomRightSolid8:before{content:\"\\F122\"}.ms-Icon--CaretDown8:before{content:\"\\EDD8\"}.ms-Icon--CaretDownSolid8:before{content:\"\\EDDC\"}[dir=ltr] .ms-Icon--CaretHollow:before{content:\"\\E817\"}[dir=ltr] .ms-Icon--CaretHollowMirrored:before,[dir=rtl] .ms-Icon--CaretHollow:before{content:\"\\EA45\"}[dir=rtl] .ms-Icon--CaretHollowMirrored:before{content:\"\\E817\"}.ms-Icon--CaretLeft8:before{content:\"\\EDD5\"}.ms-Icon--CaretLeftSolid8:before{content:\"\\EDD9\"}.ms-Icon--CaretRight:before{content:\"\\F06B\"}.ms-Icon--CaretRight8:before{content:\"\\EDD6\"}.ms-Icon--CaretRightSolid8:before{content:\"\\EDDA\"}.ms-Icon--CaretSolid16:before{content:\"\\EE62\"}.ms-Icon--CaretSolidDown:before{content:\"\\F08E\"}.ms-Icon--CaretSolidLeft:before{content:\"\\F08D\"}[dir=ltr] .ms-Icon--CaretSolid:before{content:\"\\E818\"}[dir=ltr] .ms-Icon--CaretSolidMirrored:before,[dir=rtl] .ms-Icon--CaretSolid:before{content:\"\\EA46\"}[dir=rtl] .ms-Icon--CaretSolidMirrored:before{content:\"\\E818\"}.ms-Icon--CaretSolidRight:before{content:\"\\F08F\"}.ms-Icon--CaretSolidUp:before{content:\"\\F090\"}.ms-Icon--CaretTopLeftCenter8:before{content:\"\\F367\"}.ms-Icon--CaretTopLeftSolid8:before{content:\"\\EF54\"}.ms-Icon--CaretTopRightCenter8:before{content:\"\\F366\"}.ms-Icon--CaretTopRightSolid8:before{content:\"\\EF55\"}.ms-Icon--CaretUp8:before{content:\"\\EDD7\"}.ms-Icon--CaretUpSolid8:before{content:\"\\EDDB\"}.ms-Icon--Cat:before{content:\"\\ED7F\"}.ms-Icon--CellPhone:before{content:\"\\E8EA\"}.ms-Icon--Certificate:before{content:\"\\EB95\"}.ms-Icon--CertifiedDatabase:before{content:\"\\F5BB\"}.ms-Icon--Chart:before{content:\"\\E999\"}.ms-Icon--ChartSeries:before{content:\"\\F513\"}.ms-Icon--ChartXAngle:before{content:\"\\F514\"}.ms-Icon--ChartYAngle:before{content:\"\\F515\"}.ms-Icon--Chat:before{content:\"\\E901\"}.ms-Icon--ChatInviteFriend:before{content:\"\\ECFE\"}.ms-Icon--ChatSolid:before{content:\"\\F344\"}.ms-Icon--Checkbox:before{content:\"\\E739\"}.ms-Icon--CheckboxComposite:before{content:\"\\E73A\"}.ms-Icon--CheckboxCompositeReversed:before{content:\"\\E73D\"}.ms-Icon--CheckboxIndeterminate:before{content:\"\\E73C\"}.ms-Icon--CheckedOutByOther12:before{content:\"\\F630\"}.ms-Icon--CheckedOutByYou12:before{content:\"\\F631\"}.ms-Icon--CheckList:before{content:\"\\E9D5\"}.ms-Icon--CheckMark:before{content:\"\\E73E\"}.ms-Icon--ChevronDown:before{content:\"\\E70D\"}.ms-Icon--ChevronDownEnd6:before{content:\"\\F36F\"}.ms-Icon--ChevronDownMed:before{content:\"\\E972\"}.ms-Icon--ChevronDownSmall:before{content:\"\\E96E\"}.ms-Icon--ChevronFold10:before{content:\"\\F36A\"}.ms-Icon--ChevronLeft:before{content:\"\\E76B\"}.ms-Icon--ChevronLeftEnd6:before{content:\"\\F371\"}.ms-Icon--ChevronLeftMed:before{content:\"\\E973\"}.ms-Icon--ChevronLeftSmall:before{content:\"\\E96F\"}.ms-Icon--ChevronRight:before{content:\"\\E76C\"}.ms-Icon--ChevronRightEnd6:before{content:\"\\F372\"}.ms-Icon--ChevronRightMed:before{content:\"\\E974\"}.ms-Icon--ChevronRightSmall:before{content:\"\\E970\"}.ms-Icon--ChevronUnfold10:before{content:\"\\F369\"}.ms-Icon--ChevronUp:before{content:\"\\E70E\"}.ms-Icon--ChevronUpEnd6:before{content:\"\\F370\"}.ms-Icon--ChevronUpMed:before{content:\"\\E971\"}.ms-Icon--ChevronUpSmall:before{content:\"\\E96D\"}.ms-Icon--Chopsticks:before{content:\"\\F4A2\"}[dir=ltr] .ms-Icon--ChromeBack:before{content:\"\\E830\"}[dir=ltr] .ms-Icon--ChromeBackMirrored:before,[dir=rtl] .ms-Icon--ChromeBack:before{content:\"\\EA47\"}[dir=rtl] .ms-Icon--ChromeBackMirrored:before{content:\"\\E830\"}.ms-Icon--ChromeClose:before{content:\"\\E8BB\"}.ms-Icon--ChromeMinimize:before{content:\"\\E921\"}.ms-Icon--CircleAddition:before{content:\"\\F2E3\"}.ms-Icon--CircleAdditionSolid:before{content:\"\\F2E4\"}.ms-Icon--CircleFill:before{content:\"\\EA3B\"}.ms-Icon--CircleHalfFull:before{content:\"\\ED9E\"}.ms-Icon--CirclePause:before{content:\"\\F2D9\"}.ms-Icon--CirclePauseSolid:before{content:\"\\F2D8\"}.ms-Icon--CirclePlus:before{content:\"\\EAEE\"}.ms-Icon--CircleRing:before{content:\"\\EA3A\"}.ms-Icon--CircleShapeSolid:before{content:\"\\F63C\"}.ms-Icon--CircleStop:before{content:\"\\F2DC\"}.ms-Icon--CircleStopSolid:before{content:\"\\F2DB\"}.ms-Icon--CityNext:before{content:\"\\EC06\"}.ms-Icon--ClassNotebookLogo16:before{content:\"\\F488\"}.ms-Icon--ClassNotebookLogo32:before{content:\"\\F486\"}.ms-Icon--ClassNotebookLogoFill16:before{content:\"\\F489\"}.ms-Icon--ClassNotebookLogoFill32:before{content:\"\\F487\"}.ms-Icon--ClassNotebookLogoInverse:before{content:\"\\EDC8\"}.ms-Icon--ClassNotebookLogoInverse16:before{content:\"\\F48B\"}.ms-Icon--ClassNotebookLogoInverse32:before{content:\"\\F48A\"}.ms-Icon--ClassroomLogo:before{content:\"\\EF75\"}.ms-Icon--Clear:before{content:\"\\E894\"}.ms-Icon--ClearFilter:before{content:\"\\EF8F\"}.ms-Icon--ClearFormatting:before{content:\"\\EDDD\"}.ms-Icon--ClearNight:before{content:\"\\E9C2\"}.ms-Icon--ClipboardSolid:before{content:\"\\F5DC\"}.ms-Icon--Clock:before{content:\"\\E917\"}.ms-Icon--CloneToDesktop:before{content:\"\\F28C\"}.ms-Icon--ClosedCaption:before{content:\"\\EF84\"}[dir=ltr] .ms-Icon--ClosePane:before{content:\"\\E89F\"}[dir=ltr] .ms-Icon--ClosePaneMirrored:before,[dir=rtl] .ms-Icon--ClosePane:before{content:\"\\EA49\"}[dir=rtl] .ms-Icon--ClosePaneMirrored:before{content:\"\\E89F\"}.ms-Icon--Cloud:before{content:\"\\E753\"}.ms-Icon--CloudAdd:before{content:\"\\ECA9\"}.ms-Icon--CloudDownload:before{content:\"\\EBD3\"}.ms-Icon--CloudUpload:before{content:\"\\EC8E\"}.ms-Icon--CloudWeather:before{content:\"\\E9BE\"}.ms-Icon--Cloudy:before{content:\"\\E9BF\"}.ms-Icon--Cocktails:before{content:\"\\EA9D\"}.ms-Icon--Code:before{content:\"\\E943\"}.ms-Icon--CodeEdit:before{content:\"\\F544\"}.ms-Icon--Coffee:before{content:\"\\EAEF\"}.ms-Icon--CoffeeScript:before{content:\"\\F2FA\"}.ms-Icon--CollapseContent:before{content:\"\\F165\"}.ms-Icon--CollapseContentSingle:before{content:\"\\F166\"}.ms-Icon--CollapseMenu:before{content:\"\\EF66\"}.ms-Icon--CollegeFootball:before{content:\"\\EB26\"}.ms-Icon--CollegeHoops:before{content:\"\\EB25\"}.ms-Icon--Color:before{content:\"\\E790\"}.ms-Icon--ColorSolid:before{content:\"\\F354\"}.ms-Icon--ColumnLeftTwoThirds:before{content:\"\\F1D6\"}.ms-Icon--ColumnLeftTwoThirdsEdit:before{content:\"\\F324\"}.ms-Icon--ColumnOptions:before{content:\"\\F317\"}.ms-Icon--ColumnRightTwoThirds:before{content:\"\\F1D7\"}.ms-Icon--ColumnRightTwoThirdsEdit:before{content:\"\\F325\"}.ms-Icon--Combine:before{content:\"\\EDBB\"}.ms-Icon--Combobox:before{content:\"\\F516\"}.ms-Icon--CommandPrompt:before{content:\"\\E756\"}.ms-Icon--Comment:before{content:\"\\E90A\"}.ms-Icon--CommentAdd:before{content:\"\\F2B3\"}.ms-Icon--CommentNext:before{content:\"\\F2B4\"}.ms-Icon--CommentPrevious:before{content:\"\\F2B5\"}.ms-Icon--CommentUrgent:before{content:\"\\F307\"}.ms-Icon--Commitments:before{content:\"\\EC4D\"}.ms-Icon--Communications:before{content:\"\\E95A\"}[dir=ltr] .ms-Icon--CompanyDirectory:before{content:\"\\EF0D\"}[dir=ltr] .ms-Icon--CompanyDirectoryMirrored:before,[dir=rtl] .ms-Icon--CompanyDirectory:before{content:\"\\EF2B\"}[dir=rtl] .ms-Icon--CompanyDirectoryMirrored:before{content:\"\\EF0D\"}.ms-Icon--CompassNW:before{content:\"\\E942\"}.ms-Icon--Completed:before{content:\"\\E930\"}.ms-Icon--CompletedSolid:before{content:\"\\EC61\"}.ms-Icon--ConfigurationSolid:before{content:\"\\F334\"}.ms-Icon--ConnectContacts:before{content:\"\\EFD4\"}.ms-Icon--ConstructionCone:before{content:\"\\E98F\"}.ms-Icon--ConstructionConeSolid:before{content:\"\\F339\"}.ms-Icon--Contact:before{content:\"\\E77B\"}.ms-Icon--ContactCard:before{content:\"\\EEBD\"}[dir=ltr] .ms-Icon--ContactCardSettings:before{content:\"\\F556\"}[dir=ltr] .ms-Icon--ContactCardSettingsMirrored:before,[dir=rtl] .ms-Icon--ContactCardSettings:before{content:\"\\F557\"}[dir=rtl] .ms-Icon--ContactCardSettingsMirrored:before{content:\"\\F556\"}.ms-Icon--ContactInfo:before{content:\"\\E779\"}.ms-Icon--ContactLink:before{content:\"\\F25F\"}.ms-Icon--ContextMenu:before{content:\"\\F37C\"}.ms-Icon--Contrast:before{content:\"\\E7A1\"}.ms-Icon--Copy:before{content:\"\\E8C8\"}.ms-Icon--Cotton:before{content:\"\\EAF3\"}.ms-Icon--CPlusPlus:before{content:\"\\F2F4\"}.ms-Icon--CPlusPlusLanguage:before{content:\"\\F2F3\"}.ms-Icon--CreateMailRule:before{content:\"\\F67A\"}.ms-Icon--Cricket:before{content:\"\\EB1E\"}.ms-Icon--CRMReport:before{content:\"\\EFFE\"}.ms-Icon--Crop:before{content:\"\\E7A8\"}.ms-Icon--Crown:before{content:\"\\ED01\"}.ms-Icon--CrownSolid:before{content:\"\\F336\"}.ms-Icon--CSharp:before{content:\"\\F2F0\"}.ms-Icon--CSharpLanguage:before{content:\"\\F2EF\"}.ms-Icon--CSS:before{content:\"\\EBEF\"}[dir=ltr] .ms-Icon--CustomList:before{content:\"\\EEBE\"}[dir=ltr] .ms-Icon--CustomListMirrored:before,[dir=rtl] .ms-Icon--CustomList:before{content:\"\\EEBF\"}[dir=rtl] .ms-Icon--CustomListMirrored:before{content:\"\\EEBE\"}.ms-Icon--Cut:before{content:\"\\E8C6\"}.ms-Icon--Cycling:before{content:\"\\EAC7\"}.ms-Icon--DashboardAdd:before{content:\"\\F52D\"}.ms-Icon--Database:before{content:\"\\EFC7\"}.ms-Icon--DataConnectionLibrary:before{content:\"\\EEB7\"}.ms-Icon--DateTime2:before{content:\"\\EA17\"}[dir=ltr] .ms-Icon--DateTime:before{content:\"\\EC92\"}[dir=ltr] .ms-Icon--DateTimeMirrored:before,[dir=rtl] .ms-Icon--DateTime:before{content:\"\\EE93\"}[dir=rtl] .ms-Icon--DateTimeMirrored:before{content:\"\\EC92\"}.ms-Icon--DeactivateOrders:before{content:\"\\EFE1\"}.ms-Icon--DecisionSolid:before{content:\"\\F350\"}.ms-Icon--DeclineCall:before{content:\"\\F405\"}.ms-Icon--DecreaseIndentLegacy:before{content:\"\\E290\"}.ms-Icon--DefaultRatio:before{content:\"\\F529\"}.ms-Icon--DefectSolid:before{content:\"\\F449\"}.ms-Icon--Delete:before{content:\"\\E74D\"}.ms-Icon--DeleteColumns:before{content:\"\\F64E\"}[dir=ltr] .ms-Icon--DeleteRows:before{content:\"\\F64F\"}[dir=ltr] .ms-Icon--DeleteRowsMirrored:before,[dir=rtl] .ms-Icon--DeleteRows:before{content:\"\\F650\"}[dir=rtl] .ms-Icon--DeleteRowsMirrored:before{content:\"\\F64F\"}.ms-Icon--DeleteTable:before{content:\"\\F651\"}.ms-Icon--DeliveryTruck:before{content:\"\\EBF4\"}.ms-Icon--DelveAnalytics:before{content:\"\\EEEE\"}.ms-Icon--DelveAnalyticsLogo:before{content:\"\\EDCA\"}.ms-Icon--DelveLogo:before{content:\"\\F280\"}.ms-Icon--DelveLogoFill:before{content:\"\\F281\"}.ms-Icon--DelveLogoInverse:before{content:\"\\ED76\"}.ms-Icon--Deploy:before{content:\"\\F29D\"}.ms-Icon--Descending:before{content:\"\\EDC1\"}.ms-Icon--Design:before{content:\"\\EB3C\"}.ms-Icon--DesktopScreenshot:before{content:\"\\F5D9\"}.ms-Icon--DeveloperTools:before{content:\"\\EC7A\"}.ms-Icon--Devices3:before{content:\"\\EA6C\"}.ms-Icon--Devices4:before{content:\"\\EB66\"}.ms-Icon--Diagnostic:before{content:\"\\E9D9\"}.ms-Icon--Dialpad:before{content:\"\\E75F\"}.ms-Icon--DiamondSolid:before{content:\"\\F34C\"}.ms-Icon--Dictionary:before{content:\"\\E82D\"}.ms-Icon--DictionaryRemove:before{content:\"\\F69A\"}.ms-Icon--DietPlanNotebook:before{content:\"\\EAC8\"}.ms-Icon--DiffInline:before{content:\"\\F309\"}.ms-Icon--DiffSideBySide:before{content:\"\\F30A\"}.ms-Icon--DisableUpdates:before{content:\"\\E8D8\"}.ms-Icon--Dislike:before{content:\"\\E8E0\"}.ms-Icon--DislikeSolid:before{content:\"\\F3C0\"}[dir=ltr] .ms-Icon--DockLeft:before{content:\"\\E90C\"}[dir=ltr] .ms-Icon--DockLeftMirrored:before,[dir=rtl] .ms-Icon--DockLeft:before{content:\"\\EA4C\"}[dir=rtl] .ms-Icon--DockLeftMirrored:before{content:\"\\E90C\"}.ms-Icon--DockRight:before{content:\"\\E90D\"}.ms-Icon--DocLibrary:before{content:\"\\EEB8\"}.ms-Icon--DocsLogoInverse:before{content:\"\\EDCB\"}.ms-Icon--Document:before{content:\"\\E8A5\"}.ms-Icon--DocumentApproval:before{content:\"\\F28B\"}.ms-Icon--Documentation:before{content:\"\\EC17\"}.ms-Icon--DocumentManagement:before{content:\"\\EFFC\"}.ms-Icon--DocumentReply:before{content:\"\\EF57\"}.ms-Icon--DocumentSearch:before{content:\"\\EF6C\"}.ms-Icon--DocumentSet:before{content:\"\\EED6\"}.ms-Icon--DOM:before{content:\"\\EC8D\"}.ms-Icon--DonutChart:before{content:\"\\F368\"}.ms-Icon--Door:before{content:\"\\EB75\"}.ms-Icon--DoubleBookmark:before{content:\"\\EB8F\"}.ms-Icon--DoubleChevronDown:before{content:\"\\EE04\"}.ms-Icon--DoubleChevronDown12:before{content:\"\\EE97\"}.ms-Icon--DoubleChevronDown8:before{content:\"\\F36B\"}.ms-Icon--DoubleChevronLeft:before{content:\"\\EDBE\"}.ms-Icon--DoubleChevronLeft12:before{content:\"\\EE98\"}.ms-Icon--DoubleChevronLeft8:before{content:\"\\F36D\"}[dir=ltr] .ms-Icon--DoubleChevronLeftMed:before{content:\"\\E991\"}[dir=ltr] .ms-Icon--DoubleChevronLeftMedMirrored:before,[dir=rtl] .ms-Icon--DoubleChevronLeftMed:before{content:\"\\EA4D\"}[dir=rtl] .ms-Icon--DoubleChevronLeftMedMirrored:before{content:\"\\E991\"}.ms-Icon--DoubleChevronRight:before{content:\"\\EDBF\"}.ms-Icon--DoubleChevronRight12:before{content:\"\\EE99\"}.ms-Icon--DoubleChevronRight8:before{content:\"\\F36E\"}.ms-Icon--DoubleChevronUp:before{content:\"\\EDBD\"}.ms-Icon--DoubleChevronUp12:before{content:\"\\EE96\"}.ms-Icon--DoubleChevronUp8:before{content:\"\\F36C\"}.ms-Icon--DoubleColumn:before{content:\"\\F1D4\"}.ms-Icon--DoubleColumnEdit:before{content:\"\\F322\"}.ms-Icon--Down:before{content:\"\\E74B\"}.ms-Icon--Download:before{content:\"\\E896\"}.ms-Icon--DownloadDocument:before{content:\"\\F549\"}.ms-Icon--DragObject:before{content:\"\\F553\"}.ms-Icon--DrillDown:before{content:\"\\F532\"}.ms-Icon--DrillDownSolid:before{content:\"\\F533\"}.ms-Icon--DrillExpand:before{content:\"\\F534\"}.ms-Icon--DrillShow:before{content:\"\\F535\"}.ms-Icon--DrillThrough:before{content:\"\\F5B9\"}.ms-Icon--DRM:before{content:\"\\ECA8\"}.ms-Icon--Drop:before{content:\"\\EB42\"}.ms-Icon--Dropdown:before{content:\"\\EDC5\"}.ms-Icon--DropShapeSolid:before{content:\"\\F63F\"}.ms-Icon--Duststorm:before{content:\"\\E9CD\"}.ms-Icon--Dynamics365Logo:before{content:\"\\EDCC\"}.ms-Icon--DynamicSMBLogo:before{content:\"\\EDCD\"}.ms-Icon--EatDrink:before{content:\"\\E807\"}.ms-Icon--EdgeLogo:before{content:\"\\EC60\"}.ms-Icon--EditContact:before{content:\"\\EFD3\"}.ms-Icon--EditMail:before{content:\"\\EF61\"}[dir=ltr] .ms-Icon--Edit:before{content:\"\\E70F\"}[dir=ltr] .ms-Icon--EditMirrored:before,[dir=rtl] .ms-Icon--Edit:before{content:\"\\EB7E\"}[dir=rtl] .ms-Icon--EditMirrored:before{content:\"\\E70F\"}.ms-Icon--EditNote:before{content:\"\\ED9D\"}.ms-Icon--EditPhoto:before{content:\"\\EF77\"}[dir=ltr] .ms-Icon--EditSolid12:before{content:\"\\F4B5\"}[dir=ltr] .ms-Icon--EditSolidMirrored12:before,[dir=rtl] .ms-Icon--EditSolid12:before{content:\"\\F4B6\"}[dir=rtl] .ms-Icon--EditSolidMirrored12:before{content:\"\\F4B5\"}.ms-Icon--EditStyle:before{content:\"\\EF60\"}.ms-Icon--Education:before{content:\"\\E7BE\"}.ms-Icon--Ellipse:before{content:\"\\F4FB\"}.ms-Icon--Embed:before{content:\"\\ECCE\"}.ms-Icon--EMI:before{content:\"\\E731\"}.ms-Icon--Emoji:before{content:\"\\E899\"}.ms-Icon--Emoji2:before{content:\"\\E76E\"}.ms-Icon--EmojiDisappointed:before{content:\"\\EA88\"}.ms-Icon--EmojiNeutral:before{content:\"\\EA87\"}.ms-Icon--EmojiTabSymbols:before{content:\"\\ED58\"}.ms-Icon--EmptyRecycleBin:before{content:\"\\EF88\"}.ms-Icon--Encryption:before{content:\"\\F69D\"}.ms-Icon--EngineeringGroup:before{content:\"\\F362\"}.ms-Icon--EntryDecline:before{content:\"\\F555\"}.ms-Icon--EntryView:before{content:\"\\F554\"}.ms-Icon--Equalizer:before{content:\"\\E9E9\"}.ms-Icon--EraseTool:before{content:\"\\E75C\"}.ms-Icon--Error:before{content:\"\\E783\"}.ms-Icon--ErrorBadge:before{content:\"\\EA39\"}.ms-Icon--Event:before{content:\"\\ECA3\"}.ms-Icon--EventAccepted:before{content:\"\\F422\"}.ms-Icon--EventDate:before{content:\"\\F059\"}.ms-Icon--EventDeclined:before{content:\"\\F425\"}.ms-Icon--EventInfo:before{content:\"\\ED8B\"}[dir=ltr] .ms-Icon--EventTentative:before{content:\"\\F423\"}[dir=ltr] .ms-Icon--EventTentativeMirrored:before,[dir=rtl] .ms-Icon--EventTentative:before{content:\"\\F424\"}[dir=rtl] .ms-Icon--EventTentativeMirrored:before{content:\"\\F423\"}.ms-Icon--ExcelDocument:before{content:\"\\EF73\"}.ms-Icon--ExcelLogo:before{content:\"\\F1E5\"}.ms-Icon--ExcelLogo16:before{content:\"\\F397\"}.ms-Icon--ExcelLogoFill:before{content:\"\\F1E6\"}.ms-Icon--ExcelLogoFill16:before{content:\"\\F398\"}.ms-Icon--ExcelLogoInverse:before{content:\"\\EC28\"}.ms-Icon--ExcelLogoInverse16:before{content:\"\\F396\"}.ms-Icon--ExchangeLogo:before{content:\"\\F284\"}.ms-Icon--ExchangeLogoFill:before{content:\"\\F285\"}.ms-Icon--ExchangeLogoInverse:before{content:\"\\ED78\"}.ms-Icon--ExerciseTracker:before{content:\"\\EACC\"}.ms-Icon--ExpandMenu:before{content:\"\\EF67\"}.ms-Icon--ExploreContent:before{content:\"\\ECCD\"}.ms-Icon--ExploreContentSingle:before{content:\"\\F164\"}.ms-Icon--ExploreData:before{content:\"\\F5B6\"}[dir=ltr] .ms-Icon--Export:before{content:\"\\EDE1\"}[dir=ltr] .ms-Icon--ExportMirrored:before,[dir=rtl] .ms-Icon--Export:before{content:\"\\EDE2\"}[dir=rtl] .ms-Icon--ExportMirrored:before{content:\"\\EDE1\"}.ms-Icon--ExternalBuild:before{content:\"\\F445\"}.ms-Icon--ExternalGit:before{content:\"\\F665\"}.ms-Icon--ExternalTFVC:before{content:\"\\F446\"}.ms-Icon--ExternalXAML:before{content:\"\\F447\"}.ms-Icon--F12DevTools:before{content:\"\\EBEE\"}.ms-Icon--FabricAssetLibrary:before{content:\"\\F09C\"}.ms-Icon--FabricDataConnectionLibrary:before{content:\"\\F09D\"}.ms-Icon--FabricDocLibrary:before{content:\"\\F09E\"}.ms-Icon--FabricFolder:before{content:\"\\F0A9\"}.ms-Icon--FabricFolderFill:before{content:\"\\F0AA\"}.ms-Icon--FabricFolderSearch:before{content:\"\\F0A4\"}[dir=ltr] .ms-Icon--FabricFormLibrary:before{content:\"\\F09F\"}[dir=ltr] .ms-Icon--FabricFormLibraryMirrored:before,[dir=rtl] .ms-Icon--FabricFormLibrary:before{content:\"\\F0A0\"}[dir=rtl] .ms-Icon--FabricFormLibraryMirrored:before{content:\"\\F09F\"}.ms-Icon--FabricMovetoFolder:before{content:\"\\F0A5\"}.ms-Icon--FabricNewFolder:before{content:\"\\F0AB\"}.ms-Icon--FabricOpenFolderHorizontal:before{content:\"\\F0A8\"}.ms-Icon--FabricPictureLibrary:before{content:\"\\F0AC\"}.ms-Icon--FabricPublicFolder:before{content:\"\\F0A3\"}[dir=ltr] .ms-Icon--FabricReportLibrary:before{content:\"\\F0A1\"}[dir=ltr] .ms-Icon--FabricReportLibraryMirrored:before,[dir=rtl] .ms-Icon--FabricReportLibrary:before{content:\"\\F0A2\"}[dir=rtl] .ms-Icon--FabricReportLibraryMirrored:before{content:\"\\F0A1\"}.ms-Icon--FabricSyncFolder:before{content:\"\\F0A7\"}.ms-Icon--FabricUnsyncFolder:before{content:\"\\F0A6\"}.ms-Icon--Family:before{content:\"\\EBDA\"}.ms-Icon--FangBody:before{content:\"\\ECEB\"}.ms-Icon--FastForward:before{content:\"\\EB9D\"}.ms-Icon--FastMode:before{content:\"\\F19A\"}.ms-Icon--Favicon:before{content:\"\\E737\"}.ms-Icon--FavoriteList:before{content:\"\\E728\"}.ms-Icon--FavoriteStar:before{content:\"\\E734\"}.ms-Icon--FavoriteStarFill:before{content:\"\\E735\"}.ms-Icon--Fax:before{content:\"\\EF5C\"}.ms-Icon--Feedback:before{content:\"\\ED15\"}[dir=ltr] .ms-Icon--FeedbackRequestSolid:before{content:\"\\F359\"}[dir=ltr] .ms-Icon--FeedbackRequestMirroredSolid:before,[dir=rtl] .ms-Icon--FeedbackRequestSolid:before{content:\"\\F35A\"}[dir=rtl] .ms-Icon--FeedbackRequestMirroredSolid:before{content:\"\\F359\"}.ms-Icon--FeedbackResponseSolid:before{content:\"\\F35B\"}.ms-Icon--Ferry:before{content:\"\\E7E3\"}.ms-Icon--FerrySolid:before{content:\"\\EB48\"}.ms-Icon--FieldChanged:before{content:\"\\F2C3\"}.ms-Icon--FieldEmpty:before{content:\"\\F2C1\"}.ms-Icon--FieldFilled:before{content:\"\\F2C2\"}.ms-Icon--FieldNotChanged:before{content:\"\\F2C4\"}.ms-Icon--FieldReadOnly:before{content:\"\\F442\"}.ms-Icon--FieldRequired:before{content:\"\\F443\"}.ms-Icon--FileASPX:before{content:\"\\F2E9\"}.ms-Icon--FileBug:before{content:\"\\F30D\"}.ms-Icon--FileCode:before{content:\"\\F30E\"}.ms-Icon--FileComment:before{content:\"\\F30F\"}.ms-Icon--FileCSS:before{content:\"\\F2EA\"}.ms-Icon--FileHTML:before{content:\"\\F2ED\"}.ms-Icon--FileImage:before{content:\"\\F311\"}.ms-Icon--FileJAVA:before{content:\"\\F2E8\"}.ms-Icon--FileLess:before{content:\"\\F2EC\"}.ms-Icon--FilePDB:before{content:\"\\F2E5\"}.ms-Icon--FileSass:before{content:\"\\F2EB\"}.ms-Icon--FileSQL:before{content:\"\\F2E7\"}.ms-Icon--FileSymlink:before{content:\"\\F312\"}.ms-Icon--FileTemplate:before{content:\"\\F2E6\"}.ms-Icon--FileTypeSolution:before{content:\"\\F387\"}.ms-Icon--FileYML:before{content:\"\\F5DA\"}.ms-Icon--Filter:before{content:\"\\E71C\"}.ms-Icon--Filters:before{content:\"\\E795\"}.ms-Icon--FilterSolid:before{content:\"\\F412\"}.ms-Icon--FiltersSolid:before{content:\"\\F353\"}.ms-Icon--Financial:before{content:\"\\E7BB\"}[dir=ltr] .ms-Icon--FinancialSolid:before{content:\"\\F346\"}[dir=ltr] .ms-Icon--FinancialMirroredSolid:before,[dir=rtl] .ms-Icon--FinancialSolid:before{content:\"\\F347\"}[dir=rtl] .ms-Icon--FinancialMirroredSolid:before{content:\"\\F346\"}.ms-Icon--Fingerprint:before{content:\"\\E928\"}.ms-Icon--FiveTileGrid:before{content:\"\\F274\"}.ms-Icon--Flag:before{content:\"\\E7C1\"}.ms-Icon--FlameSolid:before{content:\"\\F1F3\"}.ms-Icon--FlickDown:before{content:\"\\E935\"}.ms-Icon--FlickLeft:before{content:\"\\E937\"}.ms-Icon--FlickRight:before{content:\"\\E938\"}.ms-Icon--FlickUp:before{content:\"\\E936\"}.ms-Icon--Flow:before{content:\"\\EF90\"}.ms-Icon--FocalPoint:before{content:\"\\F277\"}.ms-Icon--Fog:before{content:\"\\E9CB\"}.ms-Icon--Folder:before{content:\"\\E8B7\"}.ms-Icon--FolderFill:before{content:\"\\E8D5\"}.ms-Icon--FolderHorizontal:before{content:\"\\F12B\"}[dir=ltr] .ms-Icon--FolderList:before{content:\"\\F2CE\"}[dir=ltr] .ms-Icon--FolderListMirrored:before,[dir=rtl] .ms-Icon--FolderList:before{content:\"\\F2CF\"}[dir=rtl] .ms-Icon--FolderListMirrored:before{content:\"\\F2CE\"}.ms-Icon--FolderOpen:before{content:\"\\E838\"}.ms-Icon--FolderQuery:before{content:\"\\F2CD\"}.ms-Icon--FolderSearch:before{content:\"\\EF65\"}.ms-Icon--FollowUser:before{content:\"\\EE05\"}.ms-Icon--Font:before{content:\"\\E8D2\"}.ms-Icon--FontColor:before{content:\"\\E8D3\"}.ms-Icon--FontColorA:before{content:\"\\F4EC\"}.ms-Icon--FontColorSwatch:before{content:\"\\F4ED\"}.ms-Icon--FontDecrease:before{content:\"\\E8E7\"}.ms-Icon--FontIncrease:before{content:\"\\E8E8\"}.ms-Icon--FontSize:before{content:\"\\E8E9\"}[dir=ltr] .ms-Icon--FormLibrary:before{content:\"\\EEB9\"}[dir=ltr] .ms-Icon--FormLibraryMirrored:before,[dir=rtl] .ms-Icon--FormLibrary:before{content:\"\\EEBA\"}[dir=rtl] .ms-Icon--FormLibraryMirrored:before{content:\"\\EEB9\"}.ms-Icon--Forward:before{content:\"\\E72A\"}.ms-Icon--ForwardEvent:before{content:\"\\ED8C\"}.ms-Icon--Freezing:before{content:\"\\E9EF\"}.ms-Icon--Frigid:before{content:\"\\E9CA\"}.ms-Icon--FSharp:before{content:\"\\F2F6\"}.ms-Icon--FSharpLanguage:before{content:\"\\F2F5\"}.ms-Icon--FullCircleMask:before{content:\"\\E91F\"}.ms-Icon--FullHistory:before{content:\"\\F31C\"}.ms-Icon--FullScreen:before{content:\"\\E740\"}.ms-Icon--FullWidth:before{content:\"\\F2FE\"}.ms-Icon--FullWidthEdit:before{content:\"\\F2FF\"}.ms-Icon--FunctionalManagerDashboard:before{content:\"\\F542\"}.ms-Icon--GallatinLogo:before{content:\"\\F496\"}.ms-Icon--Generate:before{content:\"\\E9DA\"}.ms-Icon--GenericScan:before{content:\"\\EE6F\"}.ms-Icon--Giftbox:before{content:\"\\EC1F\"}.ms-Icon--GiftboxOpen:before{content:\"\\F133\"}.ms-Icon--GiftBoxSolid:before{content:\"\\F341\"}.ms-Icon--GiftCard:before{content:\"\\EB8E\"}.ms-Icon--GitFork:before{content:\"\\F661\"}.ms-Icon--GitGraph:before{content:\"\\F2CA\"}.ms-Icon--Glasses:before{content:\"\\EA16\"}.ms-Icon--Glimmer:before{content:\"\\ECF4\"}.ms-Icon--GlobalNavButton:before{content:\"\\E700\"}.ms-Icon--Globe:before{content:\"\\E774\"}.ms-Icon--Globe2:before{content:\"\\F49A\"}.ms-Icon--GlobeFavorite:before{content:\"\\EF53\"}.ms-Icon--Golf:before{content:\"\\EB1F\"}.ms-Icon--GotoToday:before{content:\"\\E8D1\"}.ms-Icon--GridViewLarge:before{content:\"\\F234\"}.ms-Icon--GridViewMedium:before{content:\"\\F233\"}.ms-Icon--GridViewSmall:before{content:\"\\F232\"}.ms-Icon--GripperBarHorizontal:before{content:\"\\E76F\"}.ms-Icon--GripperBarVertical:before{content:\"\\E784\"}.ms-Icon--GripperTool:before{content:\"\\E75E\"}.ms-Icon--Group:before{content:\"\\E902\"}.ms-Icon--GroupedAscending:before{content:\"\\EE67\"}.ms-Icon--GroupedDescending:before{content:\"\\EE66\"}.ms-Icon--GroupedList:before{content:\"\\EF74\"}.ms-Icon--GroupObject:before{content:\"\\F4F1\"}.ms-Icon--GUID:before{content:\"\\F52B\"}.ms-Icon--Guitar:before{content:\"\\F49B\"}.ms-Icon--HailDay:before{content:\"\\EA00\"}.ms-Icon--HailNight:before{content:\"\\EA13\"}.ms-Icon--HalfAlpha:before{content:\"\\E97E\"}.ms-Icon--HalfCircle:before{content:\"\\F501\"}.ms-Icon--HandsFree:before{content:\"\\EAD0\"}.ms-Icon--Handwriting:before{content:\"\\E929\"}.ms-Icon--HardDrive:before{content:\"\\EDA2\"}.ms-Icon--HardDriveGroup:before{content:\"\\F18F\"}.ms-Icon--HardDriveLock:before{content:\"\\F55A\"}.ms-Icon--HardDriveUnlock:before{content:\"\\F55B\"}.ms-Icon--Header1:before{content:\"\\EA19\"}.ms-Icon--Header2:before{content:\"\\EF36\"}.ms-Icon--Header3:before{content:\"\\EF37\"}.ms-Icon--Header4:before{content:\"\\EF38\"}.ms-Icon--Headset:before{content:\"\\E95B\"}.ms-Icon--HeadsetSolid:before{content:\"\\F348\"}.ms-Icon--Health:before{content:\"\\E95E\"}.ms-Icon--HealthSolid:before{content:\"\\F33F\"}.ms-Icon--Heart:before{content:\"\\EB51\"}.ms-Icon--HeartBroken:before{content:\"\\EA92\"}.ms-Icon--HeartFill:before{content:\"\\EB52\"}[dir=ltr] .ms-Icon--Help:before{content:\"\\E897\"}[dir=ltr] .ms-Icon--HelpMirrored:before,[dir=rtl] .ms-Icon--Help:before{content:\"\\EA51\"}[dir=rtl] .ms-Icon--HelpMirrored:before{content:\"\\E897\"}.ms-Icon--Hexagon:before{content:\"\\F4FE\"}.ms-Icon--Hide:before{content:\"\\ED1A\"}.ms-Icon--Hide2:before{content:\"\\EF89\"}.ms-Icon--Highlight:before{content:\"\\E7E6\"}.ms-Icon--HighlightMappedShapes:before{content:\"\\F2A1\"}.ms-Icon--HintText:before{content:\"\\F50F\"}.ms-Icon--History:before{content:\"\\E81C\"}.ms-Icon--Home:before{content:\"\\E80F\"}.ms-Icon--HomeSolid:before{content:\"\\EA8A\"}.ms-Icon--HorizontalDistributeCenter:before{content:\"\\F4F9\"}.ms-Icon--Hospital:before{content:\"\\E91D\"}.ms-Icon--Hotel:before{content:\"\\E824\"}.ms-Icon--HourGlass:before{content:\"\\EA03\"}.ms-Icon--IconSetsFlag:before{content:\"\\F2A4\"}.ms-Icon--IDBadge:before{content:\"\\F427\"}.ms-Icon--ImageCrosshair:before{content:\"\\F2C9\"}.ms-Icon--ImageDiff:before{content:\"\\F30B\"}.ms-Icon--ImagePixel:before{content:\"\\F30C\"}.ms-Icon--ImageSearch:before{content:\"\\F4E8\"}.ms-Icon--Important:before{content:\"\\E8C9\"}[dir=ltr] .ms-Icon--Import:before{content:\"\\E8B5\"}[dir=ltr] .ms-Icon--ImportMirrored:before,[dir=rtl] .ms-Icon--Import:before{content:\"\\EA52\"}[dir=rtl] .ms-Icon--ImportMirrored:before{content:\"\\E8B5\"}.ms-Icon--Inbox:before{content:\"\\F41C\"}.ms-Icon--InboxCheck:before{content:\"\\EF64\"}.ms-Icon--IncidentTriangle:before{content:\"\\E814\"}.ms-Icon--IncreaseIndentLegacy:before{content:\"\\E291\"}.ms-Icon--Info:before{content:\"\\E946\"}.ms-Icon--Info2:before{content:\"\\EA1F\"}.ms-Icon--InfoSolid:before{content:\"\\F167\"}.ms-Icon--InsertColumnsLeft:before{content:\"\\F64A\"}.ms-Icon--InsertColumnsRight:before{content:\"\\F64B\"}.ms-Icon--InsertRowsAbove:before{content:\"\\F64C\"}.ms-Icon--InsertRowsBelow:before{content:\"\\F64D\"}.ms-Icon--InsertSignatureLine:before{content:\"\\F677\"}.ms-Icon--InsertTextBox:before{content:\"\\EC7D\"}.ms-Icon--InstallToDrive:before{content:\"\\F28D\"}.ms-Icon--InternetSharing:before{content:\"\\E704\"}[dir=ltr] .ms-Icon--IRMForward:before{content:\"\\F41F\"}[dir=ltr] .ms-Icon--IRMForwardMirrored:before,[dir=rtl] .ms-Icon--IRMForward:before{content:\"\\F420\"}[dir=rtl] .ms-Icon--IRMForwardMirrored:before{content:\"\\F41F\"}[dir=ltr] .ms-Icon--IRMReply:before{content:\"\\F41D\"}[dir=ltr] .ms-Icon--IRMReplyMirrored:before,[dir=rtl] .ms-Icon--IRMReply:before{content:\"\\F41E\"}[dir=rtl] .ms-Icon--IRMReplyMirrored:before{content:\"\\F41D\"}.ms-Icon--IssueSolid:before{content:\"\\F448\"}[dir=ltr] .ms-Icon--IssueTracking:before{content:\"\\EEC0\"}[dir=ltr] .ms-Icon--IssueTrackingMirrored:before,[dir=rtl] .ms-Icon--IssueTracking:before{content:\"\\EEC1\"}[dir=rtl] .ms-Icon--IssueTrackingMirrored:before{content:\"\\EEC0\"}.ms-Icon--Italic:before{content:\"\\E8DB\"}.ms-Icon--JavaScriptLanguage:before{content:\"\\F2EE\"}.ms-Icon--JoinOnlineMeeting:before{content:\"\\ED8F\"}.ms-Icon--JS:before{content:\"\\EBF0\"}.ms-Icon--KaizalaLogo:before{content:\"\\F492\"}.ms-Icon--Label:before{content:\"\\E932\"}.ms-Icon--LadybugSolid:before{content:\"\\F44A\"}.ms-Icon--Lamp:before{content:\"\\EB19\"}.ms-Icon--LandscapeOrientation:before{content:\"\\EF6B\"}.ms-Icon--LaptopSecure:before{content:\"\\F552\"}.ms-Icon--LaptopSelected:before{content:\"\\EC76\"}.ms-Icon--LargeGrid:before{content:\"\\EECB\"}.ms-Icon--Leave:before{content:\"\\F627\"}.ms-Icon--Library:before{content:\"\\E8F1\"}.ms-Icon--Lifesaver:before{content:\"\\EF62\"}.ms-Icon--LifesaverLock:before{content:\"\\EF63\"}.ms-Icon--Light:before{content:\"\\E793\"}.ms-Icon--Lightbulb:before{content:\"\\EA80\"}.ms-Icon--LightningBolt:before{content:\"\\E945\"}.ms-Icon--LightWeight:before{content:\"\\F4EE\"}.ms-Icon--Like:before{content:\"\\E8E1\"}.ms-Icon--LikeSolid:before{content:\"\\F3BF\"}.ms-Icon--Line:before{content:\"\\F4FC\"}.ms-Icon--LineChart:before{content:\"\\E9E6\"}.ms-Icon--LineSpacing:before{content:\"\\F517\"}.ms-Icon--LineStyle:before{content:\"\\F50C\"}.ms-Icon--LineThickness:before{content:\"\\F50D\"}.ms-Icon--Link:before{content:\"\\E71B\"}.ms-Icon--LinkedInLogo:before{content:\"\\F20A\"}[dir=ltr] .ms-Icon--List:before{content:\"\\EA37\"}[dir=ltr] .ms-Icon--ListMirrored:before,[dir=rtl] .ms-Icon--List:before{content:\"\\EA55\"}[dir=rtl] .ms-Icon--ListMirrored:before{content:\"\\EA37\"}.ms-Icon--LocaleLanguage:before{content:\"\\F2B7\"}.ms-Icon--Location:before{content:\"\\E81D\"}.ms-Icon--LocationCircle:before{content:\"\\E80E\"}.ms-Icon--LocationDot:before{content:\"\\E827\"}.ms-Icon--LocationFill:before{content:\"\\E920\"}.ms-Icon--LocationOutline:before{content:\"\\F2D0\"}.ms-Icon--Lock:before{content:\"\\E72E\"}.ms-Icon--LockSolid:before{content:\"\\E9A2\"}.ms-Icon--LogRemove:before{content:\"\\F316\"}.ms-Icon--LookupEntities:before{content:\"\\F5B5\"}.ms-Icon--LowerBrightness:before{content:\"\\EC8A\"}.ms-Icon--LyncLogo:before{content:\"\\ED79\"}.ms-Icon--Mail:before{content:\"\\E715\"}.ms-Icon--MailAlert:before{content:\"\\ED80\"}.ms-Icon--MailCheck:before{content:\"\\ED81\"}.ms-Icon--MailFill:before{content:\"\\E8A8\"}[dir=ltr] .ms-Icon--MailForward:before{content:\"\\E89C\"}[dir=ltr] .ms-Icon--MailForwardMirrored:before,[dir=rtl] .ms-Icon--MailForward:before{content:\"\\EA56\"}[dir=rtl] .ms-Icon--MailForwardMirrored:before{content:\"\\E89C\"}.ms-Icon--MailLowImportance:before{content:\"\\ED82\"}.ms-Icon--MailPause:before{content:\"\\ED83\"}.ms-Icon--MailReminder:before{content:\"\\F418\"}.ms-Icon--MailRepeat:before{content:\"\\ED84\"}[dir=ltr] .ms-Icon--MailReplyAll:before{content:\"\\E8C2\"}[dir=ltr] .ms-Icon--MailReplyAllMirrored:before,[dir=rtl] .ms-Icon--MailReplyAll:before{content:\"\\EA58\"}[dir=rtl] .ms-Icon--MailReplyAllMirrored:before{content:\"\\E8C2\"}[dir=ltr] .ms-Icon--MailReply:before{content:\"\\E8CA\"}[dir=ltr] .ms-Icon--MailReplyMirrored:before,[dir=rtl] .ms-Icon--MailReply:before{content:\"\\EA57\"}[dir=rtl] .ms-Icon--MailReplyMirrored:before{content:\"\\E8CA\"}.ms-Icon--MailSolid:before{content:\"\\F343\"}[dir=ltr] .ms-Icon--MailTentative:before{content:\"\\F416\"}[dir=ltr] .ms-Icon--MailTentativeMirrored:before,[dir=rtl] .ms-Icon--MailTentative:before{content:\"\\F417\"}[dir=rtl] .ms-Icon--MailTentativeMirrored:before{content:\"\\F416\"}.ms-Icon--MailUndelivered:before{content:\"\\F415\"}.ms-Icon--ManagerSelfService:before{content:\"\\EE23\"}.ms-Icon--MapDirections:before{content:\"\\E816\"}.ms-Icon--MapPin:before{content:\"\\E707\"}.ms-Icon--MapPinSolid:before{content:\"\\F52E\"}.ms-Icon--MarkDownLanguage:before{content:\"\\F2FB\"}.ms-Icon--Market:before{content:\"\\EAFC\"}.ms-Icon--MarketDown:before{content:\"\\EF42\"}.ms-Icon--MasterDatabase:before{content:\"\\F5BA\"}.ms-Icon--MaximumValue:before{content:\"\\F5BC\"}.ms-Icon--Medal:before{content:\"\\EE38\"}.ms-Icon--MediaAdd:before{content:\"\\F510\"}.ms-Icon--Medical:before{content:\"\\EAD4\"}.ms-Icon--Megaphone:before{content:\"\\E789\"}.ms-Icon--MegaphoneSolid:before{content:\"\\F332\"}.ms-Icon--Memo:before{content:\"\\E77C\"}.ms-Icon--Merge:before{content:\"\\E7D5\"}.ms-Icon--MergeDuplicate:before{content:\"\\F29A\"}.ms-Icon--Message:before{content:\"\\E8BD\"}.ms-Icon--MessageFill:before{content:\"\\EC70\"}.ms-Icon--MicOff:before{content:\"\\EC54\"}.ms-Icon--Microphone:before{content:\"\\E720\"}.ms-Icon--MicrosoftFlowLogo:before{content:\"\\F4B1\"}.ms-Icon--MicrosoftStaffhubLogo:before{content:\"\\F130\"}.ms-Icon--MiniContract:before{content:\"\\E93B\"}.ms-Icon--MiniExpand:before{content:\"\\E93A\"}.ms-Icon--MiniLink:before{content:\"\\E732\"}.ms-Icon--MinimumValue:before{content:\"\\F5BD\"}.ms-Icon--MobileReport:before{content:\"\\F18A\"}.ms-Icon--MobileSelected:before{content:\"\\EC75\"}.ms-Icon--Money:before{content:\"\\EAFD\"}.ms-Icon--More:before{content:\"\\E712\"}.ms-Icon--MoreSports:before{content:\"\\EB22\"}.ms-Icon--MoreVertical:before{content:\"\\F2BC\"}.ms-Icon--Move:before{content:\"\\E7C2\"}.ms-Icon--Movers:before{content:\"\\EBCD\"}.ms-Icon--MoveToFolder:before{content:\"\\E8DE\"}.ms-Icon--MSNLogo:before{content:\"\\EB6C\"}.ms-Icon--MSNVideos:before{content:\"\\EB1C\"}.ms-Icon--MSNVideosSolid:before{content:\"\\F2DA\"}.ms-Icon--MTMLogo:before{content:\"\\F44B\"}[dir=ltr] .ms-Icon--MultiSelect:before{content:\"\\E762\"}[dir=ltr] .ms-Icon--MultiSelectMirrored:before,[dir=rtl] .ms-Icon--MultiSelect:before{content:\"\\EA98\"}[dir=rtl] .ms-Icon--MultiSelectMirrored:before{content:\"\\E762\"}.ms-Icon--MusicInCollection:before{content:\"\\E940\"}.ms-Icon--MusicInCollectionFill:before{content:\"\\EA36\"}.ms-Icon--MusicNote:before{content:\"\\EC4F\"}.ms-Icon--MyMoviesTV:before{content:\"\\EE6C\"}.ms-Icon--Nav2DMapView:before{content:\"\\E800\"}[dir=ltr] .ms-Icon--NavigateBack:before{content:\"\\F2DD\"}[dir=ltr] .ms-Icon--NavigateBackMirrored:before,[dir=rtl] .ms-Icon--NavigateBack:before{content:\"\\F2DE\"}[dir=rtl] .ms-Icon--NavigateBackMirrored:before{content:\"\\F2DD\"}.ms-Icon--NavigateExternalInline:before{content:\"\\F35F\"}[dir=ltr] .ms-Icon--NavigateForward:before{content:\"\\F2DF\"}[dir=ltr] .ms-Icon--NavigateForwardMirrored:before,[dir=rtl] .ms-Icon--NavigateForward:before{content:\"\\F2E0\"}[dir=rtl] .ms-Icon--NavigateForwardMirrored:before{content:\"\\F2DF\"}.ms-Icon--NavigationFlipper:before{content:\"\\F51D\"}.ms-Icon--NetworkTower:before{content:\"\\EC05\"}.ms-Icon--NewAnalyticsQuery:before{content:\"\\F1E0\"}.ms-Icon--NewFolder:before{content:\"\\E8F4\"}.ms-Icon--News:before{content:\"\\E900\"}.ms-Icon--NewsSearch:before{content:\"\\F4E9\"}.ms-Icon--NewTeamProject:before{content:\"\\F2B2\"}.ms-Icon--Next:before{content:\"\\E893\"}.ms-Icon--NonprofitLogo32:before{content:\"\\F495\"}.ms-Icon--NormalWeight:before{content:\"\\F4EF\"}.ms-Icon--NoteForward:before{content:\"\\ED99\"}.ms-Icon--NotePinned:before{content:\"\\ED9A\"}.ms-Icon--NoteReply:before{content:\"\\ED98\"}.ms-Icon--NotExecuted:before{content:\"\\F440\"}.ms-Icon--NotImpactedSolid:before{content:\"\\F441\"}.ms-Icon--NugetLogo:before{content:\"\\F44C\"}.ms-Icon--NumberedList:before{content:\"\\EA1C\"}.ms-Icon--NumberField:before{content:\"\\EDC4\"}.ms-Icon--NumberSequence:before{content:\"\\F52A\"}.ms-Icon--Octagon:before{content:\"\\F4FD\"}.ms-Icon--OEM:before{content:\"\\E74C\"}.ms-Icon--OfficeAddinsLogo:before{content:\"\\EEC7\"}.ms-Icon--OfficeAssistantLogo:before{content:\"\\EDCE\"}.ms-Icon--OfficeFormsLogo:before{content:\"\\F434\"}.ms-Icon--OfficeFormsLogo16:before{content:\"\\F436\"}.ms-Icon--OfficeFormsLogo24:before{content:\"\\F43B\"}.ms-Icon--OfficeFormsLogoFill:before{content:\"\\F435\"}.ms-Icon--OfficeFormsLogoFill16:before{content:\"\\F437\"}.ms-Icon--OfficeFormsLogoFill24:before{content:\"\\F43C\"}.ms-Icon--OfficeFormsLogoInverse:before{content:\"\\EF86\"}.ms-Icon--OfficeFormsLogoInverse16:before{content:\"\\F433\"}.ms-Icon--OfficeFormsLogoInverse24:before{content:\"\\F43A\"}.ms-Icon--OfficeLogo:before{content:\"\\EB6E\"}.ms-Icon--OfficeStoreLogo:before{content:\"\\EDCF\"}.ms-Icon--OfficeVideoLogo:before{content:\"\\F282\"}.ms-Icon--OfficeVideoLogoFill:before{content:\"\\F283\"}.ms-Icon--OfficeVideoLogoInverse:before{content:\"\\ED7A\"}.ms-Icon--OfflineOneDriveParachute:before{content:\"\\EEC8\"}.ms-Icon--OfflineOneDriveParachuteDisabled:before{content:\"\\EEC9\"}.ms-Icon--OfflineStorageSolid:before{content:\"\\F34E\"}.ms-Icon--OneDrive:before{content:\"\\E941\"}.ms-Icon--OneDriveAdd:before{content:\"\\EF32\"}.ms-Icon--OneDriveFolder16:before{content:\"\\F53B\"}.ms-Icon--OneNoteEduLogoInverse:before{content:\"\\EDD0\"}.ms-Icon--OneNoteLogo:before{content:\"\\F1E7\"}.ms-Icon--OneNoteLogo16:before{content:\"\\F39A\"}.ms-Icon--OneNoteLogoFill:before{content:\"\\F1E8\"}.ms-Icon--OneNoteLogoFill16:before{content:\"\\F39B\"}.ms-Icon--OneNoteLogoInverse:before{content:\"\\EC0D\"}.ms-Icon--OneNoteLogoInverse16:before{content:\"\\F399\"}.ms-Icon--OpenFile:before{content:\"\\E8E5\"}.ms-Icon--OpenFolderHorizontal:before{content:\"\\ED25\"}.ms-Icon--OpenInNewWindow:before{content:\"\\E8A7\"}[dir=ltr] .ms-Icon--OpenPane:before{content:\"\\E8A0\"}[dir=ltr] .ms-Icon--OpenPaneMirrored:before,[dir=rtl] .ms-Icon--OpenPane:before{content:\"\\EA5B\"}[dir=rtl] .ms-Icon--OpenPaneMirrored:before{content:\"\\E8A0\"}.ms-Icon--OpenSource:before{content:\"\\EBC2\"}.ms-Icon--Org:before{content:\"\\ECA6\"}.ms-Icon--Orientation:before{content:\"\\E8B4\"}.ms-Icon--OutlookLogo:before{content:\"\\F1E9\"}.ms-Icon--OutlookLogo16:before{content:\"\\F39D\"}.ms-Icon--OutlookLogoFill:before{content:\"\\F1EA\"}.ms-Icon--OutlookLogoFill16:before{content:\"\\F39E\"}.ms-Icon--OutlookLogoInverse:before{content:\"\\EB6D\"}.ms-Icon--OutlookLogoInverse16:before{content:\"\\F39C\"}.ms-Icon--OutOfOffice:before{content:\"\\ED34\"}.ms-Icon--Package:before{content:\"\\E7B8\"}.ms-Icon--Packages:before{content:\"\\F318\"}.ms-Icon--Padding:before{content:\"\\F518\"}.ms-Icon--PaddingBottom:before{content:\"\\F51A\"}.ms-Icon--PaddingLeft:before{content:\"\\F51B\"}.ms-Icon--PaddingRight:before{content:\"\\F51C\"}.ms-Icon--PaddingTop:before{content:\"\\F519\"}.ms-Icon--Page:before{content:\"\\E7C3\"}.ms-Icon--PageAdd:before{content:\"\\EA1A\"}.ms-Icon--PageCheckedin:before{content:\"\\F104\"}.ms-Icon--PageCheckedOut:before{content:\"\\F02C\"}.ms-Icon--PageEdit:before{content:\"\\EFB6\"}.ms-Icon--PageLeft:before{content:\"\\E760\"}[dir=ltr] .ms-Icon--PageListSolid:before{content:\"\\F33A\"}[dir=ltr] .ms-Icon--PageListMirroredSolid:before,[dir=rtl] .ms-Icon--PageListSolid:before{content:\"\\F33B\"}[dir=rtl] .ms-Icon--PageListMirroredSolid:before{content:\"\\F33A\"}.ms-Icon--PageLock:before{content:\"\\F43F\"}.ms-Icon--PageRemove:before{content:\"\\EFBA\"}.ms-Icon--PageRight:before{content:\"\\E761\"}.ms-Icon--PageSolid:before{content:\"\\E729\"}.ms-Icon--PanoIndicator:before{content:\"\\E7B0\"}.ms-Icon--Parachute:before{content:\"\\F351\"}.ms-Icon--ParachuteSolid:before{content:\"\\F352\"}.ms-Icon--Parameter:before{content:\"\\F306\"}[dir=ltr] .ms-Icon--ParkingLocation:before{content:\"\\E811\"}[dir=ltr] .ms-Icon--ParkingLocationMirrored:before,[dir=rtl] .ms-Icon--ParkingLocation:before{content:\"\\EA5E\"}[dir=rtl] .ms-Icon--ParkingLocationMirrored:before{content:\"\\E811\"}[dir=ltr] .ms-Icon--ParkingSolid:before{content:\"\\F34A\"}[dir=ltr] .ms-Icon--ParkingMirroredSolid:before,[dir=rtl] .ms-Icon--ParkingSolid:before{content:\"\\F34B\"}[dir=rtl] .ms-Icon--ParkingMirroredSolid:before{content:\"\\F34A\"}.ms-Icon--PartlyCloudyDay:before{content:\"\\E9C0\"}.ms-Icon--PartlyCloudyNight:before{content:\"\\E9C1\"}.ms-Icon--PartyLeader:before{content:\"\\ECA7\"}.ms-Icon--Paste:before{content:\"\\E77F\"}.ms-Icon--PasteAsCode:before{content:\"\\F5D6\"}.ms-Icon--PasteAsText:before{content:\"\\F5D5\"}.ms-Icon--Pause:before{content:\"\\E769\"}.ms-Icon--PaymentCard:before{content:\"\\E8C7\"}.ms-Icon--PC1:before{content:\"\\E977\"}.ms-Icon--PDF:before{content:\"\\EA90\"}.ms-Icon--PencilReply:before{content:\"\\EF7B\"}.ms-Icon--Pentagon:before{content:\"\\F4FF\"}.ms-Icon--People:before{content:\"\\E716\"}.ms-Icon--PeopleAdd:before{content:\"\\EA15\"}.ms-Icon--PeopleAlert:before{content:\"\\ED93\"}.ms-Icon--PeopleBlock:before{content:\"\\ED91\"}.ms-Icon--PeoplePause:before{content:\"\\ED94\"}.ms-Icon--PeopleRepeat:before{content:\"\\ED92\"}.ms-Icon--Permissions:before{content:\"\\E8D7\"}.ms-Icon--PermissionsSolid:before{content:\"\\F349\"}.ms-Icon--Personalize:before{content:\"\\E771\"}.ms-Icon--Phishing:before{content:\"\\F679\"}.ms-Icon--Phone:before{content:\"\\E717\"}.ms-Icon--Photo2:before{content:\"\\EB9F\"}.ms-Icon--Photo2Add:before{content:\"\\ECAB\"}.ms-Icon--Photo2Remove:before{content:\"\\ECAC\"}.ms-Icon--PhotoCollection:before{content:\"\\E7AA\"}.ms-Icon--Picture:before{content:\"\\E8B9\"}.ms-Icon--PictureCenter:before{content:\"\\F522\"}.ms-Icon--PictureFill:before{content:\"\\F523\"}.ms-Icon--PictureLibrary:before{content:\"\\EEC2\"}.ms-Icon--PicturePosition:before{content:\"\\F524\"}.ms-Icon--PictureStretch:before{content:\"\\F525\"}.ms-Icon--PictureTile:before{content:\"\\F526\"}.ms-Icon--PieDouble:before{content:\"\\EB04\"}.ms-Icon--PieSingle:before{content:\"\\EB05\"}.ms-Icon--PieSingleSolid:before{content:\"\\F530\"}.ms-Icon--Pill:before{content:\"\\EACB\"}.ms-Icon--Pin:before{content:\"\\E718\"}.ms-Icon--Pinned:before{content:\"\\E840\"}.ms-Icon--PinnedFill:before{content:\"\\E842\"}.ms-Icon--PivotChart:before{content:\"\\F24C\"}.ms-Icon--PlannerLogo:before{content:\"\\EDD1\"}.ms-Icon--PlanView:before{content:\"\\F360\"}.ms-Icon--Play:before{content:\"\\E768\"}.ms-Icon--PlayerSettings:before{content:\"\\EF58\"}.ms-Icon--PlayResume:before{content:\"\\F2C6\"}.ms-Icon--Plug:before{content:\"\\F300\"}.ms-Icon--PlugConnected:before{content:\"\\F302\"}.ms-Icon--PlugDisconnected:before{content:\"\\F303\"}.ms-Icon--PlugSolid:before{content:\"\\F301\"}.ms-Icon--POI:before{content:\"\\ECAF\"}.ms-Icon--POISolid:before{content:\"\\F2D1\"}.ms-Icon--PostUpdate:before{content:\"\\E8F3\"}.ms-Icon--PowerApps:before{content:\"\\EDD2\"}.ms-Icon--PowerApps2Logo:before{content:\"\\F092\"}.ms-Icon--PowerAppsLogo:before{content:\"\\F091\"}.ms-Icon--PowerBILogo:before{content:\"\\EA1E\"}.ms-Icon--PowerButton:before{content:\"\\E7E8\"}.ms-Icon--PowerPointDocument:before{content:\"\\EF72\"}.ms-Icon--PowerPointLogo:before{content:\"\\F1EB\"}.ms-Icon--PowerPointLogo16:before{content:\"\\F394\"}.ms-Icon--PowerPointLogoFill:before{content:\"\\F1EC\"}.ms-Icon--PowerPointLogoFill16:before{content:\"\\F395\"}.ms-Icon--PowerPointLogoInverse:before{content:\"\\EC2A\"}.ms-Icon--PowerPointLogoInverse16:before{content:\"\\F393\"}.ms-Icon--Precipitation:before{content:\"\\E9CF\"}.ms-Icon--PresenceChickletVideo:before{content:\"\\E979\"}.ms-Icon--Preview:before{content:\"\\E8FF\"}.ms-Icon--PreviewLink:before{content:\"\\E8A1\"}.ms-Icon--Previous:before{content:\"\\E892\"}.ms-Icon--PrimaryCalendar:before{content:\"\\F4AE\"}.ms-Icon--Print:before{content:\"\\E749\"}.ms-Icon--PrintfaxPrinterFile:before{content:\"\\E956\"}.ms-Icon--Processing:before{content:\"\\E9F5\"}.ms-Icon--ProcessMetaTask:before{content:\"\\F290\"}.ms-Icon--Product:before{content:\"\\ECDC\"}.ms-Icon--ProfileSearch:before{content:\"\\EF35\"}.ms-Icon--ProFootball:before{content:\"\\EB27\"}.ms-Icon--ProgressLoopInner:before{content:\"\\ECDE\"}.ms-Icon--ProgressLoopOuter:before{content:\"\\ECDF\"}.ms-Icon--ProgressRingDots:before{content:\"\\F16A\"}.ms-Icon--ProHockey:before{content:\"\\EB28\"}.ms-Icon--ProjectCollection:before{content:\"\\F363\"}.ms-Icon--ProjectLogo16:before{content:\"\\F480\"}.ms-Icon--ProjectLogo32:before{content:\"\\F47E\"}.ms-Icon--ProjectLogoFill16:before{content:\"\\F481\"}.ms-Icon--ProjectLogoFill32:before{content:\"\\F47F\"}.ms-Icon--ProjectLogoInverse:before{content:\"\\EDD4\"}.ms-Icon--ProtectedDocument:before{content:\"\\E8A6\"}.ms-Icon--ProtectionCenterLogo32:before{content:\"\\F494\"}.ms-Icon--ProtectRestrict:before{content:\"\\F22A\"}.ms-Icon--PublicCalendar:before{content:\"\\EF6D\"}[dir=ltr] .ms-Icon--PublicContactCard:before{content:\"\\EF6E\"}[dir=ltr] .ms-Icon--PublicContactCardMirrored:before,[dir=rtl] .ms-Icon--PublicContactCard:before{content:\"\\F230\"}[dir=rtl] .ms-Icon--PublicContactCardMirrored:before{content:\"\\EF6E\"}.ms-Icon--PublicEmail:before{content:\"\\EF6F\"}.ms-Icon--PublicFolder:before{content:\"\\EF70\"}.ms-Icon--PublishCourse:before{content:\"\\F699\"}.ms-Icon--PublisherLogo:before{content:\"\\F1ED\"}.ms-Icon--PublisherLogo16:before{content:\"\\F3A0\"}.ms-Icon--PublisherLogoFill:before{content:\"\\F1EE\"}.ms-Icon--PublisherLogoFill16:before{content:\"\\F3A1\"}.ms-Icon--PublisherLogoInverse16:before{content:\"\\F39F\"}.ms-Icon--Puzzle:before{content:\"\\EA86\"}.ms-Icon--PY:before{content:\"\\F2F9\"}.ms-Icon--PythonLanguage:before{content:\"\\F2F8\"}.ms-Icon--QuarterCircle:before{content:\"\\F502\"}.ms-Icon--QueryList:before{content:\"\\F2B8\"}[dir=ltr] .ms-Icon--Questionnaire:before{content:\"\\EE19\"}[dir=ltr] .ms-Icon--QuestionnaireMirrored:before,[dir=rtl] .ms-Icon--Questionnaire:before{content:\"\\EE4B\"}[dir=rtl] .ms-Icon--QuestionnaireMirrored:before{content:\"\\EE19\"}.ms-Icon--QuickNote:before{content:\"\\E70B\"}.ms-Icon--QuickNoteSolid:before{content:\"\\F338\"}.ms-Icon--R:before{content:\"\\F4EB\"}.ms-Icon--RadioBtnOff:before{content:\"\\ECCA\"}.ms-Icon--RadioBtnOn:before{content:\"\\ECCB\"}.ms-Icon--RadioBullet:before{content:\"\\E915\"}.ms-Icon--Rain:before{content:\"\\E9C4\"}.ms-Icon--RainShowersDay:before{content:\"\\E9C3\"}.ms-Icon--RainShowersNight:before{content:\"\\EA0F\"}.ms-Icon--RainSnow:before{content:\"\\E9C7\"}.ms-Icon--RawSource:before{content:\"\\F299\"}.ms-Icon--Read:before{content:\"\\E8C3\"}.ms-Icon--ReadingMode:before{content:\"\\E736\"}.ms-Icon--ReadingModeSolid:before{content:\"\\F33D\"}.ms-Icon--ReadOutLoud:before{content:\"\\F112\"}.ms-Icon--ReceiptCheck:before{content:\"\\EF5B\"}.ms-Icon--ReceiptForward:before{content:\"\\EF59\"}.ms-Icon--ReceiptReply:before{content:\"\\EF5A\"}[dir=ltr] .ms-Icon--ReceiptTentative:before{content:\"\\F41A\"}[dir=ltr] .ms-Icon--ReceiptTentativeMirrored:before,[dir=rtl] .ms-Icon--ReceiptTentative:before{content:\"\\F41B\"}[dir=rtl] .ms-Icon--ReceiptTentativeMirrored:before{content:\"\\F41A\"}.ms-Icon--ReceiptUndelivered:before{content:\"\\F419\"}.ms-Icon--Recent:before{content:\"\\E823\"}.ms-Icon--Record2:before{content:\"\\EA3F\"}.ms-Icon--RectangleShapeSolid:before{content:\"\\F640\"}.ms-Icon--RectangularClipping:before{content:\"\\F407\"}.ms-Icon--RecurringEvent:before{content:\"\\EF5D\"}.ms-Icon--RecurringTask:before{content:\"\\EDB2\"}.ms-Icon--RecycleBin:before{content:\"\\EF87\"}.ms-Icon--Redeploy:before{content:\"\\F29E\"}.ms-Icon--RedEye:before{content:\"\\E7B3\"}.ms-Icon--Redo:before{content:\"\\E7A6\"}.ms-Icon--Refresh:before{content:\"\\E72C\"}.ms-Icon--ReminderGroup:before{content:\"\\EBF8\"}.ms-Icon--ReminderPerson:before{content:\"\\EBF7\"}.ms-Icon--Remote:before{content:\"\\E8AF\"}.ms-Icon--Remove:before{content:\"\\E738\"}.ms-Icon--RemoveEvent:before{content:\"\\ED8A\"}.ms-Icon--RemoveFilter:before{content:\"\\EB08\"}.ms-Icon--RemoveLink:before{content:\"\\ED90\"}.ms-Icon--RemoveOccurrence:before{content:\"\\ED9B\"}.ms-Icon--Rename:before{content:\"\\E8AC\"}.ms-Icon--RenewalCurrent:before{content:\"\\F545\"}.ms-Icon--RenewalFuture:before{content:\"\\F546\"}.ms-Icon--ReopenPages:before{content:\"\\ED50\"}.ms-Icon--Repair:before{content:\"\\E90F\"}.ms-Icon--ReplyAllAlt:before{content:\"\\EF5F\"}[dir=ltr] .ms-Icon--ReplyAll:before{content:\"\\EE0A\"}[dir=ltr] .ms-Icon--ReplyAllMirrored:before,[dir=rtl] .ms-Icon--ReplyAll:before{content:\"\\EE36\"}[dir=rtl] .ms-Icon--ReplyAllMirrored:before{content:\"\\EE0A\"}.ms-Icon--ReplyAlt:before{content:\"\\EF5E\"}[dir=ltr] .ms-Icon--Reply:before{content:\"\\E97A\"}[dir=ltr] .ms-Icon--ReplyMirrored:before,[dir=rtl] .ms-Icon--Reply:before{content:\"\\EE35\"}[dir=rtl] .ms-Icon--ReplyMirrored:before{content:\"\\E97A\"}.ms-Icon--Repo:before{content:\"\\F2CB\"}.ms-Icon--ReportAdd:before{content:\"\\F52C\"}.ms-Icon--ReportHacked:before{content:\"\\E730\"}[dir=ltr] .ms-Icon--ReportLibrary:before{content:\"\\EEBB\"}[dir=ltr] .ms-Icon--ReportLibraryMirrored:before,[dir=rtl] .ms-Icon--ReportLibrary:before{content:\"\\EEBC\"}[dir=rtl] .ms-Icon--ReportLibraryMirrored:before{content:\"\\EEBB\"}.ms-Icon--RepoSolid:before{content:\"\\F2CC\"}.ms-Icon--ReturnToSession:before{content:\"\\ED24\"}[dir=ltr] .ms-Icon--ReviewRequestSolid:before{content:\"\\F356\"}[dir=ltr] .ms-Icon--ReviewRequestMirroredSolid:before,[dir=rtl] .ms-Icon--ReviewRequestSolid:before{content:\"\\F357\"}[dir=rtl] .ms-Icon--ReviewRequestMirroredSolid:before{content:\"\\F356\"}.ms-Icon--ReviewResponseSolid:before{content:\"\\F358\"}.ms-Icon--ReviewSolid:before{content:\"\\F355\"}.ms-Icon--RevToggleKey:before{content:\"\\E845\"}.ms-Icon--Rewind:before{content:\"\\EB9E\"}.ms-Icon--Ribbon:before{content:\"\\E9D1\"}.ms-Icon--RibbonSolid:before{content:\"\\F345\"}.ms-Icon--RightDoubleQuote:before{content:\"\\E9B1\"}.ms-Icon--RightTriangle:before{content:\"\\F500\"}.ms-Icon--Ringer:before{content:\"\\EA8F\"}.ms-Icon--RingerOff:before{content:\"\\F2C5\"}.ms-Icon--RingerRemove:before{content:\"\\F279\"}.ms-Icon--Robot:before{content:\"\\E99A\"}.ms-Icon--Rocket:before{content:\"\\F3B3\"}.ms-Icon--Room:before{content:\"\\ED9F\"}.ms-Icon--Rotate:before{content:\"\\E7AD\"}.ms-Icon--RowsChild:before{content:\"\\F29C\"}.ms-Icon--RowsGroup:before{content:\"\\F29B\"}.ms-Icon--Rugby:before{content:\"\\EB2D\"}.ms-Icon--Running:before{content:\"\\EADA\"}.ms-Icon--Sad:before{content:\"\\E757\"}.ms-Icon--SadSolid:before{content:\"\\F33E\"}.ms-Icon--Save:before{content:\"\\E74E\"}.ms-Icon--SaveAll:before{content:\"\\F203\"}.ms-Icon--SaveAndClose:before{content:\"\\F038\"}.ms-Icon--SaveAs:before{content:\"\\E792\"}.ms-Icon--Savings:before{content:\"\\EB0B\"}.ms-Icon--ScaleUp:before{content:\"\\ED09\"}.ms-Icon--ScheduleEventAction:before{content:\"\\F1EF\"}.ms-Icon--ScopeTemplate:before{content:\"\\F2B0\"}.ms-Icon--Script:before{content:\"\\F03A\"}.ms-Icon--ScrollUpDown:before{content:\"\\EC8F\"}.ms-Icon--Search:before{content:\"\\E721\"}.ms-Icon--SearchAndApps:before{content:\"\\E773\"}.ms-Icon--SearchBookmark:before{content:\"\\F5B8\"}.ms-Icon--SearchCalendar:before{content:\"\\F4AF\"}[dir=ltr] .ms-Icon--SearchIssue:before{content:\"\\F09A\"}[dir=ltr] .ms-Icon--SearchIssueMirrored:before,[dir=rtl] .ms-Icon--SearchIssue:before{content:\"\\F09B\"}[dir=rtl] .ms-Icon--SearchIssueMirrored:before{content:\"\\F09A\"}.ms-Icon--Section:before{content:\"\\EC0C\"}.ms-Icon--Sections:before{content:\"\\EF76\"}.ms-Icon--SecurityGroup:before{content:\"\\ED85\"}.ms-Icon--SelectAll:before{content:\"\\E8B3\"}.ms-Icon--Sell:before{content:\"\\EB0C\"}.ms-Icon--SemiboldWeight:before{content:\"\\F4F0\"}[dir=ltr] .ms-Icon--Send:before{content:\"\\E724\"}[dir=ltr] .ms-Icon--SendMirrored:before,[dir=rtl] .ms-Icon--Send:before{content:\"\\EA63\"}[dir=rtl] .ms-Icon--SendMirrored:before{content:\"\\E724\"}.ms-Icon--Separator:before{content:\"\\F35E\"}.ms-Icon--Server:before{content:\"\\F201\"}.ms-Icon--ServerEnviroment:before{content:\"\\F29F\"}.ms-Icon--ServerProcesses:before{content:\"\\F1FE\"}.ms-Icon--SetAction:before{content:\"\\F071\"}.ms-Icon--Settings:before{content:\"\\E713\"}.ms-Icon--Share:before{content:\"\\E72D\"}.ms-Icon--ShareiOS:before{content:\"\\EF79\"}.ms-Icon--SharepointLogo:before{content:\"\\F27E\"}.ms-Icon--SharepointLogoFill:before{content:\"\\F27F\"}.ms-Icon--SharepointLogoInverse:before{content:\"\\ED18\"}.ms-Icon--Shield:before{content:\"\\EA18\"}.ms-Icon--ShieldSolid:before{content:\"\\F340\"}.ms-Icon--Shop:before{content:\"\\E719\"}.ms-Icon--ShoppingCart:before{content:\"\\E7BF\"}.ms-Icon--ShoppingCartSolid:before{content:\"\\F342\"}.ms-Icon--ShopServer:before{content:\"\\F2B6\"}[dir=ltr] .ms-Icon--ShowResults:before{content:\"\\E8BC\"}[dir=ltr] .ms-Icon--ShowResultsMirrored:before,[dir=rtl] .ms-Icon--ShowResults:before{content:\"\\EA65\"}[dir=rtl] .ms-Icon--ShowResultsMirrored:before{content:\"\\E8BC\"}[dir=ltr] .ms-Icon--SidePanel:before{content:\"\\EF52\"}[dir=ltr] .ms-Icon--SidePanelMirrored:before,[dir=rtl] .ms-Icon--SidePanel:before{content:\"\\F221\"}[dir=rtl] .ms-Icon--SidePanelMirrored:before{content:\"\\EF52\"}.ms-Icon--SignOut:before{content:\"\\F3B1\"}.ms-Icon--SingleBookmark:before{content:\"\\EDFF\"}.ms-Icon--SingleBookmarkSolid:before{content:\"\\EE00\"}.ms-Icon--SingleColumn:before{content:\"\\F1D3\"}.ms-Icon--SingleColumnEdit:before{content:\"\\F321\"}.ms-Icon--SIPMove:before{content:\"\\E759\"}.ms-Icon--SiteScan:before{content:\"\\EBEC\"}.ms-Icon--SizeLegacy:before{content:\"\\E2B2\"}.ms-Icon--SkiResorts:before{content:\"\\EB45\"}.ms-Icon--SkypeCheck:before{content:\"\\EF80\"}.ms-Icon--SkypeCircleCheck:before{content:\"\\EF7D\"}.ms-Icon--SkypeCircleClock:before{content:\"\\EF7E\"}.ms-Icon--SkypeCircleMinus:before{content:\"\\EF7F\"}.ms-Icon--SkypeClock:before{content:\"\\EF81\"}.ms-Icon--SkypeForBusinessLogo:before{content:\"\\F0FC\"}.ms-Icon--SkypeForBusinessLogo16:before{content:\"\\F40F\"}.ms-Icon--SkypeForBusinessLogoFill:before{content:\"\\F27D\"}.ms-Icon--SkypeForBusinessLogoFill16:before{content:\"\\F410\"}.ms-Icon--SkypeLogo:before{content:\"\\EB6F\"}.ms-Icon--SkypeLogo16:before{content:\"\\F40E\"}.ms-Icon--SkypeMessage:before{content:\"\\EF83\"}.ms-Icon--SkypeMinus:before{content:\"\\EF82\"}.ms-Icon--Slider:before{content:\"\\F527\"}.ms-Icon--SliderHandleSize:before{content:\"\\F528\"}.ms-Icon--SliderThumb:before{content:\"\\EC13\"}.ms-Icon--Snooze:before{content:\"\\F4BD\"}.ms-Icon--Snow:before{content:\"\\E9C8\"}.ms-Icon--Snowflake:before{content:\"\\EB46\"}.ms-Icon--SnowShowerDay:before{content:\"\\E9FD\"}.ms-Icon--SnowShowerNight:before{content:\"\\EA11\"}.ms-Icon--Soccer:before{content:\"\\EB21\"}.ms-Icon--SocialListeningLogo:before{content:\"\\ED7C\"}.ms-Icon--Sort:before{content:\"\\E8CB\"}.ms-Icon--SortDown:before{content:\"\\EE69\"}.ms-Icon--SortLines:before{content:\"\\E9D0\"}.ms-Icon--SortUp:before{content:\"\\EE68\"}.ms-Icon--Source:before{content:\"\\EB1B\"}.ms-Icon--Spacer:before{content:\"\\F40D\"}.ms-Icon--Speakers:before{content:\"\\E7F5\"}.ms-Icon--SpeedHigh:before{content:\"\\EC4A\"}.ms-Icon--Split:before{content:\"\\EDBC\"}.ms-Icon--SplitObject:before{content:\"\\F547\"}.ms-Icon--Sprint:before{content:\"\\F3B0\"}.ms-Icon--Squalls:before{content:\"\\E9CC\"}.ms-Icon--SquareShapeSolid:before{content:\"\\F63D\"}.ms-Icon--Stack:before{content:\"\\F26F\"}.ms-Icon--StackedBarChart:before{content:\"\\F24D\"}.ms-Icon--StackedLineChart:before{content:\"\\F24E\"}.ms-Icon--StackIndicator:before{content:\"\\E7FF\"}.ms-Icon--StaffNotebookLogo16:before{content:\"\\F48E\"}.ms-Icon--StaffNotebookLogo32:before{content:\"\\F48C\"}.ms-Icon--StaffNotebookLogoFill16:before{content:\"\\F48F\"}.ms-Icon--StaffNotebookLogoFill32:before{content:\"\\F48D\"}.ms-Icon--StaffNotebookLogoInverted16:before{content:\"\\F491\"}.ms-Icon--StaffNotebookLogoInverted32:before{content:\"\\F490\"}.ms-Icon--Starburst:before{content:\"\\EF78\"}.ms-Icon--StarburstSolid:before{content:\"\\F33C\"}.ms-Icon--StatusCircleBlock2:before{content:\"\\F141\"}.ms-Icon--StatusCircleCheckmark:before{content:\"\\F13E\"}.ms-Icon--StatusCircleErrorX:before{content:\"\\F13D\"}.ms-Icon--StatusCircleExclamation:before{content:\"\\F13C\"}.ms-Icon--StatusCircleInfo:before{content:\"\\F13F\"}.ms-Icon--StatusCircleInner:before{content:\"\\F137\"}.ms-Icon--StatusCircleOuter:before{content:\"\\F136\"}.ms-Icon--StatusCircleQuestionMark:before{content:\"\\F142\"}.ms-Icon--StatusCircleRing:before{content:\"\\F138\"}.ms-Icon--StatusErrorFull:before{content:\"\\EB90\"}.ms-Icon--StatusTriangle:before{content:\"\\EA82\"}.ms-Icon--StatusTriangleExclamation:before{content:\"\\F13B\"}.ms-Icon--StatusTriangleInner:before{content:\"\\F13A\"}.ms-Icon--StatusTriangleOuter:before{content:\"\\F139\"}.ms-Icon--Step:before{content:\"\\F241\"}.ms-Icon--StepInsert:before{content:\"\\F242\"}.ms-Icon--StepShared:before{content:\"\\F243\"}.ms-Icon--StepSharedAdd:before{content:\"\\F244\"}.ms-Icon--StepSharedInsert:before{content:\"\\F245\"}.ms-Icon--StockDown:before{content:\"\\EB0F\"}.ms-Icon--StockUp:before{content:\"\\EB11\"}.ms-Icon--Stop:before{content:\"\\E71A\"}.ms-Icon--StopSolid:before{content:\"\\EE95\"}.ms-Icon--Stopwatch:before{content:\"\\E916\"}.ms-Icon--StoreLogo16:before{content:\"\\EA96\"}.ms-Icon--StoreLogoMed20:before{content:\"\\EA04\"}.ms-Icon--Storyboard:before{content:\"\\F308\"}.ms-Icon--Streaming:before{content:\"\\E93E\"}.ms-Icon--StreamingOff:before{content:\"\\F2BB\"}.ms-Icon--StreamLogo:before{content:\"\\F329\"}.ms-Icon--Strikethrough:before{content:\"\\EDE0\"}.ms-Icon--Subscribe:before{content:\"\\EDA1\"}.ms-Icon--Subscript:before{content:\"\\EDDF\"}.ms-Icon--SubstitutionsIn:before{content:\"\\EB31\"}.ms-Icon--Suitcase:before{content:\"\\EDD3\"}.ms-Icon--SunAdd:before{content:\"\\EF69\"}.ms-Icon--Sunny:before{content:\"\\E9BD\"}.ms-Icon--SunQuestionMark:before{content:\"\\EF6A\"}.ms-Icon--Superscript:before{content:\"\\EDDE\"}.ms-Icon--SurveyQuestions:before{content:\"\\F01B\"}.ms-Icon--SwayLogo16:before{content:\"\\F484\"}.ms-Icon--SwayLogo32:before{content:\"\\F482\"}.ms-Icon--SwayLogoFill16:before{content:\"\\F485\"}.ms-Icon--SwayLogoFill32:before{content:\"\\F483\"}.ms-Icon--SwayLogoInverse:before{content:\"\\ED29\"}.ms-Icon--Switch:before{content:\"\\E8AB\"}.ms-Icon--SwitcherStartEnd:before{content:\"\\E810\"}.ms-Icon--Sync:before{content:\"\\E895\"}.ms-Icon--SyncFolder:before{content:\"\\E8F7\"}.ms-Icon--SyncOccurence:before{content:\"\\F4A3\"}.ms-Icon--SyncToPC:before{content:\"\\EE6E\"}.ms-Icon--System:before{content:\"\\E770\"}.ms-Icon--Tab:before{content:\"\\E7E9\"}.ms-Icon--Table:before{content:\"\\ED86\"}.ms-Icon--Tablet:before{content:\"\\E70A\"}.ms-Icon--TabletMode:before{content:\"\\EBFC\"}.ms-Icon--TabletSelected:before{content:\"\\EC74\"}.ms-Icon--Tag:before{content:\"\\E8EC\"}.ms-Icon--Taskboard:before{content:\"\\F1C2\"}[dir=ltr] .ms-Icon--TaskGroup:before{content:\"\\F2AE\"}[dir=ltr] .ms-Icon--TaskGroupMirrored:before,[dir=rtl] .ms-Icon--TaskGroup:before{content:\"\\F2AF\"}[dir=rtl] .ms-Icon--TaskGroupMirrored:before{content:\"\\F2AE\"}.ms-Icon--TaskLogo:before{content:\"\\F493\"}[dir=ltr] .ms-Icon--TaskManager:before{content:\"\\EDB7\"}[dir=ltr] .ms-Icon--TaskManagerMirrored:before,[dir=rtl] .ms-Icon--TaskManager:before{content:\"\\EDB8\"}[dir=rtl] .ms-Icon--TaskManagerMirrored:before{content:\"\\EDB7\"}.ms-Icon--TaskSolid:before{content:\"\\F333\"}.ms-Icon--Taxi:before{content:\"\\F4A1\"}.ms-Icon--TeamFavorite:before{content:\"\\F2AD\"}.ms-Icon--TeamsLogo:before{content:\"\\F27B\"}.ms-Icon--TeamsLogoFill:before{content:\"\\F27C\"}.ms-Icon--TeamsLogoInverse:before{content:\"\\F27A\"}.ms-Icon--Teamwork:before{content:\"\\EA12\"}.ms-Icon--Teeth:before{content:\"\\F4A0\"}.ms-Icon--TemporaryUser:before{content:\"\\EE58\"}.ms-Icon--Tennis:before{content:\"\\EB33\"}.ms-Icon--TestAutoSolid:before{content:\"\\F3A8\"}.ms-Icon--TestBeaker:before{content:\"\\F3A5\"}.ms-Icon--TestBeakerSolid:before{content:\"\\F3A6\"}.ms-Icon--TestCase:before{content:\"\\F3AF\"}.ms-Icon--TestExploreSolid:before{content:\"\\F3A7\"}.ms-Icon--TestImpactSolid:before{content:\"\\F3AA\"}.ms-Icon--TestParameter:before{content:\"\\F3AD\"}.ms-Icon--TestPlan:before{content:\"\\F3AB\"}.ms-Icon--TestStep:before{content:\"\\F3AC\"}.ms-Icon--TestSuite:before{content:\"\\F3AE\"}.ms-Icon--TestUserSolid:before{content:\"\\F3A9\"}.ms-Icon--TextBox:before{content:\"\\EDC2\"}.ms-Icon--TextCallout:before{content:\"\\F2A2\"}.ms-Icon--TextDocument:before{content:\"\\F029\"}.ms-Icon--TextDocumentShared:before{content:\"\\F02B\"}.ms-Icon--TextField:before{content:\"\\EDC3\"}.ms-Icon--TextOverflow:before{content:\"\\F51F\"}.ms-Icon--TFVCLogo:before{content:\"\\F44D\"}.ms-Icon--ThisPC:before{content:\"\\EC4E\"}.ms-Icon--ThreeQuarterCircle:before{content:\"\\F503\"}[dir=ltr] .ms-Icon--ThumbnailView:before{content:\"\\E7B6\"}[dir=ltr] .ms-Icon--ThumbnailViewMirrored:before,[dir=rtl] .ms-Icon--ThumbnailView:before{content:\"\\EA67\"}[dir=rtl] .ms-Icon--ThumbnailViewMirrored:before{content:\"\\E7B6\"}.ms-Icon--Thunderstorms:before{content:\"\\E9C6\"}.ms-Icon--Ticket:before{content:\"\\EB54\"}.ms-Icon--Tiles:before{content:\"\\ECA5\"}.ms-Icon--Tiles2:before{content:\"\\EF7C\"}.ms-Icon--TimeEntry:before{content:\"\\EF95\"}.ms-Icon--Timeline:before{content:\"\\ED9C\"}.ms-Icon--TimelineDelivery:before{content:\"\\F2AB\"}.ms-Icon--TimelineMatrixView:before{content:\"\\F361\"}.ms-Icon--TimelineProgress:before{content:\"\\F2AA\"}.ms-Icon--Timer:before{content:\"\\E91E\"}.ms-Icon--TimeSheet:before{content:\"\\EA05\"}.ms-Icon--ToDoLogoBottom:before{content:\"\\F4B3\"}.ms-Icon--ToDoLogoInverse:before{content:\"\\F4BC\"}.ms-Icon--ToDoLogoTop:before{content:\"\\F4B4\"}.ms-Icon--ToggleBorder:before{content:\"\\EC12\"}.ms-Icon--ToggleFilled:before{content:\"\\EC11\"}.ms-Icon--ToggleOff:before{content:\"\\F19F\"}.ms-Icon--ToggleThumb:before{content:\"\\EC14\"}.ms-Icon--Toll:before{content:\"\\F160\"}.ms-Icon--Touch:before{content:\"\\E815\"}.ms-Icon--TouchPointer:before{content:\"\\E7C9\"}[dir=ltr] .ms-Icon--Trackers:before{content:\"\\EADF\"}[dir=ltr] .ms-Icon--TrackersMirrored:before,[dir=rtl] .ms-Icon--Trackers:before{content:\"\\EE92\"}[dir=rtl] .ms-Icon--TrackersMirrored:before{content:\"\\EADF\"}.ms-Icon--Train:before{content:\"\\E7C0\"}.ms-Icon--TrainSolid:before{content:\"\\EB4D\"}.ms-Icon--TransferCall:before{content:\"\\ED95\"}.ms-Icon--Transition:before{content:\"\\F3BC\"}.ms-Icon--TransitionEffect:before{content:\"\\F5B4\"}.ms-Icon--TransitionPop:before{content:\"\\F5B2\"}.ms-Icon--TransitionPush:before{content:\"\\F5B3\"}.ms-Icon--Trending12:before{content:\"\\F62D\"}.ms-Icon--TriangleDown12:before{content:\"\\EED1\"}.ms-Icon--TriangleLeft12:before{content:\"\\EED2\"}.ms-Icon--TriangleRight12:before{content:\"\\EED3\"}.ms-Icon--TriangleShapeSolid:before{content:\"\\F63E\"}.ms-Icon--TriangleSolid:before{content:\"\\EA08\"}.ms-Icon--TriangleSolidDown12:before{content:\"\\EECD\"}.ms-Icon--TriangleSolidLeft12:before{content:\"\\EECE\"}.ms-Icon--TriangleSolidRight12:before{content:\"\\EECF\"}.ms-Icon--TriangleSolidUp12:before{content:\"\\EECC\"}.ms-Icon--TriangleUp12:before{content:\"\\EED0\"}.ms-Icon--TriggerApproval:before{content:\"\\F3B2\"}.ms-Icon--TriggerAuto:before{content:\"\\F24A\"}.ms-Icon--TriggerUser:before{content:\"\\F24B\"}.ms-Icon--TripleColumn:before{content:\"\\F1D5\"}.ms-Icon--TripleColumnEdit:before{content:\"\\F323\"}.ms-Icon--Trophy:before{content:\"\\ED3F\"}.ms-Icon--Trophy2:before{content:\"\\F1AE\"}.ms-Icon--Trophy2Solid:before{content:\"\\F337\"}.ms-Icon--TurnRight:before{content:\"\\E7DB\"}.ms-Icon--TVMonitor:before{content:\"\\E7F4\"}.ms-Icon--TVMonitorSelected:before{content:\"\\EC77\"}.ms-Icon--TypeScriptLanguage:before{content:\"\\F2F7\"}.ms-Icon--Umbrella:before{content:\"\\EC04\"}.ms-Icon--Underline:before{content:\"\\E8DC\"}.ms-Icon--Undo:before{content:\"\\E7A7\"}[dir=ltr] .ms-Icon--Uneditable:before{content:\"\\ED1D\"}[dir=ltr] .ms-Icon--UneditableMirrored:before,[dir=rtl] .ms-Icon--Uneditable:before{content:\"\\F4B9\"}[dir=rtl] .ms-Icon--UneditableMirrored:before{content:\"\\ED1D\"}[dir=ltr] .ms-Icon--UneditableSolid12:before{content:\"\\F4B7\"}[dir=ltr] .ms-Icon--UneditableSolidMirrored12:before,[dir=rtl] .ms-Icon--UneditableSolid12:before{content:\"\\F4B8\"}[dir=rtl] .ms-Icon--UneditableSolidMirrored12:before{content:\"\\F4B7\"}.ms-Icon--Unfavorite:before{content:\"\\E8D9\"}.ms-Icon--UngroupObject:before{content:\"\\F4F2\"}.ms-Icon--UnknownCall:before{content:\"\\ED97\"}[dir=ltr] .ms-Icon--Unknown:before{content:\"\\E9CE\"}[dir=ltr] .ms-Icon--UnknownMirrored:before,[dir=rtl] .ms-Icon--Unknown:before{content:\"\\F22E\"}[dir=rtl] .ms-Icon--UnknownMirrored:before{content:\"\\E9CE\"}[dir=ltr] .ms-Icon--UnknownSolid:before{content:\"\\F2E1\"}[dir=ltr] .ms-Icon--UnknownMirroredSolid:before,[dir=rtl] .ms-Icon--UnknownSolid:before{content:\"\\F2E2\"}[dir=rtl] .ms-Icon--UnknownMirroredSolid:before{content:\"\\F2E1\"}.ms-Icon--Unlock:before{content:\"\\E785\"}.ms-Icon--UnlockSolid:before{content:\"\\F304\"}.ms-Icon--Unpin:before{content:\"\\E77A\"}.ms-Icon--Unsubscribe:before{content:\"\\EDA0\"}.ms-Icon--UnsyncFolder:before{content:\"\\E8F6\"}.ms-Icon--UnsyncOccurence:before{content:\"\\F4A4\"}.ms-Icon--Up:before{content:\"\\E74A\"}.ms-Icon--Upload:before{content:\"\\E898\"}.ms-Icon--UserEvent:before{content:\"\\F69C\"}.ms-Icon--UserFollowed:before{content:\"\\F25C\"}.ms-Icon--UserPause:before{content:\"\\F2BA\"}.ms-Icon--UserRemove:before{content:\"\\F69B\"}.ms-Icon--UserSync:before{content:\"\\F2B9\"}.ms-Icon--Vacation:before{content:\"\\F49F\"}.ms-Icon--Variable:before{content:\"\\F305\"}.ms-Icon--VariableGroup:before{content:\"\\F31B\"}.ms-Icon--VB:before{content:\"\\F2F2\"}.ms-Icon--VennDiagram:before{content:\"\\F273\"}.ms-Icon--VersionControlPush:before{content:\"\\F664\"}.ms-Icon--VerticalDistributeCenter:before{content:\"\\F4FA\"}.ms-Icon--Video:before{content:\"\\E714\"}.ms-Icon--VideoOff:before{content:\"\\F4B0\"}.ms-Icon--VideoSearch:before{content:\"\\F4EA\"}.ms-Icon--VideoSolid:before{content:\"\\EA0C\"}.ms-Icon--View:before{content:\"\\E890\"}.ms-Icon--ViewAll:before{content:\"\\E8A9\"}.ms-Icon--ViewAll2:before{content:\"\\EF56\"}.ms-Icon--ViewDashboard:before{content:\"\\F246\"}.ms-Icon--ViewList:before{content:\"\\F247\"}.ms-Icon--ViewListGroup:before{content:\"\\F248\"}.ms-Icon--ViewListTree:before{content:\"\\F249\"}.ms-Icon--VisioDiagram:before{content:\"\\F2A0\"}.ms-Icon--VisioDocument:before{content:\"\\F2A9\"}.ms-Icon--VisioLogo:before{content:\"\\F2A7\"}.ms-Icon--VisioLogo16:before{content:\"\\F3A3\"}.ms-Icon--VisioLogoFill:before{content:\"\\F2A8\"}.ms-Icon--VisioLogoFill16:before{content:\"\\F3A4\"}.ms-Icon--VisioLogoInverse:before{content:\"\\ED7D\"}.ms-Icon--VisioLogoInverse16:before{content:\"\\F3A2\"}.ms-Icon--VisualBasicLanguage:before{content:\"\\F2F1\"}.ms-Icon--VisualsFolder:before{content:\"\\F520\"}.ms-Icon--VisualsStore:before{content:\"\\F521\"}.ms-Icon--VisualStudioIDELogo32:before{content:\"\\F5D0\"}.ms-Icon--VisualStudioLogo:before{content:\"\\EC22\"}.ms-Icon--VoicemailForward:before{content:\"\\ED87\"}.ms-Icon--VoicemailIRM:before{content:\"\\F421\"}.ms-Icon--VoicemailReply:before{content:\"\\ED88\"}.ms-Icon--Volume0:before{content:\"\\E992\"}.ms-Icon--Volume1:before{content:\"\\E993\"}.ms-Icon--Volume2:before{content:\"\\E994\"}.ms-Icon--Volume3:before{content:\"\\E995\"}.ms-Icon--VolumeDisabled:before{content:\"\\EA85\"}.ms-Icon--VSTSAltLogo1:before{content:\"\\F382\"}.ms-Icon--VSTSAltLogo2:before{content:\"\\F383\"}.ms-Icon--VSTSLogo:before{content:\"\\F381\"}.ms-Icon--Waffle:before{content:\"\\ED89\"}.ms-Icon--WaffleOffice365:before{content:\"\\F4E0\"}[dir=ltr] .ms-Icon--WaitlistConfirm:before{content:\"\\F550\"}[dir=ltr] .ms-Icon--WaitlistConfirmMirrored:before,[dir=rtl] .ms-Icon--WaitlistConfirm:before{content:\"\\F551\"}[dir=rtl] .ms-Icon--WaitlistConfirmMirrored:before{content:\"\\F550\"}.ms-Icon--Warning:before{content:\"\\E7BA\"}.ms-Icon--Warning12:before{content:\"\\F62F\"}.ms-Icon--WebPublish:before{content:\"\\F52F\"}.ms-Icon--Website:before{content:\"\\EB41\"}.ms-Icon--Weights:before{content:\"\\EADB\"}.ms-Icon--WhiteBoardApp16:before{content:\"\\F673\"}.ms-Icon--WhiteBoardApp32:before{content:\"\\F674\"}.ms-Icon--WifiEthernet:before{content:\"\\EE77\"}.ms-Icon--WindDirection:before{content:\"\\EBE6\"}.ms-Icon--WindowEdit:before{content:\"\\F50E\"}.ms-Icon--WindowsLogo:before{content:\"\\E782\"}.ms-Icon--Wines:before{content:\"\\EABF\"}.ms-Icon--WipePhone:before{content:\"\\ED8D\"}.ms-Icon--WordDocument:before{content:\"\\EF71\"}.ms-Icon--WordLogo:before{content:\"\\F1E3\"}.ms-Icon--WordLogo16:before{content:\"\\F391\"}.ms-Icon--WordLogoFill:before{content:\"\\F1E4\"}.ms-Icon--WordLogoFill16:before{content:\"\\F392\"}.ms-Icon--WordLogoInverse:before{content:\"\\EC29\"}.ms-Icon--WordLogoInverse16:before{content:\"\\F390\"}.ms-Icon--Work:before{content:\"\\E821\"}.ms-Icon--WorkFlow:before{content:\"\\EA01\"}.ms-Icon--WorkforceManagement:before{content:\"\\EE0F\"}.ms-Icon--WorkItem:before{content:\"\\F314\"}.ms-Icon--WorkItemBar:before{content:\"\\F35C\"}.ms-Icon--WorkItemBarSolid:before{content:\"\\F35D\"}.ms-Icon--WorkItemBug:before{content:\"\\F315\"}.ms-Icon--World:before{content:\"\\E909\"}.ms-Icon--WorldClock:before{content:\"\\E918\"}.ms-Icon--YammerLogo:before{content:\"\\ED19\"}.ms-Icon--ZipFolder:before{content:\"\\F012\"}.ms-Icon--Zoom:before{content:\"\\E71E\"}.ms-Icon--ZoomIn:before{content:\"\\E8A3\"}.ms-Icon--ZoomOut:before{content:\"\\E71F\"}.ms-Icon--HumanResources:before{content:\"\\F240\"}.ms-Icon--StoreLogo:before{content:\"\\EA96\"}.ms-Icon--StoreLogoMed:before{content:\"\\EA04\"}@media (max-width:479px){.ms-hiddenLgDown,.ms-hiddenMdDown,.ms-hiddenSm,.ms-hiddenXlDown,.ms-hiddenXxlDown{display:none!important}}@media (min-width:480px) and (max-width:639px){.ms-hiddenLgDown,.ms-hiddenMd,.ms-hiddenMdDown,.ms-hiddenMdUp,.ms-hiddenXlDown,.ms-hiddenXxlDown{display:none!important}}@media (min-width:640px) and (max-width:1023px){.ms-hiddenLg,.ms-hiddenLgDown,.ms-hiddenLgUp,.ms-hiddenMdUp,.ms-hiddenXlDown,.ms-hiddenXxlDown{display:none!important}}@media (min-width:1024px) and (max-width:1365px){.ms-hiddenLgUp,.ms-hiddenMdUp,.ms-hiddenXl,.ms-hiddenXlDown,.ms-hiddenXlUp,.ms-hiddenXxlDown{display:none!important}}@media (min-width:1366px) and (max-width:1919px){.ms-hiddenLgUp,.ms-hiddenMdUp,.ms-hiddenXlUp,.ms-hiddenXxl,.ms-hiddenXxlDown,.ms-hiddenXxlUp{display:none!important}}@media (min-width:1920px){.ms-hiddenLgUp,.ms-hiddenMdUp,.ms-hiddenXlUp,.ms-hiddenXxlUp,.ms-hiddenXxxl{display:none!important}}.ms-sm12{width:100%}.ms-sm11{width:91.66666666666666%}.ms-sm10{width:83.33333333333334%}.ms-sm9{width:75%}.ms-sm8{width:66.66666666666666%}.ms-sm7{width:58.333333333333336%}.ms-sm6{width:50%}.ms-sm5{width:41.66666666666667%}.ms-sm4{width:33.33333333333333%}.ms-sm3{width:25%}.ms-sm2{width:16.666666666666664%}.ms-sm1{width:8.333333333333332%}[dir=ltr] .ms-smPull12{right:100%}[dir=rtl] .ms-smPull12{left:100%}[dir=ltr] .ms-smPull11{right:91.66667%}[dir=rtl] .ms-smPull11{left:91.66667%}[dir=ltr] .ms-smPull10{right:83.33333%}[dir=rtl] .ms-smPull10{left:83.33333%}[dir=ltr] .ms-smPull9{right:75%}[dir=rtl] .ms-smPull9{left:75%}[dir=ltr] .ms-smPull8{right:66.66667%}[dir=rtl] .ms-smPull8{left:66.66667%}[dir=ltr] .ms-smPull7{right:58.33333%}[dir=rtl] .ms-smPull7{left:58.33333%}[dir=ltr] .ms-smPull6{right:50%}[dir=rtl] .ms-smPull6{left:50%}[dir=ltr] .ms-smPull5{right:41.66667%}[dir=rtl] .ms-smPull5{left:41.66667%}[dir=ltr] .ms-smPull4{right:33.33333%}[dir=rtl] .ms-smPull4{left:33.33333%}[dir=ltr] .ms-smPull3{right:25%}[dir=rtl] .ms-smPull3{left:25%}[dir=ltr] .ms-smPull2{right:16.66667%}[dir=rtl] .ms-smPull2{left:16.66667%}[dir=ltr] .ms-smPull1{right:8.33333%}[dir=rtl] .ms-smPull1{left:8.33333%}[dir=ltr] .ms-smPull0{right:auto}[dir=rtl] .ms-smPull0{left:auto}[dir=ltr] .ms-smPush12{left:100%}[dir=rtl] .ms-smPush12{right:100%}[dir=ltr] .ms-smPush11{left:91.66667%}[dir=rtl] .ms-smPush11{right:91.66667%}[dir=ltr] .ms-smPush10{left:83.33333%}[dir=rtl] .ms-smPush10{right:83.33333%}[dir=ltr] .ms-smPush9{left:75%}[dir=rtl] .ms-smPush9{right:75%}[dir=ltr] .ms-smPush8{left:66.66667%}[dir=rtl] .ms-smPush8{right:66.66667%}[dir=ltr] .ms-smPush7{left:58.33333%}[dir=rtl] .ms-smPush7{right:58.33333%}[dir=ltr] .ms-smPush6{left:50%}[dir=rtl] .ms-smPush6{right:50%}[dir=ltr] .ms-smPush5{left:41.66667%}[dir=rtl] .ms-smPush5{right:41.66667%}[dir=ltr] .ms-smPush4{left:33.33333%}[dir=rtl] .ms-smPush4{right:33.33333%}[dir=ltr] .ms-smPush3{left:25%}[dir=rtl] .ms-smPush3{right:25%}[dir=ltr] .ms-smPush2{left:16.66667%}[dir=rtl] .ms-smPush2{right:16.66667%}[dir=ltr] .ms-smPush1{left:8.33333%}[dir=rtl] .ms-smPush1{right:8.33333%}[dir=ltr] .ms-smPush0{left:auto}[dir=rtl] .ms-smPush0{right:auto}[dir=ltr] .ms-smOffset11{margin-left:91.66667%}[dir=rtl] .ms-smOffset11{margin-right:91.66667%}[dir=ltr] .ms-smOffset10{margin-left:83.33333%}[dir=rtl] .ms-smOffset10{margin-right:83.33333%}[dir=ltr] .ms-smOffset9{margin-left:75%}[dir=rtl] .ms-smOffset9{margin-right:75%}[dir=ltr] .ms-smOffset8{margin-left:66.66667%}[dir=rtl] .ms-smOffset8{margin-right:66.66667%}[dir=ltr] .ms-smOffset7{margin-left:58.33333%}[dir=rtl] .ms-smOffset7{margin-right:58.33333%}[dir=ltr] .ms-smOffset6{margin-left:50%}[dir=rtl] .ms-smOffset6{margin-right:50%}[dir=ltr] .ms-smOffset5{margin-left:41.66667%}[dir=rtl] .ms-smOffset5{margin-right:41.66667%}[dir=ltr] .ms-smOffset4{margin-left:33.33333%}[dir=rtl] .ms-smOffset4{margin-right:33.33333%}[dir=ltr] .ms-smOffset3{margin-left:25%}[dir=rtl] .ms-smOffset3{margin-right:25%}[dir=ltr] .ms-smOffset2{margin-left:16.66667%}[dir=rtl] .ms-smOffset2{margin-right:16.66667%}[dir=ltr] .ms-smOffset1{margin-left:8.33333%}[dir=rtl] .ms-smOffset1{margin-right:8.33333%}[dir=ltr] .ms-smOffset0{margin-left:0}[dir=rtl] .ms-smOffset0{margin-right:0}@media (min-width:480px){.ms-md12{width:100%}}@media (min-width:480px){.ms-md11{width:91.66666666666666%}}@media (min-width:480px){.ms-md10{width:83.33333333333334%}}@media (min-width:480px){.ms-md9{width:75%}}@media (min-width:480px){.ms-md8{width:66.66666666666666%}}@media (min-width:480px){.ms-md7{width:58.333333333333336%}}@media (min-width:480px){.ms-md6{width:50%}}@media (min-width:480px){.ms-md5{width:41.66666666666667%}}@media (min-width:480px){.ms-md4{width:33.33333333333333%}}@media (min-width:480px){.ms-md3{width:25%}}@media (min-width:480px){.ms-md2{width:16.666666666666664%}}@media (min-width:480px){.ms-md1{width:8.333333333333332%}}@media (min-width:480px){[dir=ltr] .ms-mdPull12{right:100%}[dir=rtl] .ms-mdPull12{left:100%}}@media (min-width:480px){[dir=ltr] .ms-mdPull11{right:91.66667%}[dir=rtl] .ms-mdPull11{left:91.66667%}}@media (min-width:480px){[dir=ltr] .ms-mdPull10{right:83.33333%}[dir=rtl] .ms-mdPull10{left:83.33333%}}@media (min-width:480px){[dir=ltr] .ms-mdPull9{right:75%}[dir=rtl] .ms-mdPull9{left:75%}}@media (min-width:480px){[dir=ltr] .ms-mdPull8{right:66.66667%}[dir=rtl] .ms-mdPull8{left:66.66667%}}@media (min-width:480px){[dir=ltr] .ms-mdPull7{right:58.33333%}[dir=rtl] .ms-mdPull7{left:58.33333%}}@media (min-width:480px){[dir=ltr] .ms-mdPull6{right:50%}[dir=rtl] .ms-mdPull6{left:50%}}@media (min-width:480px){[dir=ltr] .ms-mdPull5{right:41.66667%}[dir=rtl] .ms-mdPull5{left:41.66667%}}@media (min-width:480px){[dir=ltr] .ms-mdPull4{right:33.33333%}[dir=rtl] .ms-mdPull4{left:33.33333%}}@media (min-width:480px){[dir=ltr] .ms-mdPull3{right:25%}[dir=rtl] .ms-mdPull3{left:25%}}@media (min-width:480px){[dir=ltr] .ms-mdPull2{right:16.66667%}[dir=rtl] .ms-mdPull2{left:16.66667%}}@media (min-width:480px){[dir=ltr] .ms-mdPull1{right:8.33333%}[dir=rtl] .ms-mdPull1{left:8.33333%}}@media (min-width:480px){[dir=ltr] .ms-mdPull0{right:auto}[dir=rtl] .ms-mdPull0{left:auto}}@media (min-width:480px){[dir=ltr] .ms-mdPush12{left:100%}[dir=rtl] .ms-mdPush12{right:100%}}@media (min-width:480px){[dir=ltr] .ms-mdPush11{left:91.66667%}[dir=rtl] .ms-mdPush11{right:91.66667%}}@media (min-width:480px){[dir=ltr] .ms-mdPush10{left:83.33333%}[dir=rtl] .ms-mdPush10{right:83.33333%}}@media (min-width:480px){[dir=ltr] .ms-mdPush9{left:75%}[dir=rtl] .ms-mdPush9{right:75%}}@media (min-width:480px){[dir=ltr] .ms-mdPush8{left:66.66667%}[dir=rtl] .ms-mdPush8{right:66.66667%}}@media (min-width:480px){[dir=ltr] .ms-mdPush7{left:58.33333%}[dir=rtl] .ms-mdPush7{right:58.33333%}}@media (min-width:480px){[dir=ltr] .ms-mdPush6{left:50%}[dir=rtl] .ms-mdPush6{right:50%}}@media (min-width:480px){[dir=ltr] .ms-mdPush5{left:41.66667%}[dir=rtl] .ms-mdPush5{right:41.66667%}}@media (min-width:480px){[dir=ltr] .ms-mdPush4{left:33.33333%}[dir=rtl] .ms-mdPush4{right:33.33333%}}@media (min-width:480px){[dir=ltr] .ms-mdPush3{left:25%}[dir=rtl] .ms-mdPush3{right:25%}}@media (min-width:480px){[dir=ltr] .ms-mdPush2{left:16.66667%}[dir=rtl] .ms-mdPush2{right:16.66667%}}@media (min-width:480px){[dir=ltr] .ms-mdPush1{left:8.33333%}[dir=rtl] .ms-mdPush1{right:8.33333%}}@media (min-width:480px){[dir=ltr] .ms-mdPush0{left:auto}[dir=rtl] .ms-mdPush0{right:auto}}@media (min-width:480px){[dir=ltr] .ms-mdOffset11{margin-left:91.66667%}[dir=rtl] .ms-mdOffset11{margin-right:91.66667%}}@media (min-width:480px){[dir=ltr] .ms-mdOffset10{margin-left:83.33333%}[dir=rtl] .ms-mdOffset10{margin-right:83.33333%}}@media (min-width:480px){[dir=ltr] .ms-mdOffset9{margin-left:75%}[dir=rtl] .ms-mdOffset9{margin-right:75%}}@media (min-width:480px){[dir=ltr] .ms-mdOffset8{margin-left:66.66667%}[dir=rtl] .ms-mdOffset8{margin-right:66.66667%}}@media (min-width:480px){[dir=ltr] .ms-mdOffset7{margin-left:58.33333%}[dir=rtl] .ms-mdOffset7{margin-right:58.33333%}}@media (min-width:480px){[dir=ltr] .ms-mdOffset6{margin-left:50%}[dir=rtl] .ms-mdOffset6{margin-right:50%}}@media (min-width:480px){[dir=ltr] .ms-mdOffset5{margin-left:41.66667%}[dir=rtl] .ms-mdOffset5{margin-right:41.66667%}}@media (min-width:480px){[dir=ltr] .ms-mdOffset4{margin-left:33.33333%}[dir=rtl] .ms-mdOffset4{margin-right:33.33333%}}@media (min-width:480px){[dir=ltr] .ms-mdOffset3{margin-left:25%}[dir=rtl] .ms-mdOffset3{margin-right:25%}}@media (min-width:480px){[dir=ltr] .ms-mdOffset2{margin-left:16.66667%}[dir=rtl] .ms-mdOffset2{margin-right:16.66667%}}@media (min-width:480px){[dir=ltr] .ms-mdOffset1{margin-left:8.33333%}[dir=rtl] .ms-mdOffset1{margin-right:8.33333%}}@media (min-width:480px){[dir=ltr] .ms-mdOffset0{margin-left:0}[dir=rtl] .ms-mdOffset0{margin-right:0}}@media (min-width:640px){.ms-lg12{width:100%}}@media (min-width:640px){.ms-lg11{width:91.66666666666666%}}@media (min-width:640px){.ms-lg10{width:83.33333333333334%}}@media (min-width:640px){.ms-lg9{width:75%}}@media (min-width:640px){.ms-lg8{width:66.66666666666666%}}@media (min-width:640px){.ms-lg7{width:58.333333333333336%}}@media (min-width:640px){.ms-lg6{width:50%}}@media (min-width:640px){.ms-lg5{width:41.66666666666667%}}@media (min-width:640px){.ms-lg4{width:33.33333333333333%}}@media (min-width:640px){.ms-lg3{width:25%}}@media (min-width:640px){.ms-lg2{width:16.666666666666664%}}@media (min-width:640px){.ms-lg1{width:8.333333333333332%}}@media (min-width:640px){[dir=ltr] .ms-lgPull12{right:100%}[dir=rtl] .ms-lgPull12{left:100%}}@media (min-width:640px){[dir=ltr] .ms-lgPull11{right:91.66667%}[dir=rtl] .ms-lgPull11{left:91.66667%}}@media (min-width:640px){[dir=ltr] .ms-lgPull10{right:83.33333%}[dir=rtl] .ms-lgPull10{left:83.33333%}}@media (min-width:640px){[dir=ltr] .ms-lgPull9{right:75%}[dir=rtl] .ms-lgPull9{left:75%}}@media (min-width:640px){[dir=ltr] .ms-lgPull8{right:66.66667%}[dir=rtl] .ms-lgPull8{left:66.66667%}}@media (min-width:640px){[dir=ltr] .ms-lgPull7{right:58.33333%}[dir=rtl] .ms-lgPull7{left:58.33333%}}@media (min-width:640px){[dir=ltr] .ms-lgPull6{right:50%}[dir=rtl] .ms-lgPull6{left:50%}}@media (min-width:640px){[dir=ltr] .ms-lgPull5{right:41.66667%}[dir=rtl] .ms-lgPull5{left:41.66667%}}@media (min-width:640px){[dir=ltr] .ms-lgPull4{right:33.33333%}[dir=rtl] .ms-lgPull4{left:33.33333%}}@media (min-width:640px){[dir=ltr] .ms-lgPull3{right:25%}[dir=rtl] .ms-lgPull3{left:25%}}@media (min-width:640px){[dir=ltr] .ms-lgPull2{right:16.66667%}[dir=rtl] .ms-lgPull2{left:16.66667%}}@media (min-width:640px){[dir=ltr] .ms-lgPull1{right:8.33333%}[dir=rtl] .ms-lgPull1{left:8.33333%}}@media (min-width:640px){[dir=ltr] .ms-lgPull0{right:auto}[dir=rtl] .ms-lgPull0{left:auto}}@media (min-width:640px){[dir=ltr] .ms-lgPush12{left:100%}[dir=rtl] .ms-lgPush12{right:100%}}@media (min-width:640px){[dir=ltr] .ms-lgPush11{left:91.66667%}[dir=rtl] .ms-lgPush11{right:91.66667%}}@media (min-width:640px){[dir=ltr] .ms-lgPush10{left:83.33333%}[dir=rtl] .ms-lgPush10{right:83.33333%}}@media (min-width:640px){[dir=ltr] .ms-lgPush9{left:75%}[dir=rtl] .ms-lgPush9{right:75%}}@media (min-width:640px){[dir=ltr] .ms-lgPush8{left:66.66667%}[dir=rtl] .ms-lgPush8{right:66.66667%}}@media (min-width:640px){[dir=ltr] .ms-lgPush7{left:58.33333%}[dir=rtl] .ms-lgPush7{right:58.33333%}}@media (min-width:640px){[dir=ltr] .ms-lgPush6{left:50%}[dir=rtl] .ms-lgPush6{right:50%}}@media (min-width:640px){[dir=ltr] .ms-lgPush5{left:41.66667%}[dir=rtl] .ms-lgPush5{right:41.66667%}}@media (min-width:640px){[dir=ltr] .ms-lgPush4{left:33.33333%}[dir=rtl] .ms-lgPush4{right:33.33333%}}@media (min-width:640px){[dir=ltr] .ms-lgPush3{left:25%}[dir=rtl] .ms-lgPush3{right:25%}}@media (min-width:640px){[dir=ltr] .ms-lgPush2{left:16.66667%}[dir=rtl] .ms-lgPush2{right:16.66667%}}@media (min-width:640px){[dir=ltr] .ms-lgPush1{left:8.33333%}[dir=rtl] .ms-lgPush1{right:8.33333%}}@media (min-width:640px){[dir=ltr] .ms-lgPush0{left:auto}[dir=rtl] .ms-lgPush0{right:auto}}@media (min-width:640px){[dir=ltr] .ms-lgOffset11{margin-left:91.66667%}[dir=rtl] .ms-lgOffset11{margin-right:91.66667%}}@media (min-width:640px){[dir=ltr] .ms-lgOffset10{margin-left:83.33333%}[dir=rtl] .ms-lgOffset10{margin-right:83.33333%}}@media (min-width:640px){[dir=ltr] .ms-lgOffset9{margin-left:75%}[dir=rtl] .ms-lgOffset9{margin-right:75%}}@media (min-width:640px){[dir=ltr] .ms-lgOffset8{margin-left:66.66667%}[dir=rtl] .ms-lgOffset8{margin-right:66.66667%}}@media (min-width:640px){[dir=ltr] .ms-lgOffset7{margin-left:58.33333%}[dir=rtl] .ms-lgOffset7{margin-right:58.33333%}}@media (min-width:640px){[dir=ltr] .ms-lgOffset6{margin-left:50%}[dir=rtl] .ms-lgOffset6{margin-right:50%}}@media (min-width:640px){[dir=ltr] .ms-lgOffset5{margin-left:41.66667%}[dir=rtl] .ms-lgOffset5{margin-right:41.66667%}}@media (min-width:640px){[dir=ltr] .ms-lgOffset4{margin-left:33.33333%}[dir=rtl] .ms-lgOffset4{margin-right:33.33333%}}@media (min-width:640px){[dir=ltr] .ms-lgOffset3{margin-left:25%}[dir=rtl] .ms-lgOffset3{margin-right:25%}}@media (min-width:640px){[dir=ltr] .ms-lgOffset2{margin-left:16.66667%}[dir=rtl] .ms-lgOffset2{margin-right:16.66667%}}@media (min-width:640px){[dir=ltr] .ms-lgOffset1{margin-left:8.33333%}[dir=rtl] .ms-lgOffset1{margin-right:8.33333%}}@media (min-width:640px){[dir=ltr] .ms-lgOffset0{margin-left:0}[dir=rtl] .ms-lgOffset0{margin-right:0}}@media (min-width:1024px){.ms-xl12{width:100%}}@media (min-width:1024px){.ms-xl11{width:91.66666666666666%}}@media (min-width:1024px){.ms-xl10{width:83.33333333333334%}}@media (min-width:1024px){.ms-xl9{width:75%}}@media (min-width:1024px){.ms-xl8{width:66.66666666666666%}}@media (min-width:1024px){.ms-xl7{width:58.333333333333336%}}@media (min-width:1024px){.ms-xl6{width:50%}}@media (min-width:1024px){.ms-xl5{width:41.66666666666667%}}@media (min-width:1024px){.ms-xl4{width:33.33333333333333%}}@media (min-width:1024px){.ms-xl3{width:25%}}@media (min-width:1024px){.ms-xl2{width:16.666666666666664%}}@media (min-width:1024px){.ms-xl1{width:8.333333333333332%}}@media (min-width:1024px){[dir=ltr] .ms-xlPull12{right:100%}[dir=rtl] .ms-xlPull12{left:100%}}@media (min-width:1024px){[dir=ltr] .ms-xlPull11{right:91.66667%}[dir=rtl] .ms-xlPull11{left:91.66667%}}@media (min-width:1024px){[dir=ltr] .ms-xlPull10{right:83.33333%}[dir=rtl] .ms-xlPull10{left:83.33333%}}@media (min-width:1024px){[dir=ltr] .ms-xlPull9{right:75%}[dir=rtl] .ms-xlPull9{left:75%}}@media (min-width:1024px){[dir=ltr] .ms-xlPull8{right:66.66667%}[dir=rtl] .ms-xlPull8{left:66.66667%}}@media (min-width:1024px){[dir=ltr] .ms-xlPull7{right:58.33333%}[dir=rtl] .ms-xlPull7{left:58.33333%}}@media (min-width:1024px){[dir=ltr] .ms-xlPull6{right:50%}[dir=rtl] .ms-xlPull6{left:50%}}@media (min-width:1024px){[dir=ltr] .ms-xlPull5{right:41.66667%}[dir=rtl] .ms-xlPull5{left:41.66667%}}@media (min-width:1024px){[dir=ltr] .ms-xlPull4{right:33.33333%}[dir=rtl] .ms-xlPull4{left:33.33333%}}@media (min-width:1024px){[dir=ltr] .ms-xlPull3{right:25%}[dir=rtl] .ms-xlPull3{left:25%}}@media (min-width:1024px){[dir=ltr] .ms-xlPull2{right:16.66667%}[dir=rtl] .ms-xlPull2{left:16.66667%}}@media (min-width:1024px){[dir=ltr] .ms-xlPull1{right:8.33333%}[dir=rtl] .ms-xlPull1{left:8.33333%}}@media (min-width:1024px){[dir=ltr] .ms-xlPull0{right:auto}[dir=rtl] .ms-xlPull0{left:auto}}@media (min-width:1024px){[dir=ltr] .ms-xlPush12{left:100%}[dir=rtl] .ms-xlPush12{right:100%}}@media (min-width:1024px){[dir=ltr] .ms-xlPush11{left:91.66667%}[dir=rtl] .ms-xlPush11{right:91.66667%}}@media (min-width:1024px){[dir=ltr] .ms-xlPush10{left:83.33333%}[dir=rtl] .ms-xlPush10{right:83.33333%}}@media (min-width:1024px){[dir=ltr] .ms-xlPush9{left:75%}[dir=rtl] .ms-xlPush9{right:75%}}@media (min-width:1024px){[dir=ltr] .ms-xlPush8{left:66.66667%}[dir=rtl] .ms-xlPush8{right:66.66667%}}@media (min-width:1024px){[dir=ltr] .ms-xlPush7{left:58.33333%}[dir=rtl] .ms-xlPush7{right:58.33333%}}@media (min-width:1024px){[dir=ltr] .ms-xlPush6{left:50%}[dir=rtl] .ms-xlPush6{right:50%}}@media (min-width:1024px){[dir=ltr] .ms-xlPush5{left:41.66667%}[dir=rtl] .ms-xlPush5{right:41.66667%}}@media (min-width:1024px){[dir=ltr] .ms-xlPush4{left:33.33333%}[dir=rtl] .ms-xlPush4{right:33.33333%}}@media (min-width:1024px){[dir=ltr] .ms-xlPush3{left:25%}[dir=rtl] .ms-xlPush3{right:25%}}@media (min-width:1024px){[dir=ltr] .ms-xlPush2{left:16.66667%}[dir=rtl] .ms-xlPush2{right:16.66667%}}@media (min-width:1024px){[dir=ltr] .ms-xlPush1{left:8.33333%}[dir=rtl] .ms-xlPush1{right:8.33333%}}@media (min-width:1024px){[dir=ltr] .ms-xlPush0{left:auto}[dir=rtl] .ms-xlPush0{right:auto}}@media (min-width:1024px){[dir=ltr] .ms-xlOffset11{margin-left:91.66667%}[dir=rtl] .ms-xlOffset11{margin-right:91.66667%}}@media (min-width:1024px){[dir=ltr] .ms-xlOffset10{margin-left:83.33333%}[dir=rtl] .ms-xlOffset10{margin-right:83.33333%}}@media (min-width:1024px){[dir=ltr] .ms-xlOffset9{margin-left:75%}[dir=rtl] .ms-xlOffset9{margin-right:75%}}@media (min-width:1024px){[dir=ltr] .ms-xlOffset8{margin-left:66.66667%}[dir=rtl] .ms-xlOffset8{margin-right:66.66667%}}@media (min-width:1024px){[dir=ltr] .ms-xlOffset7{margin-left:58.33333%}[dir=rtl] .ms-xlOffset7{margin-right:58.33333%}}@media (min-width:1024px){[dir=ltr] .ms-xlOffset6{margin-left:50%}[dir=rtl] .ms-xlOffset6{margin-right:50%}}@media (min-width:1024px){[dir=ltr] .ms-xlOffset5{margin-left:41.66667%}[dir=rtl] .ms-xlOffset5{margin-right:41.66667%}}@media (min-width:1024px){[dir=ltr] .ms-xlOffset4{margin-left:33.33333%}[dir=rtl] .ms-xlOffset4{margin-right:33.33333%}}@media (min-width:1024px){[dir=ltr] .ms-xlOffset3{margin-left:25%}[dir=rtl] .ms-xlOffset3{margin-right:25%}}@media (min-width:1024px){[dir=ltr] .ms-xlOffset2{margin-left:16.66667%}[dir=rtl] .ms-xlOffset2{margin-right:16.66667%}}@media (min-width:1024px){[dir=ltr] .ms-xlOffset1{margin-left:8.33333%}[dir=rtl] .ms-xlOffset1{margin-right:8.33333%}}@media (min-width:1024px){[dir=ltr] .ms-xlOffset0{margin-left:0}[dir=rtl] .ms-xlOffset0{margin-right:0}}@media (min-width:1366px){.ms-xxl12{width:100%}}@media (min-width:1366px){.ms-xxl11{width:91.66666666666666%}}@media (min-width:1366px){.ms-xxl10{width:83.33333333333334%}}@media (min-width:1366px){.ms-xxl9{width:75%}}@media (min-width:1366px){.ms-xxl8{width:66.66666666666666%}}@media (min-width:1366px){.ms-xxl7{width:58.333333333333336%}}@media (min-width:1366px){.ms-xxl6{width:50%}}@media (min-width:1366px){.ms-xxl5{width:41.66666666666667%}}@media (min-width:1366px){.ms-xxl4{width:33.33333333333333%}}@media (min-width:1366px){.ms-xxl3{width:25%}}@media (min-width:1366px){.ms-xxl2{width:16.666666666666664%}}@media (min-width:1366px){.ms-xxl1{width:8.333333333333332%}}@media (min-width:1366px){[dir=ltr] .ms-xxlPull12{right:100%}[dir=rtl] .ms-xxlPull12{left:100%}}@media (min-width:1366px){[dir=ltr] .ms-xxlPull11{right:91.66667%}[dir=rtl] .ms-xxlPull11{left:91.66667%}}@media (min-width:1366px){[dir=ltr] .ms-xxlPull10{right:83.33333%}[dir=rtl] .ms-xxlPull10{left:83.33333%}}@media (min-width:1366px){[dir=ltr] .ms-xxlPull9{right:75%}[dir=rtl] .ms-xxlPull9{left:75%}}@media (min-width:1366px){[dir=ltr] .ms-xxlPull8{right:66.66667%}[dir=rtl] .ms-xxlPull8{left:66.66667%}}@media (min-width:1366px){[dir=ltr] .ms-xxlPull7{right:58.33333%}[dir=rtl] .ms-xxlPull7{left:58.33333%}}@media (min-width:1366px){[dir=ltr] .ms-xxlPull6{right:50%}[dir=rtl] .ms-xxlPull6{left:50%}}@media (min-width:1366px){[dir=ltr] .ms-xxlPull5{right:41.66667%}[dir=rtl] .ms-xxlPull5{left:41.66667%}}@media (min-width:1366px){[dir=ltr] .ms-xxlPull4{right:33.33333%}[dir=rtl] .ms-xxlPull4{left:33.33333%}}@media (min-width:1366px){[dir=ltr] .ms-xxlPull3{right:25%}[dir=rtl] .ms-xxlPull3{left:25%}}@media (min-width:1366px){[dir=ltr] .ms-xxlPull2{right:16.66667%}[dir=rtl] .ms-xxlPull2{left:16.66667%}}@media (min-width:1366px){[dir=ltr] .ms-xxlPull1{right:8.33333%}[dir=rtl] .ms-xxlPull1{left:8.33333%}}@media (min-width:1366px){[dir=ltr] .ms-xxlPull0{right:auto}[dir=rtl] .ms-xxlPull0{left:auto}}@media (min-width:1366px){[dir=ltr] .ms-xxlPush12{left:100%}[dir=rtl] .ms-xxlPush12{right:100%}}@media (min-width:1366px){[dir=ltr] .ms-xxlPush11{left:91.66667%}[dir=rtl] .ms-xxlPush11{right:91.66667%}}@media (min-width:1366px){[dir=ltr] .ms-xxlPush10{left:83.33333%}[dir=rtl] .ms-xxlPush10{right:83.33333%}}@media (min-width:1366px){[dir=ltr] .ms-xxlPush9{left:75%}[dir=rtl] .ms-xxlPush9{right:75%}}@media (min-width:1366px){[dir=ltr] .ms-xxlPush8{left:66.66667%}[dir=rtl] .ms-xxlPush8{right:66.66667%}}@media (min-width:1366px){[dir=ltr] .ms-xxlPush7{left:58.33333%}[dir=rtl] .ms-xxlPush7{right:58.33333%}}@media (min-width:1366px){[dir=ltr] .ms-xxlPush6{left:50%}[dir=rtl] .ms-xxlPush6{right:50%}}@media (min-width:1366px){[dir=ltr] .ms-xxlPush5{left:41.66667%}[dir=rtl] .ms-xxlPush5{right:41.66667%}}@media (min-width:1366px){[dir=ltr] .ms-xxlPush4{left:33.33333%}[dir=rtl] .ms-xxlPush4{right:33.33333%}}@media (min-width:1366px){[dir=ltr] .ms-xxlPush3{left:25%}[dir=rtl] .ms-xxlPush3{right:25%}}@media (min-width:1366px){[dir=ltr] .ms-xxlPush2{left:16.66667%}[dir=rtl] .ms-xxlPush2{right:16.66667%}}@media (min-width:1366px){[dir=ltr] .ms-xxlPush1{left:8.33333%}[dir=rtl] .ms-xxlPush1{right:8.33333%}}@media (min-width:1366px){[dir=ltr] .ms-xxlPush0{left:auto}[dir=rtl] .ms-xxlPush0{right:auto}}@media (min-width:1366px){[dir=ltr] .ms-xxlOffset11{margin-left:91.66667%}[dir=rtl] .ms-xxlOffset11{margin-right:91.66667%}}@media (min-width:1366px){[dir=ltr] .ms-xxlOffset10{margin-left:83.33333%}[dir=rtl] .ms-xxlOffset10{margin-right:83.33333%}}@media (min-width:1366px){[dir=ltr] .ms-xxlOffset9{margin-left:75%}[dir=rtl] .ms-xxlOffset9{margin-right:75%}}@media (min-width:1366px){[dir=ltr] .ms-xxlOffset8{margin-left:66.66667%}[dir=rtl] .ms-xxlOffset8{margin-right:66.66667%}}@media (min-width:1366px){[dir=ltr] .ms-xxlOffset7{margin-left:58.33333%}[dir=rtl] .ms-xxlOffset7{margin-right:58.33333%}}@media (min-width:1366px){[dir=ltr] .ms-xxlOffset6{margin-left:50%}[dir=rtl] .ms-xxlOffset6{margin-right:50%}}@media (min-width:1366px){[dir=ltr] .ms-xxlOffset5{margin-left:41.66667%}[dir=rtl] .ms-xxlOffset5{margin-right:41.66667%}}@media (min-width:1366px){[dir=ltr] .ms-xxlOffset4{margin-left:33.33333%}[dir=rtl] .ms-xxlOffset4{margin-right:33.33333%}}@media (min-width:1366px){[dir=ltr] .ms-xxlOffset3{margin-left:25%}[dir=rtl] .ms-xxlOffset3{margin-right:25%}}@media (min-width:1366px){[dir=ltr] .ms-xxlOffset2{margin-left:16.66667%}[dir=rtl] .ms-xxlOffset2{margin-right:16.66667%}}@media (min-width:1366px){[dir=ltr] .ms-xxlOffset1{margin-left:8.33333%}[dir=rtl] .ms-xxlOffset1{margin-right:8.33333%}}@media (min-width:1366px){[dir=ltr] .ms-xxlOffset0{margin-left:0}[dir=rtl] .ms-xxlOffset0{margin-right:0}}@media (min-width:1920px){.ms-xxxl12{width:100%}}@media (min-width:1920px){.ms-xxxl11{width:91.66666666666666%}}@media (min-width:1920px){.ms-xxxl10{width:83.33333333333334%}}@media (min-width:1920px){.ms-xxxl9{width:75%}}@media (min-width:1920px){.ms-xxxl8{width:66.66666666666666%}}@media (min-width:1920px){.ms-xxxl7{width:58.333333333333336%}}@media (min-width:1920px){.ms-xxxl6{width:50%}}@media (min-width:1920px){.ms-xxxl5{width:41.66666666666667%}}@media (min-width:1920px){.ms-xxxl4{width:33.33333333333333%}}@media (min-width:1920px){.ms-xxxl3{width:25%}}@media (min-width:1920px){.ms-xxxl2{width:16.666666666666664%}}@media (min-width:1920px){.ms-xxxl1{width:8.333333333333332%}}@media (min-width:1920px){[dir=ltr] .ms-xxxlPull12{right:100%}[dir=rtl] .ms-xxxlPull12{left:100%}}@media (min-width:1920px){[dir=ltr] .ms-xxxlPull11{right:91.66667%}[dir=rtl] .ms-xxxlPull11{left:91.66667%}}@media (min-width:1920px){[dir=ltr] .ms-xxxlPull10{right:83.33333%}[dir=rtl] .ms-xxxlPull10{left:83.33333%}}@media (min-width:1920px){[dir=ltr] .ms-xxxlPull9{right:75%}[dir=rtl] .ms-xxxlPull9{left:75%}}@media (min-width:1920px){[dir=ltr] .ms-xxxlPull8{right:66.66667%}[dir=rtl] .ms-xxxlPull8{left:66.66667%}}@media (min-width:1920px){[dir=ltr] .ms-xxxlPull7{right:58.33333%}[dir=rtl] .ms-xxxlPull7{left:58.33333%}}@media (min-width:1920px){[dir=ltr] .ms-xxxlPull6{right:50%}[dir=rtl] .ms-xxxlPull6{left:50%}}@media (min-width:1920px){[dir=ltr] .ms-xxxlPull5{right:41.66667%}[dir=rtl] .ms-xxxlPull5{left:41.66667%}}@media (min-width:1920px){[dir=ltr] .ms-xxxlPull4{right:33.33333%}[dir=rtl] .ms-xxxlPull4{left:33.33333%}}@media (min-width:1920px){[dir=ltr] .ms-xxxlPull3{right:25%}[dir=rtl] .ms-xxxlPull3{left:25%}}@media (min-width:1920px){[dir=ltr] .ms-xxxlPull2{right:16.66667%}[dir=rtl] .ms-xxxlPull2{left:16.66667%}}@media (min-width:1920px){[dir=ltr] .ms-xxxlPull1{right:8.33333%}[dir=rtl] .ms-xxxlPull1{left:8.33333%}}@media (min-width:1920px){[dir=ltr] .ms-xxxlPull0{right:auto}[dir=rtl] .ms-xxxlPull0{left:auto}}@media (min-width:1920px){[dir=ltr] .ms-xxxlPush12{left:100%}[dir=rtl] .ms-xxxlPush12{right:100%}}@media (min-width:1920px){[dir=ltr] .ms-xxxlPush11{left:91.66667%}[dir=rtl] .ms-xxxlPush11{right:91.66667%}}@media (min-width:1920px){[dir=ltr] .ms-xxxlPush10{left:83.33333%}[dir=rtl] .ms-xxxlPush10{right:83.33333%}}@media (min-width:1920px){[dir=ltr] .ms-xxxlPush9{left:75%}[dir=rtl] .ms-xxxlPush9{right:75%}}@media (min-width:1920px){[dir=ltr] .ms-xxxlPush8{left:66.66667%}[dir=rtl] .ms-xxxlPush8{right:66.66667%}}@media (min-width:1920px){[dir=ltr] .ms-xxxlPush7{left:58.33333%}[dir=rtl] .ms-xxxlPush7{right:58.33333%}}@media (min-width:1920px){[dir=ltr] .ms-xxxlPush6{left:50%}[dir=rtl] .ms-xxxlPush6{right:50%}}@media (min-width:1920px){[dir=ltr] .ms-xxxlPush5{left:41.66667%}[dir=rtl] .ms-xxxlPush5{right:41.66667%}}@media (min-width:1920px){[dir=ltr] .ms-xxxlPush4{left:33.33333%}[dir=rtl] .ms-xxxlPush4{right:33.33333%}}@media (min-width:1920px){[dir=ltr] .ms-xxxlPush3{left:25%}[dir=rtl] .ms-xxxlPush3{right:25%}}@media (min-width:1920px){[dir=ltr] .ms-xxxlPush2{left:16.66667%}[dir=rtl] .ms-xxxlPush2{right:16.66667%}}@media (min-width:1920px){[dir=ltr] .ms-xxxlPush1{left:8.33333%}[dir=rtl] .ms-xxxlPush1{right:8.33333%}}@media (min-width:1920px){[dir=ltr] .ms-xxxlPush0{left:auto}[dir=rtl] .ms-xxxlPush0{right:auto}}@media (min-width:1920px){[dir=ltr] .ms-xxxlOffset11{margin-left:91.66667%}[dir=rtl] .ms-xxxlOffset11{margin-right:91.66667%}}@media (min-width:1920px){[dir=ltr] .ms-xxxlOffset10{margin-left:83.33333%}[dir=rtl] .ms-xxxlOffset10{margin-right:83.33333%}}@media (min-width:1920px){[dir=ltr] .ms-xxxlOffset9{margin-left:75%}[dir=rtl] .ms-xxxlOffset9{margin-right:75%}}@media (min-width:1920px){[dir=ltr] .ms-xxxlOffset8{margin-left:66.66667%}[dir=rtl] .ms-xxxlOffset8{margin-right:66.66667%}}@media (min-width:1920px){[dir=ltr] .ms-xxxlOffset7{margin-left:58.33333%}[dir=rtl] .ms-xxxlOffset7{margin-right:58.33333%}}@media (min-width:1920px){[dir=ltr] .ms-xxxlOffset6{margin-left:50%}[dir=rtl] .ms-xxxlOffset6{margin-right:50%}}@media (min-width:1920px){[dir=ltr] .ms-xxxlOffset5{margin-left:41.66667%}[dir=rtl] .ms-xxxlOffset5{margin-right:41.66667%}}@media (min-width:1920px){[dir=ltr] .ms-xxxlOffset4{margin-left:33.33333%}[dir=rtl] .ms-xxxlOffset4{margin-right:33.33333%}}@media (min-width:1920px){[dir=ltr] .ms-xxxlOffset3{margin-left:25%}[dir=rtl] .ms-xxxlOffset3{margin-right:25%}}@media (min-width:1920px){[dir=ltr] .ms-xxxlOffset2{margin-left:16.66667%}[dir=rtl] .ms-xxxlOffset2{margin-right:16.66667%}}@media (min-width:1920px){[dir=ltr] .ms-xxxlOffset1{margin-left:8.33333%}[dir=rtl] .ms-xxxlOffset1{margin-right:8.33333%}}@media (min-width:1920px){[dir=ltr] .ms-xxxlOffset0{margin-left:0}[dir=rtl] .ms-xxxlOffset0{margin-right:0}}.ms-borderBox,.ms-borderBox:after,.ms-borderBox:before{box-sizing:border-box}.ms-borderBase{border:1px solid}.ms-clearfix{*zoom:1}.ms-clearfix:after,.ms-clearfix:before{display:table;content:\"\";line-height:0}.ms-clearfix:after{clear:both}.ms-normalize{box-sizing:border-box;box-shadow:none;margin:0;padding:0}[dir=ltr] .ms-textAlignLeft{text-align:left}[dir=ltr] .ms-textAlignRight,[dir=rtl] .ms-textAlignLeft{text-align:right}[dir=rtl] .ms-textAlignRight{text-align:left}.ms-textAlignCenter{text-align:center}.ms-screenReaderOnly{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.ms-textTruncate{overflow:hidden;text-overflow:ellipsis;word-wrap:normal}.ms-noWrap,.ms-textTruncate{white-space:nowrap}.ms-Fabric{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;color:#333;font-family:\"Segoe UI Web (West European)\",Segoe UI,-apple-system,BlinkMacSystemFont,Roboto,Helvetica Neue,sans-serif;font-size:14px}.ms-Fabric button,.ms-Fabric input,.ms-Fabric textarea{font-family:inherit}.ms-Fabric[lang^=ar],.ms-Fabric [lang^=ar],[lang^=ar] .ms-Fabric{font-family:Segoe UI Web\\ (Arabic),Segoe UI,-apple-system,BlinkMacSystemFont,Roboto,Helvetica Neue,sans-serif}.ms-Fabric[lang^=bg],.ms-Fabric [lang^=bg],[lang^=bg] .ms-Fabric{font-family:Segoe UI Web\\ (Cyrillic),Segoe UI,-apple-system,BlinkMacSystemFont,Roboto,Helvetica Neue,sans-serif}.ms-Fabric[lang^=cs],.ms-Fabric [lang^=cs],[lang^=cs] .ms-Fabric{font-family:\"Segoe UI Web (East European)\",Segoe UI,-apple-system,BlinkMacSystemFont,Roboto,Helvetica Neue,sans-serif}.ms-Fabric[lang^=el],.ms-Fabric [lang^=el],[lang^=el] .ms-Fabric{font-family:Segoe UI Web\\ (Greek),Segoe UI,-apple-system,BlinkMacSystemFont,Roboto,Helvetica Neue,sans-serif}.ms-Fabric[lang^=et],.ms-Fabric [lang^=et],[lang^=et] .ms-Fabric{font-family:\"Segoe UI Web (East European)\",Segoe UI,-apple-system,BlinkMacSystemFont,Roboto,Helvetica Neue,sans-serif}.ms-Fabric[lang^=he],.ms-Fabric [lang^=he],[lang^=he] .ms-Fabric{font-family:Segoe UI Web\\ (Hebrew),Segoe UI,-apple-system,BlinkMacSystemFont,Roboto,Helvetica Neue,sans-serif}.ms-Fabric[lang^=hi],.ms-Fabric [lang^=hi],[lang^=hi] .ms-Fabric{font-family:Nirmala UI,Segoe UI,-apple-system,BlinkMacSystemFont,Roboto,Helvetica Neue,sans-serif}.ms-Fabric[lang^=hr],.ms-Fabric [lang^=hr],.ms-Fabric[lang^=hu],.ms-Fabric [lang^=hu],[lang^=hr] .ms-Fabric,[lang^=hu] .ms-Fabric{font-family:\"Segoe UI Web (East European)\",Segoe UI,-apple-system,BlinkMacSystemFont,Roboto,Helvetica Neue,sans-serif}.ms-Fabric[lang^=ja],.ms-Fabric [lang^=ja],[lang^=ja] .ms-Fabric{font-family:Yu Gothic UI,Meiryo UI,Meiryo,MS Pgothic,Osaka,Segoe UI,-apple-system,BlinkMacSystemFont,Roboto,Helvetica Neue,sans-serif}.ms-Fabric[lang^=kk],.ms-Fabric [lang^=kk],[lang^=kk] .ms-Fabric{font-family:\"Segoe UI Web (East European)\",Segoe UI,-apple-system,BlinkMacSystemFont,Roboto,Helvetica Neue,sans-serif}.ms-Fabric[lang^=ko],.ms-Fabric [lang^=ko],[lang^=ko] .ms-Fabric{font-family:Malgun Gothic,Gulim,Segoe UI,-apple-system,BlinkMacSystemFont,Roboto,Helvetica Neue,sans-serif}.ms-Fabric[lang^=lo],.ms-Fabric [lang^=lo],[lang^=lo] .ms-Fabric{font-family:Leelawadee UI Web,Lao UI,DokChampa,Segoe UI,-apple-system,BlinkMacSystemFont,Roboto,Helvetica Neue,sans-serif}.ms-Fabric[lang^=lt],.ms-Fabric [lang^=lt],.ms-Fabric[lang^=lv],.ms-Fabric [lang^=lv],.ms-Fabric[lang^=pl],.ms-Fabric [lang^=pl],[lang^=lt] .ms-Fabric,[lang^=lv] .ms-Fabric,[lang^=pl] .ms-Fabric{font-family:\"Segoe UI Web (East European)\",Segoe UI,-apple-system,BlinkMacSystemFont,Roboto,Helvetica Neue,sans-serif}.ms-Fabric[lang^=ru],.ms-Fabric [lang^=ru],[lang^=ru] .ms-Fabric{font-family:Segoe UI Web\\ (Cyrillic),Segoe UI,-apple-system,BlinkMacSystemFont,Roboto,Helvetica Neue,sans-serif}.ms-Fabric[lang^=sk],.ms-Fabric [lang^=sk],.ms-Fabric[lang^=sr-latn],.ms-Fabric [lang^=sr-latn],[lang^=sk] .ms-Fabric,[lang^=sr-latn] .ms-Fabric{font-family:\"Segoe UI Web (East European)\",Segoe UI,-apple-system,BlinkMacSystemFont,Roboto,Helvetica Neue,sans-serif}.ms-Fabric[lang^=th],.ms-Fabric [lang^=th],[lang^=th] .ms-Fabric{font-family:Leelawadee UI Web,Kmer UI,Segoe UI,-apple-system,BlinkMacSystemFont,Roboto,Helvetica Neue,sans-serif}.ms-Fabric[lang^=tr],.ms-Fabric [lang^=tr],[lang^=tr] .ms-Fabric{font-family:\"Segoe UI Web (East European)\",Segoe UI,-apple-system,BlinkMacSystemFont,Roboto,Helvetica Neue,sans-serif}.ms-Fabric[lang^=uk],.ms-Fabric [lang^=uk],[lang^=uk] .ms-Fabric{font-family:Segoe UI Web\\ (Cyrillic),Segoe UI,-apple-system,BlinkMacSystemFont,Roboto,Helvetica Neue,sans-serif}.ms-Fabric[lang^=vi],.ms-Fabric [lang^=vi],[lang^=vi] .ms-Fabric{font-family:Segoe UI Web\\ (Vietnamese),Segoe UI,-apple-system,BlinkMacSystemFont,Roboto,Helvetica Neue,sans-serif}.ms-Fabric[lang^=zh-hans],.ms-Fabric [lang^=zh-hans],[lang^=zh-hans] .ms-Fabric{font-family:Microsoft Yahei UI,Verdana,Simsun,Segoe UI,-apple-system,BlinkMacSystemFont,Roboto,Helvetica Neue,sans-serif}.ms-Fabric[lang^=zh-hant],.ms-Fabric [lang^=zh-hant],[lang^=zh-hant] .ms-Fabric{font-family:Microsoft Jhenghei UI,Pmingliu,Segoe UI,-apple-system,BlinkMacSystemFont,Roboto,Helvetica Neue,sans-serif}.ms-Fabric--selawik{font-family:Selawik Web,Segoe UI,-apple-system,BlinkMacSystemFont,Roboto,Helvetica Neue,sans-serif}", ""]);

// exports


/***/ }),

/***/ "../node_modules/css-loader/lib/css-base.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap) {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
  var base64 = new Buffer(JSON.stringify(sourceMap)).toString('base64');
  var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

  return '/*# ' + data + ' */';
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/buffer/index.js").Buffer))

/***/ }),

/***/ "../node_modules/emotion/dist/index.esm.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "flush", function() { return flush; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hydrate", function() { return hydrate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cx", function() { return cx; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "merge", function() { return merge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRegisteredStyles", function() { return getRegisteredStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "injectGlobal", function() { return injectGlobal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "keyframes", function() { return keyframes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "css", function() { return css; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sheet", function() { return sheet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "caches", function() { return caches; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_emotion__ = __webpack_require__("../node_modules/create-emotion/dist/index.esm.js");


var context = typeof global !== 'undefined' ? global : {};

var _createEmotion = Object(__WEBPACK_IMPORTED_MODULE_0_create_emotion__["a" /* default */])(context),
    flush = _createEmotion.flush,
    hydrate = _createEmotion.hydrate,
    cx = _createEmotion.cx,
    merge = _createEmotion.merge,
    getRegisteredStyles = _createEmotion.getRegisteredStyles,
    injectGlobal = _createEmotion.injectGlobal,
    keyframes = _createEmotion.keyframes,
    css = _createEmotion.css,
    sheet = _createEmotion.sheet,
    caches = _createEmotion.caches;



/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../node_modules/ieee754/index.js":
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ "../node_modules/memoize-one/dist/memoize-one.esm.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var simpleIsEqual = function simpleIsEqual(a, b) {
  return a === b;
};

function index (resultFn, isEqual) {
  if (isEqual === void 0) {
    isEqual = simpleIsEqual;
  }

  var lastThis;
  var lastArgs = [];
  var lastResult;
  var calledOnce = false;

  var isNewArgEqualToLast = function isNewArgEqualToLast(newArg, index) {
    return isEqual(newArg, lastArgs[index]);
  };

  var result = function result() {
    for (var _len = arguments.length, newArgs = new Array(_len), _key = 0; _key < _len; _key++) {
      newArgs[_key] = arguments[_key];
    }

    if (calledOnce && lastThis === this && newArgs.length === lastArgs.length && newArgs.every(isNewArgEqualToLast)) {
      return lastResult;
    }

    lastResult = resultFn.apply(this, newArgs);
    calledOnce = true;
    lastThis = this;
    lastArgs = newArgs;
    return lastResult;
  };

  return result;
}

/* harmony default export */ __webpack_exports__["default"] = (index);


/***/ }),

/***/ "../node_modules/office-ui-fabric-react/dist/css/fabric.min.css":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("../node_modules/css-loader/index.js!../node_modules/office-ui-fabric-react/dist/css/fabric.min.css");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("../node_modules/style-loader/addStyles.js")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js!./fabric.min.css", function() {
			var newContent = require("!!../../../css-loader/index.js!./fabric.min.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "../node_modules/office-ui-fabric-react/lib/Icons.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("../node_modules/tslib/tslib.es6.js");
tslib_1.__exportStar(__webpack_require__("../node_modules/@uifabric/icons/lib/index.js"), exports);
//# sourceMappingURL=Icons.js.map

/***/ }),

/***/ "../node_modules/performance-now/lib/performance-now.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/node-libs-browser/node_modules/process/browser.js")))

/***/ }),

/***/ "../node_modules/raf/index.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__("../node_modules/performance-now/lib/performance-now.js")
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../node_modules/react-hot-loader/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("../node_modules/react-hot-loader/lib/index.js")


/***/ }),

/***/ "../node_modules/react-hot-loader/lib/AppContainer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable global-require */

if (true) {
  module.exports = __webpack_require__("../node_modules/react-hot-loader/lib/AppContainer.prod.js");
} else {
  module.exports = require('./AppContainer.dev');
}

/***/ }),

/***/ "../node_modules/react-hot-loader/lib/AppContainer.prod.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/prop-types */

var React = __webpack_require__("../node_modules/react/index.js");

var Component = React.Component;

var AppContainer = function (_Component) {
  _inherits(AppContainer, _Component);

  function AppContainer() {
    _classCallCheck(this, AppContainer);

    return _possibleConstructorReturn(this, (AppContainer.__proto__ || Object.getPrototypeOf(AppContainer)).apply(this, arguments));
  }

  _createClass(AppContainer, [{
    key: 'render',
    value: function render() {
      if (this.props.component) {
        return React.createElement(this.props.component, this.props.props);
      }

      return React.Children.only(this.props.children);
    }
  }]);

  return AppContainer;
}(Component);

module.exports = AppContainer;

/***/ }),

/***/ "../node_modules/react-hot-loader/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable global-require */

if (true) {
  module.exports = __webpack_require__("../node_modules/react-hot-loader/lib/index.prod.js");
} else {
  module.exports = require('./index.dev');
}

/***/ }),

/***/ "../node_modules/react-hot-loader/lib/index.prod.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports.AppContainer = __webpack_require__("../node_modules/react-hot-loader/lib/AppContainer.js");

/***/ }),

/***/ "../node_modules/react-hot-loader/lib/patch.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable global-require */

if (true) {
  module.exports = __webpack_require__("../node_modules/react-hot-loader/lib/patch.prod.js");
} else {
  module.exports = require('./patch.dev');
}

/***/ }),

/***/ "../node_modules/react-hot-loader/lib/patch.prod.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* noop */


/***/ }),

/***/ "../node_modules/react-hot-loader/patch.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("../node_modules/react-hot-loader/lib/patch.js")


/***/ }),

/***/ "../node_modules/react-input-autosize/lib/AutosizeInput.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];

var cleanInputProps = function cleanInputProps(inputProps) {
	INPUT_PROPS_BLACKLIST.forEach(function (field) {
		return delete inputProps[field];
	});
	return inputProps;
};

var copyStyles = function copyStyles(styles, node) {
	node.style.fontSize = styles.fontSize;
	node.style.fontFamily = styles.fontFamily;
	node.style.fontWeight = styles.fontWeight;
	node.style.fontStyle = styles.fontStyle;
	node.style.letterSpacing = styles.letterSpacing;
	node.style.textTransform = styles.textTransform;
};

var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;

var generateId = function generateId() {
	// we only need an auto-generated ID for stylesheet injection, which is only
	// used for IE. so if the browser is not IE, this should return undefined.
	return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
};

var AutosizeInput = function (_Component) {
	_inherits(AutosizeInput, _Component);

	function AutosizeInput(props) {
		_classCallCheck(this, AutosizeInput);

		var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));

		_this.inputRef = function (el) {
			_this.input = el;
			if (typeof _this.props.inputRef === 'function') {
				_this.props.inputRef(el);
			}
		};

		_this.placeHolderSizerRef = function (el) {
			_this.placeHolderSizer = el;
		};

		_this.sizerRef = function (el) {
			_this.sizer = el;
		};

		_this.state = {
			inputWidth: props.minWidth,
			inputId: props.id || generateId()
		};
		return _this;
	}

	_createClass(AutosizeInput, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.mounted = true;
			this.copyInputStyles();
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			var id = nextProps.id;

			if (id !== this.props.id) {
				this.setState({ inputId: id || generateId() });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (prevState.inputWidth !== this.state.inputWidth) {
				if (typeof this.props.onAutosize === 'function') {
					this.props.onAutosize(this.state.inputWidth);
				}
			}
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.mounted = false;
		}
	}, {
		key: 'copyInputStyles',
		value: function copyInputStyles() {
			if (!this.mounted || !window.getComputedStyle) {
				return;
			}
			var inputStyles = this.input && window.getComputedStyle(this.input);
			if (!inputStyles) {
				return;
			}
			copyStyles(inputStyles, this.sizer);
			if (this.placeHolderSizer) {
				copyStyles(inputStyles, this.placeHolderSizer);
			}
		}
	}, {
		key: 'updateInputWidth',
		value: function updateInputWidth() {
			if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = void 0;
			if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
				newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.sizer.scrollWidth + 2;
			}
			// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
			var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
			newInputWidth += extraWidth;
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		}
	}, {
		key: 'getInput',
		value: function getInput() {
			return this.input;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.input.focus();
		}
	}, {
		key: 'blur',
		value: function blur() {
			this.input.blur();
		}
	}, {
		key: 'select',
		value: function select() {
			this.input.select();
		}
	}, {
		key: 'renderStyles',
		value: function renderStyles() {
			// this method injects styles to hide IE's clear indicator, which messes
			// with input size detection. the stylesheet is only injected when the
			// browser is IE, and can also be disabled by the `injectStyles` prop.
			var injectStyles = this.props.injectStyles;

			return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
					__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
				} }) : null;
		}
	}, {
		key: 'render',
		value: function render() {
			var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
				if (previousValue !== null && previousValue !== undefined) {
					return previousValue;
				}
				return currentValue;
			});

			var wrapperStyle = _extends({}, this.props.style);
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';

			var inputStyle = _extends({
				boxSizing: 'content-box',
				width: this.state.inputWidth + 'px'
			}, this.props.inputStyle);

			var inputProps = _objectWithoutProperties(this.props, []);

			cleanInputProps(inputProps);
			inputProps.className = this.props.inputClassName;
			inputProps.id = this.state.inputId;
			inputProps.style = inputStyle;

			return _react2.default.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				this.renderStyles(),
				_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
				_react2.default.createElement(
					'div',
					{ ref: this.sizerRef, style: sizerStyle },
					sizerValue
				),
				this.props.placeholder ? _react2.default.createElement(
					'div',
					{ ref: this.placeHolderSizerRef, style: sizerStyle },
					this.props.placeholder
				) : null
			);
		}
	}]);

	return AutosizeInput;
}(_react.Component);

AutosizeInput.propTypes = {
	className: _propTypes2.default.string, // className for the outer element
	defaultValue: _propTypes2.default.any, // default field value
	extraWidth: _propTypes2.default.oneOfType([// additional width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
	injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
	inputClassName: _propTypes2.default.string, // className for the input element
	inputRef: _propTypes2.default.func, // ref callback for the input element
	inputStyle: _propTypes2.default.object, // css styles for the input element
	minWidth: _propTypes2.default.oneOfType([// minimum width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
	onChange: _propTypes2.default.func, // onChange handler: function(event) {}
	placeholder: _propTypes2.default.string, // placeholder text
	placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
	style: _propTypes2.default.object, // css styles for the outer element
	value: _propTypes2.default.any // field value
};
AutosizeInput.defaultProps = {
	minWidth: 1,
	injectStyles: true
};

exports.default = AutosizeInput;

/***/ }),

/***/ "../node_modules/react-select/lib/Async.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeAsyncSelect = exports.defaultProps = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _Select = __webpack_require__("../node_modules/react-select/lib/Select.js");

var _Select2 = _interopRequireDefault(_Select);

var _utils = __webpack_require__("../node_modules/react-select/lib/utils.js");

var _stateManager = __webpack_require__("../node_modules/react-select/lib/stateManager.js");

var _stateManager2 = _interopRequireDefault(_stateManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultProps = exports.defaultProps = {
  cacheOptions: false,
  defaultOptions: false
};

var makeAsyncSelect = function makeAsyncSelect(SelectComponent) {
  var _class, _temp;

  return _temp = _class = function (_Component) {
    _inherits(Async, _Component);

    function Async(props) {
      _classCallCheck(this, Async);

      var _this = _possibleConstructorReturn(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this));

      _this.mounted = false;
      _this.optionsCache = {};

      _this.handleInputChange = function (newValue, actionMeta) {
        var _this$props = _this.props,
            cacheOptions = _this$props.cacheOptions,
            onInputChange = _this$props.onInputChange;
        // TODO

        var inputValue = (0, _utils.handleInputChange)(newValue, actionMeta, onInputChange);
        if (!inputValue) {
          delete _this.lastRequest;
          _this.setState({
            inputValue: '',
            loadedInputValue: '',
            loadedOptions: [],
            isLoading: false,
            passEmptyOptions: false
          });
          return;
        }
        if (cacheOptions && _this.optionsCache[inputValue]) {
          _this.setState({
            inputValue: inputValue,
            loadedInputValue: inputValue,
            loadedOptions: _this.optionsCache[inputValue],
            isLoading: false,
            passEmptyOptions: false
          });
        } else {
          var request = _this.lastRequest = {};
          _this.setState({
            inputValue: inputValue,
            isLoading: true,
            passEmptyOptions: !_this.state.loadedInputValue
          }, function () {
            _this.loadOptions(inputValue, function (options) {
              if (!_this.mounted) return;
              if (options) {
                _this.optionsCache[inputValue] = options;
              }
              if (request !== _this.lastRequest) return;
              delete _this.lastRequest;
              _this.setState({
                isLoading: false,
                loadedInputValue: inputValue,
                loadedOptions: options || [],
                passEmptyOptions: false
              });
            });
          });
        }
        return inputValue;
      };

      _this.state = {
        defaultOptions: Array.isArray(props.defaultOptions) ? props.defaultOptions : undefined,
        inputValue: '',
        isLoading: props.defaultOptions === true ? true : false,
        loadedOptions: [],
        passEmptyOptions: false
      };
      return _this;
    }

    _createClass(Async, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        this.mounted = true;
        var defaultOptions = this.props.defaultOptions;

        if (defaultOptions === true) {
          this.loadOptions('', function (options) {
            if (!_this2.mounted) return;
            var isLoading = !!_this2.lastRequest;
            _this2.setState({ defaultOptions: options || [], isLoading: isLoading });
          });
        }
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        // if the cacheOptions prop changes, clear the cache
        if (nextProps.cacheOptions !== this.props.cacheOptions) {
          this.optionsCache = {};
        }
        if (nextProps.defaultOptions !== this.props.defaultOptions) {
          this.setState({
            defaultOptions: Array.isArray(nextProps.defaultOptions) ? nextProps.defaultOptions : undefined
          });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.mounted = false;
      }
    }, {
      key: 'focus',
      value: function focus() {
        this.select.focus();
      }
    }, {
      key: 'blur',
      value: function blur() {
        this.select.blur();
      }
    }, {
      key: 'loadOptions',
      value: function loadOptions(inputValue, callback) {
        var loadOptions = this.props.loadOptions;

        if (!loadOptions) return callback();
        var loader = loadOptions(inputValue, callback);
        if (loader && typeof loader.then === 'function') {
          loader.then(callback, function () {
            return callback();
          });
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _this3 = this;

        var _props = this.props,
            loadOptions = _props.loadOptions,
            props = _objectWithoutProperties(_props, ['loadOptions']);

        var _state = this.state,
            defaultOptions = _state.defaultOptions,
            inputValue = _state.inputValue,
            isLoading = _state.isLoading,
            loadedInputValue = _state.loadedInputValue,
            loadedOptions = _state.loadedOptions,
            passEmptyOptions = _state.passEmptyOptions;

        var options = passEmptyOptions ? [] : inputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
        return (
          // $FlowFixMe
          _react2.default.createElement(SelectComponent, _extends({}, props, {
            filterOption: this.props.filterOption || null,
            ref: function ref(_ref) {
              _this3.select = _ref;
            },
            options: options,
            isLoading: isLoading,
            onInputChange: this.handleInputChange
          }))
        );
      }
    }]);

    return Async;
  }(_react.Component), _class.defaultProps = defaultProps, _temp;
};

exports.makeAsyncSelect = makeAsyncSelect;
exports.default = makeAsyncSelect((0, _stateManager2.default)(_Select2.default));

/***/ }),

/***/ "../node_modules/react-select/lib/Select.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultProps = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _memoizeOne = __webpack_require__("../node_modules/memoize-one/dist/memoize-one.esm.js");

var _memoizeOne2 = _interopRequireDefault(_memoizeOne);

var _Menu = __webpack_require__("../node_modules/react-select/lib/components/Menu.js");

var _reactFastCompare = __webpack_require__("../node_modules/react-select/lib/internal/react-fast-compare.js");

var _reactFastCompare2 = _interopRequireDefault(_reactFastCompare);

var _filters = __webpack_require__("../node_modules/react-select/lib/filters.js");

var _index = __webpack_require__("../node_modules/react-select/lib/internal/index.js");

var _index2 = __webpack_require__("../node_modules/react-select/lib/accessibility/index.js");

var _utils = __webpack_require__("../node_modules/react-select/lib/utils.js");

var _builtins = __webpack_require__("../node_modules/react-select/lib/builtins.js");

var _index3 = __webpack_require__("../node_modules/react-select/lib/components/index.js");

var _styles = __webpack_require__("../node_modules/react-select/lib/styles.js");

var _theme = __webpack_require__("../node_modules/react-select/lib/theme.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultProps = exports.defaultProps = {
  backspaceRemovesValue: true,
  blurInputOnSelect: (0, _utils.isTouchCapable)(),
  captureMenuScroll: !(0, _utils.isTouchCapable)(),
  closeMenuOnSelect: true,
  closeMenuOnScroll: false,
  components: {},
  controlShouldRenderValue: true,
  escapeClearsValue: false,
  filterOption: (0, _filters.createFilter)(),
  formatGroupLabel: _builtins.formatGroupLabel,
  getOptionLabel: _builtins.getOptionLabel,
  getOptionValue: _builtins.getOptionValue,
  isDisabled: false,
  isLoading: false,
  isMulti: false,
  isRtl: false,
  isSearchable: true,
  isOptionDisabled: _builtins.isOptionDisabled,
  loadingMessage: function loadingMessage() {
    return 'Loading...';
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: false,
  menuPlacement: 'bottom',
  menuPosition: 'absolute',
  menuShouldBlockScroll: false,
  menuShouldScrollIntoView: !(0, _utils.isMobileDevice)(),
  noOptionsMessage: function noOptionsMessage() {
    return 'No options';
  },
  openMenuOnFocus: false,
  openMenuOnClick: true,
  options: [],
  pageSize: 5,
  placeholder: 'Select...',
  screenReaderStatus: function screenReaderStatus(_ref) {
    var count = _ref.count;
    return count + ' result' + (count !== 1 ? 's' : '') + ' available';
  },
  styles: {},
  tabIndex: '0',
  tabSelectsValue: true
};

var instanceId = 1;

var Select = function (_Component) {
  _inherits(Select, _Component);

  // Lifecycle
  // ------------------------------

  // Refs
  // ------------------------------

  // Misc. Instance Properties
  // ------------------------------

  function Select(props) {
    _classCallCheck(this, Select);

    var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

    _initialiseProps.call(_this);

    var value = props.value;

    _this.cacheComponents = (0, _memoizeOne2.default)(_this.cacheComponents, _reactFastCompare2.default).bind(_this);
    _this.cacheComponents(props.components);
    _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++instanceId);

    var selectValue = (0, _utils.cleanValue)(value);
    var menuOptions = _this.buildMenuOptions(props, selectValue);

    _this.state.menuOptions = menuOptions;
    _this.state.selectValue = selectValue;
    return _this;
  } // TODO


  _createClass(Select, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.startListeningComposition();
      this.startListeningToTouch();

      if (this.props.closeMenuOnScroll && document && document.addEventListener) {
        // Listen to all scroll events, and filter them out inside of 'onScroll'
        document.addEventListener('scroll', this.onScroll, true);
      }

      if (this.props.autoFocus) {
        this.focusInput();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props = this.props,
          options = _props.options,
          value = _props.value,
          inputValue = _props.inputValue;
      // re-cache custom components

      this.cacheComponents(nextProps.components);
      // rebuild the menu options
      if (nextProps.value !== value || nextProps.options !== options || nextProps.inputValue !== inputValue) {
        var _selectValue = (0, _utils.cleanValue)(nextProps.value);
        var _menuOptions = this.buildMenuOptions(nextProps, _selectValue);
        var _focusedValue = this.getNextFocusedValue(_selectValue);
        var _focusedOption = this.getNextFocusedOption(_menuOptions.focusable);
        this.setState({ menuOptions: _menuOptions, selectValue: _selectValue, focusedOption: _focusedOption, focusedValue: _focusedValue });
      }
      // some updates should toggle the state of the input visibility
      if (this.inputIsHiddenAfterUpdate != null) {
        this.setState({
          inputIsHidden: this.inputIsHiddenAfterUpdate
        });
        delete this.inputIsHiddenAfterUpdate;
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props2 = this.props,
          isDisabled = _props2.isDisabled,
          menuIsOpen = _props2.menuIsOpen;
      var isFocused = this.state.isFocused;


      if (
      // ensure focus is restored correctly when the control becomes enabled
      isFocused && !isDisabled && prevProps.isDisabled ||
      // ensure focus is on the Input when the menu opens
      isFocused && menuIsOpen && !prevProps.menuIsOpen) {
        this.focusInput();
      }

      // scroll the focused option into view if necessary
      if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
        (0, _utils.scrollIntoView)(this.menuListRef, this.focusedOptionRef);
      }
      this.scrollToFocusedOptionOnUpdate = false;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stopListeningComposition();
      this.stopListeningToTouch();
      document.removeEventListener('scroll', this.onScroll, true);
    }
  }, {
    key: 'onMenuOpen',

    // ==============================
    // Consumer Handlers
    // ==============================

    value: function onMenuOpen() {
      this.props.onMenuOpen();
    }
  }, {
    key: 'onMenuClose',
    value: function onMenuClose() {
      var _props3 = this.props,
          isSearchable = _props3.isSearchable,
          isMulti = _props3.isMulti;

      this.announceAriaLiveContext({
        event: 'input',
        context: { isSearchable: isSearchable, isMulti: isMulti }
      });
      this.onInputChange('', { action: 'menu-close' });
      this.props.onMenuClose();
    }
  }, {
    key: 'onInputChange',
    value: function onInputChange(newValue, actionMeta) {
      this.props.onInputChange(newValue, actionMeta);
    }

    // ==============================
    // Methods
    // ==============================

  }, {
    key: 'focusInput',
    value: function focusInput() {
      if (!this.inputRef) return;
      this.inputRef.focus();
    }
  }, {
    key: 'blurInput',
    value: function blurInput() {
      if (!this.inputRef) return;
      this.inputRef.blur();
    }

    // aliased for consumers

  }, {
    key: 'openMenu',
    value: function openMenu(focusOption) {
      var _state = this.state,
          menuOptions = _state.menuOptions,
          selectValue = _state.selectValue;
      var isMulti = this.props.isMulti;

      var openAtIndex = focusOption === 'first' ? 0 : menuOptions.focusable.length - 1;

      if (!isMulti) {
        var selectedIndex = menuOptions.focusable.indexOf(selectValue[0]);
        if (selectedIndex > -1) {
          openAtIndex = selectedIndex;
        }
      }

      this.scrollToFocusedOptionOnUpdate = true;
      this.inputIsHiddenAfterUpdate = false;

      this.onMenuOpen();
      this.setState({
        focusedValue: null,
        focusedOption: menuOptions.focusable[openAtIndex]
      });

      this.announceAriaLiveContext({ event: 'menu' });
    }
  }, {
    key: 'focusValue',
    value: function focusValue(direction) {
      var _props4 = this.props,
          isMulti = _props4.isMulti,
          isSearchable = _props4.isSearchable;
      var _state2 = this.state,
          selectValue = _state2.selectValue,
          focusedValue = _state2.focusedValue;

      // Only multiselects support value focusing

      if (!isMulti) return;

      this.setState({
        focusedOption: null
      });

      var focusedIndex = selectValue.indexOf(focusedValue);
      if (!focusedValue) {
        focusedIndex = -1;
        this.announceAriaLiveContext({ event: 'value' });
      }

      var lastIndex = selectValue.length - 1;
      var nextFocus = -1;
      if (!selectValue.length) return;

      switch (direction) {
        case 'previous':
          if (focusedIndex === 0) {
            // don't cycle from the start to the end
            nextFocus = 0;
          } else if (focusedIndex === -1) {
            // if nothing is focused, focus the last value first
            nextFocus = lastIndex;
          } else {
            nextFocus = focusedIndex - 1;
          }
          break;
        case 'next':
          if (focusedIndex > -1 && focusedIndex < lastIndex) {
            nextFocus = focusedIndex + 1;
          }
          break;
      }

      if (nextFocus === -1) {
        this.announceAriaLiveContext({
          event: 'input',
          context: { isSearchable: isSearchable, isMulti: isMulti }
        });
      }

      this.setState({
        inputIsHidden: nextFocus === -1 ? false : true,
        focusedValue: selectValue[nextFocus]
      });
    }
  }, {
    key: 'focusOption',
    value: function focusOption() {
      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
      var pageSize = this.props.pageSize;
      var _state3 = this.state,
          focusedOption = _state3.focusedOption,
          menuOptions = _state3.menuOptions;

      var options = menuOptions.focusable;

      if (!options.length) return;
      var nextFocus = 0; // handles 'first'
      var focusedIndex = options.indexOf(focusedOption);
      if (!focusedOption) {
        focusedIndex = -1;
        this.announceAriaLiveContext({ event: 'menu' });
      }

      if (direction === 'up') {
        nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
      } else if (direction === 'down') {
        nextFocus = (focusedIndex + 1) % options.length;
      } else if (direction === 'pageup') {
        nextFocus = focusedIndex - pageSize;
        if (nextFocus < 0) nextFocus = 0;
      } else if (direction === 'pagedown') {
        nextFocus = focusedIndex + pageSize;
        if (nextFocus > options.length - 1) nextFocus = options.length - 1;
      } else if (direction === 'last') {
        nextFocus = options.length - 1;
      }
      this.scrollToFocusedOptionOnUpdate = true;
      this.setState({
        focusedOption: options[nextFocus],
        focusedValue: null
      });
    }
  }, {
    key: 'getTheme',


    // ==============================
    // Getters
    // ==============================

    value: function getTheme() {
      // Use the default theme if there are no customizations.
      if (!this.props.theme) {
        return _theme.defaultTheme;
      }
      // If the theme prop is a function, assume the function
      // knows how to merge the passed-in default theme with
      // its own modifications.
      if (typeof this.props.theme === 'function') {
        return this.props.theme(_theme.defaultTheme);
      }
      // Otherwise, if a plain theme object was passed in,
      // overlay it with the default theme.
      return _extends({}, _theme.defaultTheme, this.props.theme);
    }
  }, {
    key: 'getCommonProps',
    value: function getCommonProps() {
      var clearValue = this.clearValue,
          getStyles = this.getStyles,
          setValue = this.setValue,
          selectOption = this.selectOption,
          props = this.props;
      var classNamePrefix = props.classNamePrefix,
          isMulti = props.isMulti,
          isRtl = props.isRtl,
          options = props.options;
      var selectValue = this.state.selectValue;

      var hasValue = this.hasValue();
      var getValue = function getValue() {
        return selectValue;
      };
      var cxPrefix = classNamePrefix;

      var cx = _utils.classNames.bind(null, cxPrefix);
      return {
        cx: cx,
        clearValue: clearValue,
        getStyles: getStyles,
        getValue: getValue,
        hasValue: hasValue,
        isMulti: isMulti,
        isRtl: isRtl,
        options: options,
        selectOption: selectOption,
        setValue: setValue,
        selectProps: props,
        theme: this.getTheme()
      };
    }
  }, {
    key: 'getNextFocusedValue',
    value: function getNextFocusedValue(nextSelectValue) {
      if (this.clearFocusValueOnUpdate) {
        this.clearFocusValueOnUpdate = false;
        return null;
      }
      var _state4 = this.state,
          focusedValue = _state4.focusedValue,
          lastSelectValue = _state4.selectValue;

      var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
      if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) {
          // the focused value is still in the selectValue, return it
          return focusedValue;
        } else if (lastFocusedIndex < nextSelectValue.length) {
          // the focusedValue is not present in the next selectValue array by
          // reference, so return the new value at the same index
          return nextSelectValue[lastFocusedIndex];
        }
      }
      return null;
    }
  }, {
    key: 'getNextFocusedOption',
    value: function getNextFocusedOption(options) {
      var lastFocusedOption = this.state.focusedOption;

      return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
    }

    // ==============================
    // Helpers
    // ==============================

  }, {
    key: 'hasValue',
    value: function hasValue() {
      var selectValue = this.state.selectValue;

      return selectValue.length > 0;
    }
  }, {
    key: 'hasOptions',
    value: function hasOptions() {
      return !!this.state.menuOptions.render.length;
    }
  }, {
    key: 'countOptions',
    value: function countOptions() {
      return this.state.menuOptions.focusable.length;
    }
  }, {
    key: 'isClearable',
    value: function isClearable() {
      var _props5 = this.props,
          isClearable = _props5.isClearable,
          isMulti = _props5.isMulti;

      // single select, by default, IS NOT clearable
      // multi select, by default, IS clearable

      if (isClearable === undefined) return isMulti;

      return isClearable;
    }
  }, {
    key: 'isOptionDisabled',
    value: function isOptionDisabled(option, selectValue) {
      return typeof this.props.isOptionDisabled === 'function' ? this.props.isOptionDisabled(option, selectValue) : false;
    }
  }, {
    key: 'isOptionSelected',
    value: function isOptionSelected(option, selectValue) {
      var _this2 = this;

      if (selectValue.indexOf(option) > -1) return true;
      if (typeof this.props.isOptionSelected === 'function') {
        return this.props.isOptionSelected(option, selectValue);
      }
      var candidate = this.getOptionValue(option);
      return selectValue.some(function (i) {
        return _this2.getOptionValue(i) === candidate;
      });
    }
  }, {
    key: 'filterOption',
    value: function filterOption(option, inputValue) {
      return this.props.filterOption ? this.props.filterOption(option, inputValue) : true;
    }
  }, {
    key: 'formatOptionLabel',
    value: function formatOptionLabel(data, context) {
      if (typeof this.props.formatOptionLabel === 'function') {
        var _inputValue = this.props.inputValue;
        var _selectValue2 = this.state.selectValue;

        return this.props.formatOptionLabel(data, {
          context: context,
          inputValue: _inputValue,
          selectValue: _selectValue2
        });
      } else {
        return this.getOptionLabel(data);
      }
    }
  }, {
    key: 'formatGroupLabel',
    value: function formatGroupLabel(data) {
      return this.props.formatGroupLabel(data);
    }

    // ==============================
    // Mouse Handlers
    // ==============================

  }, {
    key: 'startListeningComposition',


    // ==============================
    // Composition Handlers
    // ==============================

    value: function startListeningComposition() {
      if (document && document.addEventListener) {
        document.addEventListener('compositionstart', this.onCompositionStart, false);
        document.addEventListener('compositionend', this.onCompositionEnd, false);
      }
    }
  }, {
    key: 'stopListeningComposition',
    value: function stopListeningComposition() {
      if (document && document.removeEventListener) {
        document.removeEventListener('compositionstart', this.onCompositionStart);
        document.removeEventListener('compositionend', this.onCompositionEnd);
      }
    }
  }, {
    key: 'startListeningToTouch',


    // ==============================
    // Touch Handlers
    // ==============================

    value: function startListeningToTouch() {
      if (document && document.addEventListener) {
        document.addEventListener('touchstart', this.onTouchStart, false);
        document.addEventListener('touchmove', this.onTouchMove, false);
        document.addEventListener('touchend', this.onTouchEnd, false);
      }
    }
  }, {
    key: 'stopListeningToTouch',
    value: function stopListeningToTouch() {
      if (document && document.removeEventListener) {
        document.removeEventListener('touchstart', this.onTouchStart);
        document.removeEventListener('touchmove', this.onTouchMove);
        document.removeEventListener('touchend', this.onTouchEnd);
      }
    }

    // ==============================
    // Focus Handlers
    // ==============================

    // ==============================
    // Keyboard Handlers
    // ==============================

  }, {
    key: 'buildMenuOptions',


    // ==============================
    // Menu Options
    // ==============================

    value: function buildMenuOptions(props, selectValue) {
      var _this3 = this;

      var _props$inputValue = props.inputValue,
          inputValue = _props$inputValue === undefined ? '' : _props$inputValue,
          options = props.options;


      var toOption = function toOption(option, id) {
        var isDisabled = _this3.isOptionDisabled(option, selectValue);
        var isSelected = _this3.isOptionSelected(option, selectValue);
        var label = _this3.getOptionLabel(option);
        var value = _this3.getOptionValue(option);

        if (_this3.shouldHideSelectedOptions() && isSelected || !_this3.filterOption({ label: label, value: value, data: option }, inputValue)) {
          return;
        }

        var onHover = isDisabled ? undefined : function () {
          return _this3.onOptionHover(option);
        };
        var onSelect = isDisabled ? undefined : function () {
          return _this3.selectOption(option);
        };
        var optionId = _this3.getElementId('option') + '-' + id;

        return {
          innerProps: {
            id: optionId,
            onClick: onSelect,
            onMouseMove: onHover,
            onMouseOver: onHover,
            role: 'option',
            tabIndex: -1
          },
          data: option,
          isDisabled: isDisabled,
          isSelected: isSelected,
          key: optionId,
          label: label,
          type: 'option',
          value: value
        };
      };

      return options.reduce(function (acc, item, itemIndex) {
        if (item.options) {
          // TODO needs a tidier implementation
          if (!_this3.hasGroups) _this3.hasGroups = true;

          var items = item.options;

          var children = items.map(function (child, i) {
            var option = toOption(child, itemIndex + '-' + i);
            if (option && !option.isDisabled) acc.focusable.push(child);
            return option;
          }).filter(Boolean);
          if (children.length) {
            var groupId = _this3.getElementId('group') + '-' + itemIndex;
            acc.render.push({
              type: 'group',
              key: groupId,
              data: item,
              options: children
            });
          }
        } else {
          var option = toOption(item, '' + itemIndex);
          if (option) {
            acc.render.push(option);
            if (!option.isDisabled) acc.focusable.push(item);
          }
        }
        return acc;
      }, { render: [], focusable: [] });
    }

    // ==============================
    // Renderers
    // ==============================

  }, {
    key: 'constructAriaLiveMessage',
    value: function constructAriaLiveMessage() {
      var _state5 = this.state,
          ariaLiveContext = _state5.ariaLiveContext,
          selectValue = _state5.selectValue,
          focusedValue = _state5.focusedValue,
          focusedOption = _state5.focusedOption;
      var _props6 = this.props,
          options = _props6.options,
          menuIsOpen = _props6.menuIsOpen,
          inputValue = _props6.inputValue,
          screenReaderStatus = _props6.screenReaderStatus;

      // An aria live message representing the currently focused value in the select.

      var focusedValueMsg = focusedValue ? (0, _index2.valueFocusAriaMessage)({
        focusedValue: focusedValue,
        getOptionLabel: this.getOptionLabel,
        selectValue: selectValue
      }) : '';
      // An aria live message representing the currently focused option in the select.
      var focusedOptionMsg = focusedOption && menuIsOpen ? (0, _index2.optionFocusAriaMessage)({
        focusedOption: focusedOption,
        getOptionLabel: this.getOptionLabel,
        options: options
      }) : '';
      // An aria live message representing the set of focusable results and current searchterm/inputvalue.
      var resultsMsg = (0, _index2.resultsAriaMessage)({
        inputValue: inputValue,
        screenReaderMessage: screenReaderStatus({ count: this.countOptions() })
      });

      return focusedValueMsg + ' ' + focusedOptionMsg + ' ' + resultsMsg + ' ' + ariaLiveContext;
    }
  }, {
    key: 'renderInput',
    value: function renderInput() {
      var _props7 = this.props,
          isDisabled = _props7.isDisabled,
          isSearchable = _props7.isSearchable,
          inputId = _props7.inputId,
          inputValue = _props7.inputValue,
          tabIndex = _props7.tabIndex;
      var Input = this.components.Input;
      var inputIsHidden = this.state.inputIsHidden;


      var id = inputId || this.getElementId('input');

      if (!isSearchable) {
        // use a dummy input to maintain focus/blur functionality
        return _react2.default.createElement(_index.DummyInput, {
          id: id,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: _utils.noop,
          onFocus: this.onInputFocus,
          readOnly: true,
          tabIndex: tabIndex,
          value: ''
        });
      }

      // aria attributes makes the JSX "noisy", separated for clarity
      var ariaAttributes = {
        'aria-autocomplete': 'list',
        'aria-label': this.props['aria-label'],
        'aria-labelledby': this.props['aria-labelledby']
      };

      var _commonProps = this.commonProps,
          cx = _commonProps.cx,
          theme = _commonProps.theme;


      return _react2.default.createElement(Input, _extends({
        autoCapitalize: 'none',
        autoComplete: 'off',
        autoCorrect: 'off',
        cx: cx,
        getStyles: this.getStyles,
        id: id,
        innerRef: this.getInputRef,
        isDisabled: isDisabled,
        isHidden: inputIsHidden,
        onBlur: this.onInputBlur,
        onChange: this.handleInputChange,
        onFocus: this.onInputFocus,
        spellCheck: 'false',
        tabIndex: tabIndex,
        theme: theme,
        type: 'text',
        value: inputValue
      }, ariaAttributes));
    }
  }, {
    key: 'renderPlaceholderOrValue',
    value: function renderPlaceholderOrValue() {
      var _this4 = this;

      var _components = this.components,
          MultiValue = _components.MultiValue,
          MultiValueContainer = _components.MultiValueContainer,
          MultiValueLabel = _components.MultiValueLabel,
          MultiValueRemove = _components.MultiValueRemove,
          SingleValue = _components.SingleValue,
          Placeholder = _components.Placeholder;
      var commonProps = this.commonProps;
      var _props8 = this.props,
          controlShouldRenderValue = _props8.controlShouldRenderValue,
          isDisabled = _props8.isDisabled,
          isMulti = _props8.isMulti,
          inputValue = _props8.inputValue,
          placeholder = _props8.placeholder;
      var _state6 = this.state,
          selectValue = _state6.selectValue,
          focusedValue = _state6.focusedValue;


      if (!this.hasValue() || !controlShouldRenderValue) {
        return inputValue ? null : _react2.default.createElement(
          Placeholder,
          _extends({}, commonProps, { key: 'placeholder', isDisabled: isDisabled }),
          placeholder
        );
      }

      if (isMulti) {
        var selectValues = selectValue.map(function (opt) {
          var isFocused = opt === focusedValue;
          return _react2.default.createElement(
            MultiValue,
            _extends({}, commonProps, {
              components: {
                Container: MultiValueContainer,
                Label: MultiValueLabel,
                Remove: MultiValueRemove
              },
              isFocused: isFocused,
              isDisabled: isDisabled,
              key: _this4.getOptionValue(opt),
              removeProps: {
                onClick: function onClick() {
                  return _this4.removeValue(opt);
                },
                onTouchEnd: function onTouchEnd() {
                  return _this4.removeValue(opt);
                },
                onMouseDown: function onMouseDown(e) {
                  e.preventDefault();
                  e.stopPropagation();
                }
              },
              data: opt
            }),
            _this4.formatOptionLabel(opt, 'value')
          );
        });
        return selectValues;
      }

      if (inputValue) {
        return null;
      }

      var singleValue = selectValue[0];
      return _react2.default.createElement(
        SingleValue,
        _extends({}, commonProps, { data: singleValue, isDisabled: isDisabled }),
        this.formatOptionLabel(singleValue, 'value')
      );
    }
  }, {
    key: 'renderClearIndicator',
    value: function renderClearIndicator() {
      var ClearIndicator = this.components.ClearIndicator;
      var commonProps = this.commonProps;
      var _props9 = this.props,
          isDisabled = _props9.isDisabled,
          isLoading = _props9.isLoading;
      var isFocused = this.state.isFocused;


      if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) {
        return null;
      }

      var innerProps = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        'aria-hidden': 'true'
      };

      return _react2.default.createElement(ClearIndicator, _extends({}, commonProps, {
        innerProps: innerProps,
        isFocused: isFocused
      }));
    }
  }, {
    key: 'renderLoadingIndicator',
    value: function renderLoadingIndicator() {
      var LoadingIndicator = this.components.LoadingIndicator;
      var commonProps = this.commonProps;
      var _props10 = this.props,
          isDisabled = _props10.isDisabled,
          isLoading = _props10.isLoading;
      var isFocused = this.state.isFocused;


      if (!LoadingIndicator || !isLoading) return null;

      var innerProps = { 'aria-hidden': 'true' };
      return _react2.default.createElement(LoadingIndicator, _extends({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: 'renderIndicatorSeparator',
    value: function renderIndicatorSeparator() {
      var _components2 = this.components,
          DropdownIndicator = _components2.DropdownIndicator,
          IndicatorSeparator = _components2.IndicatorSeparator;

      // separator doesn't make sense without the dropdown indicator

      if (!DropdownIndicator || !IndicatorSeparator) return null;

      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;


      return _react2.default.createElement(IndicatorSeparator, _extends({}, commonProps, {
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: 'renderDropdownIndicator',
    value: function renderDropdownIndicator() {
      var DropdownIndicator = this.components.DropdownIndicator;

      if (!DropdownIndicator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;


      var innerProps = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        'aria-hidden': 'true'
      };

      return _react2.default.createElement(DropdownIndicator, _extends({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: 'renderMenu',
    value: function renderMenu() {
      var _this5 = this;

      var _components3 = this.components,
          Group = _components3.Group,
          GroupHeading = _components3.GroupHeading,
          Menu = _components3.Menu,
          MenuList = _components3.MenuList,
          MenuPortal = _components3.MenuPortal,
          LoadingMessage = _components3.LoadingMessage,
          NoOptionsMessage = _components3.NoOptionsMessage,
          Option = _components3.Option;
      var commonProps = this.commonProps;
      var _state7 = this.state,
          focusedOption = _state7.focusedOption,
          menuOptions = _state7.menuOptions;
      var _props11 = this.props,
          captureMenuScroll = _props11.captureMenuScroll,
          inputValue = _props11.inputValue,
          isLoading = _props11.isLoading,
          loadingMessage = _props11.loadingMessage,
          minMenuHeight = _props11.minMenuHeight,
          maxMenuHeight = _props11.maxMenuHeight,
          menuIsOpen = _props11.menuIsOpen,
          menuPlacement = _props11.menuPlacement,
          menuPosition = _props11.menuPosition,
          menuPortalTarget = _props11.menuPortalTarget,
          menuShouldBlockScroll = _props11.menuShouldBlockScroll,
          menuShouldScrollIntoView = _props11.menuShouldScrollIntoView,
          noOptionsMessage = _props11.noOptionsMessage,
          onMenuScrollToTop = _props11.onMenuScrollToTop,
          onMenuScrollToBottom = _props11.onMenuScrollToBottom;


      if (!menuIsOpen) return null;

      // TODO: Internal Option Type here
      var render = function render(props) {
        // for performance, the menu options in state aren't changed when the
        // focused option changes so we calculate additional props based on that
        var isFocused = focusedOption === props.data;
        props.innerRef = isFocused ? _this5.getFocusedOptionRef : undefined;

        return _react2.default.createElement(
          Option,
          _extends({}, commonProps, props, { isFocused: isFocused }),
          _this5.formatOptionLabel(props.data, 'menu')
        );
      };

      var menuUI = void 0;

      if (this.hasOptions()) {
        menuUI = menuOptions.render.map(function (item) {
          if (item.type === 'group') {
            var type = item.type,
                group = _objectWithoutProperties(item, ['type']);

            var headingId = item.key + '-heading';

            return _react2.default.createElement(
              Group,
              _extends({}, commonProps, group, {
                Heading: GroupHeading,
                headingProps: {
                  id: headingId
                },
                label: _this5.formatGroupLabel(item.data)
              }),
              item.options.map(function (option) {
                return render(option);
              })
            );
          } else if (item.type === 'option') {
            return render(item);
          }
        });
      } else if (isLoading) {
        var message = loadingMessage({ inputValue: inputValue });
        if (message === null) return null;
        menuUI = _react2.default.createElement(
          LoadingMessage,
          commonProps,
          message
        );
      } else {
        var _message = noOptionsMessage({ inputValue: inputValue });
        if (_message === null) return null;
        menuUI = _react2.default.createElement(
          NoOptionsMessage,
          commonProps,
          _message
        );
      }
      var menuPlacementProps = {
        minMenuHeight: minMenuHeight,
        maxMenuHeight: maxMenuHeight,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition,
        menuShouldScrollIntoView: menuShouldScrollIntoView
      };

      var menuElement = _react2.default.createElement(
        _Menu.MenuPlacer,
        _extends({}, commonProps, menuPlacementProps),
        function (_ref2) {
          var ref = _ref2.ref,
              _ref2$placerProps = _ref2.placerProps,
              placement = _ref2$placerProps.placement,
              maxHeight = _ref2$placerProps.maxHeight;
          return _react2.default.createElement(
            Menu,
            _extends({}, commonProps, menuPlacementProps, {
              innerRef: ref,
              innerProps: {
                onMouseDown: _this5.onMenuMouseDown,
                onMouseMove: _this5.onMenuMouseMove
              },
              isLoading: isLoading,
              placement: placement
            }),
            _react2.default.createElement(
              _index.ScrollCaptor,
              {
                isEnabled: captureMenuScroll,
                onTopArrive: onMenuScrollToTop,
                onBottomArrive: onMenuScrollToBottom
              },
              _react2.default.createElement(
                _index.ScrollBlock,
                { isEnabled: menuShouldBlockScroll },
                _react2.default.createElement(
                  MenuList,
                  _extends({}, commonProps, {
                    innerRef: _this5.getMenuListRef,
                    isLoading: isLoading,
                    maxHeight: maxHeight
                  }),
                  menuUI
                )
              )
            )
          );
        }
      );

      // positioning behaviour is almost identical for portalled and fixed,
      // so we use the same component. the actual portalling logic is forked
      // within the component based on `menuPosition`
      return menuPortalTarget || menuPosition === 'fixed' ? _react2.default.createElement(
        MenuPortal,
        _extends({}, commonProps, {
          appendTo: menuPortalTarget,
          controlElement: this.controlRef,
          menuPlacement: menuPlacement,
          menuPosition: menuPosition
        }),
        menuElement
      ) : menuElement;
    }
  }, {
    key: 'renderFormField',
    value: function renderFormField() {
      var _this6 = this;

      var _props12 = this.props,
          delimiter = _props12.delimiter,
          isDisabled = _props12.isDisabled,
          isMulti = _props12.isMulti,
          name = _props12.name;
      var selectValue = this.state.selectValue;


      if (!name || isDisabled) return;

      if (isMulti) {
        if (delimiter) {
          var _value = selectValue.map(function (opt) {
            return _this6.getOptionValue(opt);
          }).join(delimiter);
          return _react2.default.createElement('input', { name: name, type: 'hidden', value: _value });
        } else {
          var input = selectValue.length > 0 ? selectValue.map(function (opt, i) {
            return _react2.default.createElement('input', {
              key: 'i-' + i,
              name: name,
              type: 'hidden',
              value: _this6.getOptionValue(opt)
            });
          }) : _react2.default.createElement('input', { name: name, type: 'hidden' });

          return _react2.default.createElement(
            'div',
            null,
            input
          );
        }
      } else {
        var _value2 = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
        return _react2.default.createElement('input', { name: name, type: 'hidden', value: _value2 });
      }
    }
  }, {
    key: 'renderLiveRegion',
    value: function renderLiveRegion() {
      if (!this.state.isFocused) return null;
      return _react2.default.createElement(
        _index.A11yText,
        { 'aria-live': 'assertive' },
        _react2.default.createElement(
          'p',
          { id: 'aria-selection-event' },
          '\xA0',
          this.state.ariaLiveSelection
        ),
        _react2.default.createElement(
          'p',
          { id: 'aria-context' },
          '\xA0',
          this.constructAriaLiveMessage()
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _components4 = this.components,
          Control = _components4.Control,
          IndicatorsContainer = _components4.IndicatorsContainer,
          SelectContainer = _components4.SelectContainer,
          ValueContainer = _components4.ValueContainer;
      var _props13 = this.props,
          className = _props13.className,
          id = _props13.id,
          isDisabled = _props13.isDisabled;
      var isFocused = this.state.isFocused;


      var commonProps = this.commonProps = this.getCommonProps();

      return _react2.default.createElement(
        SelectContainer,
        _extends({}, commonProps, {
          className: className,
          innerProps: {
            id: id,
            onKeyDown: this.onKeyDown
          },
          isDisabled: isDisabled,
          isFocused: isFocused
        }),
        this.renderLiveRegion(),
        _react2.default.createElement(
          Control,
          _extends({}, commonProps, {
            innerRef: this.getControlRef,
            innerProps: {
              onMouseDown: this.onControlMouseDown,
              onTouchEnd: this.onControlTouchEnd
            },
            isDisabled: isDisabled,
            isFocused: isFocused
          }),
          _react2.default.createElement(
            ValueContainer,
            _extends({}, commonProps, { isDisabled: isDisabled }),
            this.renderPlaceholderOrValue(),
            this.renderInput()
          ),
          _react2.default.createElement(
            IndicatorsContainer,
            _extends({}, commonProps, { isDisabled: isDisabled }),
            this.renderClearIndicator(),
            this.renderLoadingIndicator(),
            this.renderIndicatorSeparator(),
            this.renderDropdownIndicator()
          )
        ),
        this.renderMenu(),
        this.renderFormField()
      );
    }
  }]);

  return Select;
}(_react.Component);

Select.defaultProps = defaultProps;

var _initialiseProps = function _initialiseProps() {
  var _this7 = this;

  this.state = {
    ariaLiveSelection: '',
    ariaLiveContext: '',
    focusedOption: null,
    focusedValue: null,
    inputIsHidden: false,
    isFocused: false,
    isComposing: false,
    menuOptions: { render: [], focusable: [] },
    selectValue: []
  };
  this.blockOptionHover = false;
  this.clearFocusValueOnUpdate = false;
  this.hasGroups = false;
  this.initialTouchX = 0;
  this.initialTouchY = 0;
  this.instancePrefix = '';
  this.openAfterFocus = false;
  this.scrollToFocusedOptionOnUpdate = false;
  this.controlRef = null;

  this.getControlRef = function (ref) {
    _this7.controlRef = ref;
  };

  this.focusedOptionRef = null;

  this.getFocusedOptionRef = function (ref) {
    _this7.focusedOptionRef = ref;
  };

  this.menuListRef = null;

  this.getMenuListRef = function (ref) {
    _this7.menuListRef = ref;
  };

  this.inputRef = null;

  this.getInputRef = function (ref) {
    _this7.inputRef = ref;
  };

  this.cacheComponents = function (components) {
    _this7.components = (0, _index3.defaultComponents)({ components: components });
  };

  this.focus = this.focusInput;
  this.blur = this.blurInput;

  this.setValue = function (newValue) {
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'set-value';
    var option = arguments[2];
    var _props14 = _this7.props,
        closeMenuOnSelect = _props14.closeMenuOnSelect,
        isMulti = _props14.isMulti,
        onChange = _props14.onChange;

    _this7.onInputChange('', { action: 'set-value' });
    if (closeMenuOnSelect) {
      _this7.inputIsHiddenAfterUpdate = !isMulti;
      _this7.onMenuClose();
    }
    // when the select value should change, we should reset focusedValue
    _this7.clearFocusValueOnUpdate = true;
    onChange(newValue, { action: action, option: option });
  };

  this.selectOption = function (newValue) {
    var _props15 = _this7.props,
        blurInputOnSelect = _props15.blurInputOnSelect,
        isMulti = _props15.isMulti;


    if (isMulti) {
      var _selectValue3 = _this7.state.selectValue;

      if (_this7.isOptionSelected(newValue, _selectValue3)) {
        var candidate = _this7.getOptionValue(newValue);
        _this7.setValue(_selectValue3.filter(function (i) {
          return _this7.getOptionValue(i) !== candidate;
        }), 'deselect-option', newValue);
        _this7.announceAriaLiveSelection({
          event: 'deselect-option',
          context: { value: _this7.getOptionLabel(newValue) }
        });
      } else {
        _this7.setValue([].concat(_toConsumableArray(_selectValue3), [newValue]), 'select-option', newValue);
        _this7.announceAriaLiveSelection({
          event: 'select-option',
          context: { value: _this7.getOptionLabel(newValue) }
        });
      }
    } else {
      _this7.setValue(newValue, 'select-option');
      _this7.announceAriaLiveSelection({
        event: 'select-option',
        context: { value: _this7.getOptionLabel(newValue) }
      });
    }

    if (blurInputOnSelect) {
      _this7.blurInput();
    }
  };

  this.removeValue = function (removedValue) {
    var onChange = _this7.props.onChange;
    var selectValue = _this7.state.selectValue;

    var candidate = _this7.getOptionValue(removedValue);
    onChange(selectValue.filter(function (i) {
      return _this7.getOptionValue(i) !== candidate;
    }), {
      action: 'remove-value',
      removedValue: removedValue
    });
    _this7.announceAriaLiveSelection({
      event: 'remove-value',
      context: {
        value: removedValue ? _this7.getOptionLabel(removedValue) : undefined
      }
    });
    _this7.focusInput();
  };

  this.clearValue = function () {
    var _props16 = _this7.props,
        isMulti = _props16.isMulti,
        onChange = _props16.onChange;

    onChange(isMulti ? [] : null, { action: 'clear' });
  };

  this.popValue = function () {
    var onChange = _this7.props.onChange;
    var selectValue = _this7.state.selectValue;

    var lastSelectedValue = selectValue[selectValue.length - 1];
    _this7.announceAriaLiveSelection({
      event: 'pop-value',
      context: {
        value: lastSelectedValue ? _this7.getOptionLabel(lastSelectedValue) : undefined
      }
    });
    onChange(selectValue.slice(0, selectValue.length - 1), {
      action: 'pop-value',
      removedValue: lastSelectedValue
    });
  };

  this.getOptionLabel = function (data) {
    return _this7.props.getOptionLabel(data);
  };

  this.getOptionValue = function (data) {
    return _this7.props.getOptionValue(data);
  };

  this.getStyles = function (key, props) {
    var base = _styles.defaultStyles[key](props);
    base.boxSizing = 'border-box';
    var custom = _this7.props.styles[key];
    return custom ? custom(base, props) : base;
  };

  this.getElementId = function (element) {
    return _this7.instancePrefix + '-' + element;
  };

  this.getActiveDescendentId = function () {
    var menuIsOpen = _this7.props.menuIsOpen;
    var _state8 = _this7.state,
        menuOptions = _state8.menuOptions,
        focusedOption = _state8.focusedOption;


    if (!focusedOption || !menuIsOpen) return undefined;

    var index = menuOptions.focusable.indexOf(focusedOption);
    var option = menuOptions.render[index];

    return option && option.key;
  };

  this.announceAriaLiveSelection = function (_ref3) {
    var event = _ref3.event,
        context = _ref3.context;

    _this7.setState({
      ariaLiveSelection: (0, _index2.valueEventAriaMessage)(event, context)
    });
  };

  this.announceAriaLiveContext = function (_ref4) {
    var event = _ref4.event,
        context = _ref4.context;

    _this7.setState({
      ariaLiveContext: (0, _index2.instructionsAriaMessage)(event, _extends({}, context, {
        label: _this7.props['aria-label']
      }))
    });
  };

  this.onMenuMouseDown = function (event) {
    if (event.button !== 0) {
      return;
    }
    event.stopPropagation();
    event.preventDefault();
    _this7.focusInput();
  };

  this.onMenuMouseMove = function (event) {
    _this7.blockOptionHover = false;
  };

  this.onControlMouseDown = function (event) {
    var openMenuOnClick = _this7.props.openMenuOnClick;

    if (!_this7.state.isFocused) {
      if (openMenuOnClick) {
        _this7.openAfterFocus = true;
      }
      _this7.focusInput();
    } else if (!_this7.props.menuIsOpen) {
      _this7.openMenu('first');
    } else {
      _this7.onMenuClose();
    }
    // $FlowFixMe HTMLElement type does not have tagName property
    if (event.target.tagName !== 'INPUT') {
      event.preventDefault();
    }
  };

  this.onDropdownIndicatorMouseDown = function (event) {
    // ignore mouse events that weren't triggered by the primary button
    if (event && event.type === 'mousedown' && event.button !== 0) {
      return;
    }
    if (_this7.props.isDisabled) return;
    var _props17 = _this7.props,
        isMulti = _props17.isMulti,
        menuIsOpen = _props17.menuIsOpen;

    _this7.focusInput();
    if (menuIsOpen) {
      _this7.inputIsHiddenAfterUpdate = !isMulti;
      _this7.onMenuClose();
    } else {
      _this7.openMenu('first');
    }
    event.preventDefault();
    event.stopPropagation();
  };

  this.onClearIndicatorMouseDown = function (event) {
    // ignore mouse events that weren't triggered by the primary button
    if (event && event.type === 'mousedown' && event.button !== 0) {
      return;
    }
    _this7.clearValue();
    event.stopPropagation();
    _this7.openAfterFocus = false;
    setTimeout(function () {
      return _this7.focusInput();
    });
  };

  this.onScroll = function (event) {
    if (typeof _this7.props.closeMenuOnScroll === 'boolean') {
      if (event.target instanceof HTMLElement && (0, _utils.isDocumentElement)(event.target)) {
        _this7.props.onMenuClose();
      }
    } else if (typeof _this7.props.closeMenuOnScroll === 'function') {
      if (_this7.props.closeMenuOnScroll(event)) {
        _this7.props.onMenuClose();
      }
    }
  };

  this.onCompositionStart = function () {
    _this7.setState({
      isComposing: true
    });
  };

  this.onCompositionEnd = function () {
    _this7.setState({
      isComposing: false
    });
  };

  this.onTouchStart = function (_ref5) {
    var _ref5$touches = _slicedToArray(_ref5.touches, 1),
        touch = _ref5$touches[0];

    _this7.initialTouchX = touch.clientX;
    _this7.initialTouchY = touch.clientY;
    _this7.userIsDragging = false;
  };

  this.onTouchMove = function (_ref6) {
    var _ref6$touches = _slicedToArray(_ref6.touches, 1),
        touch = _ref6$touches[0];

    var deltaX = Math.abs(touch.clientX - _this7.initialTouchX);
    var deltaY = Math.abs(touch.clientY - _this7.initialTouchY);
    var moveThreshold = 5;

    _this7.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
  };

  this.onTouchEnd = function (event) {
    if (_this7.userIsDragging) return;

    // type cast the EventTarget
    var target = event.target;

    // close the menu if the user taps outside
    if (_this7.controlRef && !_this7.controlRef.contains(target) && _this7.menuListRef && !_this7.menuListRef.contains(target)) {
      _this7.blurInput();
    }

    // reset move vars
    _this7.initialTouchX = 0;
    _this7.initialTouchY = 0;
  };

  this.onControlTouchEnd = function (event) {
    if (_this7.userIsDragging) return;

    _this7.onControlMouseDown(event);
  };

  this.onClearIndicatorTouchEnd = function (event) {
    if (_this7.userIsDragging) return;

    _this7.onClearIndicatorMouseDown(event);
  };

  this.onDropdownIndicatorTouchEnd = function (event) {
    if (_this7.userIsDragging) return;

    _this7.onDropdownIndicatorMouseDown(event);
  };

  this.handleInputChange = function (event) {
    var inputValue = event.currentTarget.value;
    _this7.inputIsHiddenAfterUpdate = false;
    _this7.onInputChange(inputValue, { action: 'input-change' });
    _this7.onMenuOpen();
  };

  this.onInputFocus = function (event) {
    var _props18 = _this7.props,
        isSearchable = _props18.isSearchable,
        isMulti = _props18.isMulti;

    if (_this7.props.onFocus) {
      _this7.props.onFocus(event);
    }
    _this7.inputIsHiddenAfterUpdate = false;
    _this7.announceAriaLiveContext({
      event: 'input',
      context: { isSearchable: isSearchable, isMulti: isMulti }
    });
    _this7.setState({
      isFocused: true
    });
    if (_this7.openAfterFocus || _this7.props.openMenuOnFocus) {
      _this7.openMenu('first');
    }
    _this7.openAfterFocus = false;
  };

  this.onInputBlur = function (event) {
    if (_this7.props.onBlur) {
      _this7.props.onBlur(event);
    }
    _this7.onInputChange('', { action: 'input-blur' });
    _this7.onMenuClose();
    _this7.setState({
      focusedValue: null,
      isFocused: false
    });
  };

  this.onOptionHover = function (focusedOption) {
    if (_this7.blockOptionHover || _this7.state.focusedOption === focusedOption) {
      return;
    }
    _this7.setState({ focusedOption: focusedOption });
  };

  this.shouldHideSelectedOptions = function () {
    var _props19 = _this7.props,
        hideSelectedOptions = _props19.hideSelectedOptions,
        isMulti = _props19.isMulti;

    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
  };

  this.onKeyDown = function (event) {
    var _props20 = _this7.props,
        isMulti = _props20.isMulti,
        backspaceRemovesValue = _props20.backspaceRemovesValue,
        escapeClearsValue = _props20.escapeClearsValue,
        inputValue = _props20.inputValue,
        isClearable = _props20.isClearable,
        isDisabled = _props20.isDisabled,
        menuIsOpen = _props20.menuIsOpen,
        onKeyDown = _props20.onKeyDown,
        tabSelectsValue = _props20.tabSelectsValue,
        openMenuOnFocus = _props20.openMenuOnFocus;
    var _state9 = _this7.state,
        isComposing = _state9.isComposing,
        focusedOption = _state9.focusedOption,
        focusedValue = _state9.focusedValue,
        selectValue = _state9.selectValue;


    if (isDisabled) return;

    if (typeof onKeyDown === 'function') {
      onKeyDown(event);
      if (event.defaultPrevented) {
        return;
      }
    }

    // Block option hover events when the user has just pressed a key
    _this7.blockOptionHover = true;
    switch (event.key) {
      case 'ArrowLeft':
        if (!isMulti || inputValue) return;
        _this7.focusValue('previous');
        break;
      case 'ArrowRight':
        if (!isMulti || inputValue) return;
        _this7.focusValue('next');
        break;
      case 'Delete':
      case 'Backspace':
        if (inputValue) return;
        if (focusedValue) {
          _this7.removeValue(focusedValue);
        } else {
          if (!backspaceRemovesValue) return;
          _this7.popValue();
        }
        break;
      case 'Tab':
        if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption ||
        // don't capture the event if the menu opens on focus and the focused
        // option is already selected; it breaks the flow of navigation
        openMenuOnFocus && _this7.isOptionSelected(focusedOption, selectValue)) {
          return;
        }
        _this7.selectOption(focusedOption);
        break;
      case 'Enter':
        if (menuIsOpen) {
          if (!focusedOption) return;
          if (isComposing) return;
          _this7.selectOption(focusedOption);
        } else {
          _this7.focusOption('first');
        }
        break;
      case 'Escape':
        if (menuIsOpen) {
          _this7.inputIsHiddenAfterUpdate = false;
          _this7.onInputChange('', { action: 'menu-close' });
          _this7.onMenuClose();
        } else if (isClearable && escapeClearsValue) {
          _this7.clearValue();
        }
        break;
      case ' ':
        // space
        if (inputValue) {
          return;
        }
        if (!menuIsOpen) {
          _this7.openMenu('first');
          break;
        }
        if (!focusedOption) return;
        _this7.selectOption(focusedOption);
        break;
      case 'ArrowUp':
        if (menuIsOpen) {
          _this7.focusOption('up');
        } else {
          _this7.openMenu('last');
        }
        break;
      case 'ArrowDown':
        if (menuIsOpen) {
          _this7.focusOption('down');
        } else {
          _this7.openMenu('first');
        }
        break;
      case 'PageUp':
        if (!menuIsOpen) return;
        _this7.focusOption('pageup');
        break;
      case 'PageDown':
        if (!menuIsOpen) return;
        _this7.focusOption('pagedown');
        break;
      case 'Home':
        if (!menuIsOpen) return;
        _this7.focusOption('first');
        break;
      case 'End':
        if (!menuIsOpen) return;
        _this7.focusOption('last');
        break;
      default:
        return;
    }
    event.preventDefault();
  };
};

exports.default = Select;

/***/ }),

/***/ "../node_modules/react-select/lib/accessibility/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var instructionsAriaMessage = exports.instructionsAriaMessage = function instructionsAriaMessage(event) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var isSearchable = context.isSearchable,
      isMulti = context.isMulti,
      label = context.label;

  switch (event) {
    case 'menu':
      return 'Use Up and Down to choose options, press Backspace to select the currently focused option, press Escape to exit the menu, press Tab to select the option and exit the menu.';
    case 'input':
      return (label ? label : 'Select') + ' is focused ' + (isSearchable ? ',type to refine list' : '') + ', press Down to open the menu, ' + (isMulti ? ' press left to focus selected values' : '');
    case 'value':
      return 'Use left and right to toggle between focused values, press Enter to remove the currently focused value';
  }
};

var valueEventAriaMessage = exports.valueEventAriaMessage = function valueEventAriaMessage(event, context) {
  var value = context.value;

  if (!value) return;
  switch (event) {
    case 'deselect-option':
    case 'pop-value':
    case 'remove-value':
      return 'option ' + value + ', deselected.';
    case 'select-option':
      return 'option ' + value + ', selected.';
  }
};

var valueFocusAriaMessage = exports.valueFocusAriaMessage = function valueFocusAriaMessage(_ref) {
  var focusedValue = _ref.focusedValue,
      getOptionLabel = _ref.getOptionLabel,
      selectValue = _ref.selectValue;
  return 'value ' + getOptionLabel(focusedValue) + ' focused, ' + (selectValue.indexOf(focusedValue) + 1) + ' of ' + selectValue.length + '.';
};
var optionFocusAriaMessage = exports.optionFocusAriaMessage = function optionFocusAriaMessage(_ref2) {
  var focusedOption = _ref2.focusedOption,
      getOptionLabel = _ref2.getOptionLabel,
      options = _ref2.options;
  return 'option ' + getOptionLabel(focusedOption) + ' focused, ' + (options.indexOf(focusedOption) + 1) + ' of ' + options.length + '.';
};
var resultsAriaMessage = exports.resultsAriaMessage = function resultsAriaMessage(_ref3) {
  var inputValue = _ref3.inputValue,
      screenReaderMessage = _ref3.screenReaderMessage;
  return '' + screenReaderMessage + (inputValue ? ' for search term ' + inputValue : '') + '.';
};

/***/ }),

/***/ "../node_modules/react-select/lib/builtins.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var formatGroupLabel = exports.formatGroupLabel = function formatGroupLabel(group) {
  return group.label;
};

var getOptionLabel = exports.getOptionLabel = function getOptionLabel(option) {
  return option.label;
};

var getOptionValue = exports.getOptionValue = function getOptionValue(option) {
  return option.value;
};

var isOptionDisabled = exports.isOptionDisabled = function isOptionDisabled(option) {
  return !!option.isDisabled;
};

/***/ }),

/***/ "../node_modules/react-select/lib/components/Control.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.css = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _emotion = __webpack_require__("../node_modules/emotion/dist/index.esm.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var css = exports.css = function css(_ref) {
  var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused,
      _ref$theme = _ref.theme,
      colors = _ref$theme.colors,
      borderRadius = _ref$theme.borderRadius,
      spacing = _ref$theme.spacing;
  return {
    alignItems: 'center',
    backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
    borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
    borderRadius: borderRadius,
    borderStyle: 'solid',
    borderWidth: 1,
    boxShadow: isFocused ? '0 0 0 1px ' + colors.primary : null,
    cursor: 'default',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    minHeight: spacing.controlHeight,
    outline: '0 !important',
    position: 'relative',
    transition: 'all 100ms',

    '&:hover': {
      borderColor: isFocused ? colors.primary : colors.neutral30
    }
  };
};

var Control = function Control(props) {
  var children = props.children,
      cx = props.cx,
      getStyles = props.getStyles,
      className = props.className,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      innerRef = props.innerRef,
      innerProps = props.innerProps;

  return _react2.default.createElement(
    'div',
    _extends({
      ref: innerRef,
      className: cx( /*#__PURE__*/(0, _emotion.css)(getStyles('control', props)), {
        'control': true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused
      }, className)
    }, innerProps),
    children
  );
};

exports.default = Control;

/***/ }),

/***/ "../node_modules/react-select/lib/components/Group.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GroupHeading = exports.groupHeadingCSS = exports.groupCSS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _emotion = __webpack_require__("../node_modules/emotion/dist/index.esm.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var groupCSS = exports.groupCSS = function groupCSS(_ref) {
  var spacing = _ref.theme.spacing;
  return {
    paddingBottom: spacing.baseUnit * 2,
    paddingTop: spacing.baseUnit * 2
  };
};

var Group = function Group(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      Heading = props.Heading,
      headingProps = props.headingProps,
      label = props.label,
      theme = props.theme;

  return _react2.default.createElement(
    'div',
    {
      className: cx( /*#__PURE__*/(0, _emotion.css)(getStyles('group', props)), { 'group': true }, className)
    },
    _react2.default.createElement(
      Heading,
      _extends({}, headingProps, { theme: theme, getStyles: getStyles, cx: cx }),
      label
    ),
    _react2.default.createElement(
      'div',
      null,
      children
    )
  );
};

var groupHeadingCSS = exports.groupHeadingCSS = function groupHeadingCSS(_ref2) {
  var spacing = _ref2.theme.spacing;
  return {
    color: '#999',
    cursor: 'default',
    display: 'block',
    fontSize: '75%',
    fontWeight: '500',
    marginBottom: '0.25em',
    paddingLeft: spacing.baseUnit * 3,
    paddingRight: spacing.baseUnit * 3,
    textTransform: 'uppercase'
  };
};

var GroupHeading = function GroupHeading(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      theme = props.theme,
      cleanProps = _objectWithoutProperties(props, ['className', 'cx', 'getStyles', 'theme']);

  return _react2.default.createElement('div', _extends({
    className: cx( /*#__PURE__*/(0, _emotion.css)(getStyles('groupHeading', _extends({ theme: theme }, cleanProps))), { 'group-heading': true }, className)
  }, cleanProps));
};

exports.GroupHeading = GroupHeading;
exports.default = Group;

/***/ }),

/***/ "../node_modules/react-select/lib/components/Input.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inputCSS = undefined;

var _emotion = __webpack_require__("../node_modules/emotion/dist/index.esm.js");

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactInputAutosize = __webpack_require__("../node_modules/react-input-autosize/lib/AutosizeInput.js");

var _reactInputAutosize2 = _interopRequireDefault(_reactInputAutosize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var inputCSS = exports.inputCSS = function inputCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    margin: spacing.baseUnit / 2,
    paddingBottom: spacing.baseUnit / 2,
    paddingTop: spacing.baseUnit / 2,
    visibility: isDisabled ? 'hidden' : 'visible',
    color: colors.neutral80
  };
};
var inputStyle = function inputStyle(isHidden) {
  return {
    background: 0,
    border: 0,
    fontSize: 'inherit',
    opacity: isHidden ? 0 : 1,
    outline: 0,
    padding: 0,
    color: 'inherit'
  };
};

var Input = function Input(_ref2) {
  var className = _ref2.className,
      cx = _ref2.cx,
      getStyles = _ref2.getStyles,
      innerRef = _ref2.innerRef,
      isHidden = _ref2.isHidden,
      isDisabled = _ref2.isDisabled,
      theme = _ref2.theme,
      props = _objectWithoutProperties(_ref2, ['className', 'cx', 'getStyles', 'innerRef', 'isHidden', 'isDisabled', 'theme']);

  return _react2.default.createElement(
    'div',
    {
      className: (0, _emotion.css)(getStyles('input', _extends({ theme: theme }, props)))
    },
    _react2.default.createElement(_reactInputAutosize2.default, _extends({
      className: cx(null, { 'input': true }, className),
      inputRef: innerRef,
      inputStyle: inputStyle(isHidden),
      disabled: isDisabled
    }, props))
  );
};

exports.default = Input;

/***/ }),

/***/ "../node_modules/react-select/lib/components/Menu.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuPortal = exports.menuPortalCSS = exports.LoadingMessage = exports.NoOptionsMessage = exports.loadingMessageCSS = exports.noOptionsMessageCSS = exports.MenuList = exports.menuListCSS = exports.MenuPlacer = exports.menuCSS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.getMenuPlacement = getMenuPlacement;

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _emotion = __webpack_require__("../node_modules/emotion/dist/index.esm.js");

var _reactDom = __webpack_require__("../node_modules/react-dom/index.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = __webpack_require__("../node_modules/react-select/lib/utils.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// ==============================
// Menu
// ==============================

// Get Menu Placement
// ------------------------------

function getMenuPlacement(_ref) {
  var maxHeight = _ref.maxHeight,
      menuEl = _ref.menuEl,
      minHeight = _ref.minHeight,
      placement = _ref.placement,
      shouldScroll = _ref.shouldScroll,
      isFixedPosition = _ref.isFixedPosition,
      theme = _ref.theme;
  var spacing = theme.spacing;

  var scrollParent = (0, _utils.getScrollParent)(menuEl);
  var defaultState = { placement: 'bottom', maxHeight: maxHeight };

  // something went wrong, return default state
  if (!menuEl || !menuEl.offsetParent) return defaultState;

  // we can't trust `scrollParent.scrollHeight` --> it may increase when
  // the menu is rendered

  var _scrollParent$getBoun = scrollParent.getBoundingClientRect(),
      scrollHeight = _scrollParent$getBoun.height;

  var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(),
      menuBottom = _menuEl$getBoundingCl.bottom,
      menuHeight = _menuEl$getBoundingCl.height,
      menuTop = _menuEl$getBoundingCl.top;

  // $FlowFixMe function returns above if there's no offsetParent


  var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(),
      containerTop = _menuEl$offsetParent$.top;

  var viewHeight = window.innerHeight;
  var scrollTop = (0, _utils.getScrollTop)(scrollParent);

  var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
  var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
  var viewSpaceAbove = containerTop - marginTop;
  var viewSpaceBelow = viewHeight - menuTop;
  var scrollSpaceAbove = viewSpaceAbove + scrollTop;
  var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;

  var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
  var scrollUp = scrollTop + menuTop - marginTop;
  var scrollDuration = 160;

  switch (placement) {
    case 'auto':
    case 'bottom':
      // 1: the menu will fit, do nothing
      if (viewSpaceBelow >= menuHeight) {
        return { placement: 'bottom', maxHeight: maxHeight };
      }

      // 2: the menu will fit, if scrolled
      if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          (0, _utils.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
        }

        return { placement: 'bottom', maxHeight: maxHeight };
      }

      // 3: the menu will fit, if constrained
      if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
        if (shouldScroll) {
          (0, _utils.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
        }

        // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.
        var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;

        return {
          placement: 'bottom',
          maxHeight: constrainedHeight
        };
      }

      // 4. Forked beviour when there isn't enough space below

      // AUTO: flip the menu, render above
      if (placement === 'auto' || isFixedPosition) {
        // may need to be constrained after flipping
        var _constrainedHeight = maxHeight;

        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          _constrainedHeight = isFixedPosition ? viewSpaceAbove - marginBottom - spacing.controlHeight : scrollSpaceAbove - marginBottom - spacing.controlHeight;
        }

        return { placement: 'top', maxHeight: _constrainedHeight };
      }

      // BOTTOM: allow browser to increase scrollable area and immediately set scroll
      if (placement === 'bottom') {
        (0, _utils.scrollTo)(scrollParent, scrollDown);
        return { placement: 'bottom', maxHeight: maxHeight };
      }
      break;
    case 'top':
      // 1: the menu will fit, do nothing
      if (viewSpaceAbove >= menuHeight) {
        return { placement: 'top', maxHeight: maxHeight };
      }

      // 2: the menu will fit, if scrolled
      if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          (0, _utils.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
        }

        return { placement: 'top', maxHeight: maxHeight };
      }

      // 3: the menu will fit, if constrained
      if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
        var _constrainedHeight2 = maxHeight;

        // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.
        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
        }

        if (shouldScroll) {
          (0, _utils.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
        }

        return {
          placement: 'top',
          maxHeight: _constrainedHeight2
        };
      }

      // 4. not enough space, the browser WILL NOT increase scrollable area when
      // absolutely positioned element rendered above the viewport (only below).
      // Flip the menu, render below
      return { placement: 'bottom', maxHeight: maxHeight };
    default:
      throw new Error('Invalid placement provided "' + placement + '".');
  }

  // fulfil contract with flow: implicit return value of undefined
  return defaultState;
}

// Menu Component
// ------------------------------

function alignToControl(placement) {
  var placementToCSSProp = { bottom: 'top', top: 'bottom' };
  return placement ? placementToCSSProp[placement] : 'bottom';
}
var coercePlacement = function coercePlacement(p) {
  return p === 'auto' ? 'bottom' : p;
};

var menuCSS = exports.menuCSS = function menuCSS(_ref2) {
  var _ref3;

  var placement = _ref2.placement,
      _ref2$theme = _ref2.theme,
      borderRadius = _ref2$theme.borderRadius,
      spacing = _ref2$theme.spacing,
      colors = _ref2$theme.colors;
  return _ref3 = {}, _defineProperty(_ref3, alignToControl(placement), '100%'), _defineProperty(_ref3, 'backgroundColor', colors.neutral0), _defineProperty(_ref3, 'borderRadius', borderRadius), _defineProperty(_ref3, 'boxShadow', '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)'), _defineProperty(_ref3, 'marginBottom', spacing.menuGutter), _defineProperty(_ref3, 'marginTop', spacing.menuGutter), _defineProperty(_ref3, 'position', 'absolute'), _defineProperty(_ref3, 'width', '100%'), _defineProperty(_ref3, 'zIndex', 1), _ref3;
};

// NOTE: internal only

var MenuPlacer = exports.MenuPlacer = function (_Component) {
  _inherits(MenuPlacer, _Component);

  function MenuPlacer() {
    var _ref4;

    var _temp, _this, _ret;

    _classCallCheck(this, MenuPlacer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref4 = MenuPlacer.__proto__ || Object.getPrototypeOf(MenuPlacer)).call.apply(_ref4, [this].concat(args))), _this), _this.state = {
      maxHeight: _this.props.maxMenuHeight,
      placement: null
    }, _this.getPlacement = function (ref) {
      var _this$props = _this.props,
          minMenuHeight = _this$props.minMenuHeight,
          maxMenuHeight = _this$props.maxMenuHeight,
          menuPlacement = _this$props.menuPlacement,
          menuPosition = _this$props.menuPosition,
          menuShouldScrollIntoView = _this$props.menuShouldScrollIntoView,
          theme = _this$props.theme;
      var getPortalPlacement = _this.context.getPortalPlacement;


      if (!ref) return;

      // DO NOT scroll if position is fixed
      var isFixedPosition = menuPosition === 'fixed';
      var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;

      var state = getMenuPlacement({
        maxHeight: maxMenuHeight,
        menuEl: ref,
        minHeight: minMenuHeight,
        placement: menuPlacement,
        shouldScroll: shouldScroll,
        isFixedPosition: isFixedPosition,
        theme: theme
      });

      if (getPortalPlacement) getPortalPlacement(state);

      _this.setState(state);
    }, _this.getUpdatedProps = function () {
      var menuPlacement = _this.props.menuPlacement;

      var placement = _this.state.placement || coercePlacement(menuPlacement);

      return _extends({}, _this.props, { placement: placement, maxHeight: _this.state.maxHeight });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MenuPlacer, [{
    key: 'render',
    value: function render() {
      var children = this.props.children;


      return children({
        ref: this.getPlacement,
        placerProps: this.getUpdatedProps()
      });
    }
  }]);

  return MenuPlacer;
}(_react.Component);

MenuPlacer.contextTypes = {
  getPortalPlacement: _propTypes2.default.func
};


var Menu = function Menu(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerRef = props.innerRef,
      innerProps = props.innerProps;

  var cn = cx( /*#__PURE__*/(0, _emotion.css)(getStyles('menu', props)), { menu: true }, className);

  return _react2.default.createElement(
    'div',
    _extends({ className: cn }, innerProps, { ref: innerRef }),
    children
  );
};

exports.default = Menu;

// ==============================
// Menu List
// ==============================

var menuListCSS = exports.menuListCSS = function menuListCSS(_ref5) {
  var maxHeight = _ref5.maxHeight,
      baseUnit = _ref5.theme.spacing.baseUnit;
  return {
    maxHeight: maxHeight,
    overflowY: 'auto',
    paddingBottom: baseUnit,
    paddingTop: baseUnit,
    position: 'relative', // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: 'touch'
  };
};
var MenuList = exports.MenuList = function MenuList(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isMulti = props.isMulti,
      innerRef = props.innerRef;

  return _react2.default.createElement(
    'div',
    {
      className: cx( /*#__PURE__*/(0, _emotion.css)(getStyles('menuList', props)), {
        'menu-list': true,
        'menu-list--is-multi': isMulti
      }, className),
      ref: innerRef
    },
    children
  );
};

// ==============================
// Menu Notices
// ==============================

var noticeCSS = function noticeCSS(_ref6) {
  var _ref6$theme = _ref6.theme,
      baseUnit = _ref6$theme.spacing.baseUnit,
      colors = _ref6$theme.colors;
  return {
    color: colors.neutral40,
    padding: baseUnit * 2 + 'px ' + baseUnit * 3 + 'px',
    textAlign: 'center'
  };
};
var noOptionsMessageCSS = exports.noOptionsMessageCSS = noticeCSS;
var loadingMessageCSS = exports.loadingMessageCSS = noticeCSS;

var NoOptionsMessage = exports.NoOptionsMessage = function NoOptionsMessage(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;

  return _react2.default.createElement(
    'div',
    _extends({
      className: cx( /*#__PURE__*/(0, _emotion.css)(getStyles('noOptionsMessage', props)), {
        'menu-notice': true,
        'menu-notice--no-options': true
      }, className)
    }, innerProps),
    children
  );
};
NoOptionsMessage.defaultProps = {
  children: 'No options'
};

var LoadingMessage = exports.LoadingMessage = function LoadingMessage(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;

  return _react2.default.createElement(
    'div',
    _extends({
      className: cx( /*#__PURE__*/(0, _emotion.css)(getStyles('loadingMessage', props)), {
        'menu-notice': true,
        'menu-notice--loading': true
      }, className)
    }, innerProps),
    children
  );
};
LoadingMessage.defaultProps = {
  children: 'Loading...'
};

// ==============================
// Menu Portal
// ==============================

var menuPortalCSS = exports.menuPortalCSS = function menuPortalCSS(_ref7) {
  var rect = _ref7.rect,
      offset = _ref7.offset,
      position = _ref7.position;
  return {
    left: rect.left,
    position: position,
    top: offset,
    width: rect.width,
    zIndex: 1
  };
};

var MenuPortal = exports.MenuPortal = function (_Component2) {
  _inherits(MenuPortal, _Component2);

  function MenuPortal() {
    var _ref8;

    var _temp2, _this2, _ret2;

    _classCallCheck(this, MenuPortal);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref8 = MenuPortal.__proto__ || Object.getPrototypeOf(MenuPortal)).call.apply(_ref8, [this].concat(args))), _this2), _this2.state = { placement: null }, _this2.getPortalPlacement = function (_ref9) {
      var placement = _ref9.placement;

      var initialPlacement = coercePlacement(_this2.props.menuPlacement);

      // avoid re-renders if the placement has not changed
      if (placement !== initialPlacement) {
        _this2.setState({ placement: placement });
      }
    }, _temp2), _possibleConstructorReturn(_this2, _ret2);
  }

  _createClass(MenuPortal, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        getPortalPlacement: this.getPortalPlacement
      };
    }

    // callback for occassions where the menu must "flip"

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          appendTo = _props.appendTo,
          children = _props.children,
          controlElement = _props.controlElement,
          menuPlacement = _props.menuPlacement,
          position = _props.menuPosition,
          getStyles = _props.getStyles;

      var isFixed = position === 'fixed';

      // bail early if required elements aren't present
      if (!appendTo && !isFixed || !controlElement) {
        return null;
      }

      var placement = this.state.placement || coercePlacement(menuPlacement);
      var rect = (0, _utils.getBoundingClientObj)(controlElement);
      var scrollDistance = isFixed ? 0 : window.pageYOffset;
      var offset = rect[placement] + scrollDistance;
      var state = { offset: offset, position: position, rect: rect };

      // same wrapper element whether fixed or portalled
      var menuWrapper = _react2.default.createElement(
        'div',
        { className: /*#__PURE__*/ /*#__PURE__*/(0, _emotion.css)(getStyles('menuPortal', state)) },
        children
      );

      return appendTo ? (0, _reactDom.createPortal)(menuWrapper, appendTo) : menuWrapper;
    }
  }]);

  return MenuPortal;
}(_react.Component);

MenuPortal.childContextTypes = {
  getPortalPlacement: _propTypes2.default.func
};

/***/ }),

/***/ "../node_modules/react-select/lib/components/MultiValue.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultiValueRemove = exports.MultiValueLabel = exports.MultiValueContainer = exports.MultiValueGeneric = exports.multiValueRemoveCSS = exports.multiValueLabelCSS = exports.multiValueCSS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _emotion = __webpack_require__("../node_modules/emotion/dist/index.esm.js");

var _indicators = __webpack_require__("../node_modules/react-select/lib/components/indicators.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var multiValueCSS = exports.multiValueCSS = function multiValueCSS(_ref) {
  var _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      borderRadius = _ref$theme.borderRadius,
      colors = _ref$theme.colors;
  return {
    backgroundColor: colors.neutral10,
    borderRadius: borderRadius / 2,
    display: 'flex',
    margin: spacing.baseUnit / 2,
    minWidth: 0 // resolves flex/text-overflow bug
  };
};

var multiValueLabelCSS = exports.multiValueLabelCSS = function multiValueLabelCSS(_ref2) {
  var _ref2$theme = _ref2.theme,
      borderRadius = _ref2$theme.borderRadius,
      colors = _ref2$theme.colors,
      cropWithEllipsis = _ref2.cropWithEllipsis;
  return {
    borderRadius: borderRadius / 2,
    color: colors.neutral80,
    fontSize: '85%',
    overflow: 'hidden',
    padding: 3,
    paddingLeft: 6,
    textOverflow: cropWithEllipsis ? 'ellipsis' : null,
    whiteSpace: 'nowrap'
  };
};

var multiValueRemoveCSS = exports.multiValueRemoveCSS = function multiValueRemoveCSS(_ref3) {
  var _ref3$theme = _ref3.theme,
      spacing = _ref3$theme.spacing,
      borderRadius = _ref3$theme.borderRadius,
      colors = _ref3$theme.colors,
      isFocused = _ref3.isFocused;
  return {
    alignItems: 'center',
    borderRadius: borderRadius / 2,
    backgroundColor: isFocused && colors.dangerLight,
    display: 'flex',
    paddingLeft: spacing.baseUnit,
    paddingRight: spacing.baseUnit,
    ':hover': {
      backgroundColor: colors.dangerLight,
      color: colors.danger
    }
  };
};

var MultiValueGeneric = exports.MultiValueGeneric = function MultiValueGeneric(_ref4) {
  var children = _ref4.children,
      innerProps = _ref4.innerProps;
  return _react2.default.createElement(
    'div',
    innerProps,
    children
  );
};

var MultiValueContainer = exports.MultiValueContainer = MultiValueGeneric;
var MultiValueLabel = exports.MultiValueLabel = MultiValueGeneric;

var MultiValueRemove = exports.MultiValueRemove = function (_Component) {
  _inherits(MultiValueRemove, _Component);

  function MultiValueRemove() {
    _classCallCheck(this, MultiValueRemove);

    return _possibleConstructorReturn(this, (MultiValueRemove.__proto__ || Object.getPrototypeOf(MultiValueRemove)).apply(this, arguments));
  }

  _createClass(MultiValueRemove, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          innerProps = _props.innerProps;

      return _react2.default.createElement(
        'div',
        innerProps,
        children
      );
    }
  }]);

  return MultiValueRemove;
}(_react.Component);

MultiValueRemove.defaultProps = {
  children: _react2.default.createElement(_indicators.CrossIcon, { size: 14 })
};

var MultiValue = function (_Component2) {
  _inherits(MultiValue, _Component2);

  function MultiValue() {
    _classCallCheck(this, MultiValue);

    return _possibleConstructorReturn(this, (MultiValue.__proto__ || Object.getPrototypeOf(MultiValue)).apply(this, arguments));
  }

  _createClass(MultiValue, [{
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          children = _props2.children,
          className = _props2.className,
          components = _props2.components,
          cx = _props2.cx,
          data = _props2.data,
          getStyles = _props2.getStyles,
          innerProps = _props2.innerProps,
          isDisabled = _props2.isDisabled,
          removeProps = _props2.removeProps,
          selectProps = _props2.selectProps;
      var Container = components.Container,
          Label = components.Label,
          Remove = components.Remove;


      var containerInnerProps = _extends({
        className: cx( /*#__PURE__*/(0, _emotion.css)(getStyles('multiValue', this.props)), {
          'multi-value': true,
          'multi-value--is-disabled': isDisabled
        }, className)
      }, innerProps);

      var labelInnerProps = {
        className: cx( /*#__PURE__*/(0, _emotion.css)(getStyles('multiValueLabel', this.props)), {
          'multi-value__label': true
        }, className)
      };

      var removeInnerProps = _extends({
        className: cx( /*#__PURE__*/(0, _emotion.css)(getStyles('multiValueRemove', this.props)), {
          'multi-value__remove': true
        }, className)
      }, removeProps);

      return _react2.default.createElement(
        Container,
        {
          data: data,
          innerProps: containerInnerProps,
          selectProps: selectProps
        },
        _react2.default.createElement(
          Label,
          {
            data: data,
            innerProps: labelInnerProps,
            selectProps: selectProps
          },
          children
        ),
        _react2.default.createElement(Remove, {
          data: data,
          innerProps: removeInnerProps,
          selectProps: selectProps
        })
      );
    }
  }]);

  return MultiValue;
}(_react.Component);

MultiValue.defaultProps = {
  cropWithEllipsis: true
};
exports.default = MultiValue;

/***/ }),

/***/ "../node_modules/react-select/lib/components/Option.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.optionCSS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _emotion = __webpack_require__("../node_modules/emotion/dist/index.esm.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var optionCSS = exports.optionCSS = function optionCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused,
      isSelected = _ref.isSelected,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
    color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
    cursor: 'default',
    display: 'block',
    fontSize: 'inherit',
    padding: spacing.baseUnit * 2 + 'px ' + spacing.baseUnit * 3 + 'px',
    width: '100%',
    userSelect: 'none',
    WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',

    // provide some affordance on touch devices
    ':active': {
      backgroundColor: isSelected ? colors.primary : colors.primary50
    }
  };
};

var Option = function Option(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      isSelected = props.isSelected,
      innerRef = props.innerRef,
      innerProps = props.innerProps;

  return _react2.default.createElement(
    'div',
    _extends({
      ref: innerRef,
      className: cx( /*#__PURE__*/(0, _emotion.css)(getStyles('option', props)), {
        'option': true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
      }, className)
    }, innerProps),
    children
  );
};

exports.default = Option;

/***/ }),

/***/ "../node_modules/react-select/lib/components/Placeholder.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.placeholderCSS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _emotion = __webpack_require__("../node_modules/emotion/dist/index.esm.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var placeholderCSS = exports.placeholderCSS = function placeholderCSS(_ref) {
  var _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    color: colors.neutral50,
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2,
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)'
  };
};

var Placeholder = function Placeholder(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;

  return _react2.default.createElement(
    'div',
    _extends({
      className: cx( /*#__PURE__*/(0, _emotion.css)(getStyles('placeholder', props)), {
        'placeholder': true
      }, className)
    }, innerProps),
    children
  );
};

exports.default = Placeholder;

/***/ }),

/***/ "../node_modules/react-select/lib/components/SingleValue.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.css = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _emotion = __webpack_require__("../node_modules/emotion/dist/index.esm.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var css = exports.css = function css(_ref) {
  var isDisabled = _ref.isDisabled,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    color: isDisabled ? colors.neutral40 : colors.neutral80,
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2,
    maxWidth: 'calc(100% - ' + spacing.baseUnit * 2 + 'px)',
    overflow: 'hidden',
    position: 'absolute',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    top: '50%',
    transform: 'translateY(-50%)'
  };
};

var SingleValue = function SingleValue(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isDisabled = props.isDisabled,
      innerProps = props.innerProps;

  return _react2.default.createElement(
    'div',
    _extends({
      className: cx( /*#__PURE__*/(0, _emotion.css)(getStyles('singleValue', props)), {
        'single-value': true,
        'single-value--is-disabled': isDisabled
      }, className)
    }, innerProps),
    children
  );
};

exports.default = SingleValue;

/***/ }),

/***/ "../node_modules/react-select/lib/components/containers.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IndicatorsContainer = exports.indicatorsContainerCSS = exports.ValueContainer = exports.valueContainerCSS = exports.SelectContainer = exports.containerCSS = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _emotion = __webpack_require__("../node_modules/emotion/dist/index.esm.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// ==============================
// Root Container
// ==============================

var containerCSS = exports.containerCSS = function containerCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      isRtl = _ref.isRtl;
  return {
    direction: isRtl ? 'rtl' : null,
    pointerEvents: isDisabled ? 'none' : null, // cancel mouse events when disabled
    position: 'relative'
  };
};
var SelectContainer = exports.SelectContainer = function SelectContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isDisabled = props.isDisabled,
      isRtl = props.isRtl;

  return _react2.default.createElement(
    'div',
    _extends({
      className: cx( /*#__PURE__*/(0, _emotion.css)(getStyles('container', props)), {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
      }, className)
    }, innerProps),
    children
  );
};

// ==============================
// Value Container
// ==============================

var valueContainerCSS = exports.valueContainerCSS = function valueContainerCSS(_ref2) {
  var spacing = _ref2.theme.spacing;
  return {
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    flexWrap: 'wrap',
    padding: spacing.baseUnit / 2 + 'px ' + spacing.baseUnit * 2 + 'px',
    WebkitOverflowScrolling: 'touch',
    position: 'relative',
    overflow: 'hidden'
  };
};

var ValueContainer = exports.ValueContainer = function (_Component) {
  _inherits(ValueContainer, _Component);

  function ValueContainer() {
    _classCallCheck(this, ValueContainer);

    return _possibleConstructorReturn(this, (ValueContainer.__proto__ || Object.getPrototypeOf(ValueContainer)).apply(this, arguments));
  }

  _createClass(ValueContainer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          cx = _props.cx,
          isMulti = _props.isMulti,
          getStyles = _props.getStyles,
          hasValue = _props.hasValue;


      return _react2.default.createElement(
        'div',
        {
          className: cx( /*#__PURE__*/(0, _emotion.css)(getStyles('valueContainer', this.props)), {
            'value-container': true,
            'value-container--is-multi': isMulti,
            'value-container--has-value': hasValue
          }, className)
        },
        children
      );
    }
  }]);

  return ValueContainer;
}(_react.Component);

// ==============================
// Indicator Container
// ==============================

var indicatorsContainerCSS = exports.indicatorsContainerCSS = function indicatorsContainerCSS() {
  return {
    alignItems: 'center',
    alignSelf: 'stretch',
    display: 'flex',
    flexShrink: 0
  };
};
var IndicatorsContainer = exports.IndicatorsContainer = function IndicatorsContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles;


  return _react2.default.createElement(
    'div',
    {
      className: cx( /*#__PURE__*/(0, _emotion.css)(getStyles('indicatorsContainer', props)), {
        'indicators': true
      }, className)
    },
    children
  );
};

/***/ }),

/***/ "../node_modules/react-select/lib/components/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultComponents = exports.components = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

__webpack_require__("../node_modules/react/index.js");

var _containers = __webpack_require__("../node_modules/react-select/lib/components/containers.js");

var _indicators = __webpack_require__("../node_modules/react-select/lib/components/indicators.js");

var _Control = __webpack_require__("../node_modules/react-select/lib/components/Control.js");

var _Control2 = _interopRequireDefault(_Control);

var _Group = __webpack_require__("../node_modules/react-select/lib/components/Group.js");

var _Group2 = _interopRequireDefault(_Group);

var _Input = __webpack_require__("../node_modules/react-select/lib/components/Input.js");

var _Input2 = _interopRequireDefault(_Input);

var _Menu = __webpack_require__("../node_modules/react-select/lib/components/Menu.js");

var _Menu2 = _interopRequireDefault(_Menu);

var _MultiValue = __webpack_require__("../node_modules/react-select/lib/components/MultiValue.js");

var _MultiValue2 = _interopRequireDefault(_MultiValue);

var _Option = __webpack_require__("../node_modules/react-select/lib/components/Option.js");

var _Option2 = _interopRequireDefault(_Option);

var _Placeholder = __webpack_require__("../node_modules/react-select/lib/components/Placeholder.js");

var _Placeholder2 = _interopRequireDefault(_Placeholder);

var _SingleValue = __webpack_require__("../node_modules/react-select/lib/components/SingleValue.js");

var _SingleValue2 = _interopRequireDefault(_SingleValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var components = exports.components = {
  ClearIndicator: _indicators.ClearIndicator,
  Control: _Control2.default,
  DropdownIndicator: _indicators.DropdownIndicator,
  DownChevron: _indicators.DownChevron,
  CrossIcon: _indicators.CrossIcon,
  Group: _Group2.default,
  GroupHeading: _Group.GroupHeading,
  IndicatorsContainer: _containers.IndicatorsContainer,
  IndicatorSeparator: _indicators.IndicatorSeparator,
  Input: _Input2.default,
  LoadingIndicator: _indicators.LoadingIndicator,
  Menu: _Menu2.default,
  MenuList: _Menu.MenuList,
  MenuPortal: _Menu.MenuPortal,
  LoadingMessage: _Menu.LoadingMessage,
  NoOptionsMessage: _Menu.NoOptionsMessage,
  MultiValue: _MultiValue2.default,
  MultiValueContainer: _MultiValue.MultiValueContainer,
  MultiValueLabel: _MultiValue.MultiValueLabel,
  MultiValueRemove: _MultiValue.MultiValueRemove,
  Option: _Option2.default,
  Placeholder: _Placeholder2.default,
  SelectContainer: _containers.SelectContainer,
  SingleValue: _SingleValue2.default,
  ValueContainer: _containers.ValueContainer
};

var defaultComponents = exports.defaultComponents = function defaultComponents(props) {
  return _extends({}, components, props.components);
};

/***/ }),

/***/ "../node_modules/react-select/lib/components/indicators.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadingIndicator = exports.loadingIndicatorCSS = exports.IndicatorSeparator = exports.indicatorSeparatorCSS = exports.ClearIndicator = exports.clearIndicatorCSS = exports.DropdownIndicator = exports.dropdownIndicatorCSS = exports.DownChevron = exports.CrossIcon = undefined;

var _emotion = __webpack_require__("../node_modules/emotion/dist/index.esm.js");

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

__webpack_require__("../node_modules/react-select/lib/types.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// ==============================
// Dropdown & Clear Icons
// ==============================

var Svg = function Svg(_ref) {
  var size = _ref.size,
      props = _objectWithoutProperties(_ref, ['size']);

  return _react2.default.createElement('svg', _extends({
    height: size,
    width: size,
    viewBox: '0 0 20 20',
    'aria-hidden': 'true',
    focusable: 'false',
    className: /*#__PURE__*/ /*#__PURE__*/(0, _emotion.css)({
      display: 'inline-block',
      fill: 'currentColor',
      lineHeight: 1,
      stroke: 'currentColor',
      strokeWidth: 0
    })
  }, props));
};

var CrossIcon = exports.CrossIcon = function CrossIcon(props) {
  return _react2.default.createElement(
    Svg,
    _extends({ size: 20 }, props),
    _react2.default.createElement('path', { d: 'M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z' })
  );
};
var DownChevron = exports.DownChevron = function DownChevron(props) {
  return _react2.default.createElement(
    Svg,
    _extends({ size: 20 }, props),
    _react2.default.createElement('path', { d: 'M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z' })
  );
};

// ==============================
// Dropdown & Clear Buttons
// ==============================

var baseCSS = function baseCSS(_ref2) {
  var isFocused = _ref2.isFocused,
      _ref2$theme = _ref2.theme,
      baseUnit = _ref2$theme.spacing.baseUnit,
      colors = _ref2$theme.colors;
  return {
    color: isFocused ? colors.neutral60 : colors.neutral20,
    display: 'flex',
    padding: baseUnit * 2,
    transition: 'color 150ms',

    ':hover': {
      color: isFocused ? colors.neutral80 : colors.neutral40
    }
  };
};

var dropdownIndicatorCSS = exports.dropdownIndicatorCSS = baseCSS;
var DropdownIndicator = exports.DropdownIndicator = function DropdownIndicator(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;

  return _react2.default.createElement(
    'div',
    _extends({}, innerProps, {
      className: cx( /*#__PURE__*/(0, _emotion.css)(getStyles('dropdownIndicator', props)), {
        'indicator': true,
        'dropdown-indicator': true
      }, className)
    }),
    children
  );
};
DropdownIndicator.defaultProps = {
  children: _react2.default.createElement(DownChevron, null)
};

var clearIndicatorCSS = exports.clearIndicatorCSS = baseCSS;
var ClearIndicator = exports.ClearIndicator = function ClearIndicator(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;

  return _react2.default.createElement(
    'div',
    _extends({}, innerProps, {
      className: cx( /*#__PURE__*/(0, _emotion.css)(getStyles('clearIndicator', props)), {
        'indicator': true,
        'clear-indicator': true
      }, className)
    }),
    children
  );
};

ClearIndicator.defaultProps = {
  children: _react2.default.createElement(CrossIcon, null)
};

// ==============================
// Separator
// ==============================

var indicatorSeparatorCSS = exports.indicatorSeparatorCSS = function indicatorSeparatorCSS(_ref3) {
  var isDisabled = _ref3.isDisabled,
      _ref3$theme = _ref3.theme,
      baseUnit = _ref3$theme.spacing.baseUnit,
      colors = _ref3$theme.colors;
  return {
    alignSelf: 'stretch',
    backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
    marginBottom: baseUnit * 2,
    marginTop: baseUnit * 2,
    width: 1
  };
};

var IndicatorSeparator = exports.IndicatorSeparator = function IndicatorSeparator(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;

  return _react2.default.createElement('span', _extends({}, innerProps, {
    className: cx( /*#__PURE__*/(0, _emotion.css)(getStyles('indicatorSeparator', props)), { 'indicator-separator': true }, className)
  }));
};

// ==============================
// Loading
// ==============================

var keyframesName = 'react-select-loading-indicator';

var loadingIndicatorCSS = exports.loadingIndicatorCSS = function loadingIndicatorCSS(_ref4) {
  var isFocused = _ref4.isFocused,
      size = _ref4.size,
      _ref4$theme = _ref4.theme,
      colors = _ref4$theme.colors,
      baseUnit = _ref4$theme.spacing.baseUnit;
  return {
    color: isFocused ? colors.neutral60 : colors.neutral20,
    display: 'flex',
    padding: baseUnit * 2,
    transition: 'color 150ms',
    alignSelf: 'center',
    fontSize: size,
    lineHeight: 1,
    marginRight: size,
    textAlign: 'center',
    verticalAlign: 'middle'
  };
};

var LoadingDot = function LoadingDot(_ref5) {
  var color = _ref5.color,
      delay = _ref5.delay,
      offset = _ref5.offset;
  return _react2.default.createElement('span', {
    className: (0, _emotion.css)({
      animationDuration: '1s',
      animationDelay: delay + 'ms',
      animationIterationCount: 'infinite',
      animationName: keyframesName,
      animationTimingFunction: 'ease-in-out',
      backgroundColor: color,
      borderRadius: '1em',
      display: 'inline-block',
      marginLeft: offset ? '1em' : null,
      height: '1em',
      verticalAlign: 'top',
      width: '1em'
    })
  });
};

// eslint-disable-next-line no-unused-expressions
(0, _emotion.injectGlobal)('@keyframes ', keyframesName, '{0%,80%,100%{opacity:0;}40%{opacity:1;}};');

var LoadingIndicator = exports.LoadingIndicator = function LoadingIndicator(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isFocused = props.isFocused,
      isRtl = props.isRtl,
      colors = props.theme.colors;

  var color = isFocused ? colors.neutral80 : colors.neutral20;

  return _react2.default.createElement(
    'div',
    _extends({}, innerProps, {
      className: cx( /*#__PURE__*/(0, _emotion.css)(getStyles('loadingIndicator', props)), {
        'indicator': true,
        'loading-indicator': true
      }, className)
    }),
    _react2.default.createElement(LoadingDot, { color: color, delay: 0, offset: isRtl }),
    _react2.default.createElement(LoadingDot, { color: color, delay: 160, offset: true }),
    _react2.default.createElement(LoadingDot, { color: color, delay: 320, offset: !isRtl })
  );
};
LoadingIndicator.defaultProps = { size: 4 };

/***/ }),

/***/ "../node_modules/react-select/lib/diacritics.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var diacritics = [{ base: 'A', letters: /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { base: 'AA', letters: /[\uA732]/g }, { base: 'AE', letters: /[\u00C6\u01FC\u01E2]/g }, { base: 'AO', letters: /[\uA734]/g }, { base: 'AU', letters: /[\uA736]/g }, { base: 'AV', letters: /[\uA738\uA73A]/g }, { base: 'AY', letters: /[\uA73C]/g }, { base: 'B', letters: /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { base: 'C', letters: /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { base: 'D', letters: /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { base: 'DZ', letters: /[\u01F1\u01C4]/g }, { base: 'Dz', letters: /[\u01F2\u01C5]/g }, { base: 'E', letters: /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { base: 'F', letters: /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { base: 'G', letters: /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { base: 'H', letters: /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { base: 'I', letters: /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { base: 'J', letters: /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { base: 'K', letters: /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { base: 'L', letters: /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { base: 'LJ', letters: /[\u01C7]/g }, { base: 'Lj', letters: /[\u01C8]/g }, { base: 'M', letters: /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { base: 'N', letters: /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { base: 'NJ', letters: /[\u01CA]/g }, { base: 'Nj', letters: /[\u01CB]/g }, { base: 'O', letters: /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { base: 'OI', letters: /[\u01A2]/g }, { base: 'OO', letters: /[\uA74E]/g }, { base: 'OU', letters: /[\u0222]/g }, { base: 'P', letters: /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { base: 'Q', letters: /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { base: 'R', letters: /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { base: 'S', letters: /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { base: 'T', letters: /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { base: 'TZ', letters: /[\uA728]/g }, { base: 'U', letters: /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { base: 'V', letters: /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { base: 'VY', letters: /[\uA760]/g }, { base: 'W', letters: /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { base: 'X', letters: /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { base: 'Y', letters: /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { base: 'Z', letters: /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { base: 'a', letters: /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { base: 'aa', letters: /[\uA733]/g }, { base: 'ae', letters: /[\u00E6\u01FD\u01E3]/g }, { base: 'ao', letters: /[\uA735]/g }, { base: 'au', letters: /[\uA737]/g }, { base: 'av', letters: /[\uA739\uA73B]/g }, { base: 'ay', letters: /[\uA73D]/g }, { base: 'b', letters: /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { base: 'c', letters: /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { base: 'd', letters: /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { base: 'dz', letters: /[\u01F3\u01C6]/g }, { base: 'e', letters: /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { base: 'f', letters: /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { base: 'g', letters: /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { base: 'h', letters: /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { base: 'hv', letters: /[\u0195]/g }, { base: 'i', letters: /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { base: 'j', letters: /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { base: 'k', letters: /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { base: 'l', letters: /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { base: 'lj', letters: /[\u01C9]/g }, { base: 'm', letters: /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { base: 'n', letters: /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { base: 'nj', letters: /[\u01CC]/g }, { base: 'o', letters: /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { base: 'oi', letters: /[\u01A3]/g }, { base: 'ou', letters: /[\u0223]/g }, { base: 'oo', letters: /[\uA74F]/g }, { base: 'p', letters: /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { base: 'q', letters: /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { base: 'r', letters: /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { base: 's', letters: /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { base: 't', letters: /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { base: 'tz', letters: /[\uA729]/g }, { base: 'u', letters: /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { base: 'v', letters: /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { base: 'vy', letters: /[\uA761]/g }, { base: 'w', letters: /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { base: 'x', letters: /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { base: 'y', letters: /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { base: 'z', letters: /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];

var stripDiacritics = exports.stripDiacritics = function stripDiacritics(str) {
	for (var i = 0; i < diacritics.length; i++) {
		str = str.replace(diacritics[i].letters, diacritics[i].base);
	}
	return str;
};

/***/ }),

/***/ "../node_modules/react-select/lib/filters.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createFilter = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _diacritics = __webpack_require__("../node_modules/react-select/lib/diacritics.js");

var trimString = function trimString(str) {
  return str.replace(/^\s+|\s+$/g, '');
};
var defaultStringify = function defaultStringify(option) {
  return option.label + ' ' + option.value;
};

var createFilter = exports.createFilter = function createFilter(config) {
  return function (option, rawInput) {
    var _ignoreCase$ignoreAcc = _extends({
      ignoreCase: true,
      ignoreAccents: true,
      stringify: defaultStringify,
      trim: true,
      matchFrom: 'any'
    }, config),
        ignoreCase = _ignoreCase$ignoreAcc.ignoreCase,
        ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents,
        stringify = _ignoreCase$ignoreAcc.stringify,
        trim = _ignoreCase$ignoreAcc.trim,
        matchFrom = _ignoreCase$ignoreAcc.matchFrom;

    var input = trim ? trimString(rawInput) : rawInput;
    var candidate = trim ? trimString(stringify(option)) : stringify(option);
    if (ignoreCase) {
      input = input.toLowerCase();
      candidate = candidate.toLowerCase();
    }
    if (ignoreAccents) {
      input = (0, _diacritics.stripDiacritics)(input);
      candidate = (0, _diacritics.stripDiacritics)(candidate);
    }
    return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
  };
};

/***/ }),

/***/ "../node_modules/react-select/lib/internal/A11yText.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _emotion = __webpack_require__("../node_modules/emotion/dist/index.esm.js");

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Assistive text to describe visual elements. Hidden for sighted users.
var A11yText = function A11yText(props) {
  return _react2.default.createElement('span', _extends({
    className: (0, _emotion.css)({
      zIndex: 9999,
      border: 0,
      clip: 'rect(1px, 1px, 1px, 1px)',
      height: 1,
      width: 1,
      position: 'absolute',
      overflow: 'hidden',
      padding: 0,
      whiteSpace: 'nowrap',
      backgroundColor: 'red',
      color: 'blue'
    })
  }, props));
};

exports.default = A11yText;

/***/ }),

/***/ "../node_modules/react-select/lib/internal/DummyInput.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _emotion = __webpack_require__("../node_modules/emotion/dist/index.esm.js");

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DummyInput = function (_Component) {
  _inherits(DummyInput, _Component);

  function DummyInput() {
    _classCallCheck(this, DummyInput);

    return _possibleConstructorReturn(this, (DummyInput.__proto__ || Object.getPrototypeOf(DummyInput)).apply(this, arguments));
  }

  _createClass(DummyInput, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          inProp = _props.in,
          out = _props.out,
          onExited = _props.onExited,
          appear = _props.appear,
          enter = _props.enter,
          exit = _props.exit,
          innerRef = _props.innerRef,
          props = _objectWithoutProperties(_props, ['in', 'out', 'onExited', 'appear', 'enter', 'exit', 'innerRef']);

      return _react2.default.createElement('input', _extends({
        ref: innerRef
      }, props, {
        className: (0, _emotion.css)({
          // get rid of any default styles
          background: 0,
          border: 0,
          fontSize: 'inherit',
          outline: 0,
          padding: 0,

          // important! without `width` browsers won't allow focus
          width: 1,

          // remove cursor on desktop
          color: 'transparent',

          // remove cursor on mobile whilst maintaining "scroll into view" behaviour
          left: -100,
          opacity: 0,
          position: 'relative',
          transform: 'scale(0)'
        })
      }));
    }
  }]);

  return DummyInput;
}(_react.Component);

exports.default = DummyInput;

/***/ }),

/***/ "../node_modules/react-select/lib/internal/NodeResolver.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/index.js");

var _reactDom = __webpack_require__("../node_modules/react-dom/index.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NodeResolver = function (_Component) {
  _inherits(NodeResolver, _Component);

  function NodeResolver() {
    _classCallCheck(this, NodeResolver);

    return _possibleConstructorReturn(this, (NodeResolver.__proto__ || Object.getPrototypeOf(NodeResolver)).apply(this, arguments));
  }

  _createClass(NodeResolver, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.innerRef((0, _reactDom.findDOMNode)(this));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.innerRef(null);
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return NodeResolver;
}(_react.Component);

exports.default = NodeResolver;

/***/ }),

/***/ "../node_modules/react-select/lib/internal/ScrollBlock.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _emotion = __webpack_require__("../node_modules/emotion/dist/index.esm.js");

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _NodeResolver = __webpack_require__("../node_modules/react-select/lib/internal/NodeResolver.js");

var _NodeResolver2 = _interopRequireDefault(_NodeResolver);

var _index = __webpack_require__("../node_modules/react-select/lib/internal/ScrollLock/index.js");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// NOTE:
// We shouldn't need this after updating to React v16.3.0, which introduces:
// - createRef() https://reactjs.org/docs/react-api.html#reactcreateref
// - forwardRef() https://reactjs.org/docs/react-api.html#reactforwardref

var ScrollBlock = function (_PureComponent) {
  _inherits(ScrollBlock, _PureComponent);

  function ScrollBlock() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ScrollBlock);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ScrollBlock.__proto__ || Object.getPrototypeOf(ScrollBlock)).call.apply(_ref, [this].concat(args))), _this), _this.state = { touchScrollTarget: null }, _this.getScrollTarget = function (ref) {
      if (ref === _this.state.touchScrollTarget) return;
      _this.setState({ touchScrollTarget: ref });
    }, _this.blurSelectInput = function () {
      if (document.activeElement) {
        document.activeElement.blur();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // must be in state to trigger a re-render, only runs once per instance


  // this will close the menu when a user clicks outside


  _createClass(ScrollBlock, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          isEnabled = _props.isEnabled;
      var touchScrollTarget = this.state.touchScrollTarget;

      // bail early if not enabled

      if (!isEnabled) return children;

      /*
       * Div
       * ------------------------------
       * blocks scrolling on non-body elements behind the menu
        * NodeResolver
       * ------------------------------
       * we need a reference to the scrollable element to "unlock" scroll on
       * mobile devices
        * ScrollLock
       * ------------------------------
       * actually does the scroll locking
       */
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('div', {
          onClick: this.blurSelectInput,
          className: (0, _emotion.css)({ position: 'fixed', left: 0, bottom: 0, right: 0, top: 0 })
        }),
        _react2.default.createElement(
          _NodeResolver2.default,
          { innerRef: this.getScrollTarget },
          children
        ),
        touchScrollTarget ? _react2.default.createElement(_index2.default, { touchScrollTarget: touchScrollTarget }) : null
      );
    }
  }]);

  return ScrollBlock;
}(_react.PureComponent);

exports.default = ScrollBlock;

/***/ }),

/***/ "../node_modules/react-select/lib/internal/ScrollCaptor.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _NodeResolver = __webpack_require__("../node_modules/react-select/lib/internal/NodeResolver.js");

var _NodeResolver2 = _interopRequireDefault(_NodeResolver);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ScrollCaptor = function (_Component) {
  _inherits(ScrollCaptor, _Component);

  function ScrollCaptor() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ScrollCaptor);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ScrollCaptor.__proto__ || Object.getPrototypeOf(ScrollCaptor)).call.apply(_ref, [this].concat(args))), _this), _this.isBottom = false, _this.isTop = false, _this.cancelScroll = function (event) {
      event.preventDefault();
      event.stopPropagation();
    }, _this.handleEventDelta = function (event, delta) {
      var _this$props = _this.props,
          onBottomArrive = _this$props.onBottomArrive,
          onBottomLeave = _this$props.onBottomLeave,
          onTopArrive = _this$props.onTopArrive,
          onTopLeave = _this$props.onTopLeave;
      var _this$scrollTarget = _this.scrollTarget,
          scrollTop = _this$scrollTarget.scrollTop,
          scrollHeight = _this$scrollTarget.scrollHeight,
          clientHeight = _this$scrollTarget.clientHeight;

      var target = _this.scrollTarget;
      var isDeltaPositive = delta > 0;
      var availableScroll = scrollHeight - clientHeight - scrollTop;
      var shouldCancelScroll = false;

      // reset bottom/top flags
      if (availableScroll > delta && _this.isBottom) {
        if (onBottomLeave) onBottomLeave(event);
        _this.isBottom = false;
      }
      if (isDeltaPositive && _this.isTop) {
        if (onTopLeave) onTopLeave(event);
        _this.isTop = false;
      }

      // bottom limit
      if (isDeltaPositive && delta > availableScroll) {
        if (onBottomArrive && !_this.isBottom) {
          onBottomArrive(event);
        }
        target.scrollTop = scrollHeight;
        shouldCancelScroll = true;
        _this.isBottom = true;

        // top limit
      } else if (!isDeltaPositive && -delta > scrollTop) {
        if (onTopArrive && !_this.isTop) {
          onTopArrive(event);
        }
        target.scrollTop = 0;
        shouldCancelScroll = true;
        _this.isTop = true;
      }

      // cancel scroll
      if (shouldCancelScroll) {
        _this.cancelScroll(event);
      }
    }, _this.onWheel = function (event) {
      _this.handleEventDelta(event, event.deltaY);
    }, _this.onTouchStart = function (event) {
      // set touch start so we can calculate touchmove delta
      _this.touchStart = event.changedTouches[0].clientY;
    }, _this.onTouchMove = function (event) {
      var deltaY = _this.touchStart - event.changedTouches[0].clientY;
      _this.handleEventDelta(event, deltaY);
    }, _this.getScrollTarget = function (ref) {
      _this.scrollTarget = ref;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ScrollCaptor, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.startListening(this.scrollTarget);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stopListening(this.scrollTarget);
    }
  }, {
    key: 'startListening',
    value: function startListening(el) {
      // bail early if no scroll available
      if (el.scrollHeight <= el.clientHeight) return;

      // all the if statements are to appease Flow 😢
      if (typeof el.addEventListener === 'function') {
        el.addEventListener('wheel', this.onWheel, false);
      }
      if (typeof el.addEventListener === 'function') {
        el.addEventListener('touchstart', this.onTouchStart, false);
      }
      if (typeof el.addEventListener === 'function') {
        el.addEventListener('touchmove', this.onTouchMove, false);
      }
    }
  }, {
    key: 'stopListening',
    value: function stopListening(el) {
      // bail early if no scroll available
      if (el.scrollHeight <= el.clientHeight) return;

      // all the if statements are to appease Flow 😢
      if (typeof el.removeEventListener === 'function') {
        el.removeEventListener('wheel', this.onWheel, false);
      }
      if (typeof el.removeEventListener === 'function') {
        el.removeEventListener('touchstart', this.onTouchStart, false);
      }
      if (typeof el.removeEventListener === 'function') {
        el.removeEventListener('touchmove', this.onTouchMove, false);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _NodeResolver2.default,
        { innerRef: this.getScrollTarget },
        this.props.children
      );
    }
  }]);

  return ScrollCaptor;
}(_react.Component);

var ScrollCaptorSwitch = function (_Component2) {
  _inherits(ScrollCaptorSwitch, _Component2);

  function ScrollCaptorSwitch() {
    _classCallCheck(this, ScrollCaptorSwitch);

    return _possibleConstructorReturn(this, (ScrollCaptorSwitch.__proto__ || Object.getPrototypeOf(ScrollCaptorSwitch)).apply(this, arguments));
  }

  _createClass(ScrollCaptorSwitch, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isEnabled = _props.isEnabled,
          props = _objectWithoutProperties(_props, ['isEnabled']);

      return isEnabled ? _react2.default.createElement(ScrollCaptor, props) : this.props.children;
    }
  }]);

  return ScrollCaptorSwitch;
}(_react.Component);

ScrollCaptorSwitch.defaultProps = { isEnabled: true };
exports.default = ScrollCaptorSwitch;

/***/ }),

/***/ "../node_modules/react-select/lib/internal/ScrollLock/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var STYLE_KEYS = exports.STYLE_KEYS = ['boxSizing', 'height', 'overflow', 'paddingRight', 'position'];

var LOCK_STYLES = exports.LOCK_STYLES = {
  boxSizing: 'border-box', // account for possible declaration `width: 100%;` on body
  overflow: 'hidden',
  position: 'relative',
  height: '100%'
};

/***/ }),

/***/ "../node_modules/react-select/lib/internal/ScrollLock/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/index.js");

var _constants = __webpack_require__("../node_modules/react-select/lib/internal/ScrollLock/constants.js");

var _utils = __webpack_require__("../node_modules/react-select/lib/internal/ScrollLock/utils.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var activeScrollLocks = 0;

var ScrollLock = function (_Component) {
  _inherits(ScrollLock, _Component);

  function ScrollLock() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ScrollLock);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ScrollLock.__proto__ || Object.getPrototypeOf(ScrollLock)).call.apply(_ref, [this].concat(args))), _this), _this.originalStyles = {}, _this.listenerOptions = {
      capture: false,
      passive: false
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ScrollLock, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (!canUseDOM) return;

      var _props = this.props,
          accountForScrollbars = _props.accountForScrollbars,
          touchScrollTarget = _props.touchScrollTarget;

      var target = document.body;
      var targetStyle = target && target.style;

      if (accountForScrollbars) {
        // store any styles already applied to the body
        _constants.STYLE_KEYS.forEach(function (key) {
          var val = targetStyle && targetStyle[key];
          _this2.originalStyles[key] = val;
        });
      }

      // apply the lock styles and padding if this is the first scroll lock
      if (accountForScrollbars && activeScrollLocks < 1) {
        var currentPadding = parseInt(this.originalStyles.paddingRight, 10) || 0;
        var clientWidth = document.body ? document.body.clientWidth : 0;
        var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;

        Object.keys(_constants.LOCK_STYLES).forEach(function (key) {
          var val = _constants.LOCK_STYLES[key];
          if (targetStyle) {
            targetStyle[key] = val;
          }
        });

        if (targetStyle) {
          targetStyle.paddingRight = adjustedPadding + 'px';
        }
      }

      // account for touch devices
      if (target && (0, _utils.isTouchDevice)()) {
        // Mobile Safari ignores { overflow: hidden } declaration on the body.
        target.addEventListener('touchmove', _utils.preventTouchMove, this.listenerOptions);

        // Allow scroll on provided target
        if (touchScrollTarget) {
          touchScrollTarget.addEventListener('touchstart', _utils.preventInertiaScroll, this.listenerOptions);
          touchScrollTarget.addEventListener('touchmove', _utils.allowTouchMove, this.listenerOptions);
        }
      }

      // increment active scroll locks
      activeScrollLocks += 1;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _this3 = this;

      if (!canUseDOM) return;

      var _props2 = this.props,
          accountForScrollbars = _props2.accountForScrollbars,
          touchScrollTarget = _props2.touchScrollTarget;

      var target = document.body;
      var targetStyle = target && target.style;

      // safely decrement active scroll locks
      activeScrollLocks = Math.max(activeScrollLocks - 1, 0);

      // reapply original body styles, if any
      if (accountForScrollbars && activeScrollLocks < 1) {
        _constants.STYLE_KEYS.forEach(function (key) {
          var val = _this3.originalStyles[key];
          if (targetStyle) {
            targetStyle[key] = val;
          }
        });
      }

      // remove touch listeners
      if (target && (0, _utils.isTouchDevice)()) {
        target.removeEventListener('touchmove', _utils.preventTouchMove, this.listenerOptions);

        if (touchScrollTarget) {
          touchScrollTarget.removeEventListener('touchstart', _utils.preventInertiaScroll, this.listenerOptions);
          touchScrollTarget.removeEventListener('touchmove', _utils.allowTouchMove, this.listenerOptions);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return ScrollLock;
}(_react.Component);

ScrollLock.defaultProps = {
  accountForScrollbars: true
};
exports.default = ScrollLock;

/***/ }),

/***/ "../node_modules/react-select/lib/internal/ScrollLock/utils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.preventTouchMove = preventTouchMove;
exports.allowTouchMove = allowTouchMove;
exports.preventInertiaScroll = preventInertiaScroll;
exports.isTouchDevice = isTouchDevice;
function preventTouchMove(e) {
  e.preventDefault();
}

function allowTouchMove(e) {
  e.stopPropagation();
}

function preventInertiaScroll() {
  var top = this.scrollTop;
  var totalScroll = this.scrollHeight;
  var currentScroll = top + this.offsetHeight;

  if (top === 0) {
    this.scrollTop = 1;
  } else if (currentScroll === totalScroll) {
    this.scrollTop = top - 1;
  }
}

// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
}

/***/ }),

/***/ "../node_modules/react-select/lib/internal/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _A11yText = __webpack_require__("../node_modules/react-select/lib/internal/A11yText.js");

Object.defineProperty(exports, 'A11yText', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_A11yText).default;
  }
});

var _DummyInput = __webpack_require__("../node_modules/react-select/lib/internal/DummyInput.js");

Object.defineProperty(exports, 'DummyInput', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DummyInput).default;
  }
});

var _NodeResolver = __webpack_require__("../node_modules/react-select/lib/internal/NodeResolver.js");

Object.defineProperty(exports, 'NodeResolver', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_NodeResolver).default;
  }
});

var _ScrollBlock = __webpack_require__("../node_modules/react-select/lib/internal/ScrollBlock.js");

Object.defineProperty(exports, 'ScrollBlock', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ScrollBlock).default;
  }
});

var _ScrollCaptor = __webpack_require__("../node_modules/react-select/lib/internal/ScrollCaptor.js");

Object.defineProperty(exports, 'ScrollCaptor', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ScrollCaptor).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "../node_modules/react-select/lib/internal/react-fast-compare.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = exportedEqual;
var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;

function equal(a, b) {
  // fast-deep-equal index.js 2.0.1
  if (a === b) return true;

  if (a && b && (typeof a === 'undefined' ? 'undefined' : _typeof(a)) == 'object' && (typeof b === 'undefined' ? 'undefined' : _typeof(b)) == 'object') {
    var arrA = isArray(a),
        arrB = isArray(b),
        i,
        length,
        key;

    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;) {
        if (!equal(a[i], b[i])) return false;
      }
      return true;
    }

    if (arrA != arrB) return false;

    var dateA = a instanceof Date,
        dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();

    var regexpA = a instanceof RegExp,
        regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();

    var keys = keyList(a);
    length = keys.length;

    if (length !== keyList(b).length) {
      return false;
    }

    for (i = length; i-- !== 0;) {
      if (!hasProp.call(b, keys[i])) return false;
    }
    // end fast-deep-equal

    // Custom handling for React
    for (i = length; i-- !== 0;) {
      key = keys[i];
      if (key === '_owner' && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of a react element
        continue;
      } else {
        // all other properties should be traversed as usual
        if (!equal(a[key], b[key])) return false;
      }
    }

    // fast-deep-equal index.js 2.0.1
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

function exportedEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (error.message && error.message.match(/stack|recursion/i)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};

/***/ }),

/***/ "../node_modules/react-select/lib/stateManager.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var manageState = function manageState(SelectComponent) {
  var _class, _temp2;

  return _temp2 = _class = function (_Component) {
    _inherits(StateManager, _Component);

    function StateManager() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, StateManager);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = StateManager.__proto__ || Object.getPrototypeOf(StateManager)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        inputValue: _this.props.inputValue !== undefined ? _this.props.inputValue : _this.props.defaultInputValue,
        menuIsOpen: _this.props.menuIsOpen !== undefined ? _this.props.menuIsOpen : _this.props.defaultMenuIsOpen,
        value: _this.props.value !== undefined ? _this.props.value : _this.props.defaultValue
      }, _this.onChange = function (value, actionMeta) {
        _this.callProp('onChange', value, actionMeta);
        _this.setState({ value: value });
      }, _this.onInputChange = function (value, actionMeta) {
        // TODO: for backwards compatibility, we allow the prop to return a new
        // value, but now inputValue is a controllable prop we probably shouldn't
        var newValue = _this.callProp('onInputChange', value, actionMeta);
        _this.setState({
          inputValue: newValue !== undefined ? newValue : value
        });
      }, _this.onMenuOpen = function () {
        _this.callProp('onMenuOpen');
        _this.setState({ menuIsOpen: true });
      }, _this.onMenuClose = function () {
        _this.callProp('onMenuClose');
        _this.setState({ menuIsOpen: false });
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(StateManager, [{
      key: 'focus',
      value: function focus() {
        this.select.focus();
      }
    }, {
      key: 'blur',
      value: function blur() {
        this.select.blur();
      }
    }, {
      key: 'getProp',
      value: function getProp(key) {
        return this.props[key] !== undefined ? this.props[key] : this.state[key];
      }
    }, {
      key: 'callProp',
      value: function callProp(name) {
        if (typeof this.props[name] === 'function') {
          var _props;

          for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          return (_props = this.props)[name].apply(_props, _toConsumableArray(args));
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        return _react2.default.createElement(SelectComponent, _extends({}, this.props, {
          ref: function ref(_ref2) {
            _this2.select = _ref2;
          },
          inputValue: this.getProp('inputValue'),
          menuIsOpen: this.getProp('menuIsOpen'),
          onChange: this.onChange,
          onInputChange: this.onInputChange,
          onMenuClose: this.onMenuClose,
          onMenuOpen: this.onMenuOpen,
          value: this.getProp('value')
        }));
      }
    }]);

    return StateManager;
  }(_react.Component), _class.defaultProps = {
    defaultInputValue: '',
    defaultMenuIsOpen: false,
    defaultValue: null
  }, _temp2;
};

exports.default = manageState;

/***/ }),

/***/ "../node_modules/react-select/lib/styles.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultStyles = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.mergeStyles = mergeStyles;

var _containers = __webpack_require__("../node_modules/react-select/lib/components/containers.js");

var _Control = __webpack_require__("../node_modules/react-select/lib/components/Control.js");

var _Group = __webpack_require__("../node_modules/react-select/lib/components/Group.js");

var _indicators = __webpack_require__("../node_modules/react-select/lib/components/indicators.js");

var _Input = __webpack_require__("../node_modules/react-select/lib/components/Input.js");

var _Placeholder = __webpack_require__("../node_modules/react-select/lib/components/Placeholder.js");

var _Option = __webpack_require__("../node_modules/react-select/lib/components/Option.js");

var _Menu = __webpack_require__("../node_modules/react-select/lib/components/Menu.js");

var _SingleValue = __webpack_require__("../node_modules/react-select/lib/components/SingleValue.js");

var _MultiValue = __webpack_require__("../node_modules/react-select/lib/components/MultiValue.js");

var defaultStyles = exports.defaultStyles = {
  clearIndicator: _indicators.clearIndicatorCSS,
  container: _containers.containerCSS,
  control: _Control.css,
  dropdownIndicator: _indicators.dropdownIndicatorCSS,
  group: _Group.groupCSS,
  groupHeading: _Group.groupHeadingCSS,
  indicatorsContainer: _containers.indicatorsContainerCSS,
  indicatorSeparator: _indicators.indicatorSeparatorCSS,
  input: _Input.inputCSS,
  loadingIndicator: _indicators.loadingIndicatorCSS,
  loadingMessage: _Menu.loadingMessageCSS,
  menu: _Menu.menuCSS,
  menuList: _Menu.menuListCSS,
  menuPortal: _Menu.menuPortalCSS,
  multiValue: _MultiValue.multiValueCSS,
  multiValueLabel: _MultiValue.multiValueLabelCSS,
  multiValueRemove: _MultiValue.multiValueRemoveCSS,
  noOptionsMessage: _Menu.noOptionsMessageCSS,
  option: _Option.optionCSS,
  placeholder: _Placeholder.placeholderCSS,
  singleValue: _SingleValue.css,
  valueContainer: _containers.valueContainerCSS
};

// Merge Utility
// Allows consumers to extend a base Select with additional styles

function mergeStyles(source) {
  var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  // initialize with source styles
  var styles = _extends({}, source);

  // massage in target styles
  Object.keys(target).forEach(function (key) {
    if (source[key]) {
      styles[key] = function (rsCss, props) {
        return target[key](source[key](rsCss, props), props);
      };
    } else {
      styles[key] = target[key];
    }
  });

  return styles;
}

/***/ }),

/***/ "../node_modules/react-select/lib/theme.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var colors = exports.colors = {
  primary: '#2684FF',
  primary75: '#4C9AFF',
  primary50: '#B2D4FF',
  primary25: '#DEEBFF',

  danger: '#DE350B',
  dangerLight: '#FFBDAD',

  neutral0: 'hsl(0, 0%, 100%)',
  neutral5: 'hsl(0, 0%, 95%)',
  neutral10: 'hsl(0, 0%, 90%)',
  neutral20: 'hsl(0, 0%, 80%)',
  neutral30: 'hsl(0, 0%, 70%)',
  neutral40: 'hsl(0, 0%, 60%)',
  neutral50: 'hsl(0, 0%, 50%)',
  neutral60: 'hsl(0, 0%, 40%)',
  neutral70: 'hsl(0, 0%, 30%)',
  neutral80: 'hsl(0, 0%, 20%)',
  neutral90: 'hsl(0, 0%, 10%)'
};

var borderRadius = 4;
var baseUnit = 4; /* Used to calculate consistent margin/padding on elements */
var controlHeight = 38; /* The minimum height of the control */
var menuGutter = baseUnit * 2; /* The amount of space between the control and menu */

var spacing = exports.spacing = {
  baseUnit: baseUnit,
  controlHeight: controlHeight,
  menuGutter: menuGutter
};

var defaultTheme = exports.defaultTheme = {
  borderRadius: borderRadius,
  colors: colors,
  spacing: spacing
};

/***/ }),

/***/ "../node_modules/react-select/lib/types.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/***/ }),

/***/ "../node_modules/react-select/lib/utils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cleanValue = exports.emptyString = exports.noop = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.classNames = classNames;
exports.handleInputChange = handleInputChange;
exports.isDocumentElement = isDocumentElement;
exports.normalizedHeight = normalizedHeight;
exports.getScrollTop = getScrollTop;
exports.scrollTo = scrollTo;
exports.getScrollParent = getScrollParent;
exports.animatedScrollTo = animatedScrollTo;
exports.scrollIntoView = scrollIntoView;
exports.getBoundingClientObj = getBoundingClientObj;
exports.toKey = toKey;
exports.isTouchCapable = isTouchCapable;
exports.isMobileDevice = isMobileDevice;

var _raf = __webpack_require__("../node_modules/raf/index.js");

var _raf2 = _interopRequireDefault(_raf);

__webpack_require__("../node_modules/react/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ==============================
// NO OP
// ==============================

var noop = exports.noop = function noop() {};
var emptyString = exports.emptyString = function emptyString() {
  return '';
};

// ==============================
// Class Name Prefixer
// ==============================

/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/
function applyPrefixToName(prefix, name) {
  if (!name) {
    return prefix;
  } else if (name[0] === '-') {
    return prefix + name;
  } else {
    return prefix + '__' + name;
  }
}

function classNames(prefix, cssKey, state, className) {
  var arr = [cssKey, className];
  if (state && prefix) {
    for (var key in state) {
      if (state.hasOwnProperty(key) && state[key]) {
        arr.push('' + applyPrefixToName(prefix, key));
      }
    }
  }

  return arr.filter(function (i) {
    return i;
  }).map(function (i) {
    return String(i).trim();
  }).join(' ');
}
// ==============================
// Clean Value
// ==============================

var cleanValue = exports.cleanValue = function cleanValue(value) {
  if (Array.isArray(value)) return value.filter(Boolean);
  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value !== null) return [value];
  return [];
};

// ==============================
// Handle Input Change
// ==============================

function handleInputChange(inputValue, actionMeta, onInputChange) {
  if (onInputChange) {
    var newValue = onInputChange(inputValue, actionMeta);
    if (typeof newValue === 'string') return newValue;
  }
  return inputValue;
}

// ==============================
// Scroll Helpers
// ==============================

function isDocumentElement(el) {
  return [document.documentElement, document.body, window].indexOf(el) > -1;
}

// Normalized Scroll Top
// ------------------------------

function normalizedHeight(el) {
  if (isDocumentElement(el)) {
    return window.innerHeight;
  }

  return el.clientHeight;
}

// Normalized scrollTo & scrollTop
// ------------------------------

function getScrollTop(el) {
  if (isDocumentElement(el)) {
    return window.pageYOffset;
  }
  return el.scrollTop;
}

function scrollTo(el, top) {
  // with a scroll distance, we perform scroll on the element
  if (isDocumentElement(el)) {
    window.scrollTo(0, top);
    return;
  }

  el.scrollTop = top;
}

// Get Scroll Parent
// ------------------------------

function getScrollParent(element) {
  var style = getComputedStyle(element);
  var excludeStaticParent = style.position === 'absolute';
  var overflowRx = /(auto|scroll)/;
  var docEl = document.documentElement; // suck it, flow...

  if (style.position === 'fixed') return docEl;

  for (var parent = element; parent = parent.parentElement;) {
    style = getComputedStyle(parent);
    if (excludeStaticParent && style.position === 'static') {
      continue;
    }
    if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
      return parent;
    }
  }

  return docEl;
}

// Animated Scroll To
// ------------------------------

/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/
function easeOutCubic(t, b, c, d) {
  return c * ((t = t / d - 1) * t * t + 1) + b;
}

function animatedScrollTo(element, to) {
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
  var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop;

  var start = getScrollTop(element);
  var change = to - start;
  var increment = 10;
  var currentTime = 0;

  function animateScroll() {
    currentTime += increment;
    var val = easeOutCubic(currentTime, start, change, duration);
    scrollTo(element, val);
    if (currentTime < duration) {
      (0, _raf2.default)(animateScroll);
    } else {
      callback(element);
    }
  }
  animateScroll();
}

// Scroll Into View
// ------------------------------

function scrollIntoView(menuEl, focusedEl) {
  var menuRect = menuEl.getBoundingClientRect();
  var focusedRect = focusedEl.getBoundingClientRect();
  var overScroll = focusedEl.offsetHeight / 3;

  if (focusedRect.bottom + overScroll > menuRect.bottom) {
    scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
  } else if (focusedRect.top - overScroll < menuRect.top) {
    scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
  }
}

// ==============================
// Get bounding client object
// ==============================

// cannot get keys using array notation with DOMRect
function getBoundingClientObj(element) {
  var rect = element.getBoundingClientRect();
  return {
    bottom: rect.bottom,
    height: rect.height,
    left: rect.left,
    right: rect.right,
    top: rect.top,
    width: rect.width
  };
}


// ==============================
// String to Key (kebabify)
// ==============================

function toKey(str) {
  return str.replace(/\W/g, '-');
}

// ==============================
// Touch Capability Detector
// ==============================

function isTouchCapable() {
  try {
    document.createEvent('TouchEvent');
    return true;
  } catch (e) {
    return false;
  }
}

// ==============================
// Mobile Device Detector
// ==============================

function isMobileDevice() {
  try {
    return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    );
  } catch (e) {
    return false;
  }
}

/***/ }),

/***/ "../node_modules/style-loader/addStyles.js":
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
var stylesInDom = {},
	memoize = function(fn) {
		var memo;
		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	},
	isOldIE = memoize(function() {
		// Test for IE <= 9 as proposed by Browserhacks
		// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
		// Tests for existence of standard globals is to allow style-loader 
		// to operate correctly into non-standard environments
		// @see https://github.com/webpack-contrib/style-loader/issues/177
		return window && document && document.all && !window.atob;
	}),
	getElement = (function(fn) {
		var memo = {};
		return function(selector) {
			if (typeof memo[selector] === "undefined") {
				memo[selector] = fn.call(this, selector);
			}
			return memo[selector]
		};
	})(function (styleTarget) {
		return document.querySelector(styleTarget)
	}),
	singletonElement = null,
	singletonCounter = 0,
	styleElementsInsertedAtTop = [],
	fixUrls = __webpack_require__("../node_modules/style-loader/fixUrls.js");

module.exports = function(list, options) {
	if(typeof DEBUG !== "undefined" && DEBUG) {
		if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};
	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (typeof options.singleton === "undefined") options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (typeof options.insertInto === "undefined") options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

	var styles = listToStyles(list);
	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			domStyle.refs--;
			mayRemove.push(domStyle);
		}
		if(newList) {
			var newStyles = listToStyles(newList);
			addStylesToDom(newStyles, options);
		}
		for(var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];
			if(domStyle.refs === 0) {
				for(var j = 0; j < domStyle.parts.length; j++)
					domStyle.parts[j]();
				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom(styles, options) {
	for(var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];
		if(domStyle) {
			domStyle.refs++;
			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}
			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];
			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}
			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles(list) {
	var styles = [];
	var newStyles = {};
	for(var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};
		if(!newStyles[id])
			styles.push(newStyles[id] = {id: id, parts: [part]});
		else
			newStyles[id].parts.push(part);
	}
	return styles;
}

function insertStyleElement(options, styleElement) {
	var styleTarget = getElement(options.insertInto)
	if (!styleTarget) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}
	var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
	if (options.insertAt === "top") {
		if(!lastStyleElementInsertedAtTop) {
			styleTarget.insertBefore(styleElement, styleTarget.firstChild);
		} else if(lastStyleElementInsertedAtTop.nextSibling) {
			styleTarget.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			styleTarget.appendChild(styleElement);
		}
		styleElementsInsertedAtTop.push(styleElement);
	} else if (options.insertAt === "bottom") {
		styleTarget.appendChild(styleElement);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(styleElement) {
	styleElement.parentNode.removeChild(styleElement);
	var idx = styleElementsInsertedAtTop.indexOf(styleElement);
	if(idx >= 0) {
		styleElementsInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var styleElement = document.createElement("style");
	options.attrs.type = "text/css";

	attachTagAttrs(styleElement, options.attrs);
	insertStyleElement(options, styleElement);
	return styleElement;
}

function createLinkElement(options) {
	var linkElement = document.createElement("link");
	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	attachTagAttrs(linkElement, options.attrs);
	insertStyleElement(options, linkElement);
	return linkElement;
}

function attachTagAttrs(element, attrs) {
	Object.keys(attrs).forEach(function (key) {
		element.setAttribute(key, attrs[key]);
	});
}

function addStyle(obj, options) {
	var styleElement, update, remove;

	if (options.singleton) {
		var styleIndex = singletonCounter++;
		styleElement = singletonElement || (singletonElement = createStyleElement(options));
		update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
		remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
	} else if(obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function") {
		styleElement = createLinkElement(options);
		update = updateLink.bind(null, styleElement, options);
		remove = function() {
			removeStyleElement(styleElement);
			if(styleElement.href)
				URL.revokeObjectURL(styleElement.href);
		};
	} else {
		styleElement = createStyleElement(options);
		update = applyToTag.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if(newObj) {
			if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
				return;
			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;
		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag(styleElement, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (styleElement.styleSheet) {
		styleElement.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = styleElement.childNodes;
		if (childNodes[index]) styleElement.removeChild(childNodes[index]);
		if (childNodes.length) {
			styleElement.insertBefore(cssNode, childNodes[index]);
		} else {
			styleElement.appendChild(cssNode);
		}
	}
}

function applyToTag(styleElement, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		styleElement.setAttribute("media", media)
	}

	if(styleElement.styleSheet) {
		styleElement.styleSheet.cssText = css;
	} else {
		while(styleElement.firstChild) {
			styleElement.removeChild(styleElement.firstChild);
		}
		styleElement.appendChild(document.createTextNode(css));
	}
}

function updateLink(linkElement, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/* If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
	and there is no publicPath defined then lets turn convertToAbsoluteUrls
	on by default.  Otherwise default to the convertToAbsoluteUrls option
	directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls){
		css = fixUrls(css);
	}

	if(sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = linkElement.href;

	linkElement.href = URL.createObjectURL(blob);

	if(oldSrc)
		URL.revokeObjectURL(oldSrc);
}


/***/ }),

/***/ "../node_modules/style-loader/fixUrls.js":
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),

/***/ "../node_modules/stylis-rule-sheet/index.js":
/***/ (function(module, exports, __webpack_require__) {

(function (factory) {
	 true ? (module['exports'] = factory()) :
		typeof define === 'function' && define['amd'] ? define(factory()) :
			(window['stylisRuleSheet'] = factory())
}(function () {

	'use strict'

	return function (insertRule) {
		var delimiter = '/*|*/'
		var needle = delimiter+'}'

		function toSheet (block) {
			if (block)
				try {
					insertRule(block + '}')
				} catch (e) {}
		}

		return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
			switch (context) {
				// property
				case 1:
					// @import
					if (depth === 0 && content.charCodeAt(0) === 64)
						return insertRule(content+';'), ''
					break
				// selector
				case 2:
					if (ns === 0)
						return content + delimiter
					break
				// at-rule
				case 3:
					switch (ns) {
						// @font-face, @page
						case 102:
						case 112:
							return insertRule(selectors[0]+content), ''
						default:
							return content + (at === 0 ? delimiter : '')
					}
				case -2:
					content.split(needle).forEach(toSheet)
			}
		}
	}
}))


/***/ }),

/***/ "../node_modules/whatwg-fetch/fetch.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["Headers"] = Headers;
/* harmony export (immutable) */ __webpack_exports__["Request"] = Request;
/* harmony export (immutable) */ __webpack_exports__["Response"] = Response;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOMException", function() { return DOMException; });
/* harmony export (immutable) */ __webpack_exports__["fetch"] = fetch;
var support = {
  searchParams: 'URLSearchParams' in self,
  iterable: 'Symbol' in self && 'iterator' in Symbol,
  blob:
    'FileReader' in self &&
    'Blob' in self &&
    (function() {
      try {
        new Blob()
        return true
      } catch (e) {
        return false
      }
    })(),
  formData: 'FormData' in self,
  arrayBuffer: 'ArrayBuffer' in self
}

function isDataView(obj) {
  return obj && DataView.prototype.isPrototypeOf(obj)
}

if (support.arrayBuffer) {
  var viewClasses = [
    '[object Int8Array]',
    '[object Uint8Array]',
    '[object Uint8ClampedArray]',
    '[object Int16Array]',
    '[object Uint16Array]',
    '[object Int32Array]',
    '[object Uint32Array]',
    '[object Float32Array]',
    '[object Float64Array]'
  ]

  var isArrayBufferView =
    ArrayBuffer.isView ||
    function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
}

function normalizeName(name) {
  if (typeof name !== 'string') {
    name = String(name)
  }
  if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
    throw new TypeError('Invalid character in header field name')
  }
  return name.toLowerCase()
}

function normalizeValue(value) {
  if (typeof value !== 'string') {
    value = String(value)
  }
  return value
}

// Build a destructive iterator for the value list
function iteratorFor(items) {
  var iterator = {
    next: function() {
      var value = items.shift()
      return {done: value === undefined, value: value}
    }
  }

  if (support.iterable) {
    iterator[Symbol.iterator] = function() {
      return iterator
    }
  }

  return iterator
}

function Headers(headers) {
  this.map = {}

  if (headers instanceof Headers) {
    headers.forEach(function(value, name) {
      this.append(name, value)
    }, this)
  } else if (Array.isArray(headers)) {
    headers.forEach(function(header) {
      this.append(header[0], header[1])
    }, this)
  } else if (headers) {
    Object.getOwnPropertyNames(headers).forEach(function(name) {
      this.append(name, headers[name])
    }, this)
  }
}

Headers.prototype.append = function(name, value) {
  name = normalizeName(name)
  value = normalizeValue(value)
  var oldValue = this.map[name]
  this.map[name] = oldValue ? oldValue + ', ' + value : value
}

Headers.prototype['delete'] = function(name) {
  delete this.map[normalizeName(name)]
}

Headers.prototype.get = function(name) {
  name = normalizeName(name)
  return this.has(name) ? this.map[name] : null
}

Headers.prototype.has = function(name) {
  return this.map.hasOwnProperty(normalizeName(name))
}

Headers.prototype.set = function(name, value) {
  this.map[normalizeName(name)] = normalizeValue(value)
}

Headers.prototype.forEach = function(callback, thisArg) {
  for (var name in this.map) {
    if (this.map.hasOwnProperty(name)) {
      callback.call(thisArg, this.map[name], name, this)
    }
  }
}

Headers.prototype.keys = function() {
  var items = []
  this.forEach(function(value, name) {
    items.push(name)
  })
  return iteratorFor(items)
}

Headers.prototype.values = function() {
  var items = []
  this.forEach(function(value) {
    items.push(value)
  })
  return iteratorFor(items)
}

Headers.prototype.entries = function() {
  var items = []
  this.forEach(function(value, name) {
    items.push([name, value])
  })
  return iteratorFor(items)
}

if (support.iterable) {
  Headers.prototype[Symbol.iterator] = Headers.prototype.entries
}

function consumed(body) {
  if (body.bodyUsed) {
    return Promise.reject(new TypeError('Already read'))
  }
  body.bodyUsed = true
}

function fileReaderReady(reader) {
  return new Promise(function(resolve, reject) {
    reader.onload = function() {
      resolve(reader.result)
    }
    reader.onerror = function() {
      reject(reader.error)
    }
  })
}

function readBlobAsArrayBuffer(blob) {
  var reader = new FileReader()
  var promise = fileReaderReady(reader)
  reader.readAsArrayBuffer(blob)
  return promise
}

function readBlobAsText(blob) {
  var reader = new FileReader()
  var promise = fileReaderReady(reader)
  reader.readAsText(blob)
  return promise
}

function readArrayBufferAsText(buf) {
  var view = new Uint8Array(buf)
  var chars = new Array(view.length)

  for (var i = 0; i < view.length; i++) {
    chars[i] = String.fromCharCode(view[i])
  }
  return chars.join('')
}

function bufferClone(buf) {
  if (buf.slice) {
    return buf.slice(0)
  } else {
    var view = new Uint8Array(buf.byteLength)
    view.set(new Uint8Array(buf))
    return view.buffer
  }
}

function Body() {
  this.bodyUsed = false

  this._initBody = function(body) {
    this._bodyInit = body
    if (!body) {
      this._bodyText = ''
    } else if (typeof body === 'string') {
      this._bodyText = body
    } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
      this._bodyBlob = body
    } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
      this._bodyFormData = body
    } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
      this._bodyText = body.toString()
    } else if (support.arrayBuffer && support.blob && isDataView(body)) {
      this._bodyArrayBuffer = bufferClone(body.buffer)
      // IE 10-11 can't handle a DataView body.
      this._bodyInit = new Blob([this._bodyArrayBuffer])
    } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
      this._bodyArrayBuffer = bufferClone(body)
    } else {
      this._bodyText = body = Object.prototype.toString.call(body)
    }

    if (!this.headers.get('content-type')) {
      if (typeof body === 'string') {
        this.headers.set('content-type', 'text/plain;charset=UTF-8')
      } else if (this._bodyBlob && this._bodyBlob.type) {
        this.headers.set('content-type', this._bodyBlob.type)
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
      }
    }
  }

  if (support.blob) {
    this.blob = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return Promise.resolve(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(new Blob([this._bodyArrayBuffer]))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as blob')
      } else {
        return Promise.resolve(new Blob([this._bodyText]))
      }
    }

    this.arrayBuffer = function() {
      if (this._bodyArrayBuffer) {
        return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
      } else {
        return this.blob().then(readBlobAsArrayBuffer)
      }
    }
  }

  this.text = function() {
    var rejected = consumed(this)
    if (rejected) {
      return rejected
    }

    if (this._bodyBlob) {
      return readBlobAsText(this._bodyBlob)
    } else if (this._bodyArrayBuffer) {
      return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
    } else if (this._bodyFormData) {
      throw new Error('could not read FormData body as text')
    } else {
      return Promise.resolve(this._bodyText)
    }
  }

  if (support.formData) {
    this.formData = function() {
      return this.text().then(decode)
    }
  }

  this.json = function() {
    return this.text().then(JSON.parse)
  }

  return this
}

// HTTP methods whose capitalization should be normalized
var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

function normalizeMethod(method) {
  var upcased = method.toUpperCase()
  return methods.indexOf(upcased) > -1 ? upcased : method
}

function Request(input, options) {
  options = options || {}
  var body = options.body

  if (input instanceof Request) {
    if (input.bodyUsed) {
      throw new TypeError('Already read')
    }
    this.url = input.url
    this.credentials = input.credentials
    if (!options.headers) {
      this.headers = new Headers(input.headers)
    }
    this.method = input.method
    this.mode = input.mode
    this.signal = input.signal
    if (!body && input._bodyInit != null) {
      body = input._bodyInit
      input.bodyUsed = true
    }
  } else {
    this.url = String(input)
  }

  this.credentials = options.credentials || this.credentials || 'same-origin'
  if (options.headers || !this.headers) {
    this.headers = new Headers(options.headers)
  }
  this.method = normalizeMethod(options.method || this.method || 'GET')
  this.mode = options.mode || this.mode || null
  this.signal = options.signal || this.signal
  this.referrer = null

  if ((this.method === 'GET' || this.method === 'HEAD') && body) {
    throw new TypeError('Body not allowed for GET or HEAD requests')
  }
  this._initBody(body)
}

Request.prototype.clone = function() {
  return new Request(this, {body: this._bodyInit})
}

function decode(body) {
  var form = new FormData()
  body
    .trim()
    .split('&')
    .forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
  return form
}

function parseHeaders(rawHeaders) {
  var headers = new Headers()
  // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
  // https://tools.ietf.org/html/rfc7230#section-3.2
  var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
  preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
    var parts = line.split(':')
    var key = parts.shift().trim()
    if (key) {
      var value = parts.join(':').trim()
      headers.append(key, value)
    }
  })
  return headers
}

Body.call(Request.prototype)

function Response(bodyInit, options) {
  if (!options) {
    options = {}
  }

  this.type = 'default'
  this.status = options.status === undefined ? 200 : options.status
  this.ok = this.status >= 200 && this.status < 300
  this.statusText = 'statusText' in options ? options.statusText : 'OK'
  this.headers = new Headers(options.headers)
  this.url = options.url || ''
  this._initBody(bodyInit)
}

Body.call(Response.prototype)

Response.prototype.clone = function() {
  return new Response(this._bodyInit, {
    status: this.status,
    statusText: this.statusText,
    headers: new Headers(this.headers),
    url: this.url
  })
}

Response.error = function() {
  var response = new Response(null, {status: 0, statusText: ''})
  response.type = 'error'
  return response
}

var redirectStatuses = [301, 302, 303, 307, 308]

Response.redirect = function(url, status) {
  if (redirectStatuses.indexOf(status) === -1) {
    throw new RangeError('Invalid status code')
  }

  return new Response(null, {status: status, headers: {location: url}})
}

var DOMException = self.DOMException
try {
  new DOMException()
} catch (err) {
  DOMException = function(message, name) {
    this.message = message
    this.name = name
    var error = Error(message)
    this.stack = error.stack
  }
  DOMException.prototype = Object.create(Error.prototype)
  DOMException.prototype.constructor = DOMException
}

function fetch(input, init) {
  return new Promise(function(resolve, reject) {
    var request = new Request(input, init)

    if (request.signal && request.signal.aborted) {
      return reject(new DOMException('Aborted', 'AbortError'))
    }

    var xhr = new XMLHttpRequest()

    function abortXhr() {
      xhr.abort()
    }

    xhr.onload = function() {
      var options = {
        status: xhr.status,
        statusText: xhr.statusText,
        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
      }
      options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
      var body = 'response' in xhr ? xhr.response : xhr.responseText
      resolve(new Response(body, options))
    }

    xhr.onerror = function() {
      reject(new TypeError('Network request failed'))
    }

    xhr.ontimeout = function() {
      reject(new TypeError('Network request failed'))
    }

    xhr.onabort = function() {
      reject(new DOMException('Aborted', 'AbortError'))
    }

    xhr.open(request.method, request.url, true)

    if (request.credentials === 'include') {
      xhr.withCredentials = true
    } else if (request.credentials === 'omit') {
      xhr.withCredentials = false
    }

    if ('responseType' in xhr && support.blob) {
      xhr.responseType = 'blob'
    }

    request.headers.forEach(function(value, name) {
      xhr.setRequestHeader(name, value)
    })

    if (request.signal) {
      request.signal.addEventListener('abort', abortXhr)

      xhr.onreadystatechange = function() {
        // DONE (success or failure)
        if (xhr.readyState === 4) {
          request.signal.removeEventListener('abort', abortXhr)
        }
      }
    }

    xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
  })
}

fetch.polyfill = true

if (!self.fetch) {
  self.fetch = fetch
  self.Headers = Headers
  self.Request = Request
  self.Response = Response
}


/***/ }),

/***/ "./components/App.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__("../node_modules/react/index.js");
var Async_1 = __webpack_require__("../node_modules/react-select/lib/Async.js");
var OfficeHelpers = __webpack_require__("../node_modules/@microsoft/office-js-helpers/dist/office.helpers.js");
var office_ui_fabric_react_1 = __webpack_require__("../node_modules/office-ui-fabric-react/lib/index.js");
var whatwg_fetch_1 = __webpack_require__("../node_modules/whatwg-fetch/fetch.js");
var URL = 'https://vita.hollandpalette.nl';
var loadOptions = function (term, callback) {
    whatwg_fetch_1.fetch(URL + "/methods/searchAccountByName", {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        headers: {
            "Content-Type": "application/json; charset=utf-8"
        },
        redirect: "follow",
        body: JSON.stringify([
            term,
            "SUPPLIER",
            window.location.hash.replace('#', '')
        ])
    })
        .then(function (response) { return response.json(); })
        .then(function (result) {
        callback(result);
    });
};
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            selectedSupplier: null,
            term: '',
        };
        _this.handleChange = function (selectedSupplier) {
            _this.setState({ selectedSupplier: selectedSupplier }, function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.insertSupplierDetails()];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); });
        };
        _this.handleInputChange = function (newValue) {
            // const term = newValue.replace(/\W/g, '');
            _this.setState({ term: newValue });
            return newValue;
        };
        _this.insertSupplierDetails = function () { return __awaiter(_this, void 0, void 0, function () {
            var error_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, Word.run(function (context) { return __awaiter(_this, void 0, void 0, function () {
                                var doc, originalRange, _a, name, billingStreet, billingCode, billingCity, phone, address;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0:
                                            doc = context.document;
                                            originalRange = doc.getSelection();
                                            _a = this.state.selectedSupplier, name = _a.name, billingStreet = _a.billingStreet, billingCode = _a.billingCode, billingCity = _a.billingCity, phone = _a.phone;
                                            if (!name) {
                                                return [2 /*return*/];
                                            }
                                            address = originalRange.insertText(name + "\r" + billingStreet + "\r" + billingCode + " " + billingCity + "\r" + phone, "End");
                                            address.font.set({
                                                name: "Arial Narrow",
                                                bold: true,
                                                size: 11
                                            });
                                            context.load(originalRange.paragraphs, 'alignment');
                                            return [4 /*yield*/, context.sync().then(function () {
                                                    originalRange.paragraphs.items.map(function (paragraph) {
                                                        paragraph.alignment = "Centered";
                                                    });
                                                })];
                                        case 1:
                                            _b.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        OfficeHelpers.UI.notify(error_1);
                        OfficeHelpers.Utilities.log(error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    App.prototype.render = function () {
        var selectedSupplier = this.state.selectedSupplier;
        return (React.createElement("div", { className: "vita" },
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("div", { className: "padding" },
                React.createElement(Async_1.default, { cacheOptions: false, loadOptions: loadOptions, defaultOptions: true, onInputChange: this.handleInputChange, onChange: this.handleChange, formatOptionLabel: function (option) { return React.createElement("span", null, option.name); }, getOptionLabel: function (option) { return option.name; }, getOptionValue: function (option) { return option._id; }, placeholder: "Find supplier..." }),
                React.createElement("div", null, selectedSupplier && (React.createElement("div", null,
                    React.createElement("br", null),
                    selectedSupplier.name,
                    React.createElement("br", null),
                    selectedSupplier.billingStreet,
                    React.createElement("br", null),
                    selectedSupplier.billingCode,
                    " ",
                    selectedSupplier.billingCity,
                    React.createElement("br", null),
                    selectedSupplier.phone))),
                React.createElement("div", null,
                    React.createElement("br", null),
                    React.createElement(office_ui_fabric_react_1.Button, { className: "normal-button", buttonType: office_ui_fabric_react_1.ButtonType.hero, onClick: this.insertSupplierDetails }, "Insert address")))));
    };
    return App;
}(React.Component));
exports.default = App;


 ;(function register() { /* react-hot-loader/webpack */ if (process.env.NODE_ENV !== 'production') { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/Users/fabianlachman/Development/Holland Palette/VitaWordAddin/Vita Word Add-in/src/components/App.tsx"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/Users/fabianlachman/Development/Holland Palette/VitaWordAddin/Vita Word Add-in/src/components/App.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/node-libs-browser/node_modules/process/browser.js")))

/***/ }),

/***/ "./index.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__("../node_modules/react/index.js");
var ReactDOM = __webpack_require__("../node_modules/react-dom/index.js");
var react_hot_loader_1 = __webpack_require__("../node_modules/react-hot-loader/index.js");
var Icons_1 = __webpack_require__("../node_modules/office-ui-fabric-react/lib/Icons.js");
var App_1 = __webpack_require__("./components/App.tsx");
__webpack_require__("./styles.less");
__webpack_require__("../node_modules/office-ui-fabric-react/dist/css/fabric.min.css");
Icons_1.initializeIcons();
var isOfficeInitialized = false;
var title = 'Vita Word Add-in';
var render = function (Component) {
    ReactDOM.render(React.createElement(react_hot_loader_1.AppContainer, null,
        React.createElement(Component, { title: title, isOfficeInitialized: isOfficeInitialized })), document.getElementById('container'));
};
/* Render application after Office initializes */
Office.initialize = function () {
    isOfficeInitialized = true;
    render(App_1.default);
};
/* Initial render showing a progress bar */
render(App_1.default);
if (false) {
    module.hot.accept('./components/App', function () {
        var NextApp = require('./components/App').default;
        render(NextApp);
    });
}


 ;(function register() { /* react-hot-loader/webpack */ if (process.env.NODE_ENV !== 'production') { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/Users/fabianlachman/Development/Holland Palette/VitaWordAddin/Vita Word Add-in/src/index.tsx"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/Users/fabianlachman/Development/Holland Palette/VitaWordAddin/Vita Word Add-in/src/index.tsx"); } } })();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/node-libs-browser/node_modules/process/browser.js")))

/***/ }),

/***/ "./styles.less":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("../node_modules/css-loader/index.js!../node_modules/less-loader/dist/cjs.js!./styles.less");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("../node_modules/style-loader/addStyles.js")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../node_modules/css-loader/index.js!../node_modules/less-loader/dist/cjs.js!./styles.less", function() {
			var newContent = require("!!../node_modules/css-loader/index.js!../node_modules/less-loader/dist/cjs.js!./styles.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/react-hot-loader/patch.js");
module.exports = __webpack_require__("./index.tsx");


/***/ })

},[1]);


// WEBPACK FOOTER //
// app.d9a3992a5defa0ad3af9.js